import React from 'react'

// Use below Key for searching through each SVG
// COACH:SVG
// SILVER:SVG
// GOLD:SVG
// PLATINUM:SVG
// COACHING-SESSION
// EVENT
// PREMIER
// PROMPTINGS-PROCESS
// SEMINAR
// TRAINING-PROGRESS

export const coachingBadges = {
  // -------------------------------------------------------COACH:SVG------------------------------------------------------------------------------------------------------------------------------------------------------
  coach: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="11 0 120 160"
    >
      <g clipPath="url(#a)">
        <path
          d="M139.276 89.662a19.152 19.152 0 0 0 4.051-3.131v24.582a17.78 17.78 0 0 1-8.89 15.394L80.55 157.618a17.77 17.77 0 0 1-17.772 0L8.89 126.507A17.78 17.78 0 0 1 0 111.113V86.531a19.08 19.08 0 0 0 4.051 3.131l58.044 33.512a19.133 19.133 0 0 0 19.141 0l58.042-33.512h-.002Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.887v32.62a19.087 19.087 0 0 1-4.051 3.131L81.234 118.15a19.128 19.128 0 0 1-19.141 0L4.051 84.64A19.212 19.212 0 0 1 0 81.51v-32.62c0-6.352 3.39-12.22 8.89-15.396L62.778 2.382a17.773 17.773 0 0 1 17.774 0l53.887 31.113a17.774 17.774 0 0 1 8.89 15.392h-.002Z"
          fill="url(#b)"
        />
        <g filter="url(#c)">
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="d"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <path
            d="M52.871 55.898c-.434 0-.84-.07-1.215-.212a2.9 2.9 0 0 1-.966-.62 2.908 2.908 0 0 1-.643-.936 3.026 3.026 0 0 1-.226-1.181c0-.43.075-.823.226-1.181.155-.359.37-.671.643-.937.28-.266.604-.47.974-.611.37-.147.775-.22 1.215-.22.488 0 .928.087 1.32.26.397.169.73.419.998.75l-.837.782a1.913 1.913 0 0 0-.644-.497 1.753 1.753 0 0 0-.773-.17c-.262 0-.504.043-.724.13a1.64 1.64 0 0 0-.571.374c-.161.163-.287.356-.378.579-.086.222-.129.47-.129.74 0 .272.043.52.129.742.09.223.217.416.378.579.16.163.351.287.571.374.22.087.462.13.724.13.28 0 .537-.054.773-.162.236-.114.45-.285.644-.514l.837.782c-.269.332-.601.584-.998.758a3.24 3.24 0 0 1-1.328.26ZM57.276 52.395h2.712v1.026h-2.712v-1.026Zm.097 2.346h3.066V55.8h-4.362v-5.702h4.257v1.059h-2.961v3.584ZM61.476 55.8v-5.702h2.438c.505 0 .94.084 1.304.252.365.163.646.4.845.709.198.31.298.679.298 1.108 0 .423-.1.79-.298 1.1-.199.304-.48.537-.845.7-.365.163-.8.245-1.304.245H62.2l.58-.579V55.8h-1.304Zm3.581 0-1.408-2.07h1.392l1.424 2.07h-1.408Zm-2.277-2.02-.58-.62h1.642c.402 0 .703-.086.901-.26.199-.18.298-.424.298-.733 0-.315-.1-.56-.298-.733-.198-.174-.499-.261-.901-.261H62.2l.58-.627v3.234ZM68.482 55.8v-4.627h-1.803v-1.075h4.909v1.075h-1.803V55.8h-1.303ZM72.29 55.8v-5.702h1.303V55.8H72.29ZM76.137 52.664h2.704v1.059h-2.704v-1.06Zm.097 3.136H74.93v-5.702h4.257v1.059h-2.953V55.8ZM80.07 55.8v-5.702h1.303V55.8H80.07ZM83.909 52.395h2.712v1.026h-2.712v-1.026Zm.097 2.346h3.066V55.8H82.71v-5.702h4.257v1.059h-2.961v3.584ZM88.109 55.8v-5.702h2.559c.611 0 1.15.12 1.617.358.467.234.832.562 1.095.986.263.423.394.926.394 1.507 0 .576-.131 1.078-.394 1.507a2.713 2.713 0 0 1-1.095.994c-.466.233-1.005.35-1.617.35h-2.56Zm1.303-1.083h1.191c.376 0 .7-.071.974-.212.28-.147.494-.353.644-.62.156-.265.233-.578.233-.936 0-.364-.077-.676-.233-.937a1.498 1.498 0 0 0-.644-.61c-.273-.148-.598-.22-.974-.22h-1.19v3.535ZM51.185 69a5.82 5.82 0 0 1-2.066-.36 4.93 4.93 0 0 1-1.642-1.052 4.943 4.943 0 0 1-1.094-1.593A5.145 5.145 0 0 1 46 63.987c0-.73.128-1.399.383-2.008.264-.61.63-1.14 1.094-1.593a4.9 4.9 0 0 1 1.656-1.038 5.56 5.56 0 0 1 2.066-.374c.83 0 1.577.148 2.243.443.675.286 1.24.71 1.696 1.274l-1.422 1.33a3.25 3.25 0 0 0-1.095-.845 2.979 2.979 0 0 0-1.313-.291c-.447 0-.857.074-1.231.221-.374.148-.698.36-.972.637a3 3 0 0 0-.642.984 3.476 3.476 0 0 0-.22 1.26c0 .461.073.882.22 1.26.154.379.369.706.642.983.274.277.598.49.972.637.374.148.784.222 1.231.222.474 0 .912-.092 1.313-.277a3.347 3.347 0 0 0 1.095-.873l1.422 1.33a4.44 4.44 0 0 1-1.696 1.288c-.666.295-1.418.443-2.257.443ZM61.086 69c-.757 0-1.46-.125-2.107-.374a5.051 5.051 0 0 1-1.669-1.052 4.94 4.94 0 0 1-1.094-1.593 5.107 5.107 0 0 1-.383-1.994c0-.72.127-1.385.383-1.994a4.84 4.84 0 0 1 1.108-1.593 5.05 5.05 0 0 1 1.669-1.052 5.667 5.667 0 0 1 2.08-.374c.756 0 1.45.124 2.079.374a4.9 4.9 0 0 1 1.655 1.052c.474.453.844.983 1.108 1.593.265.6.397 1.264.397 1.994 0 .72-.132 1.39-.397 2.008a4.843 4.843 0 0 1-1.108 1.593 5.015 5.015 0 0 1-1.655 1.038 5.56 5.56 0 0 1-2.066.374Zm-.014-1.911c.429 0 .821-.074 1.177-.222a2.817 2.817 0 0 0 1.587-1.62c.155-.378.232-.799.232-1.26 0-.462-.077-.882-.232-1.26a2.831 2.831 0 0 0-.63-.984 2.68 2.68 0 0 0-.944-.637 3.142 3.142 0 0 0-1.19-.221c-.428 0-.825.074-1.19.221-.356.148-.67.36-.944.637a3 3 0 0 0-.643.984 3.476 3.476 0 0 0-.219 1.26c0 .452.073.872.22 1.26.154.379.364.706.629.983.273.277.592.49.957.637a3.14 3.14 0 0 0 1.19.222ZM66.585 68.834l4.268-9.694h2.19l4.281 9.694H75l-3.503-8.559h.876l-3.516 8.559h-2.27Zm2.134-2.077.589-1.704h4.924l.602 1.704H68.72ZM82.767 69a5.82 5.82 0 0 1-2.066-.36 4.93 4.93 0 0 1-1.641-1.052 4.944 4.944 0 0 1-1.095-1.593 5.144 5.144 0 0 1-.383-2.008c0-.73.128-1.399.383-2.008.265-.61.63-1.14 1.095-1.593a4.9 4.9 0 0 1 1.655-1.038 5.56 5.56 0 0 1 2.066-.374c.83 0 1.578.148 2.243.443.675.286 1.24.71 1.697 1.274l-1.423 1.33a3.25 3.25 0 0 0-1.094-.845 2.979 2.979 0 0 0-1.314-.291c-.447 0-.857.074-1.231.221a2.79 2.79 0 0 0-.971.637 3 3 0 0 0-.643.984 3.478 3.478 0 0 0-.22 1.26c0 .461.074.882.22 1.26.155.379.369.706.643.983.273.277.597.49.971.637a3.32 3.32 0 0 0 1.231.222c.474 0 .912-.092 1.314-.277a3.346 3.346 0 0 0 1.094-.873l1.423 1.33a4.44 4.44 0 0 1-1.697 1.288c-.665.295-1.418.443-2.257.443ZM94.784 59.14H97v9.694h-2.216V59.14Zm-4.35 9.694h-2.217V59.14h2.216v9.694Zm4.514-3.975h-4.679v-1.897h4.679v1.897Z"
            fill="#9042AE"
          />
          <path
            d="M122.112 137.805H88.461l-3.092-10.066h27.468l9.275 10.066ZM140.304 127.739h-27.467l-6.396-6.941h23.203l10.66 6.941ZM93.349 153.719H49.92l4.888-15.914h33.652l4.888 15.914ZM54.81 137.805H21.157l9.275-10.066h27.468l-3.092 10.066ZM30.433 127.739H2.966l10.66-6.941h23.203l-6.396 6.941Z"
            fill="#000"
          />
          <path
            d="m62.35 133.817-.048-.004a7.249 7.249 0 0 1-2.214-.58 1.637 1.637 0 0 1-.973-1.493v-1.063c0-.466.193-.912.51-1.24a3.507 3.507 0 0 1-.244-.339c-1.04-1.615-.358-3.431.148-4.166.33-.479.804-1.077 1.262-1.653.285-.358.557-.701.764-.98.4-.536.644-1.463.67-1.698v-.221c.003-.664.248-1.08.586-1.369a1.68 1.68 0 0 1-.483-.56c-.269-.504-.755-1.427-.989-1.94l-.038-.083c-.313-.681-.512-1.295-.008-2.491l.057-.133c.607-1.444 2.027-4.825 7.061-10.109.07-.074.132-.14.185-.2h-.07c-.946.062-1.893.167-2.965.735-.248.213-.41.517-.597.865-.195.362-.415.773-.773 1.104-.604.557-1.7.675-2.512.675-1.6 0-2.535-.464-2.78-1.378a1.799 1.799 0 0 1-.06-.415c-.42 0-.814-.1-1.17-.298-.413-.221-1.124-.603-1.32-4.408-.095-.657.082-1.64.893-2.433l.112-.108c.767-.746 3.103-3.015 4.407-5.262.22-.378.5-.742.836-1.08a11.792 11.792 0 0 1 1.4-1.202c-.169-.194-.338-.385-.504-.572-1.047-1.18-1.803-2.031-1.68-3.05.058-.479.315-.897.723-1.18.248-.17.71-.488 1.567-.488.787 0 2.16.229 5.8 1.99.499.057.974.129 1.45.22 1.12.218 2.186.545 3.18.973l-.018-.256 2.12 1.381c.723.47 1.406 1.015 2.03 1.619l.235.227.096.313c.023.078.047.157.069.236l.145-.706 1.672 2.69c.618.995 1.15 2.108 1.58 3.306l.108.3-.046.313c-.1.67-.249 1.417-.471 2.211l1.051-1.312.439 2.84c.036.235.071.472.102.714.153 1.195.209 2.601.158 4.064l-.011.339-.18.287a18.414 18.414 0 0 1-1.592 2.17l1.77-.993-.423 2.59a33.63 33.63 0 0 1-.827 3.736l.12-.031-.86 2.299c-.24.64-.5 1.262-.774 1.849a1.69 1.69 0 0 1-.551.66c.325.285.559.697.563 1.343v.229c.026.235.27 1.163.669 1.698.208.28.48.622.764.98.457.576.932 1.174 1.262 1.654.505.734 1.188 2.55.148 4.165-.078.121-.16.234-.245.339.317.328.51.774.51 1.24v1.063c0 .644-.383 1.23-.973 1.493a7.249 7.249 0 0 1-2.214.58l-.047.004H62.348h.001Z"
            fill="#fff"
          />
          <path
            d="m82.541 130.193-1.073-.387-.34-.123v-.143s1.044-.119 1.69-1.124c.657-1.019.22-2.262-.126-2.765-.51-.741-1.462-1.876-1.998-2.595-.608-.814-.92-2.096-.92-2.428v-.246c-.003-.326-.033-.426-.67-.687-.132-.056-.678-.255-.73-.274l-.012-.004a.711.711 0 0 1-.348-.629c0-.393.282-.708.632-.708h.848a.425.425 0 0 0 .386-.244c.267-.572.511-1.159.735-1.756a19.33 19.33 0 0 1-3.683.6 23.935 23.935 0 0 0 4.242-2.257 32.04 32.04 0 0 0 .946-4.108c-3.004 1.684-6.474 2.256-6.474 2.256 3.548-2.069 5.671-4.53 6.894-6.489.05-1.434-.006-2.75-.15-3.861a27 27 0 0 0-.097-.681c-2.502 3.124-5.36 4.596-5.36 4.596 2.88-2.807 3.97-6.21 4.34-8.714a16.084 16.084 0 0 0-1.465-3.067C79.138 97.6 77.7 99.38 77.7 99.38c.932-2.972.688-5.562.085-7.543a12.255 12.255 0 0 0-1.84-1.467c.099 1.476-.032 3.254-.527 4.689.01-2.442-.598-4.32-1.296-5.672a14.215 14.215 0 0 0-3.007-.932c-.59-.112-1.121-.181-1.568-.227-5.128-2.504-5.828-2.016-6.294-1.695-.734.507.81 1.83 2.132 3.449.31.379.31.64 0 .877-.263.2-1.054.679-1.891 1.526a4.114 4.114 0 0 0-.641.827c-1.464 2.521-4.083 5.01-4.729 5.64-.673.657-.517 1.391-.517 1.391s.155 3.161.673 3.44c.958.531 2.16-.649 2.435-.346.22.243-.751 1.256-.596 1.837.155.582 2.72.557 3.212.101.492-.455.673-1.453 1.528-2.099 1.351-.745 2.537-.87 3.593-.939.198-.014 1.254.01 1.534.289.524.522.233 1.106-.661 2.044-5.033 5.283-6.29 8.491-6.869 9.862-.348.824-.21 1.028.032 1.559.224.493.723 1.438.953 1.868a.423.423 0 0 0 .373.224h.797c.348 0 .632.315.632.707a.71.71 0 0 1-.358.634c-.052.019-.598.218-.73.273-.638.261-.668.36-.67.687v.247c0 .332-.313 1.613-.92 2.428-.535.718-1.488 1.853-1.998 2.595-.346.502-.782 1.746-.127 2.764a2.528 2.528 0 0 0 1.691 1.125v.143l-.34.123-1.073.387a.551.551 0 0 0-.342.484v1.063a.37.37 0 0 0 .222.337c.924.411 1.796.475 1.796.475h18.469s.871-.065 1.796-.475a.37.37 0 0 0 .222-.337v-1.063a.551.551 0 0 0-.342-.484l.002-.002Z"
            fill="#000"
          />
          <path
            d="M69.122 88.842c-.352-.19-1.225-.661-1.516-.824.148.14.987.909 1.347 1.265.04.04.096.062.153.061.88-.014 1.754-.043 2.634-.057a27.328 27.328 0 0 0-2.304-.347.844.844 0 0 1-.314-.097Z"
            fill="url(#e)"
          />
          <path
            d="M72.462 94.484c.235.826.55 2.325.346 3.672-.172 1.14-.79 2.127-1.395 2.942 1.642-1.22 1.832-2.63 1.872-3.013.168-1.572-.321-2.586-.823-3.6Z"
            fill="url(#f)"
          />
          <path
            d="M74.844 94.235c-.11-1.837-.51-2.969-.821-3.636-.294-.255-.727-.465-.968-.497.671.86 1.312 2.12 1.79 4.133Z"
            fill="url(#g)"
          />
          <path
            d="M76.924 98.859c.107-.592.671-3.643.088-6.285.047.043.39.45.575.747.344 1.89-.112 4.252-.663 5.538Z"
            fill="url(#h)"
          />
          <path
            d="M75.645 111.53c2.362-1.42 4.923-3.746 6.031-5.583.062-.936.013-1.396-.024-2.606-.173.955-.506 2.57-.506 2.57s-1.731 2.915-5.5 5.619Z"
            fill="url(#i)"
          />
          <path
            d="M76.713 105.081c2.2-2.327 3.268-4.469 3.856-6.99a10.018 10.018 0 0 0-.672-1.802c.115.512.182 1.13.19 1.903-.314 1.855-1.446 4.48-3.374 6.89v-.001Z"
            fill="url(#j)"
          />
          <path
            d="M76.951 115.844a34.144 34.144 0 0 0 3.604-1.971c.276-.831.485-1.594.706-2.311-.182.419-.576 1.16-.818 1.604a2.01 2.01 0 0 1-.541.637 39.63 39.63 0 0 1-2.95 2.042v-.001Z"
            fill="url(#k)"
          />
          <path
            d="M79.742 116.757c-.125.27-.19.438-.362.718a.314.314 0 0 1-.256.142c-.356.015-.61-.005-.93-.005.298-.106.655-.134.92-.28.266-.146.433-.332.627-.575h.001Z"
            fill="url(#l)"
          />
          <path
            d="M75.281 119.944c.777-.011 2.54-.008 2.678-.008.36 0 .039.403-1.089.403a3.434 3.434 0 0 1-1.588-.395Z"
            fill="url(#m)"
          />
          <path
            d="M78.528 122.482c.052.04.4.849.516 1.089.416.862 1.499 2.333 1.579 2.477.105.187.042.437-.076.614-.143.213-.408.304-.655.378-.295.087-1.32.144-1.974-.384-.738-.597-.783-1.496-.836-1.829-.095-.596-.037-1.724.164-2.19.178-.411.889-.46 1.282-.155Z"
            fill="url(#n)"
          />
          <path
            d="M77.45 130.409c1.326 0 2.593 0 3.889-.005.112 0 .2.136-.156.277-.465.185-1.111.331-1.566.33-.77-.005-1.408-.202-2.166-.602Z"
            fill="url(#o)"
          />
          <path
            d="M76.007 119.291c-.018.018-.012.066.009.066.567-.008.816-.005 1.083-.007.04 0 .072-.061.072-.133 0-.157 0-.28-.002-.439 0-.071-.031-.13-.07-.131-.084-.003-.258-.01-.343.019-.043.015-.29.17-.749.624v.001Z"
            fill="url(#p)"
          />
          <path
            d="M58.745 103.022c-.028-.443-.12-.881-.208-1.304-.087-.42-.177-.856-.205-1.292a2.42 2.42 0 0 1 .072-.794c.07-.262.27-.536.496-.682l.356-.223c.26-.16.484-.298.71-.475a12.38 12.38 0 0 0 3.117-3.603c.123-.216.236-.44.346-.657.184-.367.38-.741.613-1.084.552-.81 2.357-1.888 3.131-2.1-.618.653-.606 1.184-.598 1.483.246.045.808.197 1.142.625a1.2 1.2 0 0 1 .248.9c-.38-.413-1.301-.786-1.977-.786-.145 0-.272.017-.379.052-.664.215-.923.592-1.281 1.116-.25.364-.475.786-.694 1.194-.114.214-.227.425-.342.624-.61 1.064-1.536 2.046-2.91 3.09-.291.22-.546.25-.757.25-.047 0-.092-.002-.134-.003a2.51 2.51 0 0 0-.11-.003.522.522 0 0 0-.202.03c-.321.135-.42.609-.388.901.041.369.218.59.473.59.064 0 .13-.015.195-.043.288-.124.55-.424.8-.915.194.545.032 1.077-.445 1.438-.172.132-.337.171-.497.209l-.138.035v.033c.004.753-.33 1.336-.435 1.402v-.008Zm9.271-8.527c-.169.357-.4.694-.716.937-.58.445-1.334.486-2.022.349.599.682 1.898.68 2.477-.023a1.344 1.344 0 0 0 .306-.87 1.772 1.772 0 0 0-.045-.393Z"
            fill="url(#q)"
          />
          <path
            d="M66.108 89.81c.101.115.199.196.35.221a.727.727 0 0 0 .521-.101c.183-.122-.176-.452-.35-.586-1.416-1.092-2.48-1.866-2.635-1.823.53.574.93.96 2.115 2.289h-.001Z"
            fill="url(#r)"
          />
          <path
            d="M60.88 104.674c.367-.045.648-.302.803-.643.153-.34.215-.873.215-1.385-.107.18-.168.322-.231.45l-.271.546-.515 1.032h-.001Z"
            fill="url(#s)"
          />
          <path
            d="M65.53 114.85c-.048.478.221 1.202.859 2.182a.212.212 0 0 1-.175.329c-.354 0-.794-.003-1.006-.007a.746.746 0 0 1-.619-.352c-.451-.726-.547-.9-.852-1.557a1.075 1.075 0 0 1-.038-.799c.835-2.433 2.03-4.071 3.423-5.904 1.608-2.117 3.607-3.596 4.236-5.304.186.855-.087 1.907-1.032 3.104-1.867 2.364-4.425 5.834-4.796 8.307v.001Z"
            fill="url(#t)"
          />
          <path
            d="M70.604 119.936c-.818.252-2.05.508-3.147.508a9.072 9.072 0 0 1-2.33-.293c-.118-.032-.255-.084-.242-.144.014-.071.272-.07.385-.07h5.334v-.001Z"
            fill="url(#u)"
          />
          <path
            d="M67.975 125.503c-.205.398-.416.805-.753 1.108-.409.368-.969.549-1.529.605-.689.07-1.13.071-1.78-.168-.25-.092-.497-.207-.683-.39a.864.864 0 0 1-.25-.698c.072-.735 1.266-1.794 1.86-3.057.168-.36.361-.739.71-.945.262-.156.693-.194 1.002-.19.658.006 1.13.072 1.564.423.446.361.41 2.242-.14 3.312Z"
            fill="url(#v)"
          />
          <path
            d="M62.138 130.41h6.116c-.717.28-1.165.41-2.184.568-.502.078-1.085.115-1.693.109a7.205 7.205 0 0 1-1.815-.231 3.95 3.95 0 0 1-.562-.215c-.187-.11-.16-.231.138-.231Z"
            fill="url(#w)"
          />
          <path
            d="M68.646 119.291c.037.018.025.066-.017.066-1.172-.008-1.687-.005-2.238-.008-.082 0-.148-.06-.148-.133 0-.156.001-.279.004-.438 0-.071.065-.13.146-.131.171-.003.372.032.548.046.093.007.758.143 1.706.597l-.001.001Z"
            fill="url(#x)"
          />
          <path
            d="M65.527 95.277a.26.26 0 0 1-.118-.024c-.124-.051-.19-.208-.19-.33 0-.261.169-.539.25-.632a.924.924 0 0 1 .675-.31c.093 0 .186.017.276.049a1.132 1.132 0 0 0-.444.35 1.152 1.152 0 0 0-.193.524c-.006.034-.009.069-.012.101-.014.14-.027.261-.184.271a.867.867 0 0 1-.06.003v-.002Z"
            fill="url(#y)"
          />
          <path
            d="m87.715 126.324-.035-.002a5.277 5.277 0 0 1-1.534-.39c-.706-.299-.782-.881-.782-1.117v-.773c0-.339.14-.663.371-.901a2.712 2.712 0 0 1-.178-.246c-.672-1.044-.384-2.181.108-2.896.255-.371.597-.678.898-.947.228-.204.443-.397.575-.574.042-.056.087-.122.136-.197v-.299c-.001-.684.224-1.06.67-1.347a1.722 1.722 0 0 1-.298-.969c0-.737.463-1.369 1.112-1.619.217-1.838.506-5.347.553-11.246a1.526 1.526 0 0 1-.453-1.749 1.501 1.501 0 0 1-.683-.998 1.691 1.691 0 0 1-1.072-1.573V93.34h14.717v5.142c0 .714-.445 1.327-1.073 1.573a1.499 1.499 0 0 1-.683.998 1.525 1.525 0 0 1-.453 1.75c.047 5.899.336 9.408.553 11.245.65.251 1.112.882 1.112 1.619 0 .358-.11.692-.298.969.446.288.671.663.67 1.347v.299c.049.074.094.14.136.196.132.178.347.37.575.575.301.269.642.575.898.946.493.716.78 1.852.108 2.896-.057.088-.117.17-.178.246.23.239.37.563.37.901v.773c0 .236-.076.818-.782 1.118a5.296 5.296 0 0 1-1.535.389l-.034.003H87.715Z"
            fill="#fff"
          />
          <path
            d="M101.363 123.267v-.052s.759-.087 1.229-.818c.477-.74.16-1.512-.092-1.877-.371-.539-1.063-.97-1.452-1.493a4.531 4.531 0 0 1-.253-.379.46.46 0 0 1-.066-.237v-.4c0-.427.019-.535-.735-.841-.141-.058-.279-.113-.408-.163h.005v-.53a.813.813 0 0 0-.049-1.626h-.201c-.213-1.539-.615-5.377-.652-12.624a.609.609 0 0 0-.004-1.213 81.993 81.993 0 0 0-.007-.656h.602a.576.576 0 0 0 .574-.578v-.527h.276a.77.77 0 0 0 .771-.77v-4.224h-2.498v2.001h-1.445v-2h-4.995v2H90.52v-2H88.02v4.223c0 .425.346.77.77.77h.277v.527c0 .319.257.578.574.578h.602c-.003.221-.006.44-.007.656a.607.607 0 0 0-.004 1.213c-.037 7.246-.439 11.085-.653 12.624h-.2a.814.814 0 0 0-.049 1.626v.53h.004c-.129.05-.267.105-.408.163-.754.307-.735.414-.735.841v.4a.457.457 0 0 1-.066.237 4.606 4.606 0 0 1-.252.379c-.39.523-1.082.954-1.453 1.493-.251.365-.568 1.137-.092 1.877.47.731 1.23.818 1.23.818v.104l-.248.089-.78.281a.403.403 0 0 0-.249.352v.773c0 .144.09.215.223.272a4.425 4.425 0 0 0 1.244.319h13.423s.597-.045 1.245-.319c.133-.057.222-.128.222-.272v-.773a.402.402 0 0 0-.249-.352l-.78-.281-.247-.089v-.052Z"
            fill="#000"
          />
          <path
            d="M89.36 117.469c1.2-.008 2.273 0 3.473-.008-.476.227-.846.452-1.984.452-.42 0-1.083-.091-1.5-.262-.155-.063-.125-.185.01-.182Z"
            fill="url(#z)"
          />
          <path
            d="M87.557 123.847h4.406c-.31.164-1.144.345-1.573.413-.716.112-1.657.151-2.528-.089-.087-.024-.356-.091-.405-.156-.054-.072-.023-.168.1-.168Z"
            fill="url(#A)"
          />
          <path
            d="M99.59 117.47c-.793-.009-1.501 0-2.295-.009.315.241.698.42 1.305.42.278 0 .744-.084 1.02-.265.102-.067.06-.149-.03-.147v.001Z"
            fill="url(#B)"
          />
          <path
            d="M92.775 111.823c0 .258-.016.517-.034.775-.028.408-.007.837-.163 1.233a1.277 1.277 0 0 1-.727.734c-.293.112-.71.071-.985-.087a.283.283 0 0 1-.153-.27c.34-3.687.435-7.533.47-10.583 0-.098.11-.168.229-.15.447.07.945.437 1.125.744.213.362.238.775.238 1.175v6.429Z"
            fill="url(#C)"
          />
          <path
            d="M97.877 104.458c.035 2.687.223 6.255.471 9.693a.227.227 0 0 1-.064.178c-.165.164-.436.165-.645.027-.25-.165-.337-.707-.344-1.008-.09-3.967-.11-6.131-.11-8.57 0-.299.689-.518.691-.32Z"
            fill="url(#D)"
          />
          <path
            d="m90.776 98.66-1.333-.013a.77.77 0 0 1-.767-.77V94.71c0-.086.07-.155.155-.155h.65c.085 0 .153.07.154.154l.002 1.915c0 .17.138.307.308.308l.834.003c.17 0 .307.138.307.308v1.11c0 .17-.139.309-.31.307Z"
            fill="url(#E)"
          />
          <path
            d="m98.71 98.66.77-.013a.77.77 0 0 0 .766-.77V94.71a.154.154 0 0 0-.155-.155h-.503a.154.154 0 0 0-.154.154l-.002 1.915c0 .17-.138.307-.308.308l-.416.003a.308.308 0 0 0-.308.308v1.11c0 .17.14.309.31.307Z"
            fill="url(#F)"
          />
          <path
            d="M92.315 100.001h-2.459a.062.062 0 0 1-.06-.063v-.311c0-.036.029-.064.063-.063l2.46.1c.032.001.057.029.057.063v.212a.063.063 0 0 1-.06.063v-.001Z"
            fill="url(#G)"
          />
          <path
            d="M97.708 100.001h1.384c.02 0 .035-.028.035-.063v-.311c0-.036-.016-.064-.036-.063l-1.274.1c-.019.002-.143.036-.143.118v.156c0 .035.016.063.035.063Z"
            fill="url(#H)"
          />
          <path
            d="M90.341 101.3c.986-.01 1.867.009 2.853-.001-.246.16-1.046.322-1.582.322-1.007 0-1.418-.175-1.418-.266 0-.058.1-.055.147-.055Z"
            fill="url(#I)"
          />
          <path
            d="M98.632 101.297h-1.73c.25.199.61.274.943.279.383.007.723-.096.833-.186.038-.031.042-.095-.046-.093Z"
            fill="url(#J)"
          />
          <path
            d="M89.735 115.226c1.161-.013 2.197.012 3.358-.001-.606.335-1.23.404-1.861.404-1.186 0-1.67-.22-1.67-.334 0-.073.117-.069.173-.069Z"
            fill="url(#K)"
          />
          <path
            d="M99.213 115.226c-.783-.013-1.482.012-2.265-.001.409.335.83.404 1.256.404.8 0 1.126-.22 1.126-.334 0-.073-.08-.069-.116-.069Z"
            fill="url(#L)"
          />
          <path
            d="M91.386 118.99a.612.612 0 0 1 .08.337c-.047.813-.354 1.723-1.337 2.121-.535.216-1.368.083-1.582.014-.259-.083-.457-.214-.481-.559-.016-.233.16-.469.292-.629.132-.16.794-.823 1.006-1.13.15-.217.443-.386.706-.41.63-.058 1.15.012 1.316.256Z"
            fill="url(#M)"
          />
          <path
            d="M98.9 119.631c.035.245.27 1.275.45 1.504.292.373.608.355.95.35.246-.004.665-.085.808-.286.118-.166.077-.428-.048-.577-.431-.512-.654-.791-1.076-1.24-.155-.166-.39-.543-.644-.497-.398.072-.48.476-.44.745v.001Z"
            fill="url(#N)"
          />
          <path
            d="M98.647 123.847c.995 0 1.947 0 2.92-.003.084 0 .151.098-.117.201-.349.134-.835.241-1.176.239-.58-.003-1.058-.146-1.627-.437Z"
            fill="url(#O)"
          />
          <path
            d="m38.982 126.687-.043-.003a6.7 6.7 0 0 1-1.949-.497c-.896-.379-.993-1.122-.993-1.423v-.984c0-.441.187-.863.492-1.169-.875-1.217-.406-2.682.124-3.369.291-.378.746-.759 1.227-1.161.298-.249.669-.559.805-.722.328-.392.64-.911.75-1.145v-.174c0-1.039.513-1.453 1.344-1.792.108-.045.259-.102.414-.16a15.847 15.847 0 0 0 1.232-6.128v-.308h-1.036c-.494 0-.982-.271-1.244-.691l-.49-.782a1.496 1.496 0 0 1-.069-1.436l.015-.028a1.75 1.75 0 0 1 .76-.758l1.47-.713a6.39 6.39 0 0 1-2.184-4.832C39.604 94.876 42.472 92 45.997 92s6.393 2.876 6.393 6.411a6.39 6.39 0 0 1-2.185 4.832l1.467.711c.315.154.606.441.761.753l.018.035a1.5 1.5 0 0 1-.07 1.437l-.49.782c-.261.419-.75.69-1.244.69h-1.036v.307c0 1.496.22 3.739 1.232 6.128.155.058.306.116.415.16.829.339 1.344.753 1.343 1.767v.199c.11.234.422.752.75 1.144.136.164.508.474.805.724.482.402.936.783 1.227 1.161.53.688 1 2.151.124 3.368.304.305.492.728.492 1.171v.983c0 .302-.097 1.044-.995 1.424a6.669 6.669 0 0 1-1.947.496l-.044.003H38.982v.001Z"
            fill="#fff"
          />
          <path
            d="m54.52 123.332-.991-.358-.314-.114v-.132s.832-.086 1.348-.802c.523-.726.175-1.611-.1-1.969-.407-.528-1.578-1.337-2.005-1.849-.484-.58-1.021-1.492-1.021-1.729v-.341c0-.359.016-.45-.617-.708-.21-.086-.613-.233-.837-.31-1.093-2.363-1.536-4.859-1.536-7.06v-1.478h2.203a.336.336 0 0 0 .256-.141l.49-.783a.33.33 0 0 0 .014-.291l-.018-.036a.577.577 0 0 0-.225-.222l-3.09-1.499a.712.712 0 0 0-.133-.045v-.187a5.243 5.243 0 0 0 3.282-4.866c0-2.894-2.34-5.241-5.227-5.241a5.233 5.233 0 0 0-5.227 5.24 5.242 5.242 0 0 0 3.283 4.865v.187a.793.793 0 0 0-.133.046l-3.09 1.499a.563.563 0 0 0-.225.222l-.018.035a.333.333 0 0 0 .014.291l.49.783a.337.337 0 0 0 .255.142h2.203v1.477c0 2.202-.443 4.697-1.535 7.061-.224.076-.627.225-.837.309-.633.259-.617.35-.617.709v.34c0 .236-.538 1.15-1.022 1.73-.427.512-1.597 1.32-2.004 1.848-.276.358-.623 1.244-.1 1.969.516.717 1.348.802 1.348.802v.132l-.313.114-.991.358a.512.512 0 0 0-.316.448v.984c0 .184.113.274.282.346a5.58 5.58 0 0 0 1.58.407h13.948s.757-.057 1.58-.407c.17-.072.282-.162.282-.346v-.984a.511.511 0 0 0-.316-.448v.002Z"
            fill="#000"
          />
          <path
            d="M38.757 123.495h4.593c-.484.178-.902.412-1.64.526a7.757 7.757 0 0 1-1.272.1 4.402 4.402 0 0 1-1.363-.214c-.09-.03-.349-.146-.422-.198-.14-.102-.12-.214.104-.214Z"
            fill="url(#P)"
          />
          <path
            d="M44.687 94.263c-2.283.765-2.91 3.061-2.78 4.324.026.246.16.938.768 1.07.911.197 1.273-.584 1.26-.702-.372-3.165 1.505-4.235 1.513-4.5.007-.24-.42-.306-.761-.192Z"
            fill="url(#Q)"
          />
          <path
            d="M44.35 105.191c.127-.044.162-.171.17-.305.028-.512-.386-.651-.826-.553-.368.082-1.27.537-1.694.747-.056.028-.053.111.006.132.483.176 1.775.181 2.346-.021h-.001Z"
            fill="url(#R)"
          />
          <path
            d="M43.35 114.205c-.07.221-.114.472.113.575.175.08.415.067.582-.019.413-.212.577-.605.634-1.068.167-1.367.261-2.755.244-4.128-.007-.622-.084-1.372-.609-1.718 0 2.608-.353 4.546-.963 6.357v.001Z"
            fill="url(#S)"
          />
          <path
            d="M43.342 117.337c-.335-.21-.795-.262-1.264-.165-.391.081-.727.246-.882.524-.217.392-1.334 1.687-1.429 1.782-.584.588-.494 1.297.017 1.437.49.135 1.07.151 1.577.152.706.001 1.368-.561 1.609-1.076.27-.578.387-.738.59-1.342.14-.422.231-1.029-.218-1.312Z"
            fill="url(#T)"
          />
          <path
            d="M41.825 115.78c.355.164.92.252 1.278.252.789 0 1.38-.176 1.69-.434-1.023.008-1.937 0-2.96.007-.115-.002-.14.115-.008.175Z"
            fill="url(#U)"
          />
          <path
            d="M50.122 123.532c1.074 0 2.127 0 3.19-.005.092 0 .074.172-.218.303-.38.171-.822.26-1.194.258-.633-.003-1.156-.186-1.778-.556Z"
            fill="url(#V)"
          />
          <path
            d="M47.883 108.457c-.155.085-.25.175-.278.522-.114 1.463.072 3.282.339 4.178.268.906.384 1.36 1.074 1.36-.85-1.989-1.136-4.328-1.136-6.06Z"
            fill="url(#W)"
          />
          <path
            d="M49.381 105.23c.155-.013.3-.048.419-.096.038-.015.084-.031.105-.062.025-.038-.026-.082-.17-.16-.278-.147-.794-.345-1.084-.454-.082-.03-.324-.119-.352.06-.02.133.033.339.096.468a.296.296 0 0 0 .148.141c.206.092.536.129.838.103Z"
            fill="url(#X)"
          />
          <path
            d="M50.374 98.267c-.09-.492-.225-.699-.32-.72-.053-.012-.094.027-.116.104-.25.936-.499 1.409-.745 1.713l-.012.014a1.867 1.867 0 0 1-.19.201.713.713 0 0 0-.074.561c.033.128.115.33.235.458.172.186.365.251.46.196.721-.897.85-2.05.762-2.527Z"
            fill="url(#Y)"
          />
          <path
            d="M49.876 118.549c.045.296.258 1.576.485 1.852.372.451.764.533 1.199.527.313-.004.864-.073 1.052-.4.124-.217.081-.566-.078-.746-.547-.617-.952-1.07-1.36-1.661-.159-.232-.478-.424-.8-.368-.505.086-.548.472-.498.797v-.001Z"
            fill="url(#Z)"
          />
          <path
            d="M50.129 115.605c-.693-.007-1.313 0-2.006-.007.275.213.61.373 1.14.373.243 0 .65-.075.891-.236.09-.059.053-.132-.025-.13Z"
            fill="url(#aa)"
          />
        </g>
        <path
          d="M73.971 24.785c-2.181.916-2.673 3.452-3.23 5.494-.8.076-1.495.284-2.385.72l-.018.025c.608-.098 1.62-.048 2.15.2-.337 1.37-.616 2.828-1.348 3.994-.828 1.423-2.96 1.576-3.965.257-.976-1.218-.276-3.338 1.169-3.867-1.605.497-2.497 2.7-1.574 4.149.976 1.597 3.5 1.915 4.941.784 1.387-1.184 1.608-3.113 1.979-4.775.034-.153.066-.306.097-.458 2.184-.095 4.8.084 6.307-1.871 2.284-2.952-.91-6.286-4.123-4.652Zm2.431 4.576c-1.313.72-2.91.715-4.383.892.24-1.034.529-2.066 1-2.994.657-1.303 2.483-2.15 3.81-1.408 1.376.831.82 2.828-.427 3.51Z"
          fill="#9245B0"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={63.344}
          y1={-23.285}
          x2={136.752}
          y2={87.616}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#9245B0" />
          <stop offset={0.302} stopColor="#8B3DAA" />
          <stop offset={0.474} stopColor="#9245B0" />
          <stop offset={0.641} stopColor="#6F3386" />
          <stop offset={0.823} stopColor="#9245B0" />
          <stop offset={0.957} stopColor="#9245B0" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={63.059}
          y1={88.681}
          x2={71.383}
          y2={88.681}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={69.609}
          y1={97.791}
          x2={73.446}
          y2={97.791}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={71.088}
          y1={92.168}
          x2={74.69}
          y2={92.168}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={76.064}
          y1={95.717}
          x2={77.638}
          y2={95.717}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={68.979}
          y1={107.436}
          x2={81.183}
          y2={107.436}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={72.47}
          y1={100.685}
          x2={80.236}
          y2={100.685}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={72.211}
          y1={113.702}
          x2={80.888}
          y2={113.702}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={76.491}
          y1={117.19}
          x2={79.608}
          y2={117.19}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={72.182}
          y1={120.138}
          x2={77.856}
          y2={120.138}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={73.034}
          y1={124.691}
          x2={80.363}
          y2={124.691}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={73.064}
          y1={130.707}
          x2={81.093}
          y2={130.707}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="p"
          x1={74.705}
          y1={119.001}
          x2={77.069}
          y2={119.001}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={58.622}
          y1={95.704}
          x2={76.12}
          y2={100.607}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={63.993}
          y1={88.782}
          x2={69.661}
          y2={88.782}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={60.88}
          y1={103.66}
          x2={62.78}
          y2={103.66}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={63.639}
          y1={110.4}
          x2={78.151}
          y2={110.4}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={64.884}
          y1={120.19}
          x2={75.562}
          y2={120.19}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={62.975}
          y1={124.511}
          x2={73.143}
          y2={124.511}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={61.882}
          y1={130.748}
          x2={73.776}
          y2={130.748}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={66.243}
          y1={119.002}
          x2={70.77}
          y2={119.002}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="y"
          x1={64.624}
          y1={94.321}
          x2={68.303}
          y2={95.236}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="z"
          x1={89.245}
          y1={117.687}
          x2={95.943}
          y2={117.687}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="A"
          x1={87.431}
          y1={124.097}
          x2={95.89}
          y2={124.097}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="B"
          x1={94.672}
          y1={117.671}
          x2={99.474}
          y2={117.671}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="C"
          x1={90.711}
          y1={109.051}
          x2={94.564}
          y2={109.051}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="D"
          x1={95.906}
          y1={109.419}
          x2={98.249}
          y2={109.419}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="E"
          x1={88.676}
          y1={96.607}
          x2={93.174}
          y2={96.607}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="F"
          x1={96.37}
          y1={96.607}
          x2={100.087}
          y2={96.607}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="G"
          x1={89.795}
          y1={99.783}
          x2={94.614}
          y2={99.783}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="H"
          x1={96.075}
          y1={99.783}
          x2={99.001}
          y2={99.783}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="I"
          x1={90.194}
          y1={101.459}
          x2={95.794}
          y2={101.459}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="J"
          x1={94.919}
          y1={101.437}
          x2={98.549}
          y2={101.437}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="K"
          x1={89.562}
          y1={115.426}
          x2={96.153}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="L"
          x1={94.328}
          y1={115.426}
          x2={99.124}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="M"
          x1={88.065}
          y1={120.141}
          x2={94.415}
          y2={120.141}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="N"
          x1={96.375}
          y1={120.184}
          x2={100.981}
          y2={120.184}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="O"
          x1={95.352}
          y1={124.064}
          x2={101.383}
          y2={124.064}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="P"
          x1={38.564}
          y1={123.808}
          x2={47.499}
          y2={123.808}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Q"
          x1={41.892}
          y1={96.949}
          x2={48.53}
          y2={96.949}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.04} stopColor="#9CAABD" />
          <stop offset={0.13} stopColor="#778291" />
          <stop offset={0.21} stopColor="#575F6A" />
          <stop offset={0.3} stopColor="#3C4149" />
          <stop offset={0.4} stopColor="#26292E" />
          <stop offset={0.51} stopColor="#151719" />
          <stop offset={0.63} stopColor="#090A0B" />
          <stop offset={0.77} stopColor="#020202" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="R"
          x1={41.959}
          y1={104.824}
          x2={46.741}
          y2={104.824}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="S"
          x1={43.294}
          y1={111.34}
          x2={46.34}
          y2={111.34}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="T"
          x1={39.364}
          y1={119.096}
          x2={47.411}
          y2={119.096}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="U"
          x1={41.736}
          y1={115.815}
          x2={47.443}
          y2={115.815}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="V"
          x1={46.558}
          y1={123.808}
          x2={53.082}
          y2={123.808}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="W"
          x1={45.986}
          y1={111.629}
          x2={48.897}
          y2={111.462}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="X"
          x1={46.517}
          y1={104.824}
          x2={49.771}
          y2={104.824}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="Y"
          x1={47.232}
          y1={99.179}
          x2={50.268}
          y2={99.179}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="Z"
          x1={46.754}
          y1={119.335}
          x2={52.44}
          y2={119.335}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="aa"
          x1={45.832}
          y1={115.784}
          x2={50.027}
          y2={115.784}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h143.327v160H0z" />
        </clipPath>
        <filter
          id="c"
          x={12.748}
          y={14.126}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={12} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="shape" result="effect1_innerShadow_144_33893" />
        </filter>
      </defs>
    </svg>
  ),
  // -------------------------------------------------------SILVER:SVG------------------------------------------------------------------------------------------------------------------------------------------------------
  silver: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="11 0 120 160"
    >
      <g clipPath="url(#a)">
        <path
          d="M139.276 89.662a19.152 19.152 0 0 0 4.051-3.131v24.582a17.78 17.78 0 0 1-8.89 15.394L80.55 157.618a17.77 17.77 0 0 1-17.772 0L8.89 126.507A17.78 17.78 0 0 1 0 111.113V86.531a19.08 19.08 0 0 0 4.051 3.131l58.044 33.512a19.133 19.133 0 0 0 19.141 0l58.042-33.512h-.002Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.887v32.62a19.087 19.087 0 0 1-4.051 3.131L81.234 118.15a19.128 19.128 0 0 1-19.141 0L4.051 84.64A19.212 19.212 0 0 1 0 81.51v-32.62c0-6.352 3.39-12.22 8.89-15.396L62.778 2.382a17.773 17.773 0 0 1 17.774 0l53.887 31.113a17.774 17.774 0 0 1 8.89 15.392h-.002Z"
          fill="url(#b)"
        />
        <g filter="url(#c)">
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="d"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <path
            d="M52.478 59.587a7.367 7.367 0 0 1-2.033-.278c-.648-.194-1.17-.442-1.566-.745l.695-1.541c.379.27.825.492 1.339.67a5.114 5.114 0 0 0 1.578.252c.404 0 .728-.038.973-.114.252-.084.437-.198.555-.341a.753.753 0 0 0 .177-.492.65.65 0 0 0-.278-.556 2.118 2.118 0 0 0-.732-.341 11.06 11.06 0 0 0-1.01-.253 14.317 14.317 0 0 1-1.1-.303 4.686 4.686 0 0 1-.997-.455 2.295 2.295 0 0 1-.745-.732c-.185-.303-.278-.69-.278-1.162 0-.505.135-.964.404-1.377.278-.42.69-.753 1.238-.997.556-.253 1.25-.38 2.084-.38.555 0 1.103.068 1.641.203.54.126 1.015.32 1.427.58l-.63 1.554a5.172 5.172 0 0 0-1.239-.518 4.4 4.4 0 0 0-1.212-.176c-.396 0-.72.046-.972.139-.253.092-.434.214-.543.366a.807.807 0 0 0-.165.505.67.67 0 0 0 .278.556c.185.134.43.244.733.328.303.084.635.169.997.253.37.084.737.18 1.1.29.37.11.706.257 1.01.442.303.185.547.43.732.733.194.303.29.686.29 1.149 0 .497-.139.951-.416 1.364-.278.413-.695.745-1.25.998-.548.252-1.242.379-2.085.379ZM57.627 59.435v-8.84h2.046v8.84h-2.046ZM61.771 59.435v-8.84h2.046v7.173h4.433v1.667h-6.479ZM71.441 59.435l-3.814-8.84h2.21l3.334 7.83h-1.3l3.384-7.83h2.034l-3.827 8.84h-2.02ZM79.909 54.156h4.256v1.591h-4.256v-1.591Zm.151 3.637h4.812v1.642h-6.845v-8.84h6.68v1.641H80.06v5.557ZM86.5 59.435v-8.84h3.826c.792 0 1.474.13 2.046.39.573.254 1.015.62 1.326 1.1.312.48.468 1.052.468 1.717 0 .657-.156 1.225-.468 1.705-.311.472-.753.834-1.326 1.086-.572.253-1.254.38-2.046.38h-2.69l.91-.897v3.359H86.5Zm5.62 0-2.21-3.208h2.185l2.235 3.208h-2.21Zm-3.574-3.132-.91-.96h2.577c.631 0 1.103-.135 1.414-.404.312-.278.468-.657.468-1.137 0-.488-.156-.867-.468-1.136-.311-.27-.783-.404-1.414-.404h-2.577l.91-.973v5.014ZM50.805 46.862c-.256 0-.494-.04-.715-.123a1.691 1.691 0 0 1-.947-.905 1.74 1.74 0 0 1-.133-.686c0-.25.044-.478.133-.687a1.69 1.69 0 0 1 .379-.544 1.7 1.7 0 0 1 .573-.355c.218-.086.456-.128.715-.128.287 0 .546.05.776.151.234.098.43.243.588.436l-.493.454a1.124 1.124 0 0 0-.379-.288 1.163 1.163 0 0 0-.88-.024.967.967 0 0 0-.337.218 1.025 1.025 0 0 0-.222.336c-.05.13-.076.273-.076.431a1.026 1.026 0 0 0 .298.767.966.966 0 0 0 .337.218c.129.05.271.076.426.076.164 0 .315-.032.454-.095.14-.066.266-.166.38-.298l.492.454c-.158.193-.354.34-.587.44-.231.102-.491.152-.782.152ZM53.398 44.826h1.596v.597h-1.596v-.597Zm.056 1.364h1.805v.616h-2.567V43.49h2.505v.616h-1.743v2.084ZM55.87 46.806V43.49h1.434c.297 0 .553.05.767.147.215.095.381.232.498.412.117.18.175.395.175.644 0 .247-.058.46-.175.64a1.12 1.12 0 0 1-.498.407c-.214.095-.47.142-.767.142h-1.009l.341-.336v1.26h-.767Zm2.107 0-.829-1.203h.82l.838 1.203h-.83Zm-1.34-1.175-.342-.36h.967c.236 0 .413-.05.53-.151a.542.542 0 0 0 .175-.427.533.533 0 0 0-.175-.426c-.117-.1-.294-.151-.53-.151h-.967l.341-.365v1.88ZM59.992 46.806v-2.69h-1.06v-.626h2.889v.626H60.76v2.69h-.768ZM62.233 46.806V43.49h.768v3.316h-.768ZM64.498 44.982h1.591v.616h-1.591v-.616Zm.056 1.824h-.767V43.49h2.506v.616h-1.739v2.7ZM66.812 46.806V43.49h.767v3.316h-.767ZM69.072 44.826h1.596v.597h-1.596v-.597Zm.056 1.364h1.805v.616h-2.567V43.49h2.505v.616H69.13v2.084ZM71.543 46.806V43.49h1.506c.36 0 .678.07.952.209.275.136.49.327.644.573.155.246.233.538.233.876 0 .335-.078.627-.233.876-.154.246-.369.44-.644.578a2.123 2.123 0 0 1-.952.204h-1.506Zm.768-.63h.7c.222 0 .413-.041.574-.123a.906.906 0 0 0 .379-.36 1.05 1.05 0 0 0 .137-.545c0-.212-.046-.393-.138-.545a.877.877 0 0 0-.378-.355 1.208 1.208 0 0 0-.573-.128h-.701v2.056ZM78.384 46.862c-.256 0-.494-.04-.715-.123a1.691 1.691 0 0 1-.947-.905 1.74 1.74 0 0 1-.133-.686c0-.25.044-.478.133-.687a1.69 1.69 0 0 1 .379-.544 1.7 1.7 0 0 1 .573-.355c.217-.086.456-.128.715-.128.287 0 .546.05.776.151.234.098.43.243.588.436l-.493.454a1.124 1.124 0 0 0-.379-.288 1.163 1.163 0 0 0-.88-.024.967.967 0 0 0-.337.218 1.025 1.025 0 0 0-.222.336c-.051.13-.076.273-.076.431a1.026 1.026 0 0 0 .298.767.966.966 0 0 0 .336.218c.13.05.272.076.427.076.164 0 .315-.032.454-.095.14-.066.266-.166.38-.298l.492.454c-.158.193-.354.34-.588.44-.23.102-.49.152-.781.152ZM81.812 46.862c-.262 0-.505-.042-.73-.127a1.753 1.753 0 0 1-.578-.36 1.692 1.692 0 0 1-.378-.545 1.728 1.728 0 0 1-.133-.682c0-.246.044-.474.133-.682.091-.208.22-.39.383-.545a1.75 1.75 0 0 1 .578-.36c.221-.085.461-.127.72-.127.262 0 .502.042.72.128a1.7 1.7 0 0 1 .957.904c.091.205.137.433.137.682a1.657 1.657 0 0 1-.52 1.231c-.162.152-.353.27-.574.356a1.947 1.947 0 0 1-.715.127Zm-.005-.653c.148 0 .284-.025.407-.076a.976.976 0 0 0 .55-.554c.053-.13.08-.273.08-.431 0-.158-.027-.302-.08-.43a.965.965 0 0 0-.218-.337.928.928 0 0 0-.327-.218 1.1 1.1 0 0 0-.412-.076 1.1 1.1 0 0 0-.412.076.99.99 0 0 0-.327.218 1.025 1.025 0 0 0-.222.336c-.051.13-.076.273-.076.431 0 .155.025.298.076.431.053.13.126.242.217.336a.976.976 0 0 0 .332.218 1.1 1.1 0 0 0 .412.076ZM83.716 46.806l1.477-3.316h.758l1.482 3.316h-.805l-1.212-2.927h.303l-1.217 2.927h-.786Zm.738-.71.204-.583h1.705l.208.582h-2.117ZM89.317 46.862c-.255 0-.494-.04-.715-.123a1.69 1.69 0 0 1-.947-.905 1.738 1.738 0 0 1-.133-.686c0-.25.045-.478.133-.687.092-.208.218-.39.379-.544a1.7 1.7 0 0 1 .573-.355c.218-.086.456-.128.715-.128.287 0 .546.05.777.151.234.098.43.243.587.436l-.492.454a1.126 1.126 0 0 0-.38-.288 1.163 1.163 0 0 0-.88-.024.967.967 0 0 0-.336.218 1.025 1.025 0 0 0-.223.336c-.05.13-.076.273-.076.431a1.026 1.026 0 0 0 .298.767.966.966 0 0 0 .337.218c.13.05.271.076.426.076.164 0 .316-.032.455-.095.139-.066.265-.166.379-.298l.492.454c-.158.193-.353.34-.587.44-.23.102-.491.152-.782.152ZM93.478 43.49h.767v3.316h-.767V43.49Zm-1.506 3.316h-.768V43.49h.768v3.316Zm1.562-1.36h-1.62v-.648h1.62v.648Z"
            fill="#A7A4A4"
          />
          <path
            d="M122.112 137.805H88.461l-3.092-10.066h27.468l9.275 10.066ZM140.304 127.739h-27.467l-6.396-6.941h23.203l10.66 6.941ZM93.349 153.719H49.92l4.888-15.914h33.652l4.888 15.914ZM54.81 137.805H21.157l9.275-10.066h27.468l-3.092 10.066ZM30.433 127.739H2.966l10.66-6.941h23.203l-6.396 6.941Z"
            fill="#000"
          />
          <path
            d="m41.122 124.85-.035-.003a5.34 5.34 0 0 1-1.635-.429 1.206 1.206 0 0 1-.718-1.102v-.785c0-.344.142-.674.377-.916a2.627 2.627 0 0 1-.18-.25c-.769-1.193-.265-2.533.109-3.076.244-.354.593-.795.932-1.221.21-.264.411-.518.564-.724.295-.395.475-1.08.494-1.253v-.164c.003-.49.184-.798.433-1.011a1.242 1.242 0 0 1-.356-.413 32.98 32.98 0 0 1-.73-1.433l-.029-.061c-.23-.503-.378-.957-.005-1.84l.041-.098c.449-1.066 1.498-3.563 5.215-7.465.051-.055.097-.103.137-.148h-.052c-.699.046-1.398.123-2.19.543-.183.157-.303.382-.44.638-.145.268-.308.571-.572.816-.446.412-1.254.498-1.854.498-1.182 0-1.873-.342-2.053-1.017a1.326 1.326 0 0 1-.045-.307c-.31 0-.601-.074-.864-.22-.304-.163-.83-.445-.975-3.255-.07-.485.061-1.212.66-1.796l.083-.08c.566-.551 2.29-2.227 3.254-3.886.162-.28.37-.548.617-.798.38-.385.75-.677 1.034-.887-.124-.144-.25-.284-.372-.423-.773-.87-1.331-1.5-1.24-2.252.042-.353.232-.663.534-.87.183-.127.523-.362 1.156-.362.582 0 1.595.17 4.283 1.47.369.042.72.095 1.07.162.828.161 1.616.403 2.349.719l-.013-.19 1.566 1.02c.534.348 1.038.75 1.499 1.196l.174.168.07.23.051.175.108-.521 1.234 1.986c.457.735.85 1.557 1.167 2.442l.08.22-.035.232a13.297 13.297 0 0 1-.347 1.633l.776-.969.324 2.097c.027.174.053.349.075.528.114.883.154 1.921.117 3.001l-.008.25-.133.212a13.5 13.5 0 0 1-1.175 1.602l1.306-.733-.312 1.913c-.155.948-.36 1.874-.61 2.759l.087-.023-.634 1.698c-.177.473-.37.932-.571 1.365a1.242 1.242 0 0 1-.408.487c.24.211.413.515.416.993v.169c.02.173.2.858.494 1.253.154.207.355.46.564.724.338.426.688.867.932 1.222.374.542.878 1.882.11 3.075a2.761 2.761 0 0 1-.18.25c.233.242.375.572.375.916v.785c0 .476-.282.909-.718 1.102a5.34 5.34 0 0 1-1.635.429l-.035.003H41.122Z"
            fill="#fff"
          />
          <path
            d="m56.033 122.173-.793-.285-.25-.091v-.105s.77-.089 1.248-.831c.484-.752.163-1.67-.093-2.041-.377-.548-1.08-1.386-1.476-1.917-.448-.601-.68-1.548-.68-1.793v-.182c-.001-.241-.023-.314-.494-.507-.097-.041-.5-.188-.539-.202l-.009-.003a.526.526 0 0 1-.257-.465c0-.29.208-.523.467-.523h.626a.314.314 0 0 0 .285-.179c.197-.423.378-.857.543-1.298-.825.221-1.73.375-2.72.444a17.732 17.732 0 0 0 3.133-1.667c.304-1.005.534-2.029.698-3.034-2.218 1.244-4.78 1.666-4.78 1.666 2.62-1.527 4.188-3.345 5.09-4.792a17.954 17.954 0 0 0-.11-2.85 19.774 19.774 0 0 0-.072-.504c-1.848 2.307-3.959 3.395-3.959 3.395 2.128-2.074 2.932-4.586 3.206-6.436-.309-.859-.675-1.61-1.082-2.264-.495 2.395-1.556 3.71-1.556 3.71.688-2.195.508-4.108.063-5.57a9.047 9.047 0 0 0-1.36-1.084c.073 1.09-.023 2.403-.389 3.462.008-1.803-.442-3.19-.957-4.188-.797-.35-1.563-.56-2.22-.688a13.443 13.443 0 0 0-1.158-.168c-3.787-1.849-4.304-1.489-4.649-1.251-.541.374.6 1.35 1.575 2.546.229.28.23.473 0 .648-.194.147-.778.501-1.396 1.127a3.037 3.037 0 0 0-.474.61c-1.08 1.862-3.015 3.7-3.492 4.165-.497.486-.382 1.028-.382 1.028s.115 2.334.497 2.54c.708.392 1.596-.479 1.798-.256.163.18-.554.928-.44 1.357.115.43 2.009.411 2.372.075.364-.336.497-1.073 1.129-1.551.998-.55 1.873-.642 2.653-.693.146-.01.926.008 1.133.214.387.385.172.817-.488 1.509-3.717 3.902-4.645 6.27-5.072 7.283-.258.609-.155.759.023 1.151.165.364.534 1.062.703 1.379.055.102.161.166.276.166h.589c.257 0 .466.233.466.522a.524.524 0 0 1-.264.468c-.038.014-.442.161-.539.202-.471.193-.493.266-.495.508v.181c0 .245-.23 1.192-.679 1.793-.396.531-1.099 1.369-1.476 1.917-.255.371-.578 1.289-.093 2.041a1.869 1.869 0 0 0 1.248.831v.105l-.25.091-.793.286a.408.408 0 0 0-.253.357v.785c0 .109.065.206.164.249a4.431 4.431 0 0 0 1.326.351h13.639s.644-.048 1.326-.351a.273.273 0 0 0 .164-.249v-.785a.406.406 0 0 0-.252-.357l.001-.002Z"
            fill="#000"
          />
          <path
            d="M46.124 91.638c-.26-.14-.905-.489-1.12-.61.11.104.73.672.995.935.03.03.07.046.113.045.65-.01 1.295-.032 1.945-.042a20.181 20.181 0 0 0-1.701-.256.623.623 0 0 1-.232-.072Z"
            fill="url(#e)"
          />
          <path
            d="M48.59 95.804c.174.61.407 1.717.256 2.712-.127.84-.584 1.57-1.03 2.172 1.212-.9 1.352-1.942 1.382-2.225.124-1.16-.237-1.91-.608-2.659Z"
            fill="url(#f)"
          />
          <path
            d="M50.35 95.62c-.082-1.357-.377-2.193-.607-2.685-.217-.189-.537-.344-.715-.368.496.635.969 1.566 1.322 3.053Z"
            fill="url(#g)"
          />
          <path
            d="M51.885 99.034c.079-.436.496-2.69.066-4.64.034.031.287.332.423.55.255 1.397-.082 3.141-.489 4.09Z"
            fill="url(#h)"
          />
          <path
            d="M50.941 108.392c1.744-1.049 3.635-2.766 4.454-4.123.045-.692.009-1.031-.019-1.925-.127.706-.373 1.898-.373 1.898s-1.278 2.153-4.062 4.15Z"
            fill="url(#i)"
          />
          <path
            d="M51.73 103.629c1.623-1.718 2.413-3.3 2.847-5.161a7.4 7.4 0 0 0-.496-1.332c.085.378.134.835.14 1.406-.231 1.37-1.068 3.308-2.491 5.088v-.001Z"
            fill="url(#j)"
          />
          <path
            d="M51.906 111.577a25.224 25.224 0 0 0 2.66-1.455c.204-.613.36-1.177.522-1.707-.135.31-.426.857-.604 1.185-.1.184-.235.343-.4.47-.358.277-1.094.821-2.178 1.508v-.001Z"
            fill="url(#k)"
          />
          <path
            d="M53.966 112.251c-.092.2-.14.324-.267.53a.225.225 0 0 1-.19.106c-.262.011-.45-.004-.686-.004.22-.078.484-.099.68-.207.196-.107.32-.245.463-.425Z"
            fill="url(#l)"
          />
          <path
            d="M50.672 114.605c.574-.008 1.876-.006 1.978-.006.265 0 .028.298-.804.298-.461 0-.874-.133-1.173-.292Z"
            fill="url(#m)"
          />
          <path
            d="M53.07 116.479c.038.03.295.627.381.804.307.637 1.106 1.723 1.166 1.829.077.139.031.323-.056.453-.106.158-.302.225-.484.28-.218.064-.974.106-1.457-.284-.546-.44-.58-1.104-.618-1.35-.07-.441-.028-1.273.121-1.618.131-.303.657-.339.947-.114Z"
            fill="url(#n)"
          />
          <path
            d="M52.274 122.333c.979 0 1.914 0 2.871-.003.083 0 .148.1-.114.204-.344.137-.821.244-1.157.243-.57-.003-1.04-.149-1.6-.444Z"
            fill="url(#o)"
          />
          <path
            d="M51.208 114.123c-.013.013-.009.049.006.049.42-.007.604-.004.8-.006.03 0 .054-.044.054-.098 0-.116 0-.206-.002-.324 0-.052-.023-.096-.052-.097-.062-.002-.19-.007-.253.014-.032.011-.214.126-.553.461v.001Z"
            fill="url(#p)"
          />
          <path
            d="M38.46 102.109a6.853 6.853 0 0 0-.153-.963 6.893 6.893 0 0 1-.151-.954 1.789 1.789 0 0 1 .053-.587.925.925 0 0 1 .366-.503c.093-.06.18-.113.263-.165.192-.118.358-.22.524-.351a9.143 9.143 0 0 0 2.302-2.66c.09-.16.174-.326.255-.486.136-.27.282-.547.454-.8.407-.599 1.74-1.394 2.312-1.551-.457.482-.448.874-.442 1.095.182.033.597.146.843.462.15.192.211.415.184.665-.282-.306-.962-.58-1.46-.58a.908.908 0 0 0-.28.038c-.49.158-.682.437-.947.824-.184.269-.35.58-.512.882-.084.157-.167.313-.252.46-.452.786-1.135 1.511-2.15 2.282a.859.859 0 0 1-.558.184c-.035 0-.068 0-.1-.002a1.938 1.938 0 0 0-.08-.002.386.386 0 0 0-.15.023c-.237.1-.31.449-.286.665.03.272.16.435.35.435a.362.362 0 0 0 .143-.032c.213-.091.406-.313.591-.675.143.402.023.795-.329 1.062-.127.097-.25.126-.367.154l-.102.026v.024c.003.557-.243.987-.321 1.036v-.006Zm6.847-6.297a1.865 1.865 0 0 1-.528.692c-.43.328-.986.359-1.494.257.442.504 1.402.503 1.83-.016a.993.993 0 0 0 .225-.643 1.317 1.317 0 0 0-.033-.29Z"
            fill="url(#q)"
          />
          <path
            d="M43.898 92.353c.075.084.147.144.258.163.112.019.26.008.385-.076.135-.09-.13-.333-.258-.432-1.046-.806-1.832-1.378-1.946-1.346.392.424.686.71 1.561 1.69Z"
            fill="url(#r)"
          />
          <path
            d="M40.037 103.329c.272-.034.479-.223.593-.475.113-.251.16-.644.16-1.023-.08.134-.125.239-.172.332l-.2.404-.38.762Z"
            fill="url(#s)"
          />
          <path
            d="M43.471 110.843c-.035.353.163.888.634 1.612a.156.156 0 0 1-.129.242c-.261 0-.586-.001-.742-.004a.554.554 0 0 1-.458-.26c-.333-.536-.404-.665-.63-1.151a.79.79 0 0 1-.027-.589c.616-1.797 1.5-3.007 2.528-4.361 1.187-1.563 2.663-2.655 3.128-3.916.137.631-.064 1.408-.762 2.292-1.379 1.746-3.268 4.309-3.542 6.135Z"
            fill="url(#t)"
          />
          <path
            d="M47.218 114.599c-.604.186-1.514.375-2.324.375-.594 0-1.16-.069-1.72-.216-.088-.023-.188-.062-.18-.106.011-.053.202-.052.285-.052H47.22v-.001Z"
            fill="url(#u)"
          />
          <path
            d="M45.277 118.71c-.151.294-.308.594-.556.818-.302.272-.716.406-1.13.447-.508.052-.834.052-1.314-.124-.184-.068-.367-.153-.505-.288a.638.638 0 0 1-.184-.515c.053-.543.935-1.325 1.373-2.258.125-.265.267-.545.525-.698.194-.115.512-.143.74-.14.486.004.834.053 1.155.313.329.266.303 1.655-.104 2.445Z"
            fill="url(#v)"
          />
          <path
            d="M40.967 122.333h4.516c-.53.207-.86.304-1.613.42-.371.057-.802.085-1.25.081a5.317 5.317 0 0 1-1.34-.171 3.002 3.002 0 0 1-.416-.159c-.138-.081-.118-.171.103-.171Z"
            fill="url(#w)"
          />
          <path
            d="M45.772 114.123c.028.013.02.049-.012.049-.866-.007-1.246-.004-1.653-.006-.06 0-.11-.044-.11-.098 0-.116.002-.206.003-.324.001-.052.048-.096.108-.097.127-.002.275.024.405.034.069.006.56.106 1.26.441v.001Z"
            fill="url(#x)"
          />
          <path
            d="M43.47 96.39a.192.192 0 0 1-.088-.018c-.092-.038-.14-.154-.14-.244 0-.193.124-.398.184-.467a.683.683 0 0 1 .499-.228.6.6 0 0 1 .203.035.835.835 0 0 0-.328.26.851.851 0 0 0-.142.386l-.009.075c-.01.103-.02.193-.136.2a.614.614 0 0 1-.044.002v-.002Z"
            fill="url(#y)"
          />
          <path
            d="m87.715 126.324-.035-.002a5.276 5.276 0 0 1-1.534-.39c-.706-.299-.782-.881-.782-1.117v-.773c0-.339.14-.663.371-.901a2.674 2.674 0 0 1-.178-.246c-.672-1.044-.385-2.181.108-2.896.255-.371.597-.678.898-.947.228-.204.443-.397.575-.574.042-.056.087-.122.135-.197v-.299c0-.684.225-1.06.671-1.347a1.722 1.722 0 0 1-.298-.969c0-.737.463-1.369 1.112-1.619.217-1.838.506-5.347.553-11.246a1.527 1.527 0 0 1-.453-1.749 1.502 1.502 0 0 1-.683-.998 1.691 1.691 0 0 1-1.073-1.573V93.34h14.717v5.142a1.69 1.69 0 0 1-1.072 1.573 1.499 1.499 0 0 1-.683.998 1.525 1.525 0 0 1-.453 1.75c.047 5.899.336 9.408.553 11.245.65.251 1.112.882 1.112 1.619 0 .358-.11.692-.298.969.446.288.671.663.67 1.347v.299c.048.074.093.14.135.196.133.178.348.37.576.575.301.269.642.575.898.946.493.716.78 1.852.108 2.896-.057.088-.117.17-.178.246.23.239.37.563.37.901v.773c0 .236-.076.818-.782 1.118a5.303 5.303 0 0 1-1.535.389l-.034.003H87.715Z"
            fill="#fff"
          />
          <path
            d="M101.363 123.268v-.052s.759-.088 1.229-.818c.477-.74.16-1.513-.092-1.878-.371-.539-1.063-.969-1.452-1.492a4.702 4.702 0 0 1-.253-.379.464.464 0 0 1-.066-.238v-.399c0-.427.019-.535-.735-.842-.141-.058-.28-.113-.408-.163h.005v-.53a.812.812 0 0 0-.049-1.625h-.201c-.213-1.54-.615-5.378-.653-12.624a.61.61 0 0 0 .568-.606.61.61 0 0 0-.571-.607 82.713 82.713 0 0 0-.007-.657h.602a.576.576 0 0 0 .574-.577v-.528h.276a.77.77 0 0 0 .77-.77V94.26h-2.497v2h-1.445v-2h-4.995v2H90.52v-2H88.02v4.223c0 .426.346.77.77.77h.277v.528c0 .319.257.577.574.577h.602c-.003.222-.006.441-.007.657a.608.608 0 0 0-.004 1.213c-.037 7.246-.439 11.084-.653 12.624h-.2a.813.813 0 0 0-.049 1.625v.53h.004a20.1 20.1 0 0 0-.408.163c-.754.307-.735.415-.735.842v.399a.459.459 0 0 1-.066.238 4.84 4.84 0 0 1-.252.379c-.39.522-1.082.953-1.453 1.492-.251.365-.568 1.138-.092 1.878.47.73 1.229.818 1.229.818v.103l-.247.09-.78.281a.4.4 0 0 0-.249.352v.772c0 .145.09.216.222.272a4.384 4.384 0 0 0 1.245.319h13.423s.596-.044 1.245-.319c.133-.056.222-.127.222-.272v-.772a.4.4 0 0 0-.249-.352l-.78-.281-.247-.09v-.052.001Z"
            fill="#000"
          />
          <path
            d="M89.36 117.47c1.2-.009 2.273 0 3.473-.008-.476.226-.846.452-1.984.452-.42 0-1.083-.091-1.5-.262-.155-.063-.125-.185.01-.183v.001Z"
            fill="url(#z)"
          />
          <path
            d="M87.557 123.848h4.406c-.31.164-1.144.345-1.573.413-.716.112-1.657.151-2.528-.089-.087-.024-.356-.091-.405-.156-.054-.072-.023-.168.1-.168Z"
            fill="url(#A)"
          />
          <path
            d="M99.59 117.47c-.793-.009-1.501.001-2.295-.008.315.24.698.42 1.305.42.278 0 .744-.085 1.02-.266.102-.066.06-.149-.03-.146Z"
            fill="url(#B)"
          />
          <path
            d="M92.775 111.823c0 .259-.016.517-.034.775-.028.409-.007.838-.163 1.233a1.282 1.282 0 0 1-.727.735c-.293.111-.71.07-.985-.087a.284.284 0 0 1-.153-.271c.34-3.686.435-7.533.47-10.583 0-.097.11-.168.229-.149.447.069.945.436 1.125.744.213.361.238.774.238 1.174v6.429Z"
            fill="url(#C)"
          />
          <path
            d="M97.877 104.458c.035 2.687.223 6.256.471 9.694a.227.227 0 0 1-.064.178c-.165.163-.436.164-.645.027-.25-.166-.337-.708-.344-1.009-.09-3.967-.11-6.13-.11-8.57 0-.299.689-.518.691-.32Z"
            fill="url(#D)"
          />
          <path
            d="m90.776 98.66-1.333-.012a.77.77 0 0 1-.767-.77v-3.169c0-.085.07-.154.155-.154h.65c.085 0 .153.069.154.153l.002 1.915c0 .17.138.308.308.308l.834.004c.17 0 .307.138.307.308v1.11c0 .17-.139.308-.31.307Z"
            fill="url(#E)"
          />
          <path
            d="m98.71 98.66.769-.012a.771.771 0 0 0 .767-.77v-3.169a.154.154 0 0 0-.155-.154h-.503a.154.154 0 0 0-.154.153l-.002 1.915c0 .17-.138.308-.308.308l-.416.004a.308.308 0 0 0-.308.308v1.11c0 .17.139.308.31.307Z"
            fill="url(#F)"
          />
          <path
            d="M92.315 100.001h-2.459a.062.062 0 0 1-.06-.063v-.31c0-.037.029-.065.063-.063l2.46.1c.032 0 .057.028.057.062v.212a.062.062 0 0 1-.06.063v-.001Z"
            fill="url(#G)"
          />
          <path
            d="M97.708 100.001h1.384c.019 0 .035-.028.035-.063v-.31c0-.037-.017-.065-.036-.064l-1.274.1c-.019.002-.143.037-.143.119v.156c0 .034.016.062.035.062Z"
            fill="url(#H)"
          />
          <path
            d="M90.34 101.3c.987-.01 1.868.01 2.854 0-.246.159-1.046.322-1.582.322-1.007 0-1.418-.175-1.418-.266 0-.059.1-.055.147-.056Z"
            fill="url(#I)"
          />
          <path
            d="M98.632 101.297h-1.73c.25.2.61.274.943.28.382.006.723-.096.833-.187.038-.031.042-.095-.046-.093Z"
            fill="url(#J)"
          />
          <path
            d="M89.735 115.226c1.161-.012 2.197.012 3.358-.001-.606.335-1.23.404-1.861.404-1.186 0-1.67-.22-1.67-.334 0-.073.117-.068.173-.069Z"
            fill="url(#K)"
          />
          <path
            d="M99.213 115.226c-.783-.012-1.482.012-2.265-.001.409.335.83.404 1.256.404.8 0 1.126-.22 1.126-.334 0-.073-.08-.068-.116-.069h-.001Z"
            fill="url(#L)"
          />
          <path
            d="M91.386 118.991a.609.609 0 0 1 .08.336c-.048.813-.354 1.724-1.337 2.121-.535.216-1.368.084-1.582.015-.259-.084-.457-.215-.481-.559-.016-.234.16-.47.292-.63.132-.16.794-.822 1.006-1.129.15-.217.443-.387.706-.411.63-.057 1.15.013 1.315.256l.001.001Z"
            fill="url(#M)"
          />
          <path
            d="M98.9 119.631c.035.245.27 1.275.45 1.504.292.374.607.355.95.351.246-.004.665-.086.808-.287.118-.165.077-.427-.048-.577-.431-.512-.654-.791-1.076-1.24-.155-.165-.39-.542-.644-.497-.398.072-.48.477-.44.746Z"
            fill="url(#N)"
          />
          <path
            d="M98.646 123.848c.996 0 1.948 0 2.921-.004.084 0 .15.099-.117.201-.349.135-.835.241-1.176.24-.58-.003-1.058-.147-1.628-.437Z"
            fill="url(#O)"
          />
          <path
            d="m61.666 135.669-.042-.003a6.575 6.575 0 0 1-1.914-.486c-.88-.374-.976-1.099-.976-1.394v-.963c0-.388.148-.761.395-1.049a3.932 3.932 0 0 1-.425-.54c-1.061-1.625-.363-3.454.154-4.195.348-.497.919-1.067 1.47-1.619.422-.422.858-.858 1.08-1.149.151-.201.315-.444.478-.707l.001-.299v-.869c0-1.068.26-1.728 1.689-2.363.216-.096.436-.193.644-.279.784-2.217 2.57-8.11 2.505-15.553-.024-2.748-.286-5.595-.728-7.97h-.834a2.131 2.131 0 0 1-.708-4.141c.073-.546.432-1.099.979-1.445a2.03 2.03 0 0 1 .261-3.02c-.835-1.866-2.394-5.43-3.114-7.632-.384-1.173-.068-2.103.966-2.842 1.071-.766 2.579-1.405 4.253-1.816.01-.08.025-.161.044-.239l-.653-.331.63-1.563-2.037.583V66.09l2.037.583-.63-1.562.936-.476a6.41 6.41 0 0 1 1.134-.418l-.001-.076a2.377 2.377 0 0 1 2.374-2.374 2.377 2.377 0 0 1 2.375 2.374c0 .025 0 .05-.002.076.66.184 1.067.385 1.134.419l.937.476-.63 1.561 2.036-.583v7.696l-2.036-.583.63 1.563-.654.331c.02.078.034.158.044.239 1.674.41 3.182 1.051 4.253 1.816 1.034.739 1.35 1.669.966 2.842-.715 2.186-2.257 5.716-3.097 7.592a2.031 2.031 0 0 1 .287 3.09c.523.348.864.885.935 1.416a2.131 2.131 0 0 1-.71 4.141h-.832c-.44 2.376-.703 5.224-.727 7.97-.065 7.442 1.721 13.336 2.505 15.554.208.086.428.183.643.279 1.428.636 1.69 1.294 1.689 2.363v.869c0 .104 0 .204.002.299.163.264.327.506.478.707.221.292.657.728 1.079 1.15.551.551 1.122 1.122 1.47 1.619.517.741 1.215 2.57.155 4.194a3.861 3.861 0 0 1-.425.54c.246.288.395.661.395 1.049v.964c0 .295-.095 1.02-.975 1.393a6.571 6.571 0 0 1-1.915.486l-.042.003H61.665l.001-.002Z"
            fill="#fff"
          />
          <path
            d="M81.799 131.792s1.115-.127 1.807-1.185c.7-1.073.235-2.382-.135-2.911-.546-.781-1.95-1.977-2.523-2.734-.21-.279-.429-.609-.627-.94a.576.576 0 0 1-.081-.286 22.94 22.94 0 0 1-.004-.471v-.824c0-.64.026-.901-1.009-1.361-.405-.18-.798-.351-1.077-.446h.001c-.706-1.88-2.824-8.22-2.751-16.444.024-2.739.29-6.14.934-9.105h1.77c.54 0 .983-.443.983-.984v-.005a.986.986 0 0 0-.983-.983h-.422v-.819c0-.27-.34-.86-1.087-.86h-.614v-1.296h.447a.888.888 0 0 0 0-1.775h-.447s2.639-5.734 3.618-8.727c.236-.72.071-1.115-.543-1.554-1.276-.913-3.16-1.558-5-1.872a.872.872 0 0 0 .282-.636c0-.495-.432-.901-.96-.901h-.166c.876-.184 1.41-.456 1.41-.456l-1.115-2.764 2.832.811v-4.656l-2.832.81 1.116-2.763s-.864-.44-2.195-.578a1.229 1.229 0 1 0-1.585 0c-1.332.14-2.195.578-2.195.578l1.115 2.764-2.832-.811v4.656l2.832-.81-1.115 2.763s.535.272 1.41.456h-.166c-.528 0-.96.406-.96.901a.87.87 0 0 0 .281.636c-1.84.314-3.723.96-5 1.872-.613.439-.778.835-.542 1.554.98 2.993 3.618 8.727 3.618 8.727h-.374a.888.888 0 0 0 0 1.775h.374v1.297h-.615c-.746 0-1.087.59-1.087.86v.818h-.423a.986.986 0 0 0-.983.983v.005c0 .54.442.983.983.983l1.772.001c.643 2.964.91 6.366.934 9.105.072 8.224-2.046 14.563-2.752 16.443-.28.096-.673.266-1.077.446-1.035.46-1.008.721-1.008 1.361v.824c0 .168-.002.327-.005.472a.582.582 0 0 1-.08.285c-.2.331-.418.662-.628.94-.573.758-1.977 1.952-2.523 2.734-.37.529-.836 1.838-.134 2.911a2.708 2.708 0 0 0 1.807 1.185v.13l-.307.111-.973.35a.502.502 0 0 0-.31.439v.964c0 .18.11.268.277.339.808.343 1.551.398 1.551.398H81.56s.743-.055 1.552-.398c.166-.071.276-.159.276-.339v-.964a.5.5 0 0 0-.31-.439l-.973-.35-.307-.111v-.13.001Z"
            fill="#000"
          />
          <path
            d="M67.516 68.367a.096.096 0 0 0-.123.091v2.991c0 .069.097.084.117.019l.578-1.9a.6.6 0 0 1 .423-.398l.845-.17c.057-.014.057-.096-.001-.11l-1.84-.523Z"
            fill="url(#P)"
          />
          <path
            d="m70.225 67.903.188-1.439a.802.802 0 0 1 .194-.433c.16-.178.353-.327.567-.437.018-.01.012-.037-.008-.037a4.904 4.904 0 0 0-1.771.356.097.097 0 0 0-.053.126c.302.746.626 1.524.773 1.878.023.053.102.044.109-.013Z"
            fill="url(#Q)"
          />
          <path
            d="M70.84 74.378c-.519-.01-1.094-.21-1.45-.365a.093.093 0 0 1-.046-.125c.278-.597.637-1.653.784-2.096.007-.023.041-.015.038.009-.046.354-.14 1.087-.208 1.728a.28.28 0 0 0 .113.256c.132.097.37.292.775.563.013.008.008.03-.007.03Z"
            fill="url(#R)"
          />
          <path
            d="M73.5 65.811c.105.014.239.048.353.097a.1.1 0 0 1 .053.128c-.293.726-.478 1.307-.795 2.088-.009.022-.04.011-.036-.011.158-.844.26-1.516.404-2.286.002-.01.01-.018.02-.017v.001Z"
            fill="url(#S)"
          />
          <path
            d="M78.443 78.916c-.033.073-.46.298-1.333.354-.495.033-1.359.076-2-.1-.113-.031-.144-.08.013-.102.271-.038.94-.056 1.91-.142.948-.084 1.463-.126 1.41-.01Z"
            fill="url(#T)"
          />
          <path
            d="M61.544 132.58c1.894 0 3.91-.004 5.925-.004a9.263 9.263 0 0 1-2.116.518c-.487.066-1.052.104-1.64.099a7.4 7.4 0 0 1-1.758-.209 3.95 3.95 0 0 1-.545-.195c-.18-.1-.155-.21.134-.21v.001Z"
            fill="url(#U)"
          />
          <path
            d="M78.164 132.576c1.31 0 2.561 0 3.842-.005.11 0 .198.123-.154.251-.46.168-1.098.3-1.547.299-.762-.004-1.39-.183-2.14-.545Z"
            fill="url(#V)"
          />
          <path
            d="M67.287 88.698h3.375a4.252 4.252 0 0 1-1.97.488c-.834 0-1.437-.33-1.5-.368-.075-.045-.06-.12.095-.12Z"
            fill="url(#W)"
          />
          <path
            d="M75.898 88.698h-1.78c.306.255.681.397 1.038.397.44 0 .79-.248.816-.294.025-.049.009-.103-.074-.103Z"
            fill="url(#X)"
          />
          <path
            d="M66.791 91.871h3.64c-.526.288-1.283.395-1.985.403-.804.009-1.532-.134-1.764-.264-.08-.045-.076-.142.11-.139Z"
            fill="url(#Y)"
          />
          <path
            d="M76.558 91.871h-2.44c.352.288.86.395 1.331.403.54.009 1.02-.139 1.175-.269.054-.045.06-.137-.065-.134Z"
            fill="url(#Z)"
          />
          <path
            d="M65.505 93.527c1.62-.013 3.068.013 4.688-.001-.846.357-1.718.431-2.599.431-1.655 0-2.33-.234-2.33-.356 0-.078.163-.074.241-.074Z"
            fill="url(#aa)"
          />
          <path
            d="M77.761 93.527c-1.191-.013-2.256.013-3.447-.001.622.358 1.264.432 1.911.432 1.218 0 1.715-.244 1.715-.366 0-.064-.121-.065-.178-.065Z"
            fill="url(#ab)"
          />
          <path
            d="M68.406 96.983c.69 3.803.887 7.003.745 10.48-.085 2.103-.333 4.216-.649 6.295-.307 2.015-.64 3.7-1.354 5.906.376.464 1.087.39 1.639.172.54-.214.855-.638.98-1.143.142-.577.207-1.222.248-1.817.258-3.787.544-7.554.356-11.348-.086-1.754-.26-5.624-.769-7.39-.18-.622-.57-.994-1.196-1.156v.001Z"
            fill="url(#ac)"
          />
          <path
            d="M75.126 119.378c-.714-3.548-.89-5.332-1.209-8.177-.278-2.487-.376-8.865.513-13.236.437.386.375.834.28 1.505-.427 3.03-.314 6.005-.216 8.814.072 2.061.828 8.281 2.03 11.435.104.276-.537.338-.758.255-.276-.102-.581-.306-.639-.595v-.001Z"
            fill="url(#ad)"
          />
          <path
            d="M64.882 121.507c1.782-.012 3.374.001 5.156-.011-.706.32-1.256.641-2.944.641-.624 0-1.61-.129-2.228-.371-.228-.089-.186-.262.016-.258v-.001Z"
            fill="url(#ae)"
          />
          <path
            d="M78.666 121.507c-1.245-.012-2.356.001-3.6-.011.493.32 1.093.561 2.046.561.436 0 1.167-.112 1.6-.354.159-.089.094-.199-.046-.195v-.001Z"
            fill="url(#af)"
          />
          <path
            d="M67.257 128.084c-.89 1.005-1.957 1.562-3.958 1.205-.408-.073-.836-.262-1.02-.633-.199-.403.028-.863.262-1.247.365-.599.98-1.16 1.795-2.204.1-.127.483-.953 2.527-.844 1.345.072 1.228.894 1.23 1.029.013 1.181-.255 2.038-.836 2.693v.001Z"
            fill="url(#ag)"
          />
          <path
            d="M78.565 124.613c.391.18.71.718.976 1.06l1.168 1.504c.173.224.336.458.446.719.304.718-.164 1.202-.585 1.281-1.011.192-1.933.089-2.413-.39-.434-.434-.596-1.375-.669-1.716-.145-.675-.35-1.437-.19-2.131.107-.469.805-.54 1.267-.327Z"
            fill="url(#ah)"
          />
          <path
            d="M73.451 73.717a.25.25 0 0 1-.053.182c-.11.14-.22.243-.429.421.179-.036.765-.198.994-.301a.097.097 0 0 0 .05-.122c-.256-.682-.452-1.107-.683-1.738-.008-.02-.036-.015-.034.006.06.515.102 1.043.154 1.552h.001Z"
            fill="url(#ai)"
          />
          <path
            d="M75.82 68.514c-.098.877-.327 2.142-.378 2.457a.143.143 0 0 1-.072.108l-.327.17s.359.113.633.197c.094.03.188-.045.188-.166-.002-.788 0-1.611 0-2.76 0-.033-.04-.04-.043-.007v.001Z"
            fill="url(#aj)"
          />
          <path
            d="M70.788 75.24h-1.035c-.108.007-.27 0-.277.102-.004.077.135.276.521.305.61.047.913-.255.913-.337 0-.053-.07-.07-.122-.07Z"
            fill="url(#ak)"
          />
          <path
            d="M73.628 75.24c.166 0 .176.06.16.11-.039.13-.247.24-.473.24-.34 0-.606-.192-.605-.273 0-.059.051-.075.208-.075l.71-.003v.001Z"
            fill="url(#al)"
          />
          <path
            d="M68.383 87.442c.332.173.809.223 1.139.078.159-.07.243-.274.224-.45-.278-2.658-.523-3.955-.74-6.323a.573.573 0 0 0-.517-.52c-.792-.086-1.483-.068-2.274-.096-.233-.008-.407.263-.339.49.747 2.495 1.334 3.939 2.185 6.466a.725.725 0 0 0 .321.355h.001Z"
            fill="url(#am)"
          />
          <path
            d="M68.19 78.455a.946.946 0 0 0 .674-.34c.158-.191.299-.377.438-.594.096-.15.228-.44.171-.505-.102-.116-.35-.076-.498-.033-.838.246-1.851.598-2.57 1.096-.07.048-.092.151-.036.217.063.071.16.098.254.118.33.07 1.076.072 1.567.043v-.002Z"
            fill="url(#an)"
          />
          <path
            d="M71.174 79.118c-1.006-.012-4.337-.045-6.46-.262-.333-.035-.264.079-.213.127a.857.857 0 0 0 .258.126c.618.186 1.098.283 2.146.348 1.543.095 3.363-.042 4.279-.238.137-.03.26-.098-.01-.1Z"
            fill="url(#ao)"
          />
          <path
            d="M75.158 77.197c.464.152 1.631.584 1.585.819-.015.074-.033.137-.196.166-.57.1-.897.08-1.104-.036-.154-.086-.302-.237-.431-.357-.13-.121-.383-.389-.382-.535.002-.224.422-.092.527-.057Z"
            fill="url(#ap)"
          />
          <path
            d="M75.89 80.409c.022-.133.071-.258.183-.333a.84.84 0 0 1 .383-.112c.209-.022.575-.03.784-.016.152.011.337.028.389.171.03.083-.01.22-.034.304-.1.338-1.45 4.663-2.122 6.665-.052.157-.267.334-.463.325-.116-.004-.199-.047-.256-.16-.056-.108.056-.708.109-.967.288-1.42.937-5.355 1.025-5.877h.001Z"
            fill="url(#aq)"
          />
          <path
            d="M70.191 91.074a32.89 32.89 0 0 0-.152-.454.193.193 0 0 0-.184-.13c-.565.005-1.068.002-1.64.008a.073.073 0 0 0-.07.071c.001.185-.004.326-.002.514 0 .029.022.054.05.054.563.003 1.669-.001 1.954-.002.032 0 .053-.03.043-.061h.001Z"
            fill="url(#ar)"
          />
          <path
            d="M74.12 91.074c.032-.098.096-.294.152-.454a.194.194 0 0 1 .184-.13c.5.006.465.008.664.008.038 0 .07.032.07.07-.001.186.003.327 0 .515 0 .029-.022.053-.05.053l-.976-.001a.046.046 0 0 1-.044-.062Z"
            fill="url(#as)"
          />
          <path
            d="M70.97 64.448a.307.307 0 0 1-.067-.007c-.15-.032-.179-.203-.184-.255-.03-.294.118-.827.647-1.003a.265.265 0 0 1 .08-.013c.04 0 .075.01.093.03.01.01.014.022.014.036 0 .017-.018.037-.052.073-.108.117-.363.392-.296.96.001.015-.015.058-.05.097a.242.242 0 0 1-.185.082Z"
            fill="url(#at)"
          />
          <path
            d="M72.467 64.696c-.022.012-.083-.005-.122-.05a.325.325 0 0 1-.06-.112c-.014-.057-.002-.104.019-.129.012-.015.046-.047.047-.048.058-.07.142-.168.203-.382.006-.017.015-.026.027-.023.022.005.053.053.071.167a.819.819 0 0 1-.186.577Z"
            fill="url(#au)"
          />
        </g>
        <path
          d="M73.971 24.785c-2.181.916-2.673 3.452-3.23 5.494-.8.076-1.495.284-2.385.72l-.018.025c.608-.098 1.62-.048 2.15.2-.337 1.37-.616 2.828-1.348 3.994-.828 1.423-2.96 1.576-3.965.257-.976-1.218-.276-3.338 1.169-3.867-1.605.497-2.497 2.7-1.574 4.149.976 1.597 3.5 1.915 4.941.784 1.387-1.184 1.608-3.113 1.979-4.775.034-.153.066-.306.097-.458 2.184-.095 4.8.084 6.307-1.871 2.284-2.952-.91-6.286-4.123-4.652Zm2.431 4.576c-1.313.72-2.91.715-4.383.892.24-1.034.529-2.066 1-2.994.657-1.303 2.483-2.15 3.81-1.408 1.376.831.82 2.828-.427 3.51Z"
          fill="#A7A4A4"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={63.344}
          y1={-23.285}
          x2={136.752}
          y2={87.616}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={41.646}
          y1={91.519}
          x2={47.793}
          y2={91.519}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={46.483}
          y1={98.246}
          x2={49.317}
          y2={98.246}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={47.576}
          y1={94.093}
          x2={50.236}
          y2={94.093}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={51.25}
          y1={96.714}
          x2={52.413}
          y2={96.714}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={46.018}
          y1={105.368}
          x2={55.031}
          y2={105.368}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={48.596}
          y1={100.383}
          x2={54.331}
          y2={100.383}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={48.405}
          y1={109.996}
          x2={54.813}
          y2={109.996}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={51.566}
          y1={112.572}
          x2={53.867}
          y2={112.572}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={48.383}
          y1={114.748}
          x2={52.573}
          y2={114.748}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={49.013}
          y1={118.11}
          x2={54.425}
          y2={118.11}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={49.035}
          y1={122.553}
          x2={54.964}
          y2={122.553}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="p"
          x1={50.246}
          y1={113.909}
          x2={51.993}
          y2={113.909}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={38.37}
          y1={96.704}
          x2={51.292}
          y2={100.325}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={42.337}
          y1={91.593}
          x2={46.522}
          y2={91.593}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={40.037}
          y1={102.58}
          x2={41.441}
          y2={102.58}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={42.075}
          y1={107.557}
          x2={52.792}
          y2={107.557}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={42.994}
          y1={114.787}
          x2={50.88}
          y2={114.787}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={41.584}
          y1={117.978}
          x2={49.093}
          y2={117.978}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={40.778}
          y1={122.584}
          x2={49.561}
          y2={122.584}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={43.998}
          y1={113.909}
          x2={47.341}
          y2={113.909}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="y"
          x1={42.802}
          y1={95.683}
          x2={45.519}
          y2={96.359}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="z"
          x1={89.245}
          y1={117.688}
          x2={95.943}
          y2={117.688}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="A"
          x1={87.431}
          y1={124.098}
          x2={95.89}
          y2={124.098}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="B"
          x1={94.672}
          y1={117.671}
          x2={99.474}
          y2={117.671}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="C"
          x1={90.711}
          y1={109.051}
          x2={94.564}
          y2={109.051}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="D"
          x1={95.906}
          y1={109.42}
          x2={98.248}
          y2={109.42}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="E"
          x1={88.676}
          y1={96.608}
          x2={93.174}
          y2={96.608}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="F"
          x1={96.37}
          y1={96.608}
          x2={100.087}
          y2={96.608}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="G"
          x1={89.795}
          y1={99.784}
          x2={94.614}
          y2={99.784}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="H"
          x1={96.075}
          y1={99.784}
          x2={99.001}
          y2={99.784}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="I"
          x1={90.194}
          y1={101.459}
          x2={95.794}
          y2={101.459}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="J"
          x1={94.919}
          y1={101.437}
          x2={98.549}
          y2={101.437}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="K"
          x1={89.562}
          y1={115.426}
          x2={96.153}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="L"
          x1={94.328}
          y1={115.426}
          x2={99.124}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="M"
          x1={88.065}
          y1={120.141}
          x2={94.414}
          y2={120.141}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="N"
          x1={96.375}
          y1={120.185}
          x2={100.981}
          y2={120.185}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="O"
          x1={95.352}
          y1={124.065}
          x2={101.383}
          y2={124.065}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="P"
          x1={67.393}
          y1={69.936}
          x2={71.137}
          y2={69.936}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Q"
          x1={69.335}
          y1={66.754}
          x2={72.789}
          y2={66.754}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="R"
          x1={69.335}
          y1={73.078}
          x2={72.17}
          y2={73.078}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="S"
          x1={73.445}
          y1={65.361}
          x2={74.61}
          y2={65.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="T"
          x1={76.532}
          y1={78.757}
          x2={76.594}
          y2={79.352}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="U"
          x1={61.296}
          y1={132.885}
          x2={72.819}
          y2={132.885}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="V"
          x1={79.905}
          y1={132.465}
          x2={79.984}
          y2={133.183}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="W"
          x1={67.147}
          y1={88.942}
          x2={73.707}
          y2={88.942}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="X"
          x1={74.942}
          y1={88.621}
          x2={75.027}
          y2={89.132}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="Y"
          x1={66.632}
          y1={92.073}
          x2={73.724}
          y2={92.073}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Z"
          x1={75.241}
          y1={91.793}
          x2={75.307}
          y2={92.318}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="aa"
          x1={65.263}
          y1={93.74}
          x2={74.466}
          y2={93.74}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ab"
          x1={75.916}
          y1={93.44}
          x2={75.97}
          y2={94.009}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ac"
          x1={67.147}
          y1={108.495}
          x2={73.278}
          y2={108.495}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ad"
          x1={74.965}
          y1={93.713}
          x2={79.573}
          y2={94.461}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ae"
          x1={64.712}
          y1={121.816}
          x2={74.656}
          y2={121.816}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="af"
          x1={76.718}
          y1={121.387}
          x2={76.805}
          y2={122.119}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ag"
          x1={62.203}
          y1={126.874}
          x2={73.2}
          y2={126.874}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ah"
          x1={79.013}
          y1={123.578}
          x2={82.156}
          y2={126.944}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ai"
          x1={73.433}
          y1={71.727}
          x2={74.714}
          y2={72.514}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="aj"
          x1={75.406}
          y1={67.921}
          x2={76.633}
          y2={68.354}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ak"
          x1={69.475}
          y1={75.445}
          x2={72.152}
          y2={75.445}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="al"
          x1={71.518}
          y1={75.415}
          x2={73.7}
          y2={75.415}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="am"
          x1={65.862}
          y1={83.869}
          x2={73.119}
          y2={83.869}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="an"
          x1={66.337}
          y1={77.706}
          x2={72.217}
          y2={77.706}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ao"
          x1={64.457}
          y1={79.169}
          x2={77.296}
          y2={79.169}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ap"
          x1={72.307}
          y1={77.688}
          x2={76.561}
          y2={77.688}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aq"
          x1={71.549}
          y1={83.677}
          x2={77.39}
          y2={83.677}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="ar"
          x1={67.55}
          y1={90.814}
          x2={72.017}
          y2={90.814}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="as"
          x1={74.592}
          y1={90.366}
          x2={74.921}
          y2={91.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="at"
          x1={70.714}
          y1={63.809}
          x2={72.28}
          y2={63.809}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="au"
          x1={72.446}
          y1={63.807}
          x2={72.895}
          y2={64.096}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h143.327v160H0z" />
        </clipPath>
        <filter
          id="c"
          x={12.748}
          y={14.126}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={8} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="shape" result="effect1_innerShadow_16_1589" />
        </filter>
      </defs>
    </svg>
  ),
  // ----------------------------------------------------------GOLD:SVG-------------------------------------------------------------------------------------------------
  gold: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="11 0 120 160"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="M138.64 90.162a19.06 19.06 0 0 0 4.023-3.132v24.582c0 6.35-3.367 12.217-8.828 15.394l-53.511 31.112a17.54 17.54 0 0 1-17.648 0L9.165 127.006c-5.461-3.175-8.828-9.044-8.828-15.394V87.03a18.968 18.968 0 0 0 4.023 3.132l57.638 33.511a18.88 18.88 0 0 0 19.008 0l57.636-33.511h-.002Z"
          fill="#303644"
        />
        <path
          d="M142.663 49.388v32.62a18.992 18.992 0 0 1-4.023 3.13L81.004 118.65a18.88 18.88 0 0 1-19.008 0L4.36 85.14a19.098 19.098 0 0 1-4.023-3.13V49.39c0-6.352 3.367-12.221 8.828-15.396L62.676 2.882a17.542 17.542 0 0 1 17.65 0l53.511 31.114c5.461 3.175 8.828 9.042 8.828 15.392h-.002Z"
          fill="url(#b)"
        />
        <g filter="url(#c)">
          <path
            d="M130.006 106.468V54.534c0-4.981-2.639-9.583-6.921-12.073L78.423 16.494a13.76 13.76 0 0 0-13.844 0L19.917 42.459c-4.284 2.49-6.921 7.092-6.921 12.073v51.934c0 4.981 2.637 9.583 6.921 12.073l44.662 25.967a13.762 13.762 0 0 0 13.844 0l44.662-25.967c4.284-2.49 6.921-7.092 6.921-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="d"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={133}
        >
          <path
            d="M130.006 106.468V54.534c0-4.981-2.639-9.583-6.921-12.073L78.423 16.494a13.761 13.761 0 0 0-13.844 0L19.917 42.459c-4.284 2.49-6.921 7.092-6.921 12.073v51.934c0 4.981 2.637 9.583 6.921 12.073l44.662 25.967a13.763 13.763 0 0 0 13.844 0l44.662-25.967c4.284-2.49 6.921-7.092 6.921-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <path
            d="M54.104 61.346a6.793 6.793 0 0 1-2.399-.41 5.831 5.831 0 0 1-1.896-1.2 5.634 5.634 0 0 1-1.255-1.816 5.839 5.839 0 0 1-.439-2.29c0-.83.147-1.594.44-2.288a5.52 5.52 0 0 1 1.27-1.816 5.589 5.589 0 0 1 1.912-1.184c.731-.284 1.536-.426 2.414-.426.972 0 1.844.163 2.618.49a5.19 5.19 0 0 1 1.975 1.42l-1.63 1.516a3.877 3.877 0 0 0-1.301-.932 3.717 3.717 0 0 0-1.537-.315 4.04 4.04 0 0 0-1.458.252c-.439.169-.82.41-1.144.726a3.42 3.42 0 0 0-.737 1.121c-.167.432-.25.91-.25 1.437 0 .516.083.99.25 1.42.178.432.424.811.737 1.137.324.316.7.558 1.129.726.439.169.92.253 1.442.253a4.55 4.55 0 0 0 1.458-.237c.48-.168.946-.447 1.395-.837l1.442 1.848c-.595.452-1.29.8-2.085 1.041a7.934 7.934 0 0 1-2.351.364Zm2.116-1.737v-4.152h2.32v4.484l-2.32-.332ZM66.23 61.346a6.694 6.694 0 0 1-2.415-.427 5.79 5.79 0 0 1-1.912-1.2 5.634 5.634 0 0 1-1.255-1.815 5.797 5.797 0 0 1-.439-2.273c0-.821.147-1.579.44-2.273.303-.695.726-1.3 1.27-1.816a5.79 5.79 0 0 1 1.912-1.2 6.524 6.524 0 0 1 2.383-.426c.867 0 1.661.142 2.382.426a5.618 5.618 0 0 1 1.897 1.2 5.518 5.518 0 0 1 1.725 4.089c0 .82-.152 1.584-.455 2.289a5.518 5.518 0 0 1-1.27 1.815c-.533.505-1.165.9-1.897 1.184a6.4 6.4 0 0 1-2.367.427Zm-.016-2.179c.49 0 .94-.084 1.348-.253a3.23 3.23 0 0 0 1.818-1.847c.178-.431.267-.91.267-1.436 0-.526-.09-1.005-.267-1.437a3.223 3.223 0 0 0-.72-1.12 3.069 3.069 0 0 0-1.083-.727 3.616 3.616 0 0 0-1.363-.252c-.492 0-.946.084-1.364.252a3.27 3.27 0 0 0-1.082.726c-.313.316-.56.69-.737 1.121-.167.432-.25.91-.25 1.437 0 .516.083.994.25 1.436.178.432.418.806.721 1.121.314.316.68.558 1.098.726.418.169.872.253 1.364.253ZM74.126 61.156v-11.05h2.54v8.966h5.502v2.084h-8.042ZM83.587 61.156v-11.05h4.985c1.192 0 2.242.231 3.151.694.91.453 1.62 1.09 2.132 1.91.512.821.768 1.795.768 2.92 0 1.116-.256 2.09-.768 2.921-.512.821-1.223 1.463-2.132 1.926-.91.453-1.96.68-3.15.68h-4.986Zm2.54-2.1h2.32c.731 0 1.364-.136 1.897-.41a3.011 3.011 0 0 0 1.254-1.2c.303-.515.454-1.12.454-1.815 0-.705-.151-1.31-.454-1.816a2.913 2.913 0 0 0-1.254-1.184c-.533-.284-1.166-.426-1.897-.426h-2.32v6.852ZM50.787 47.4a2.01 2.01 0 0 1-.71-.124 1.696 1.696 0 0 1-.94-.904 1.751 1.751 0 0 1-.132-.687c0-.25.043-.478.131-.687.091-.208.217-.39.377-.544.163-.155.352-.273.569-.355.216-.086.453-.128.71-.128.285 0 .542.05.771.151.232.098.426.243.583.436l-.489.455a1.118 1.118 0 0 0-.376-.29 1.148 1.148 0 0 0-.875-.024.961.961 0 0 0-.334.219 1.024 1.024 0 0 0-.296.767c0 .158.025.302.075.431.053.13.127.242.221.336a.96.96 0 0 0 .334.218c.129.05.27.076.423.076.163 0 .314-.032.452-.095a1.15 1.15 0 0 0 .376-.298l.49.455c-.158.192-.352.339-.584.44a1.901 1.901 0 0 1-.776.152ZM53.361 45.363h1.585v.597h-1.585v-.597Zm.057 1.364h1.792v.616h-2.55v-3.316h2.489v.616h-1.731v2.084ZM55.816 47.343v-3.316h1.425c.294 0 .548.05.762.147.213.095.377.232.493.412.116.18.174.395.174.645 0 .246-.058.459-.174.639-.116.177-.28.312-.493.407a1.865 1.865 0 0 1-.762.142h-1.002l.339-.336v1.26h-.762Zm2.093 0-.823-1.203h.813l.833 1.203h-.823Zm-1.331-1.175-.339-.36h.96c.235 0 .41-.05.526-.151a.544.544 0 0 0 .174-.426.535.535 0 0 0-.174-.427c-.116-.1-.291-.151-.526-.151h-.96l.339-.365v1.88ZM59.91 47.343v-2.69h-1.053v-.625h2.868v.625h-1.053v2.69h-.762ZM62.135 47.343v-3.316h.762v3.316h-.762ZM64.384 45.52h1.58v.615h-1.58v-.616Zm.056 1.823h-.761v-3.316h2.487v.616H64.44v2.7ZM66.682 47.343v-3.316h.762v3.316h-.762ZM68.926 45.363h1.585v.597h-1.585v-.597Zm.056 1.364h1.792v.616h-2.549v-3.316h2.488v.616h-1.73v2.084ZM71.38 47.343v-3.316h1.496c.357 0 .672.07.945.209.273.136.486.327.64.573.154.246.23.538.23.876 0 .335-.076.627-.23.876a1.581 1.581 0 0 1-.64.578 2.094 2.094 0 0 1-.945.204H71.38Zm.762-.63h.696c.22 0 .41-.041.57-.123a.903.903 0 0 0 .376-.36c.09-.155.136-.336.136-.545a1.04 1.04 0 0 0-.136-.544.874.874 0 0 0-.377-.356 1.193 1.193 0 0 0-.569-.128h-.696v2.056ZM78.173 47.4a2.01 2.01 0 0 1-.71-.124 1.695 1.695 0 0 1-.94-.904 1.751 1.751 0 0 1-.132-.687c0-.25.044-.478.131-.687.091-.208.217-.39.377-.544.163-.155.352-.273.569-.355.216-.086.453-.128.71-.128.285 0 .542.05.771.151.232.098.427.243.583.436l-.489.455a1.117 1.117 0 0 0-.376-.29 1.147 1.147 0 0 0-.875-.024.96.96 0 0 0-.334.219 1.025 1.025 0 0 0-.296.767c0 .158.025.302.075.431.054.13.127.242.221.336a.958.958 0 0 0 .334.218c.129.05.27.076.424.076.163 0 .313-.032.451-.095.138-.066.263-.166.376-.298l.49.455c-.157.192-.352.339-.584.44a1.902 1.902 0 0 1-.776.152ZM81.577 47.4a2.01 2.01 0 0 1-.724-.128 1.738 1.738 0 0 1-.574-.36 1.69 1.69 0 0 1-.376-.545 1.739 1.739 0 0 1-.132-.682c0-.246.044-.474.132-.682.09-.208.218-.39.38-.544.164-.155.355-.275.574-.36.22-.086.458-.128.715-.128.26 0 .499.042.715.128a1.685 1.685 0 0 1 1.086 1.586 1.656 1.656 0 0 1-1.086 1.587 1.922 1.922 0 0 1-.71.128Zm-.005-.654c.148 0 .282-.025.405-.076a.97.97 0 0 0 .545-.554c.053-.13.08-.273.08-.43 0-.159-.026-.302-.08-.432a.968.968 0 0 0-.54-.554 1.085 1.085 0 0 0-.41-.076c-.147 0-.284.026-.409.076a.982.982 0 0 0-.324.218 1.025 1.025 0 0 0-.297.767c0 .155.025.298.076.431a.969.969 0 0 0 .546.554c.124.05.26.076.408.076ZM83.467 47.343l1.468-3.316h.752l1.472 3.316h-.8l-1.203-2.927h.3l-1.208 2.927h-.78Zm.734-.71.202-.583h1.693l.207.582h-2.102ZM89.03 47.4a2.01 2.01 0 0 1-.71-.124 1.696 1.696 0 0 1-.94-.904 1.751 1.751 0 0 1-.132-.687c0-.25.044-.478.132-.687.09-.208.216-.39.376-.544.163-.155.353-.273.569-.355.216-.086.453-.128.71-.128.285 0 .542.05.771.151.232.098.427.243.583.436l-.489.455a1.118 1.118 0 0 0-.376-.29 1.147 1.147 0 0 0-.875-.024.96.96 0 0 0-.334.219 1.026 1.026 0 0 0-.296.767c0 .158.025.302.075.431.054.13.127.242.221.336a.959.959 0 0 0 .334.218c.129.05.27.076.424.076.163 0 .313-.032.451-.095a1.15 1.15 0 0 0 .376-.298l.49.455c-.157.192-.352.339-.584.44a1.902 1.902 0 0 1-.776.152ZM93.161 44.028h.762v3.315h-.762v-3.316Zm-1.495 3.315h-.762v-3.316h.762v3.316Zm1.552-1.36h-1.609v-.648h1.609v.648Z"
            fill="#D4A123"
          />
          <path
            d="M121.596 138.305H88.18l-3.07-10.067h27.275l9.211 10.067Z"
            fill="#000"
          />
          <path
            d="M139.661 128.239h-27.276l-6.351-6.941h23.041l10.586 6.941ZM93.034 154.219H49.909l4.854-15.914H88.18l4.853 15.914ZM54.763 138.305H21.347l9.21-10.067h27.277l-3.07 10.067Z"
            fill="#000"
          />
          <path
            d="M30.558 128.239H3.282l10.585-6.941H36.91l-6.351 6.941Z"
            fill="#000"
          />
          <path
            d="m41.172 125.349-.035-.002a5.304 5.304 0 0 1-1.623-.429 1.209 1.209 0 0 1-.714-1.103v-.785c0-.344.142-.673.375-.915a2.773 2.773 0 0 1-.18-.25c-.762-1.193-.262-2.534.11-3.077.242-.354.589-.795.925-1.221.208-.264.408-.517.56-.723.293-.396.472-1.081.49-1.254v-.163c.004-.491.183-.798.43-1.011a1.242 1.242 0 0 1-.353-.414 32.488 32.488 0 0 1-.726-1.432l-.028-.062c-.23-.502-.375-.956-.005-1.839l.041-.099c.445-1.066 1.487-3.563 5.178-7.465a7.61 7.61 0 0 0 .136-.147h-.05c-.695.045-1.39.123-2.176.542-.181.158-.3.382-.438.639-.142.268-.304.571-.566.815-.443.412-1.246.499-1.842.499-1.174 0-1.86-.342-2.039-1.018a1.333 1.333 0 0 1-.044-.306c-.308 0-.597-.074-.858-.22-.303-.163-.824-.446-.968-3.255-.07-.486.06-1.212.655-1.797l.082-.08c.563-.55 2.275-2.226 3.232-3.886.16-.279.367-.547.613-.797a8.664 8.664 0 0 1 1.026-.888c-.123-.143-.248-.284-.37-.422-.767-.871-1.321-1.5-1.231-2.252.042-.354.23-.663.53-.871a1.84 1.84 0 0 1 1.149-.361c.578 0 1.584.169 4.253 1.47.366.041.715.094 1.063.161.821.162 1.604.404 2.332.72l-.013-.19 1.555 1.02c.53.348 1.03.75 1.488 1.196l.173.167.07.231.05.175.107-.522 1.226 1.987c.454.735.844 1.556 1.16 2.441l.078.221-.034.232a13.393 13.393 0 0 1-.345 1.633l.77-.97.323 2.098c.026.173.052.348.074.528.113.882.153 1.92.116 3l-.008.25-.132.213a13.65 13.65 0 0 1-1.167 1.602l1.298-.733-.31 1.912a25.005 25.005 0 0 1-.607 2.76l.087-.024-.63 1.698c-.176.473-.367.932-.567 1.365a1.243 1.243 0 0 1-.404.488c.238.211.41.515.413.992v.169c.019.173.198.859.49 1.254.153.206.353.459.56.723.336.426.684.867.926 1.222.37.542.87 1.883.108 3.076a2.923 2.923 0 0 1-.18.25c.233.242.375.571.375.915v.785c0 .476-.28.909-.714 1.103a5.304 5.304 0 0 1-1.624.429l-.034.002H41.17Z"
            fill="#fff"
          />
          <path
            d="m55.979 122.673-.788-.285-.248-.091v-.106s.765-.088 1.24-.831c.48-.752.16-1.67-.093-2.041-.375-.548-1.073-1.386-1.466-1.916-.445-.602-.675-1.548-.675-1.793v-.182c-.002-.241-.023-.315-.491-.508-.096-.04-.497-.187-.535-.202l-.009-.003a.524.524 0 0 1-.255-.464c0-.29.207-.523.464-.523h.622c.12 0 .23-.07.282-.18.196-.423.375-.856.54-1.297-.82.221-1.718.375-2.701.443 1.2-.497 2.228-1.07 3.11-1.667.303-1.004.53-2.029.694-3.033-2.203 1.243-4.747 1.666-4.747 1.666 2.601-1.528 4.158-3.345 5.055-4.792a18.088 18.088 0 0 0-.11-2.851 19.088 19.088 0 0 0-.071-.503c-1.835 2.307-3.931 3.394-3.931 3.394 2.112-2.073 2.911-4.586 3.183-6.435-.306-.86-.67-1.61-1.074-2.265-.492 2.395-1.546 3.71-1.546 3.71.683-2.195.505-4.107.062-5.57a8.985 8.985 0 0 0-1.35-1.084c.073 1.09-.023 2.403-.385 3.463.007-1.803-.44-3.19-.951-4.189a10.37 10.37 0 0 0-2.205-.688 13.226 13.226 0 0 0-1.15-.167c-3.76-1.85-4.273-1.489-4.616-1.252-.537.374.595 1.351 1.564 2.547.227.28.228.473 0 .647-.193.148-.773.502-1.387 1.127-.18.184-.341.388-.47.611-1.073 1.862-2.994 3.7-3.467 4.165-.494.486-.38 1.027-.38 1.027s.114 2.335.494 2.54c.702.393 1.584-.479 1.785-.255.162.18-.55.928-.436 1.357.114.429 1.994.411 2.355.074.36-.336.494-1.073 1.12-1.55.991-.55 1.86-.642 2.635-.694.145-.009.92.008 1.125.215.384.385.17.816-.485 1.508-3.69 3.902-4.612 6.271-5.036 7.283-.256.609-.154.76.023 1.152.164.363.53 1.061.698 1.379a.31.31 0 0 0 .274.165h.585c.255 0 .463.233.463.523a.525.525 0 0 1-.263.468c-.037.014-.438.161-.535.202-.468.192-.49.266-.49.507v.182c0 .245-.23 1.192-.675 1.793-.394.531-1.092 1.369-1.466 1.916-.254.371-.574 1.29-.093 2.042a1.85 1.85 0 0 0 1.24.83v.106l-.249.091-.787.285a.409.409 0 0 0-.251.358v.785c0 .108.065.205.163.249.677.303 1.317.351 1.317.351h13.543s.639-.048 1.317-.351a.275.275 0 0 0 .163-.249v-.785a.409.409 0 0 0-.251-.358l.002-.001Z"
            fill="#000"
          />
          <path
            d="M46.139 92.137c-.259-.14-.899-.489-1.112-.609.108.103.724.671.988.935.03.03.07.046.112.045.645-.011 1.286-.032 1.931-.043a19.908 19.908 0 0 0-1.689-.256.614.614 0 0 1-.23-.071v-.001Z"
            fill="url(#e)"
          />
          <path
            d="M48.587 96.304c.173.609.404 1.717.255 2.711-.127.841-.58 1.571-1.023 2.172 1.204-.9 1.343-1.942 1.372-2.224.123-1.161-.235-1.91-.604-2.66Z"
            fill="url(#f)"
          />
          <path
            d="M50.335 96.119c-.081-1.356-.374-2.193-.603-2.685-.215-.189-.533-.344-.71-.368.493.635.963 1.566 1.313 3.053Z"
            fill="url(#g)"
          />
          <path
            d="M51.86 99.533c.078-.436.492-2.69.065-4.64.034.031.285.332.42.55.253 1.397-.081 3.141-.485 4.09Z"
            fill="url(#h)"
          />
          <path
            d="M50.922 108.891c1.732-1.048 3.61-2.766 4.423-4.123.045-.691.009-1.031-.018-1.924-.127.705-.371 1.898-.371 1.898s-1.27 2.152-4.034 4.149Z"
            fill="url(#i)"
          />
          <path
            d="M51.705 104.129c1.613-1.719 2.396-3.3 2.828-5.162-.134-.5-.271-.854-.493-1.331.084.378.133.835.14 1.406-.23 1.369-1.061 3.308-2.475 5.087Z"
            fill="url(#j)"
          />
          <path
            d="M51.88 112.077a24.984 24.984 0 0 0 2.642-1.455c.203-.613.356-1.177.518-1.707-.134.31-.423.857-.6 1.185a1.473 1.473 0 0 1-.397.47 28.68 28.68 0 0 1-2.163 1.508v-.001Z"
            fill="url(#k)"
          />
          <path
            d="M53.926 112.751c-.092.199-.139.324-.266.53a.227.227 0 0 1-.187.106c-.261.01-.448-.004-.682-.004.218-.079.48-.1.675-.208.194-.107.317-.244.46-.424Z"
            fill="url(#l)"
          />
          <path
            d="M50.655 115.105c.57-.008 1.863-.006 1.964-.006.263 0 .028.298-.798.298a2.51 2.51 0 0 1-1.165-.292Z"
            fill="url(#m)"
          />
          <path
            d="M53.036 116.979c.038.03.293.627.379.804.305.637 1.098 1.723 1.157 1.829.077.139.031.323-.055.453-.106.158-.3.225-.481.28-.216.064-.967.106-1.447-.284-.541-.44-.575-1.104-.614-1.35-.07-.441-.027-1.273.121-1.618.13-.303.652-.339.94-.114Z"
            fill="url(#n)"
          />
          <path
            d="M52.246 122.833c.972 0 1.9 0 2.851-.004.082 0 .147.1-.114.204-.34.137-.815.245-1.148.244-.566-.003-1.033-.149-1.589-.444Z"
            fill="url(#o)"
          />
          <path
            d="M51.188 114.622c-.014.014-.01.049.006.049.416-.006.599-.004.794-.005.03 0 .053-.045.053-.099l-.001-.323c0-.053-.023-.096-.052-.097-.061-.002-.189-.008-.252.014-.031.011-.212.125-.548.461Z"
            fill="url(#p)"
          />
          <path
            d="M38.529 102.608a6.896 6.896 0 0 0-.152-.963 6.937 6.937 0 0 1-.15-.954 1.802 1.802 0 0 1 .052-.587.925.925 0 0 1 .364-.503c.092-.06.178-.113.26-.165.192-.118.356-.22.521-.351a9.125 9.125 0 0 0 2.286-2.66c.09-.16.173-.325.254-.486.135-.27.279-.547.45-.8.404-.598 1.728-1.394 2.295-1.551-.453.482-.444.875-.438 1.095.18.033.592.146.837.462.148.192.21.415.182.665-.279-.306-.954-.58-1.45-.58a.9.9 0 0 0-.278.038c-.486.158-.676.437-.939.824-.183.269-.348.58-.509.882-.083.157-.166.313-.25.46-.449.786-1.127 1.511-2.135 2.282a.85.85 0 0 1-.554.184c-.035 0-.068 0-.099-.002a1.911 1.911 0 0 0-.08-.002.38.38 0 0 0-.149.023c-.235.099-.308.449-.284.665.03.272.16.435.347.435a.357.357 0 0 0 .143-.032c.211-.091.403-.313.587-.675.141.402.023.795-.327 1.062-.126.097-.248.126-.364.154a5.263 5.263 0 0 0-.102.026v.024c.003.557-.241.987-.319 1.036v-.006Zm6.799-6.297a1.864 1.864 0 0 1-.525.692c-.426.329-.979.359-1.483.257.439.504 1.392.503 1.816-.016a.995.995 0 0 0 .225-.642 1.317 1.317 0 0 0-.033-.29Z"
            fill="url(#q)"
          />
          <path
            d="M43.928 92.852c.075.084.146.144.257.163a.53.53 0 0 0 .382-.075c.134-.09-.129-.334-.256-.433-1.04-.806-1.82-1.378-1.933-1.346.39.424.682.71 1.55 1.69v.001Z"
            fill="url(#r)"
          />
          <path
            d="M40.094 103.829c.27-.034.476-.223.59-.475.112-.251.157-.644.157-1.023-.078.134-.123.239-.17.332-.065.135-.132.269-.198.404-.066.134-.334.676-.378.762Z"
            fill="url(#s)"
          />
          <path
            d="M43.504 111.343c-.035.353.163.887.63 1.611.067.104-.005.243-.128.243-.26 0-.582-.002-.737-.005a.547.547 0 0 1-.454-.26c-.331-.536-.401-.665-.626-1.15a.798.798 0 0 1-.027-.59c.612-1.797 1.489-3.006 2.51-4.36 1.18-1.563 2.645-2.655 3.106-3.917.137.632-.064 1.409-.757 2.293-1.368 1.745-3.245 4.308-3.517 6.134v.001Z"
            fill="url(#t)"
          />
          <path
            d="M47.225 115.099c-.6.186-1.503.375-2.308.375-.59 0-1.152-.07-1.708-.217-.087-.023-.187-.061-.178-.106.01-.052.2-.052.283-.052H47.225Z"
            fill="url(#u)"
          />
          <path
            d="M45.298 119.209c-.15.294-.306.595-.553.819-.3.272-.71.405-1.12.447-.506.051-.83.052-1.307-.125a1.372 1.372 0 0 1-.5-.287.643.643 0 0 1-.183-.516c.052-.543.928-1.325 1.363-2.257.124-.266.265-.546.521-.698.192-.115.509-.143.735-.141.482.005.829.054 1.147.313.327.267.3 1.655-.103 2.446v-.001Z"
            fill="url(#v)"
          />
          <path
            d="M41.017 122.833h4.485c-.526.207-.854.303-1.602.42a7.831 7.831 0 0 1-1.241.08 5.201 5.201 0 0 1-1.33-.171 2.844 2.844 0 0 1-.413-.158c-.137-.081-.118-.171.101-.171Z"
            fill="url(#w)"
          />
          <path
            d="M45.79 114.622c.027.014.018.049-.013.049-.86-.006-1.237-.004-1.641-.005-.06 0-.108-.045-.108-.099 0-.115 0-.206.002-.323 0-.053.048-.096.107-.097.126-.002.273.023.402.034.068.005.556.105 1.251.441Z"
            fill="url(#x)"
          />
          <path
            d="M43.502 96.889a.19.19 0 0 1-.086-.018c-.09-.037-.14-.153-.14-.243 0-.193.124-.398.184-.467a.676.676 0 0 1 .495-.228c.068 0 .136.011.202.035a.83.83 0 0 0-.326.259.854.854 0 0 0-.14.386c-.005.026-.007.052-.01.075-.01.103-.02.193-.135.2a.606.606 0 0 1-.044.002v-.001Z"
            fill="url(#y)"
          />
          <path
            d="m87.439 126.824-.034-.002a5.21 5.21 0 0 1-1.524-.39c-.7-.299-.776-.881-.776-1.117v-.773c0-.339.139-.663.368-.901a2.704 2.704 0 0 1-.177-.246c-.667-1.044-.382-2.181.107-2.896.254-.371.593-.678.892-.947.226-.204.44-.397.57-.574.043-.056.087-.122.136-.197v-.299c-.001-.684.223-1.06.665-1.347a1.737 1.737 0 0 1 .808-2.588c.217-1.838.503-5.347.55-11.246a1.53 1.53 0 0 1-.45-1.749 1.502 1.502 0 0 1-.678-.998 1.692 1.692 0 0 1-1.065-1.573V93.84h14.614v5.142c0 .714-.442 1.326-1.065 1.573-.078.421-.33.781-.679.998a1.532 1.532 0 0 1-.45 1.75c.047 5.899.334 9.408.55 11.245a1.736 1.736 0 0 1 .808 2.588c.443.288.667.663.666 1.347v.299c.048.074.092.14.134.196.131.178.345.37.572.575.298.269.637.575.892.946.489.716.774 1.852.106 2.896-.056.088-.115.17-.176.246.228.239.368.563.368.901v.773c0 .236-.076.818-.777 1.118a5.24 5.24 0 0 1-1.524.389l-.034.003H87.439Z"
            fill="#fff"
          />
          <path
            d="M100.992 123.768v-.052s.753-.088 1.22-.818c.473-.74.159-1.513-.091-1.878-.369-.539-1.056-.969-1.443-1.492a4.987 4.987 0 0 1-.251-.379.463.463 0 0 1-.065-.238v-.399c0-.427.019-.535-.73-.842a21.32 21.32 0 0 0-.405-.163h.005v-.53a.81.81 0 0 0 .76-.81.812.812 0 0 0-.809-.815h-.2c-.211-1.54-.61-5.378-.647-12.624a.608.608 0 0 0-.004-1.213 82.713 82.713 0 0 0-.006-.657h.597c.315 0 .57-.259.57-.577v-.528h.275a.767.767 0 0 0 .764-.77V94.76h-2.48v2h-1.434v-2h-4.96v2h-1.435v-2h-2.48v4.223c0 .426.343.77.765.77h.275v.528c0 .319.254.577.57.577h.597l-.007.657a.607.607 0 0 0-.004 1.213c-.037 7.246-.435 11.084-.648 12.624h-.2a.812.812 0 0 0-.809.815.81.81 0 0 0 .761.81v.53h.005c-.128.05-.266.105-.405.163-.749.307-.73.415-.73.842v.399a.46.46 0 0 1-.066.238 4.813 4.813 0 0 1-.25.379c-.387.522-1.075.953-1.443 1.492-.25.365-.564 1.138-.091 1.878.467.73 1.22.818 1.22.818v.103l-.245.09-.775.281a.4.4 0 0 0-.247.352v.772c0 .145.089.216.22.272a4.328 4.328 0 0 0 1.237.319h13.329s.592-.044 1.236-.319c.132-.056.221-.127.221-.272v-.772a.4.4 0 0 0-.247-.352l-.775-.281-.245-.09v-.052.001Z"
            fill="#000"
          />
          <path
            d="M89.072 117.97c1.192-.009 2.257 0 3.45-.008-.473.226-.84.452-1.97.452-.418 0-1.076-.091-1.49-.262-.154-.063-.125-.185.01-.183v.001Z"
            fill="url(#z)"
          />
          <path
            d="M87.282 124.348h4.375c-.308.164-1.136.345-1.562.413-.71.112-1.645.151-2.51-.089-.086-.024-.353-.091-.402-.156-.054-.072-.023-.168.099-.168Z"
            fill="url(#A)"
          />
          <path
            d="M99.232 117.97c-.788-.009-1.492.001-2.28-.008.313.24.693.42 1.296.42.276 0 .739-.085 1.012-.266.102-.066.06-.149-.029-.146Z"
            fill="url(#B)"
          />
          <path
            d="M92.464 112.323c0 .259-.016.517-.034.775-.028.409-.007.838-.162 1.233-.12.307-.363.597-.722.735-.29.111-.705.07-.978-.087a.284.284 0 0 1-.152-.271c.338-3.686.432-7.533.466-10.583.001-.097.11-.168.228-.149.444.069.938.436 1.118.744.21.361.236.774.236 1.174v6.429Z"
            fill="url(#C)"
          />
          <path
            d="M97.53 104.958c.034 2.687.221 6.255.468 9.693a.228.228 0 0 1-.063.178c-.165.164-.434.165-.641.027-.25-.165-.335-.707-.342-1.008-.09-3.967-.109-6.131-.109-8.57 0-.299.684-.518.686-.32h.001Z"
            fill="url(#D)"
          />
          <path
            d="m90.479 99.16-1.324-.012a.768.768 0 0 1-.761-.77v-3.169c0-.085.068-.154.153-.154h.646c.084 0 .152.069.153.153l.002 1.915c0 .17.137.308.305.308l.828.004c.169 0 .306.138.306.308v1.11c0 .17-.138.308-.308.307Z"
            fill="url(#E)"
          />
          <path
            d="m98.357 99.16.764-.012a.768.768 0 0 0 .761-.77v-3.169a.154.154 0 0 0-.153-.154h-.5a.154.154 0 0 0-.153.153l-.002 1.915c0 .17-.137.308-.305.308l-.414.004a.307.307 0 0 0-.305.308v1.11c0 .17.138.308.307.307Z"
            fill="url(#F)"
          />
          <path
            d="M92.007 100.502h-2.441a.062.062 0 0 1-.061-.063v-.311c0-.036.03-.064.064-.062l2.441.099a.061.061 0 0 1 .058.063v.211a.063.063 0 0 1-.06.064v-.001Z"
            fill="url(#G)"
          />
          <path
            d="M97.362 100.501h1.374c.02 0 .035-.028.035-.063v-.31c0-.036-.016-.065-.036-.064l-1.265.101c-.018.002-.142.036-.142.118v.155c0 .035.016.063.035.063Z"
            fill="url(#H)"
          />
          <path
            d="M90.047 101.801c.979-.01 1.853.009 2.833-.001-.245.16-1.038.322-1.57.322-1.001 0-1.41-.175-1.41-.266 0-.058.1-.055.147-.055Z"
            fill="url(#I)"
          />
          <path
            d="M98.28 101.798H96.56c.249.199.606.274.937.279.38.007.718-.096.828-.186.037-.031.041-.095-.046-.093Z"
            fill="url(#J)"
          />
          <path
            d="M89.445 115.726c1.153-.012 2.182.012 3.335-.001-.602.335-1.222.404-1.849.404-1.177 0-1.658-.22-1.658-.334 0-.073.117-.068.172-.069Z"
            fill="url(#K)"
          />
          <path
            d="M98.857 115.726c-.778-.012-1.472.012-2.25-.001.407.335.825.404 1.248.404.794 0 1.118-.22 1.118-.334 0-.073-.079-.068-.116-.069Z"
            fill="url(#L)"
          />
          <path
            d="M91.084 119.491a.615.615 0 0 1 .079.337c-.046.813-.35 1.723-1.327 2.121-.531.216-1.358.083-1.571.014-.257-.083-.454-.214-.478-.559-.016-.233.159-.469.29-.629.132-.16.79-.823 1-1.13.149-.217.44-.386.7-.41.625-.058 1.142.012 1.307.256Z"
            fill="url(#M)"
          />
          <path
            d="M98.546 120.132c.035.245.268 1.275.446 1.503.29.374.604.356.944.351.245-.004.661-.085.803-.286.117-.166.076-.428-.049-.577-.427-.512-.649-.791-1.067-1.24-.155-.166-.388-.543-.64-.497-.395.072-.477.476-.438.745v.001Z"
            fill="url(#N)"
          />
          <path
            d="M98.294 124.347c.99 0 1.934 0 2.901-.003.083 0 .149.098-.116.201-.347.134-.83.241-1.169.239-.575-.003-1.05-.146-1.616-.437Z"
            fill="url(#O)"
          />
          <path
            d="m61.572 136.169-.042-.003a6.49 6.49 0 0 1-1.9-.486c-.875-.374-.97-1.099-.97-1.394v-.963c0-.388.147-.761.393-1.049a3.92 3.92 0 0 1-.423-.54c-1.053-1.625-.36-3.454.154-4.195.345-.497.912-1.067 1.46-1.619.419-.422.851-.858 1.071-1.149.151-.201.314-.444.475-.707l.002-.299v-.869c-.001-1.068.258-1.728 1.677-2.363.214-.096.432-.193.639-.279.778-2.217 2.552-8.11 2.487-15.553-.024-2.748-.284-5.595-.722-7.97h-.828a2.124 2.124 0 0 1-2.114-2.129c0-.93.59-1.72 1.41-2.013.073-.544.43-1.098.973-1.444a2.033 2.033 0 0 1-.55-1.394c0-.665.318-1.255.81-1.627-.83-1.865-2.378-5.43-3.093-7.63-.382-1.174-.068-2.104.959-2.843 1.064-.766 2.56-1.405 4.223-1.816.01-.08.025-.161.044-.239l-.649-.331.626-1.563-2.023.583V66.59l2.023.583-.626-1.562.93-.476a6.34 6.34 0 0 1 1.126-.418l-.001-.076a2.369 2.369 0 0 1 2.358-2.374 2.369 2.369 0 0 1 2.356 2.45 6.39 6.39 0 0 1 1.126.419l.93.476-.626 1.561 2.023-.583v7.696l-2.023-.583.626 1.563-.649.331c.02.078.034.158.043.239 1.663.41 3.16 1.051 4.224 1.816 1.027.739 1.34 1.669.959 2.842-.71 2.186-2.241 5.716-3.075 7.592.522.368.863.978.863 1.667 0 .553-.221 1.055-.578 1.423.52.348.857.885.928 1.416a2.13 2.13 0 0 1 1.41 2.007 2.125 2.125 0 0 1-2.114 2.134h-.827c-.437 2.376-.698 5.224-.722 7.97-.065 7.442 1.71 13.336 2.488 15.554.206.086.424.183.638.279 1.419.636 1.678 1.294 1.677 2.363v.869c0 .104 0 .204.002.299.162.264.325.506.475.707.22.292.652.728 1.07 1.15.549.551 1.116 1.122 1.46 1.619.514.741 1.208 2.57.155 4.194a3.855 3.855 0 0 1-.422.54c.245.288.392.661.392 1.049v.964c0 .295-.094 1.02-.968 1.393a6.487 6.487 0 0 1-1.901.486l-.043.003H61.571l.002-.002Z"
            fill="#fff"
          />
          <path
            d="M81.564 132.292s1.107-.126 1.795-1.185c.696-1.072.233-2.382-.135-2.911-.541-.781-1.936-1.976-2.505-2.734a10.687 10.687 0 0 1-.623-.94.58.58 0 0 1-.08-.285 23.816 23.816 0 0 1-.004-.472v-.824c0-.64.026-.9-1.002-1.361-.402-.179-.792-.35-1.07-.446h.002c-.7-1.879-2.804-8.219-2.732-16.444.024-2.739.289-6.14.927-9.105h1.758a.982.982 0 0 0 .976-.983v-.005c0-.54-.439-.983-.976-.983h-.419v-.82c0-.27-.338-.859-1.08-.859h-.61V90.64h.444a.885.885 0 0 0 .882-.888.885.885 0 0 0-.882-.888h-.443s2.62-5.734 3.593-8.727c.234-.719.07-1.115-.54-1.554-1.267-.912-3.137-1.557-4.964-1.872a.874.874 0 0 0 .28-.635c0-.496-.43-.902-.954-.902h-.165c.87-.184 1.401-.456 1.401-.456l-1.107-2.763 2.812.81v-4.656l-2.812.811 1.107-2.764s-.858-.439-2.18-.578c.265-.225.433-.56.433-.938 0-.678-.546-1.228-1.22-1.228a1.23 1.23 0 0 0-.787 2.166c-1.321.14-2.18.578-2.18.578l1.108 2.764-2.812-.81v4.656l2.812-.811-1.107 2.764s.531.271 1.401.455h-.165c-.525 0-.954.406-.954.902 0 .248.107.472.28.635-1.828.315-3.698.96-4.965 1.872-.61.44-.773.835-.539 1.554.972 2.993 3.593 8.727 3.593 8.727h-.372a.885.885 0 0 0-.882.888c0 .49.395.888.882.888h.372v1.296h-.61c-.742 0-1.08.59-1.08.86v.819h-.42a.982.982 0 0 0-.977.983v.005c0 .54.44.983.976.983h1.76c.64 2.965.904 6.366.927 9.105.072 8.224-2.031 14.563-2.732 16.443-.277.096-.668.267-1.07.447-1.027.46-1.001.72-1.001 1.36v.825c0 .167-.002.326-.004.471a.58.58 0 0 1-.08.285c-.198.331-.415.662-.624.941-.568.757-1.963 1.952-2.505 2.733-.367.53-.83 1.839-.133 2.912a2.685 2.685 0 0 0 1.795 1.185v.129l-.306.112-.966.35a.501.501 0 0 0-.308.439v.963c0 .18.11.269.275.339a5.4 5.4 0 0 0 1.541.398h19.713s.738-.055 1.54-.398c.166-.07.276-.159.276-.339v-.963a.5.5 0 0 0-.308-.439l-.966-.35-.306-.112v-.129Z"
            fill="#000"
          />
          <path
            d="M67.38 68.867a.096.096 0 0 0-.121.092v2.99c0 .07.096.084.117.02l.573-1.9a.599.599 0 0 1 .42-.399l.84-.169c.056-.015.056-.097-.002-.11l-1.827-.524Z"
            fill="url(#P)"
          />
          <path
            d="m70.071 68.404.187-1.44a.805.805 0 0 1 .192-.433c.16-.178.351-.327.564-.437.017-.009.011-.036-.009-.036a4.84 4.84 0 0 0-1.758.355.097.097 0 0 0-.053.127c.3.745.622 1.524.769 1.877.022.054.1.045.107-.013h.001Z"
            fill="url(#Q)"
          />
          <path
            d="M70.681 74.878c-.514-.01-1.085-.21-1.439-.365a.093.093 0 0 1-.046-.125c.276-.597.633-1.653.778-2.096.008-.023.042-.015.039.009a78.46 78.46 0 0 0-.207 1.728.28.28 0 0 0 .112.256c.131.097.368.292.77.563.013.008.008.03-.007.03Z"
            fill="url(#R)"
          />
          <path
            d="M73.323 66.311c.104.015.237.048.35.097a.1.1 0 0 1 .054.128c-.292.726-.475 1.307-.79 2.089-.009.021-.04.01-.036-.012.157-.844.258-1.516.401-2.286.002-.01.01-.018.021-.016Z"
            fill="url(#S)"
          />
          <path
            d="M78.232 79.416c-.033.073-.458.298-1.324.354-.492.033-1.349.076-1.985-.1-.113-.031-.145-.08.012-.102.27-.038.933-.056 1.897-.142.94-.084 1.452-.126 1.4-.01Z"
            fill="url(#T)"
          />
          <path
            d="M61.451 133.081c1.88 0 3.883-.005 5.884-.005a9.195 9.195 0 0 1-2.102.519c-.484.065-1.044.104-1.628.099a7.301 7.301 0 0 1-1.746-.21 4.04 4.04 0 0 1-.542-.194c-.179-.1-.153-.21.133-.21l.001.001Z"
            fill="url(#U)"
          />
          <path
            d="M77.955 133.076c1.3 0 2.543 0 3.815-.005.11 0 .196.123-.153.251-.456.168-1.09.3-1.536.299-.757-.004-1.381-.183-2.126-.545Z"
            fill="url(#V)"
          />
          <path
            d="M67.154 89.198h3.351a4.198 4.198 0 0 1-1.956.488c-.829 0-1.427-.33-1.49-.368-.074-.045-.06-.12.095-.12Z"
            fill="url(#W)"
          />
          <path
            d="M75.705 89.198h-1.769c.305.256.677.398 1.032.398.437 0 .784-.248.81-.294.025-.05.008-.104-.073-.104Z"
            fill="url(#X)"
          />
          <path
            d="M66.661 92.371h3.615c-.522.288-1.274.395-1.971.403-.799.009-1.522-.134-1.752-.264-.08-.045-.076-.142.108-.139Z"
            fill="url(#Y)"
          />
          <path
            d="M76.36 92.371h-2.424c.35.288.855.395 1.323.403.535.009 1.012-.139 1.167-.269.053-.045.058-.137-.065-.134Z"
            fill="url(#Z)"
          />
          <path
            d="M65.384 94.027c1.61-.013 3.046.013 4.656-.001-.84.357-1.707.431-2.581.431-1.645 0-2.315-.234-2.315-.356 0-.078.163-.074.24-.074Z"
            fill="url(#aa)"
          />
          <path
            d="M77.555 94.027c-1.184-.013-2.24.013-3.424-.001.618.358 1.256.432 1.899.432 1.209 0 1.702-.244 1.702-.366 0-.064-.12-.065-.176-.065h-.001Z"
            fill="url(#ab)"
          />
          <path
            d="M68.265 97.484c.686 3.803.88 7.002.74 10.479-.085 2.104-.33 4.216-.644 6.296-.305 2.015-.636 3.699-1.345 5.905.373.464 1.08.39 1.627.172.536-.213.85-.637.973-1.142.141-.578.206-1.222.247-1.818.256-3.787.54-7.553.354-11.347-.087-1.754-.259-5.624-.764-7.39-.179-.623-.567-.995-1.188-1.157v.002Z"
            fill="url(#ac)"
          />
          <path
            d="M74.938 119.878c-.709-3.548-.884-5.332-1.2-8.177-.277-2.487-.374-8.865.508-13.236.435.386.373.834.28 1.505-.425 3.03-.313 6.005-.216 8.814.072 2.061.822 8.281 2.015 11.435.105.276-.533.338-.751.255-.274-.102-.578-.306-.635-.595v-.001Z"
            fill="url(#ad)"
          />
          <path
            d="M64.765 122.006c1.77-.012 3.35.001 5.12-.011-.7.321-1.247.642-2.924.642-.619 0-1.597-.13-2.212-.372-.226-.089-.184-.262.017-.258l-.001-.001Z"
            fill="url(#ae)"
          />
          <path
            d="M78.453 122.006c-1.236-.012-2.34.001-3.575-.011.49.321 1.086.562 2.032.562.433 0 1.159-.113 1.588-.355.159-.089.095-.199-.045-.195v-.001Z"
            fill="url(#af)"
          />
          <path
            d="M67.124 128.584c-.883 1.005-1.943 1.562-3.93 1.205-.405-.073-.83-.262-1.013-.633-.197-.403.028-.863.26-1.247.362-.599.973-1.16 1.782-2.204.1-.127.48-.953 2.51-.844 1.336.072 1.219.894 1.22 1.029.014 1.181-.252 2.038-.83 2.693v.001Z"
            fill="url(#ag)"
          />
          <path
            d="M78.352 125.113c.39.181.706.719.97 1.061l1.16 1.504c.172.224.334.457.443.718.301.718-.163 1.203-.581 1.282-1.004.192-1.92.089-2.397-.391-.43-.433-.59-1.375-.663-1.716-.145-.674-.35-1.436-.19-2.131.107-.468.8-.539 1.258-.327Z"
            fill="url(#ah)"
          />
          <path
            d="M73.275 74.217a.25.25 0 0 1-.053.182c-.11.14-.218.243-.426.421.178-.036.76-.198.987-.301a.098.098 0 0 0 .05-.122c-.255-.682-.45-1.107-.679-1.738-.007-.02-.035-.015-.033.006.06.515.1 1.043.153 1.552Z"
            fill="url(#ai)"
          />
          <path
            d="M75.627 69.014c-.098.876-.325 2.142-.376 2.457a.143.143 0 0 1-.071.107l-.325.171.629.197c.094.03.186-.046.186-.166v-2.76c0-.034-.038-.04-.042-.007Z"
            fill="url(#aj)"
          />
          <path
            d="M70.63 75.74h-1.027c-.108.007-.27 0-.275.102-.005.077.133.276.517.305.605.047.906-.255.906-.337 0-.053-.068-.07-.12-.07Z"
            fill="url(#ak)"
          />
          <path
            d="M73.45 75.74c.165 0 .175.06.16.11-.04.13-.246.24-.47.24-.337 0-.602-.192-.601-.273 0-.059.05-.075.207-.075l.704-.003v.001Z"
            fill="url(#al)"
          />
          <path
            d="M68.242 87.942c.33.173.803.223 1.13.078.159-.07.243-.274.224-.45-.277-2.658-.52-3.955-.736-6.323a.571.571 0 0 0-.513-.52c-.786-.086-1.472-.068-2.257-.096-.232-.008-.405.263-.337.49.742 2.495 1.324 3.939 2.169 6.466a.723.723 0 0 0 .32.355Z"
            fill="url(#am)"
          />
          <path
            d="M68.05 78.956a.938.938 0 0 0 .67-.34c.156-.192.296-.378.434-.595.096-.15.227-.44.17-.504-.1-.116-.346-.077-.494-.033-.832.245-1.839.598-2.552 1.095-.07.049-.092.152-.036.217.063.072.16.099.252.118.328.07 1.069.072 1.557.043v-.001Z"
            fill="url(#an)"
          />
          <path
            d="M71.013 79.619c-.999-.012-4.306-.045-6.415-.263-.33-.034-.262.08-.21.127a.848.848 0 0 0 .255.126c.614.186 1.09.284 2.131.348 1.532.095 3.34-.042 4.25-.238.136-.03.259-.097-.01-.1Z"
            fill="url(#ao)"
          />
          <path
            d="M74.97 77.698c.46.152 1.62.584 1.573.818-.015.075-.032.137-.194.166-.567.101-.89.08-1.096-.036-.153-.086-.3-.237-.428-.357-.13-.121-.38-.388-.38-.534.003-.225.42-.092.524-.058Z"
            fill="url(#ap)"
          />
          <path
            d="M75.696 80.908c.022-.132.071-.258.182-.333a.83.83 0 0 1 .38-.112c.208-.022.571-.03.78-.015.15.01.334.027.385.17.03.084-.009.22-.033.305-.1.337-1.44 4.662-2.108 6.665-.052.156-.265.333-.459.325-.115-.005-.198-.047-.255-.16-.055-.108.057-.709.109-.968.286-1.42.93-5.354 1.018-5.877Z"
            fill="url(#aq)"
          />
          <path
            d="M70.037 91.573c-.032-.098-.095-.294-.15-.454a.192.192 0 0 0-.183-.129c-.561.005-1.061.001-1.629.007a.072.072 0 0 0-.07.072c.002.185-.003.325-.001.513 0 .03.022.054.05.054.558.003 1.656 0 1.94-.001.032 0 .052-.03.043-.062Z"
            fill="url(#ar)"
          />
          <path
            d="M73.939 91.573c.032-.098.096-.294.15-.454a.193.193 0 0 1 .184-.129c.496.006.461.007.659.007.038 0 .07.033.07.071-.002.186.003.326 0 .514 0 .03-.022.053-.051.053l-.968-.001a.046.046 0 0 1-.044-.061Z"
            fill="url(#as)"
          />
          <path
            d="M70.811 64.948a.304.304 0 0 1-.067-.007c-.148-.032-.177-.203-.182-.255-.03-.294.117-.827.642-1.003a.261.261 0 0 1 .08-.013c.04 0 .074.01.092.03.01.01.014.022.014.036 0 .017-.018.037-.052.073-.107.117-.36.392-.294.96.002.015-.014.058-.049.097a.24.24 0 0 1-.184.082Z"
            fill="url(#at)"
          />
          <path
            d="M72.297 65.196c-.021.012-.082-.005-.12-.05a.327.327 0 0 1-.061-.112c-.013-.057-.001-.104.02-.129.012-.015.045-.047.046-.048a.917.917 0 0 0 .202-.382c.006-.017.015-.026.027-.023.022.005.052.053.07.167a.823.823 0 0 1-.184.577Z"
            fill="url(#au)"
          />
        </g>
        <path
          d="M73.791 25.285c-2.166.916-2.654 3.452-3.208 5.494-.794.076-1.484.284-2.367.72l-.019.025c.604-.098 1.61-.048 2.135.2-.334 1.37-.611 2.828-1.338 3.994-.823 1.423-2.939 1.576-3.937.257-.97-1.218-.274-3.338 1.16-3.867-1.594.497-2.48 2.7-1.562 4.149.969 1.597 3.474 1.915 4.906.784 1.377-1.184 1.597-3.113 1.965-4.775.034-.153.065-.306.097-.458 2.168-.095 4.765.084 6.262-1.871 2.268-2.952-.904-6.286-4.094-4.652Zm2.414 4.576c-1.303.72-2.89.715-4.352.892.237-1.034.525-2.066.993-2.994.653-1.303 2.466-2.15 3.783-1.408 1.366.831.815 2.828-.424 3.51Z"
          fill="#DBA82B"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={63.239}
          y1={-22.785}
          x2={136.846}
          y2={87.641}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#EDC434" />
          <stop offset={0.302} stopColor="#E8B43A" />
          <stop offset={0.474} stopColor="#D29F21" />
          <stop offset={0.641} stopColor="#F2CC34" />
          <stop offset={0.823} stopColor="#ECBD39" />
          <stop offset={0.957} stopColor="#E5B832" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={41.692}
          y1={92.018}
          x2={47.797}
          y2={92.018}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={46.495}
          y1={98.746}
          x2={49.309}
          y2={98.746}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={47.58}
          y1={94.592}
          x2={50.221}
          y2={94.592}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={51.229}
          y1={97.213}
          x2={52.384}
          y2={97.213}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={46.034}
          y1={105.868}
          x2={54.983}
          y2={105.868}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={48.594}
          y1={100.882}
          x2={54.288}
          y2={100.882}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={48.404}
          y1={110.496}
          x2={54.767}
          y2={110.496}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={51.542}
          y1={113.071}
          x2={53.828}
          y2={113.071}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={48.382}
          y1={115.248}
          x2={52.543}
          y2={115.248}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={49.007}
          y1={118.61}
          x2={54.382}
          y2={118.61}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={49.029}
          y1={123.053}
          x2={54.916}
          y2={123.053}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="p"
          x1={50.233}
          y1={114.408}
          x2={51.967}
          y2={114.408}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={38.439}
          y1={97.203}
          x2={51.283}
          y2={100.778}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={42.378}
          y1={92.092}
          x2={46.534}
          y2={92.092}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={40.094}
          y1={103.08}
          x2={41.488}
          y2={103.08}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={42.118}
          y1={108.057}
          x2={52.76}
          y2={108.057}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={43.031}
          y1={115.286}
          x2={50.861}
          y2={115.286}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={41.631}
          y1={118.477}
          x2={49.087}
          y2={118.477}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={40.83}
          y1={123.083}
          x2={49.552}
          y2={123.083}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={44.028}
          y1={114.409}
          x2={47.347}
          y2={114.409}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="y"
          x1={42.84}
          y1={96.183}
          x2={45.54}
          y2={96.85}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="z"
          x1={88.958}
          y1={118.188}
          x2={95.61}
          y2={118.188}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="A"
          x1={87.157}
          y1={124.598}
          x2={95.557}
          y2={124.598}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="B"
          x1={94.347}
          y1={118.171}
          x2={99.116}
          y2={118.171}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="C"
          x1={90.414}
          y1={109.551}
          x2={94.24}
          y2={109.551}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="D"
          x1={95.573}
          y1={109.919}
          x2={97.899}
          y2={109.919}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="E"
          x1={88.394}
          y1={97.108}
          x2={92.86}
          y2={97.108}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="F"
          x1={96.034}
          y1={97.108}
          x2={99.724}
          y2={97.108}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="G"
          x1={89.505}
          y1={100.284}
          x2={94.29}
          y2={100.284}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="H"
          x1={95.74}
          y1={100.284}
          x2={98.646}
          y2={100.284}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="I"
          x1={89.901}
          y1={101.96}
          x2={95.462}
          y2={101.96}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="J"
          x1={94.592}
          y1={101.938}
          x2={98.197}
          y2={101.938}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="K"
          x1={89.273}
          y1={115.926}
          x2={95.819}
          y2={115.926}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="L"
          x1={94.006}
          y1={115.926}
          x2={98.769}
          y2={115.926}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="M"
          x1={87.787}
          y1={120.642}
          x2={94.092}
          y2={120.642}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="N"
          x1={96.038}
          y1={120.685}
          x2={100.612}
          y2={120.685}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="O"
          x1={95.022}
          y1={124.564}
          x2={101.011}
          y2={124.564}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="P"
          x1={67.259}
          y1={70.437}
          x2={70.977}
          y2={70.437}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Q"
          x1={69.187}
          y1={67.255}
          x2={72.618}
          y2={67.255}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="R"
          x1={69.187}
          y1={73.578}
          x2={72.003}
          y2={73.578}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="S"
          x1={71.984}
          y1={67.473}
          x2={73.663}
          y2={67.473}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="T"
          x1={71.082}
          y1={79.572}
          x2={77.948}
          y2={79.572}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="U"
          x1={61.204}
          y1={133.385}
          x2={72.647}
          y2={133.385}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="V"
          x1={73.656}
          y1={133.346}
          x2={81.536}
          y2={133.346}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="W"
          x1={67.015}
          y1={89.442}
          x2={73.529}
          y2={89.442}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="X"
          x1={71.901}
          y1={89.397}
          x2={75.632}
          y2={89.397}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="Y"
          x1={66.503}
          y1={92.573}
          x2={73.545}
          y2={92.573}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Z"
          x1={71.161}
          y1={92.573}
          x2={76.248}
          y2={92.573}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="aa"
          x1={65.144}
          y1={94.24}
          x2={74.283}
          y2={94.24}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ab"
          x1={70.174}
          y1={94.241}
          x2={77.428}
          y2={94.241}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="ac"
          x1={67.015}
          y1={108.995}
          x2={73.102}
          y2={108.995}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ad"
          x1={70.473}
          y1={109.484}
          x2={76.101}
          y2={109.484}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="ae"
          x1={64.596}
          y1={122.316}
          x2={74.471}
          y2={122.316}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="af"
          x1={70.797}
          y1={122.276}
          x2={78.277}
          y2={122.276}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="ag"
          x1={62.105}
          y1={127.374}
          x2={73.025}
          y2={127.374}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ah"
          x1={72.656}
          y1={127.383}
          x2={80.684}
          y2={127.383}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="ai"
          x1={71.651}
          y1={73.733}
          x2={73.75}
          y2={73.733}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="aj"
          x1={73.959}
          y1={70.472}
          x2={75.602}
          y2={70.472}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="ak"
          x1={69.327}
          y1={75.945}
          x2={71.985}
          y2={75.945}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="al"
          x1={71.355}
          y1={75.915}
          x2={73.522}
          y2={75.915}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="am"
          x1={65.739}
          y1={84.369}
          x2={72.945}
          y2={84.369}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="an"
          x1={66.21}
          y1={78.207}
          x2={72.049}
          y2={78.207}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ao"
          x1={64.344}
          y1={79.67}
          x2={77.093}
          y2={79.67}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ap"
          x1={72.138}
          y1={78.188}
          x2={76.363}
          y2={78.188}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aq"
          x1={71.386}
          y1={84.177}
          x2={77.186}
          y2={84.177}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="ar"
          x1={67.415}
          y1={91.314}
          x2={71.85}
          y2={91.314}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="as"
          x1={72.764}
          y1={91.313}
          x2={74.913}
          y2={91.313}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <linearGradient
          id="at"
          x1={70.557}
          y1={64.309}
          x2={72.112}
          y2={64.309}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="au"
          x1={71.698}
          y1={64.825}
          x2={72.454}
          y2={64.825}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAA72A" />
          <stop offset={0.2} stopColor="#ECC235" />
          <stop offset={0.36} stopColor="#EDBE39" />
          <stop offset={0.5} stopColor="#D7A326" />
          <stop offset={0.64} stopColor="#D9A825" />
          <stop offset={0.77} stopColor="#ECC036" />
          <stop offset={0.9} stopColor="#DDA92D" />
          <stop offset={1} stopColor="#ECC036" />
        </linearGradient>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(.337 .5)"
            d="M0 0h142.326v160H0z"
          />
        </clipPath>
        <filter
          id="c"
          x={12.996}
          y={14.626}
          width={117.01}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={12} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend in2="shape" result="effect1_innerShadow_18_3711" />
        </filter>
      </defs>
    </svg>
  ),
  // -----------------------------------------------------------PLATINUM:SVG----------------------------------------------------------------------------------------------------------
  platinum: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="11 0 120 160"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="M81.374 53.15a11.189 11.189 0 0 0 2.367-1.827v14.345c0 3.705-1.981 7.129-5.194 8.983L47.062 92.805a10.394 10.394 0 0 1-10.383 0L5.194 74.651A10.372 10.372 0 0 1 0 65.668V51.323c.694.704 1.488 1.321 2.367 1.828L36.28 72.706a11.189 11.189 0 0 0 11.183 0L81.375 53.15h-.001Z"
          fill="#303644"
        />
        <path
          d="M83.74 29.357v19.035a11.152 11.152 0 0 1-2.366 1.827L47.462 69.774a11.188 11.188 0 0 1-11.183 0L2.367 50.221A11.22 11.22 0 0 1 0 48.392V29.358c0-3.706 1.98-7.13 5.194-8.984L36.679 2.22a10.395 10.395 0 0 1 10.384 0l31.485 18.156a10.37 10.37 0 0 1 5.194 8.981h-.001Z"
          fill="url(#b)"
        />
        <g filter="url(#c)">
          <path
            d="M76.294 62.665V32.36a8.135 8.135 0 0 0-4.072-7.045L45.944 10.162a8.154 8.154 0 0 0-8.146 0L11.52 25.314a8.132 8.132 0 0 0-4.072 7.045v30.305a8.132 8.132 0 0 0 4.072 7.045l26.278 15.153a8.154 8.154 0 0 0 8.146 0l26.278-15.153a8.132 8.132 0 0 0 4.072-7.045v.001Z"
            fill="#fff"
          />
        </g>
        <mask
          id="d"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={7}
          y={9}
          width={70}
          height={77}
        >
          <path
            d="M76.294 62.665V32.36a8.135 8.135 0 0 0-4.072-7.045L45.944 10.162a8.154 8.154 0 0 0-8.146 0L11.52 25.314a8.132 8.132 0 0 0-4.072 7.045v30.305a8.132 8.132 0 0 0 4.072 7.045l26.278 15.153a8.154 8.154 0 0 0 8.146 0l26.278-15.153a8.132 8.132 0 0 0 4.072-7.045v.001Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <path
            d="M16.987 35.555v-6.449h2.795c.578 0 1.076.096 1.494.286.418.184.74.451.968.802.228.35.341.767.341 1.252 0 .48-.113.894-.34 1.244-.228.35-.551.62-.97.81-.417.185-.915.277-1.493.277h-1.965l.664-.672v2.45h-1.494Zm1.494-2.285-.664-.709h1.881c.462 0 .806-.098 1.034-.295.227-.196.34-.47.34-.82 0-.356-.113-.632-.34-.829-.228-.196-.572-.295-1.034-.295h-1.881l.664-.709v3.657ZM23.652 35.555v-6.449h1.494v5.233h3.238v1.216h-4.732ZM28.406 35.555l2.878-6.449h1.476l2.887 6.449h-1.568l-2.361-5.693h.59l-2.37 5.693h-1.532Zm1.44-1.382.396-1.133h3.32l.406 1.133h-4.123ZM37.33 35.555v-5.233h-2.066v-1.216h5.626v1.216h-2.066v5.233H37.33ZM41.694 35.555v-6.449h1.494v6.449h-1.494ZM44.72 35.555v-6.449h1.236l3.81 4.643h-.6v-4.643h1.476v6.449h-1.227l-3.818-4.643h.6v4.643H44.72ZM55.038 35.666c-.916 0-1.632-.255-2.149-.765-.516-.51-.775-1.238-.775-2.183v-3.612h1.495v3.556c0 .614.126 1.057.378 1.327s.605.405 1.06.405c.455 0 .809-.135 1.061-.405.252-.27.378-.712.378-1.327v-3.556h1.476v3.612c0 .945-.258 1.673-.775 2.183-.516.51-1.233.764-2.149.764ZM59.439 35.555v-6.449h1.236l2.748 4.551h-.655l2.703-4.55h1.227l.018 6.448h-1.402l-.01-4.302h.26l-2.16 3.62h-.673l-2.204-3.62h.314v4.302h-1.402ZM29.683 27.528c-.149 0-.288-.024-.417-.072a1 1 0 0 1-.554-.527 1.016 1.016 0 0 1-.077-.401c0-.146.026-.28.077-.4a.987.987 0 0 1 .222-.319.994.994 0 0 1 .334-.207c.128-.05.267-.075.418-.075.168 0 .32.03.454.089.137.057.25.142.343.254l-.288.265a.656.656 0 0 0-.221-.168.681.681 0 0 0-.515-.014.564.564 0 0 0-.326.323.686.686 0 0 0-.044.252.599.599 0 0 0 .174.448c.055.055.12.097.196.127a.68.68 0 0 0 .515-.011.676.676 0 0 0 .221-.174l.288.265a.899.899 0 0 1-.343.257 1.129 1.129 0 0 1-.457.088ZM31.198 26.34h.933v.348h-.933v-.348Zm.033.796h1.055v.36h-1.5V25.56h1.464v.359H31.23v1.216ZM32.642 27.495v-1.934h.839c.173 0 .323.028.448.085a.648.648 0 0 1 .29.24c.069.106.103.23.103.377a.67.67 0 0 1-.103.373.654.654 0 0 1-.29.237 1.106 1.106 0 0 1-.448.083h-.59l.2-.196v.735h-.449Zm1.232 0-.485-.702h.48l.489.702h-.484Zm-.783-.685-.2-.21h.565c.138 0 .241-.03.31-.089a.316.316 0 0 0 .102-.248.311.311 0 0 0-.102-.25c-.069-.058-.172-.088-.31-.088h-.565l.2-.213v1.098ZM35.051 27.495v-1.57h-.62v-.364h1.688v.364h-.62v1.57h-.448ZM36.36 27.495v-1.934h.449v1.934h-.448ZM37.684 26.431h.93v.36h-.93v-.36Zm.033 1.064h-.448v-1.934h1.463v.359h-1.015v1.575ZM39.036 27.495v-1.934h.448v1.934h-.448ZM40.356 26.34h.932v.348h-.932v-.348Zm.033.796h1.054v.36h-1.5V25.56h1.465v.359h-1.019v1.216ZM41.8 27.495v-1.934h.88c.21 0 .396.04.556.121.16.08.286.19.377.335a.94.94 0 0 1 .135.51.95.95 0 0 1-.136.512.928.928 0 0 1-.376.337c-.16.08-.346.12-.556.12h-.88Zm.448-.367h.41a.73.73 0 0 0 .335-.072.53.53 0 0 0 .221-.21.612.612 0 0 0 .08-.318.602.602 0 0 0-.08-.318.513.513 0 0 0-.221-.207.706.706 0 0 0-.335-.075h-.41v1.2ZM45.797 27.528c-.15 0-.289-.024-.418-.072a1 1 0 0 1-.553-.527 1.014 1.014 0 0 1-.078-.401c0-.146.026-.28.078-.4a.986.986 0 0 1 .22-.319.996.996 0 0 1 .336-.207c.127-.05.266-.075.418-.075.167 0 .319.03.453.089.137.057.251.142.343.254l-.287.265a.656.656 0 0 0-.222-.168.681.681 0 0 0-.515-.014.564.564 0 0 0-.326.323.684.684 0 0 0-.044.252.598.598 0 0 0 .174.448c.055.055.121.097.197.127a.68.68 0 0 0 .514-.011.676.676 0 0 0 .222-.174l.288.265a.899.899 0 0 1-.344.257 1.129 1.129 0 0 1-.456.088ZM47.8 27.528c-.154 0-.296-.025-.427-.074a.987.987 0 0 1-.559-.528 1.006 1.006 0 0 1-.077-.398c0-.144.026-.277.077-.398a.967.967 0 0 1 .224-.318c.096-.09.209-.16.338-.21.13-.05.27-.075.42-.075.154 0 .294.025.421.075a.992.992 0 0 1 .56.528c.053.12.08.252.08.398a.967.967 0 0 1-.64.926 1.14 1.14 0 0 1-.417.074Zm-.003-.381a.622.622 0 0 0 .238-.044.57.57 0 0 0 .32-.324.65.65 0 0 0 .048-.251.65.65 0 0 0-.175-.448.542.542 0 0 0-.19-.127.644.644 0 0 0-.241-.044.578.578 0 0 0-.562.368.686.686 0 0 0-.044.25.621.621 0 0 0 .172.448.57.57 0 0 0 .193.128c.074.03.154.044.24.044ZM48.912 27.495l.863-1.934h.443l.866 1.934h-.47l-.709-1.708h.177l-.71 1.708h-.46Zm.431-.415.12-.34h.996l.121.34h-1.237ZM52.185 27.528c-.15 0-.289-.024-.418-.072a.999.999 0 0 1-.553-.527 1.014 1.014 0 0 1-.078-.401c0-.146.026-.28.078-.4a.987.987 0 0 1 .221-.319.994.994 0 0 1 .335-.207c.127-.05.266-.075.418-.075.167 0 .319.03.453.089.137.057.251.142.343.254l-.287.265a.656.656 0 0 0-.222-.168.681.681 0 0 0-.515-.014.566.566 0 0 0-.326.323.686.686 0 0 0-.044.252.6.6 0 0 0 .174.448c.056.055.121.097.197.127a.68.68 0 0 0 .514-.011.677.677 0 0 0 .222-.174l.287.265a.898.898 0 0 1-.343.257 1.128 1.128 0 0 1-.456.088ZM54.615 25.56h.449v1.935h-.449v-1.934Zm-.88 1.935h-.448v-1.934h.449v1.934Zm.914-.793h-.947v-.379h.947v.379Z"
            fill="#605E62"
          />
          <path
            d="M71.346 81.243H51.684l-1.806-5.874h16.049l5.419 5.874Z"
            fill="#000"
          />
          <path
            d="M81.974 75.37H65.926l-3.736-4.05h13.556l6.228 4.05ZM54.54 90.53H29.167l2.856-9.287h19.661l2.856 9.287ZM32.023 81.243H12.362l5.419-5.874H33.83l-1.807 5.874Z"
            fill="#000"
          />
          <path
            d="M17.781 75.37H1.733l6.228-4.05h13.557l-3.737 4.05Z"
            fill="#000"
          />
          <path
            d="m24.026 73.683-.02-.002a3.14 3.14 0 0 1-.956-.25.705.705 0 0 1-.42-.644v-.458c0-.2.084-.392.22-.534a1.549 1.549 0 0 1-.105-.146c-.448-.696-.154-1.478.064-1.795.143-.207.347-.464.545-.712.123-.154.24-.302.33-.422.172-.231.277-.631.288-.732v-.096c.002-.286.108-.465.253-.59a.727.727 0 0 1-.208-.24 19.249 19.249 0 0 1-.427-.837l-.016-.036c-.135-.293-.221-.558-.003-1.073l.024-.057c.262-.622.875-2.08 3.047-4.357l.08-.086h-.03c-.409.027-.817.072-1.28.317-.107.092-.177.223-.258.373-.084.156-.179.333-.333.476-.26.24-.733.29-1.084.29-.69 0-1.094-.2-1.2-.593a.776.776 0 0 1-.025-.18 1.03 1.03 0 0 1-.505-.127c-.178-.096-.485-.26-.57-1.9-.04-.283.036-.707.386-1.048l.048-.047c.331-.322 1.339-1.3 1.901-2.268.095-.163.216-.32.361-.465.222-.225.438-.396.604-.518l-.217-.247c-.452-.508-.778-.875-.725-1.314a.716.716 0 0 1 .312-.508c.107-.074.306-.21.676-.21.34 0 .931.098 2.502.857.215.024.42.055.626.095.483.094.943.235 1.372.42l-.008-.111.915.595c.312.203.606.437.876.697l.101.098.041.135.03.102.063-.304.721 1.159c.267.429.497.908.682 1.425l.047.128-.02.136c-.043.288-.108.61-.203.952l.453-.565.19 1.224a11.055 11.055 0 0 1 .112 2.059l-.005.146-.078.123a7.928 7.928 0 0 1-.687.935l.764-.427-.183 1.116c-.09.553-.21 1.093-.356 1.61l.051-.014-.37.991c-.104.276-.216.544-.334.797a.727.727 0 0 1-.239.284c.14.123.242.3.244.58v.098c.011.1.116.5.288.731.09.12.208.269.33.423.197.248.402.505.544.713.218.316.513 1.098.064 1.794-.033.052-.069.101-.105.146.136.142.22.334.22.534v.459c0 .277-.165.53-.42.643a3.14 3.14 0 0 1-.956.25l-.02.002h-8.01.001Z"
            fill="#fff"
          />
          <path
            d="m32.738 72.12-.463-.166-.147-.053v-.061s.45-.052.73-.485c.283-.439.095-.975-.055-1.191-.22-.32-.63-.809-.862-1.118-.262-.351-.397-.904-.397-1.047v-.106c-.001-.14-.014-.183-.29-.296-.056-.024-.292-.11-.314-.118-.002 0-.003 0-.005-.002a.307.307 0 0 1-.15-.27c0-.17.121-.306.272-.306h.366c.071 0 .137-.04.167-.105.115-.246.22-.5.317-.757a8.367 8.367 0 0 1-1.589.259 10.34 10.34 0 0 0 1.83-.973c.178-.586.312-1.184.408-1.77-1.296.726-2.793.972-2.793.972 1.53-.891 2.447-1.952 2.975-2.796a10.471 10.471 0 0 0-.065-1.663c-.013-.1-.027-.198-.042-.294-1.08 1.346-2.313 1.98-2.313 1.98 1.243-1.21 1.713-2.676 1.873-3.755a6.926 6.926 0 0 0-.632-1.321c-.29 1.398-.91 2.165-.91 2.165.402-1.281.297-2.397.037-3.25a5.284 5.284 0 0 0-.794-.633c.043.636-.014 1.402-.227 2.02.004-1.052-.258-1.861-.56-2.444a6.138 6.138 0 0 0-1.297-.401 7.875 7.875 0 0 0-.677-.098c-2.212-1.08-2.514-.869-2.715-.73-.317.218.35.788.92 1.486.134.163.134.276 0 .378-.114.086-.455.292-.816.657a1.776 1.776 0 0 0-.277.356c-.631 1.087-1.761 2.16-2.04 2.431-.29.283-.223.6-.223.6s.067 1.362.29 1.482c.414.228.933-.28 1.05-.15.096.106-.323.542-.256.793.067.25 1.173.24 1.386.043.212-.196.29-.626.659-.905.583-.32 1.094-.375 1.55-.404.086-.006.541.004.662.124.226.225.1.477-.285.88-2.172 2.278-2.714 3.66-2.964 4.25-.15.356-.09.444.014.673.096.212.312.619.411.804.032.06.094.097.161.097h.344c.15 0 .273.136.273.305 0 .12-.063.225-.155.273-.022.008-.258.094-.315.118-.275.112-.288.155-.289.296V68c0 .143-.135.695-.397 1.046-.23.31-.642.799-.862 1.118-.15.217-.338.753-.055 1.192.28.433.73.485.73.485v.061l-.147.053-.463.167a.238.238 0 0 0-.147.208v.458c0 .064.038.12.095.146.399.177.775.204.775.204h7.969s.376-.028.775-.204a.16.16 0 0 0 .095-.146v-.458a.238.238 0 0 0-.147-.208l.001-.001Z"
            fill="#000"
          />
          <path
            d="M26.948 54.303a77.95 77.95 0 0 1-.654-.356c.064.06.426.392.581.545a.091.091 0 0 0 .066.027c.38-.007.757-.019 1.137-.025-.467-.09-.844-.134-.994-.15a.364.364 0 0 1-.136-.041Z"
            fill="url(#e)"
          />
          <path
            d="M28.39 56.733c.1.356.237 1.002.149 1.583-.075.49-.341.916-.602 1.267.708-.525.79-1.133.807-1.298.073-.677-.138-1.114-.355-1.552Z"
            fill="url(#f)"
          />
          <path
            d="M29.417 56.626c-.048-.791-.22-1.28-.355-1.567a.981.981 0 0 0-.417-.214c.29.37.566.913.772 1.781Z"
            fill="url(#g)"
          />
          <path
            d="M30.314 58.618c.046-.255.29-1.57.039-2.708.02.019.167.194.247.322.149.815-.048 1.833-.286 2.386Z"
            fill="url(#h)"
          />
          <path
            d="M29.763 64.079c1.018-.612 2.123-1.614 2.602-2.406.026-.404.005-.602-.01-1.123-.075.412-.219 1.107-.219 1.107s-.747 1.256-2.373 2.422Z"
            fill="url(#i)"
          />
          <path
            d="M30.223 61.3c.95-1.003 1.41-1.926 1.664-3.012a4.313 4.313 0 0 0-.29-.777c.05.22.079.487.082.82-.135.8-.624 1.93-1.455 2.97V61.3Z"
            fill="url(#j)"
          />
          <path
            d="M30.326 65.938c.568-.27 1.021-.516 1.555-.849.119-.358.21-.687.305-.996-.08.18-.25.5-.353.691a.867.867 0 0 1-.234.275c-.21.16-.639.478-1.273.88Z"
            fill="url(#k)"
          />
          <path
            d="M31.53 66.331c-.054.116-.082.189-.156.31a.134.134 0 0 1-.11.06c-.154.007-.264-.001-.402-.001.129-.046.283-.058.398-.121a.874.874 0 0 0 .27-.248Z"
            fill="url(#l)"
          />
          <path
            d="M29.605 67.705c.336-.005 1.097-.004 1.156-.004.155 0 .017.174-.47.174-.27 0-.51-.077-.685-.17Z"
            fill="url(#m)"
          />
          <path
            d="M31.006 68.798c.023.018.173.366.223.47.18.371.647 1.005.681 1.067.045.08.019.188-.032.265-.062.092-.177.13-.283.163-.127.037-.57.061-.851-.166-.32-.257-.339-.644-.361-.788-.041-.257-.017-.743.07-.944.077-.177.384-.198.553-.066Z"
            fill="url(#n)"
          />
          <path
            d="M30.541 72.215c.572 0 1.12 0 1.678-.002.049 0 .086.058-.067.12-.2.079-.48.142-.675.141-.333-.002-.608-.087-.935-.259Z"
            fill="url(#o)"
          />
          <path
            d="M29.919 67.423c-.008.008-.006.029.003.029.245-.004.353-.002.468-.003.017 0 .03-.026.03-.058v-.189c0-.03-.013-.056-.03-.056-.037-.001-.111-.005-.148.008-.019.006-.125.073-.323.269Z"
            fill="url(#p)"
          />
          <path
            d="M22.47 60.413a3.987 3.987 0 0 0-.089-.562 4.023 4.023 0 0 1-.088-.557 1.045 1.045 0 0 1 .03-.342.54.54 0 0 1 .215-.294l.153-.096c.113-.069.21-.128.306-.205a5.339 5.339 0 0 0 1.346-1.552c.052-.093.101-.19.149-.284.08-.158.164-.319.264-.467.238-.349 1.017-.813 1.351-.905-.267.282-.261.51-.258.64.107.019.349.085.493.269a.518.518 0 0 1 .107.388c-.164-.178-.562-.339-.853-.339a.531.531 0 0 0-.164.023c-.286.092-.398.255-.552.48-.108.157-.205.34-.3.515-.049.092-.098.183-.147.269-.264.459-.663.882-1.256 1.331a.503.503 0 0 1-.326.108 1.479 1.479 0 0 1-.105-.002.227.227 0 0 0-.088.013c-.138.058-.181.262-.167.388.018.159.094.254.204.254a.213.213 0 0 0 .084-.019c.124-.053.237-.182.345-.394a.524.524 0 0 1-.192.62.52.52 0 0 1-.214.09l-.06.015v.014c.002.325-.142.576-.188.605v-.004Zm4.001-3.674a1.088 1.088 0 0 1-.309.403c-.25.192-.576.21-.872.15.258.294.819.294 1.068-.01a.58.58 0 0 0 .132-.374.77.77 0 0 0-.019-.17Z"
            fill="url(#q)"
          />
          <path
            d="M25.648 54.72c.044.049.086.084.15.095a.314.314 0 0 0 .226-.044c.078-.052-.076-.195-.151-.252-.611-.47-1.07-.805-1.137-.786.229.248.4.414.912.986Z"
            fill="url(#r)"
          />
          <path
            d="M23.392 61.125c.159-.02.28-.13.346-.277.067-.146.093-.376.093-.597-.046.078-.072.14-.1.194l-.116.235a97.16 97.16 0 0 1-.223.445Z"
            fill="url(#s)"
          />
          <path
            d="M25.398 65.51c-.02.206.096.517.37.94a.091.091 0 0 1-.075.142c-.152 0-.342-.001-.434-.003a.322.322 0 0 1-.267-.152 4.772 4.772 0 0 1-.367-.671.462.462 0 0 1-.017-.344c.36-1.049.876-1.755 1.477-2.545.694-.912 1.556-1.549 1.828-2.285.08.369-.038.822-.446 1.338-.805 1.018-1.909 2.514-2.069 3.58Z"
            fill="url(#t)"
          />
          <path
            d="M27.588 67.701a5.001 5.001 0 0 1-1.358.22c-.347 0-.678-.042-1.005-.127-.052-.014-.11-.036-.105-.062.006-.03.118-.03.166-.03h2.302Z"
            fill="url(#u)"
          />
          <path
            d="M26.453 70.1c-.088.171-.18.347-.325.477-.176.16-.418.237-.66.261-.296.03-.487.03-.767-.072a.812.812 0 0 1-.295-.168.372.372 0 0 1-.108-.301c.031-.317.546-.773.802-1.317.073-.156.156-.319.307-.408.113-.067.3-.083.432-.082.284.003.488.032.675.183.192.155.177.966-.06 1.427Z"
            fill="url(#v)"
          />
          <path
            d="M23.935 72.215h2.638c-.309.12-.502.177-.942.245-.216.033-.468.05-.73.047a3.097 3.097 0 0 1-.783-.1 1.7 1.7 0 0 1-.243-.093c-.08-.047-.069-.1.06-.1Z"
            fill="url(#w)"
          />
          <path
            d="M26.743 67.423c.016.008.01.029-.008.029-.505-.004-.727-.002-.965-.004-.035 0-.064-.025-.064-.057 0-.068 0-.12.002-.189 0-.03.028-.056.063-.056.074-.002.16.013.236.02.04.003.327.061.736.257Z"
            fill="url(#x)"
          />
          <path
            d="M25.397 57.076a.113.113 0 0 1-.05-.01c-.054-.023-.083-.09-.083-.143 0-.113.073-.232.108-.272a.399.399 0 0 1 .291-.133c.04 0 .08.006.12.02a.488.488 0 0 0-.192.151.497.497 0 0 0-.084.226l-.005.044c-.006.06-.011.112-.08.116a.397.397 0 0 1-.025.001Z"
            fill="url(#y)"
          />
          <path
            d="m51.248 74.543-.02-.001a3.086 3.086 0 0 1-.896-.228.692.692 0 0 1-.457-.652v-.45c0-.198.082-.387.217-.526a1.597 1.597 0 0 1-.104-.144c-.393-.61-.225-1.273.063-1.69.149-.217.348-.395.524-.553.133-.119.26-.232.336-.334.025-.033.051-.072.08-.116v-.174c-.001-.399.13-.618.391-.786a1.014 1.014 0 0 1 .476-1.51c.127-1.073.295-3.12.323-6.562a.89.89 0 0 1-.265-1.021.876.876 0 0 1-.399-.582.987.987 0 0 1-.627-.918v-3.001h8.6v3c0 .417-.26.775-.628.919a.875.875 0 0 1-.399.582.888.888 0 0 1-.264 1.02c.027 3.443.196 5.49.323 6.563a1.013 1.013 0 0 1 .475 1.51c.261.168.392.387.392.786v.174c.028.044.054.082.079.115.077.103.203.216.336.335.176.158.375.336.525.552.288.418.456 1.082.063 1.69-.034.052-.068.1-.104.144.134.14.216.328.216.526v.45a.692.692 0 0 1-.457.653 3.09 3.09 0 0 1-.896.227l-.02.002h-7.883Z"
            fill="#fff"
          />
          <path
            d="M59.222 72.76v-.031s.444-.051.718-.477c.279-.432.094-.883-.053-1.096-.217-.315-.621-.566-.85-.87a2.892 2.892 0 0 1-.147-.222.267.267 0 0 1-.038-.139v-.233c0-.249.01-.312-.43-.491a13.778 13.778 0 0 0-.238-.095h.003v-.31a.475.475 0 0 0-.029-.948h-.117c-.125-.898-.36-3.138-.381-7.366a.356.356 0 0 0 .331-.354.356.356 0 0 0-.334-.354l-.003-.383h.351a.336.336 0 0 0 .335-.337v-.308h.162a.45.45 0 0 0 .45-.45v-2.464h-1.459v1.167h-.844v-1.167H53.73v1.167h-.844v-1.167h-1.459v2.465c0 .248.202.45.45.45h.162v.307c0 .186.15.337.335.337h.352c-.002.129-.004.257-.004.383a.355.355 0 0 0-.003.708c-.021 4.228-.256 6.468-.38 7.366h-.118a.475.475 0 0 0-.028.949v.31h.002c-.075.028-.156.06-.239.094-.44.18-.43.242-.43.491v.233a.266.266 0 0 1-.037.139 2.78 2.78 0 0 1-.148.221c-.228.305-.632.556-.849.871-.147.213-.332.664-.053 1.096.275.426.718.477.718.477v.06l-.145.053-.456.163a.235.235 0 0 0-.145.206v.45c0 .085.052.126.13.16.379.16.727.186.727.186h7.843s.348-.026.727-.187c.078-.033.13-.074.13-.158v-.451a.234.234 0 0 0-.146-.206l-.455-.163-.145-.053v-.03Z"
            fill="#000"
          />
          <path
            d="M52.21 69.376c.7-.005 1.327 0 2.029-.005-.278.132-.495.264-1.16.264-.245 0-.633-.053-.876-.153-.09-.037-.073-.108.006-.107Z"
            fill="url(#z)"
          />
          <path
            d="M51.156 73.098h2.574c-.181.095-.668.201-.92.24-.417.066-.967.089-1.476-.051-.05-.014-.208-.053-.236-.091-.032-.042-.014-.098.058-.098Z"
            fill="url(#A)"
          />
          <path
            d="M58.187 69.376c-.464-.005-.878 0-1.341-.005.184.14.407.245.762.245.162 0 .435-.05.596-.155.06-.039.035-.087-.017-.085Z"
            fill="url(#B)"
          />
          <path
            d="M54.205 66.08c0 .152-.01.302-.02.453-.016.239-.005.489-.096.72a.747.747 0 0 1-.424.428.737.737 0 0 1-.576-.05.166.166 0 0 1-.09-.159c.2-2.15.255-4.395.275-6.175.001-.057.065-.098.134-.087.261.04.552.254.658.434.124.211.139.452.139.685v3.752Z"
            fill="url(#C)"
          />
          <path
            d="M57.185 61.783c.02 1.567.13 3.65.276 5.656a.132.132 0 0 1-.038.104c-.096.095-.255.096-.377.016-.146-.097-.197-.413-.2-.589a198.739 198.739 0 0 1-.065-5c0-.175.403-.303.404-.187Z"
            fill="url(#D)"
          />
          <path
            d="m53.037 58.4-.78-.008a.45.45 0 0 1-.447-.449v-1.85c0-.049.04-.09.09-.09h.38c.05 0 .09.041.09.09l.002 1.118c0 .1.08.18.18.18l.486.002c.1 0 .18.08.18.18v.647c0 .1-.081.18-.181.18Z"
            fill="url(#E)"
          />
          <path
            d="m57.672 58.4.45-.008a.45.45 0 0 0 .447-.449v-1.85a.09.09 0 0 0-.09-.09h-.294a.09.09 0 0 0-.09.09l-.001 1.118c0 .1-.08.18-.18.18l-.243.002c-.1 0-.18.08-.18.18v.647c0 .1.081.18.181.18Z"
            fill="url(#F)"
          />
          <path
            d="M53.936 59.182H52.5a.036.036 0 0 1-.036-.036v-.182c0-.02.017-.037.037-.036l1.437.058c.02 0 .034.017.034.036v.124c0 .02-.016.037-.036.037Z"
            fill="url(#G)"
          />
          <path
            d="M57.087 59.183h.808c.011 0 .02-.017.02-.037v-.181c0-.022-.009-.038-.02-.037l-.745.058c-.01.001-.083.021-.083.07v.09c0 .02.009.037.02.037Z"
            fill="url(#H)"
          />
          <path
            d="M52.782 59.94c.577-.006 1.091.006 1.667 0-.144.093-.61.188-.924.188-.588 0-.829-.102-.829-.156 0-.034.059-.031.086-.032Z"
            fill="url(#I)"
          />
          <path
            d="M57.626 59.938h-1.01c.145.117.356.16.55.163.224.004.423-.056.487-.108.023-.018.025-.056-.027-.055Z"
            fill="url(#J)"
          />
          <path
            d="M52.429 68.067c.678-.008 1.283.007 1.962-.001-.354.195-.72.236-1.088.236-.693 0-.975-.129-.975-.195 0-.043.068-.04.1-.04Z"
            fill="url(#K)"
          />
          <path
            d="M57.966 68.067c-.457-.008-.866.007-1.323-.001.239.195.485.236.734.236.467 0 .658-.129.658-.195 0-.043-.047-.04-.068-.04Z"
            fill="url(#L)"
          />
          <path
            d="M53.393 70.263c.034.05.05.136.046.197-.027.474-.206 1.005-.78 1.237-.313.126-.8.049-.925.009-.151-.049-.267-.125-.28-.326-.01-.137.093-.274.17-.368.077-.093.464-.48.588-.659a.605.605 0 0 1 .412-.24c.368-.033.672.008.769.15Z"
            fill="url(#M)"
          />
          <path
            d="M57.783 70.637c.02.143.158.744.262.877.171.219.356.208.556.205.144-.002.389-.05.472-.167.07-.097.045-.25-.028-.337-.252-.299-.382-.462-.628-.724-.091-.096-.229-.316-.377-.29-.232.043-.28.279-.258.436Z"
            fill="url(#N)"
          />
          <path
            d="M57.635 73.098c.582 0 1.138 0 1.707-.002.049 0 .087.057-.069.117-.204.079-.487.14-.687.14-.338-.002-.618-.086-.95-.255Z"
            fill="url(#O)"
          />
          <path
            d="m36.03 79.996-.026-.001a3.857 3.857 0 0 1-1.118-.284c-.514-.218-.57-.641-.57-.813v-.562c0-.227.086-.444.23-.612a2.27 2.27 0 0 1-.248-.316c-.62-.948-.212-2.015.09-2.447.204-.29.537-.623.86-.945.246-.246.5-.5.63-.671.089-.117.184-.259.28-.412V72.25c0-.623.152-1.008.987-1.379.126-.056.254-.112.376-.163.458-1.293 1.502-4.732 1.463-9.076-.014-1.603-.167-3.264-.425-4.65h-.487a1.244 1.244 0 0 1-.414-2.417c.043-.318.253-.64.572-.843a1.181 1.181 0 0 1 .153-1.762c-.488-1.089-1.399-3.17-1.82-4.453-.224-.685-.04-1.228.565-1.659.626-.447 1.507-.82 2.485-1.06.006-.047.014-.094.025-.139l-.381-.194.368-.911-1.19.34v-4.491l1.19.34-.368-.911.547-.278c.039-.02.277-.137.662-.244v-.044a1.388 1.388 0 0 1 2.774 0v.044c.385.107.623.224.662.244l.547.278-.368.911 1.19-.34v4.49l-1.19-.34.368.912-.382.194c.012.045.02.092.026.14.978.24 1.859.613 2.485 1.059.604.431.788.974.564 1.659-.418 1.275-1.319 3.335-1.81 4.43a1.185 1.185 0 0 1 .169 1.803c.305.203.504.516.546.826a1.244 1.244 0 0 1-.415 2.416h-.486c-.258 1.387-.41 3.049-.425 4.651-.038 4.343 1.006 7.782 1.464 9.076.12.05.25.107.375.164.835.37.987.755.987 1.379v.507l.001.174c.095.154.191.295.28.412.129.171.383.425.63.671.322.322.656.655.859.945.302.432.71 1.5.09 2.448a2.252 2.252 0 0 1-.248.315c.144.168.23.385.23.612v.562c0 .172-.055.596-.569.814a3.853 3.853 0 0 1-1.118.283l-.026.002H36.028l.001-.002Z"
            fill="#fff"
          />
          <path
            d="M47.791 77.734s.652-.074 1.057-.692c.409-.626.136-1.39-.08-1.698-.318-.456-1.139-1.154-1.474-1.596a6.298 6.298 0 0 1-.366-.548.336.336 0 0 1-.047-.167 13.115 13.115 0 0 1-.003-.275v-.481c0-.373.016-.526-.589-.794a8.965 8.965 0 0 0-.63-.26h.002c-.413-1.097-1.65-4.797-1.608-9.596.014-1.598.17-3.583.546-5.313h1.034a.576.576 0 0 0 .574-.574v-.003a.576.576 0 0 0-.574-.574h-.247v-.477c0-.158-.199-.502-.635-.502h-.359v-.756h.261a.518.518 0 1 0 0-1.037h-.26s1.541-3.346 2.113-5.092c.138-.42.042-.651-.317-.907-.745-.532-1.846-.909-2.92-1.092a.508.508 0 0 0 .164-.371c0-.29-.253-.526-.562-.526h-.097c.512-.108.825-.266.825-.266l-.652-1.613 1.655.473V40.28l-1.655.473.652-1.613s-.505-.256-1.282-.337a.717.717 0 1 0-.926 0c-.779.082-1.283.337-1.283.337l.652 1.613-1.655-.473v2.717l1.655-.473-.652 1.613s.313.158.824.266h-.097c-.309 0-.561.236-.561.526 0 .144.063.275.164.37-1.075.184-2.175.56-2.92 1.093-.36.256-.456.487-.318.907.572 1.746 2.114 5.092 2.114 5.092h-.219a.518.518 0 1 0 0 1.037h.219v.756h-.36c-.435 0-.634.344-.634.502v.477h-.248a.576.576 0 0 0-.574.574v.003c0 .315.259.573.574.573h1.036c.376 1.73.531 3.716.545 5.314.042 4.799-1.195 8.498-1.607 9.595a8.846 8.846 0 0 0-.63.26c-.604.27-.589.421-.589.795v.48c0 .098 0 .191-.002.276a.339.339 0 0 1-.048.166 6.374 6.374 0 0 1-.366.549c-.335.442-1.155 1.139-1.474 1.595-.216.309-.489 1.073-.079 1.699a1.582 1.582 0 0 0 1.056.691v.076l-.18.065-.568.204a.292.292 0 0 0-.181.256v.563c0 .105.065.156.162.197.472.2.907.233.907.233h11.598s.434-.032.907-.233c.097-.04.161-.092.161-.197v-.563a.291.291 0 0 0-.18-.256l-.57-.204-.18-.065v-.076h.001Z"
            fill="#000"
          />
          <path
            d="M39.447 40.723a.056.056 0 0 0-.072.054v1.745c0 .04.056.049.069.01l.337-1.108a.35.35 0 0 1 .247-.233l.494-.098c.033-.009.033-.057 0-.064l-1.076-.306Z"
            fill="url(#P)"
          />
          <path
            d="m41.03 40.453.11-.84a.468.468 0 0 1 .113-.252c.094-.104.206-.191.331-.256.01-.005.007-.021-.005-.021a2.868 2.868 0 0 0-1.035.207.057.057 0 0 0-.03.074c.176.435.365.89.452 1.096.013.031.059.026.063-.008Z"
            fill="url(#Q)"
          />
          <path
            d="M41.389 44.23c-.303-.005-.64-.121-.847-.212a.054.054 0 0 1-.027-.073c.162-.348.372-.964.457-1.223.005-.014.025-.01.023.005-.027.207-.081.635-.121 1.009a.163.163 0 0 0 .065.149c.078.057.217.17.453.328.008.005.005.018-.004.017Z"
            fill="url(#R)"
          />
          <path
            d="M42.943 39.232c.061.008.14.028.206.056a.058.058 0 0 1 .032.075c-.172.424-.28.763-.465 1.219-.005.012-.024.006-.021-.007.092-.492.152-.884.236-1.334.001-.006.006-.01.012-.01v.001Z"
            fill="url(#S)"
          />
          <path
            d="M45.831 46.879c-.019.042-.27.174-.779.206-.29.02-.794.044-1.168-.058-.066-.019-.085-.047.007-.06.159-.022.55-.032 1.117-.083.553-.048.854-.073.823-.005Z"
            fill="url(#T)"
          />
          <path
            d="M35.958 78.194c1.106 0 2.284-.003 3.462-.003-.37.131-.686.23-1.237.303-.285.038-.614.06-.958.058a4.331 4.331 0 0 1-1.027-.123 2.339 2.339 0 0 1-.319-.113c-.105-.058-.09-.122.079-.122Z"
            fill="url(#U)"
          />
          <path
            d="M45.668 78.191c.765 0 1.496 0 2.245-.002.064 0 .115.071-.09.146a2.964 2.964 0 0 1-.904.174c-.445-.002-.813-.106-1.251-.318Z"
            fill="url(#V)"
          />
          <path
            d="M39.313 52.587h1.972c-.34.183-.755.285-1.15.285-.488 0-.84-.193-.878-.215-.043-.026-.035-.07.056-.07Z"
            fill="url(#W)"
          />
          <path
            d="M44.344 52.587h-1.04c.179.149.398.232.607.232.257 0 .461-.145.476-.172.015-.028.005-.06-.043-.06Z"
            fill="url(#X)"
          />
          <path
            d="M39.023 54.438h2.127c-.307.168-.75.231-1.16.235-.47.006-.895-.078-1.03-.154-.047-.026-.045-.082.063-.08Z"
            fill="url(#Y)"
          />
          <path
            d="M44.73 54.438h-1.426c.206.168.503.231.778.235.315.006.596-.08.686-.156.032-.027.035-.08-.038-.079Z"
            fill="url(#Z)"
          />
          <path
            d="M38.272 55.406c.947-.008 1.792.007 2.74-.001-.495.208-1.005.251-1.52.251-.967 0-1.361-.136-1.361-.207 0-.046.096-.043.141-.044Z"
            fill="url(#aa)"
          />
          <path
            d="M45.433 55.406c-.696-.008-1.318.007-2.014-.001.363.209.738.252 1.117.252.711 0 1.001-.143 1.001-.214 0-.037-.07-.037-.104-.037Z"
            fill="url(#ab)"
          />
          <path
            d="M39.967 57.422c.403 2.219.518 4.086.435 6.115a33.57 33.57 0 0 1-.379 3.673c-.18 1.176-.374 2.16-.791 3.447.22.27.635.227.957.1a.928.928 0 0 0 .573-.667c.083-.337.121-.713.145-1.06.15-2.21.318-4.408.208-6.622-.05-1.023-.152-3.282-.45-4.312-.104-.364-.333-.58-.698-.675Z"
            fill="url(#ac)"
          />
          <path
            d="M43.894 70.49c-.418-2.07-.52-3.111-.707-4.771-.162-1.451-.22-5.173.3-7.724.255.226.218.487.163.879-.25 1.767-.183 3.503-.126 5.143.042 1.202.484 4.832 1.186 6.672.061.161-.314.198-.442.15-.162-.06-.34-.18-.374-.348Z"
            fill="url(#ad)"
          />
          <path
            d="M37.908 71.732c1.041-.007 1.971 0 3.013-.006-.413.186-.734.374-1.72.374-.365 0-.94-.076-1.303-.217-.133-.052-.108-.153.01-.15Z"
            fill="url(#ae)"
          />
          <path
            d="M45.961 71.732c-.727-.007-1.376 0-2.103-.006.288.186.639.327 1.196.327.254 0 .681-.065.934-.206.093-.052.055-.117-.027-.114Z"
            fill="url(#af)"
          />
          <path
            d="M39.295 75.57c-.52.587-1.143.912-2.312.704-.238-.043-.488-.153-.596-.37-.116-.235.017-.503.154-.727.213-.35.572-.677 1.048-1.286.058-.075.282-.556 1.476-.493.786.042.718.522.718.6.008.69-.148 1.19-.488 1.572Z"
            fill="url(#ag)"
          />
          <path
            d="M45.902 73.544c.23.105.416.42.57.62l.683.877c.102.13.197.267.261.419.177.419-.096.702-.342.748-.59.112-1.13.052-1.41-.228-.254-.253-.348-.803-.39-1.001-.085-.394-.206-.839-.112-1.244.063-.273.47-.315.74-.19Z"
            fill="url(#ah)"
          />
          <path
            d="M42.914 43.845a.146.146 0 0 1-.03.106 1.696 1.696 0 0 1-.251.246c.104-.021.447-.115.58-.176a.057.057 0 0 0 .03-.07c-.15-.399-.264-.647-.4-1.015-.004-.012-.02-.008-.02.004.036.3.06.608.091.905Z"
            fill="url(#ai)"
          />
          <path
            d="M44.299 40.81c-.058.51-.192 1.249-.222 1.433a.084.084 0 0 1-.042.063l-.19.1.37.114c.054.017.109-.027.109-.097v-1.61c0-.02-.023-.024-.025-.004Z"
            fill="url(#aj)"
          />
          <path
            d="m41.359 44.733-.605.001c-.063.004-.158 0-.162.06-.002.044.08.16.305.178.356.026.533-.15.533-.197 0-.031-.04-.042-.071-.042Z"
            fill="url(#ak)"
          />
          <path
            d="M43.018 44.734c.097 0 .102.035.094.064-.023.076-.145.14-.277.14-.198 0-.354-.112-.354-.16 0-.034.03-.043.122-.043l.415-.002Z"
            fill="url(#al)"
          />
          <path
            d="M39.953 51.854c.194.1.473.13.666.046.092-.04.142-.16.13-.263-.162-1.55-.305-2.308-.432-3.69a.335.335 0 0 0-.302-.303c-.463-.05-.866-.04-1.328-.056-.137-.005-.238.153-.198.286.436 1.456.779 2.298 1.276 3.773.027.08.114.169.188.207Z"
            fill="url(#am)"
          />
          <path
            d="M39.84 46.61a.553.553 0 0 0 .394-.199 3.53 3.53 0 0 0 .256-.346c.056-.088.134-.257.1-.295-.059-.068-.204-.045-.29-.02-.49.144-1.082.35-1.502.64-.04.028-.054.089-.021.127.036.042.093.057.148.069.193.04.629.042.916.025v-.001Z"
            fill="url(#an)"
          />
          <path
            d="M41.584 46.997c-.588-.007-2.534-.026-3.774-.153-.195-.02-.155.046-.125.074a.5.5 0 0 0 .151.073c.361.109.642.166 1.254.203.901.056 1.965-.024 2.5-.139.08-.017.152-.056-.006-.058Z"
            fill="url(#ao)"
          />
          <path
            d="M43.912 45.876c.271.089.953.341.926.478-.009.044-.02.08-.114.097-.334.059-.524.047-.645-.021-.09-.05-.177-.139-.252-.209-.076-.07-.224-.226-.224-.311.002-.131.247-.054.308-.034Z"
            fill="url(#ap)"
          />
          <path
            d="M44.34 47.75c.012-.078.041-.151.106-.195a.492.492 0 0 1 .224-.065c.122-.013.336-.018.459-.009.088.006.197.016.227.1.017.048-.006.128-.02.177-.059.197-.848 2.72-1.24 3.89-.03.09-.156.194-.27.189-.068-.003-.117-.028-.15-.094-.033-.062.033-.413.064-.564.168-.829.547-3.125.599-3.43Z"
            fill="url(#aq)"
          />
          <path
            d="m41.01 53.973-.089-.265a.113.113 0 0 0-.108-.075c-.33.002-.624 0-.958.004a.042.042 0 0 0-.041.042c0 .108-.002.19 0 .3 0 .016.012.03.029.03.328.002.974 0 1.141 0 .019 0 .031-.018.025-.036Z"
            fill="url(#ar)"
          />
          <path
            d="M43.305 53.973c.019-.057.056-.172.089-.265a.113.113 0 0 1 .108-.075c.292.003.271.004.387.004.023 0 .041.019.041.041 0 .109.002.19 0 .3a.03.03 0 0 1-.03.031h-.57a.027.027 0 0 1-.025-.036Z"
            fill="url(#as)"
          />
          <path
            d="M41.465 38.437a.176.176 0 0 1-.04-.005c-.087-.019-.104-.118-.107-.148-.018-.172.07-.483.378-.586a.155.155 0 0 1 .047-.008c.024 0 .044.007.054.018a.032.032 0 0 1 .009.021c0 .01-.011.022-.03.043-.064.068-.213.228-.174.56 0 .009-.008.034-.029.056a.142.142 0 0 1-.108.049Z"
            fill="url(#at)"
          />
          <path
            d="M42.34 38.581c-.013.007-.049-.003-.072-.029a.19.19 0 0 1-.035-.065c-.008-.034-.001-.061.011-.076l.028-.028c.034-.04.083-.098.119-.223.003-.01.009-.015.016-.013.012.003.03.03.041.097a.478.478 0 0 1-.109.337Z"
            fill="url(#au)"
          />
        </g>
        <g clipPath="url(#av)">
          <path
            d="M43.219 15.292c-1.275.535-1.562 2.015-1.888 3.206-.467.045-.873.166-1.393.42l-.01.015c.355-.057.946-.028 1.255.116-.196.8-.36 1.65-.787 2.331-.484.83-1.73.92-2.316.15-.57-.71-.162-1.948.682-2.257-.938.29-1.459 1.576-.92 2.422.571.932 2.046 1.117 2.888.457.81-.69.94-1.816 1.156-2.786l.057-.267c1.276-.056 2.804.049 3.685-1.092 1.334-1.723-.532-3.668-2.41-2.715Zm1.42 2.67c-.767.421-1.7.418-2.56.52.139-.603.308-1.204.583-1.746.385-.76 1.451-1.255 2.226-.822.804.485.48 1.65-.249 2.048Z"
            fill="#605E62"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={37.01}
          y1={-12.758}
          x2={79.825}
          y2={52.006}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={24.332}
          y1={54.233}
          x2={27.924}
          y2={54.233}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={27.158}
          y1={58.158}
          x2={28.814}
          y2={58.158}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={27.796}
          y1={55.735}
          x2={29.35}
          y2={55.735}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={29.944}
          y1={57.264}
          x2={30.623}
          y2={57.264}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={26.886}
          y1={62.314}
          x2={32.152}
          y2={62.314}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={28.393}
          y1={59.405}
          x2={31.743}
          y2={59.405}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={28.281}
          y1={65.015}
          x2={32.025}
          y2={65.015}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={30.128}
          y1={66.518}
          x2={31.473}
          y2={66.518}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={28.268}
          y1={67.788}
          x2={30.716}
          y2={67.788}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={28.636}
          y1={69.75}
          x2={31.798}
          y2={69.75}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={28.649}
          y1={72.344}
          x2={32.113}
          y2={72.344}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="p"
          x1={29.357}
          y1={67.298}
          x2={30.377}
          y2={67.298}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={22.418}
          y1={57.259}
          x2={29.966}
          y2={59.377}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={24.735}
          y1={54.276}
          x2={27.181}
          y2={54.276}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={23.392}
          y1={60.688}
          x2={24.212}
          y2={60.688}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={24.582}
          y1={63.592}
          x2={30.844}
          y2={63.592}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={25.12}
          y1={67.811}
          x2={29.727}
          y2={67.811}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={24.296}
          y1={69.673}
          x2={28.683}
          y2={69.673}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={23.825}
          y1={72.361}
          x2={28.956}
          y2={72.361}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={25.706}
          y1={67.299}
          x2={27.659}
          y2={67.299}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="y"
          x1={25.007}
          y1={56.663}
          x2={26.595}
          y2={57.059}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="z"
          x1={52.142}
          y1={69.503}
          x2={56.056}
          y2={69.503}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="A"
          x1={51.082}
          y1={73.244}
          x2={56.025}
          y2={73.244}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="B"
          x1={55.313}
          y1={69.493}
          x2={58.118}
          y2={69.493}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="C"
          x1={52.999}
          y1={64.463}
          x2={55.25}
          y2={64.463}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="D"
          x1={56.034}
          y1={64.678}
          x2={57.402}
          y2={64.678}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="E"
          x1={51.81}
          y1={57.202}
          x2={54.438}
          y2={57.202}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="F"
          x1={56.305}
          y1={57.202}
          x2={58.476}
          y2={57.202}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="G"
          x1={52.464}
          y1={59.055}
          x2={55.279}
          y2={59.055}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="H"
          x1={56.133}
          y1={59.056}
          x2={57.842}
          y2={59.056}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="I"
          x1={52.696}
          y1={60.033}
          x2={55.968}
          y2={60.033}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="J"
          x1={55.457}
          y1={60.02}
          x2={57.578}
          y2={60.02}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="K"
          x1={52.328}
          y1={68.183}
          x2={56.179}
          y2={68.183}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="L"
          x1={55.112}
          y1={68.183}
          x2={57.914}
          y2={68.183}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="M"
          x1={51.453}
          y1={70.935}
          x2={55.163}
          y2={70.935}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="N"
          x1={56.308}
          y1={70.96}
          x2={58.999}
          y2={70.96}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="O"
          x1={55.71}
          y1={73.224}
          x2={59.234}
          y2={73.224}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="P"
          x1={39.375}
          y1={41.639}
          x2={41.563}
          y2={41.639}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Q"
          x1={40.51}
          y1={39.782}
          x2={42.528}
          y2={39.782}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="R"
          x1={40.509}
          y1={43.472}
          x2={42.166}
          y2={43.472}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="S"
          x1={42.911}
          y1={38.97}
          x2={43.592}
          y2={39.282}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="T"
          x1={44.714}
          y1={46.786}
          x2={44.751}
          y2={47.133}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="U"
          x1={35.813}
          y1={78.372}
          x2={42.545}
          y2={78.372}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="V"
          x1={46.685}
          y1={78.127}
          x2={46.731}
          y2={78.545}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="W"
          x1={39.232}
          y1={52.73}
          x2={43.064}
          y2={52.73}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="X"
          x1={43.785}
          y1={52.542}
          x2={43.835}
          y2={52.84}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="Y"
          x1={38.93}
          y1={54.556}
          x2={43.074}
          y2={54.556}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Z"
          x1={43.96}
          y1={54.393}
          x2={43.998}
          y2={54.699}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="aa"
          x1={38.131}
          y1={55.53}
          x2={43.508}
          y2={55.53}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ab"
          x1={44.355}
          y1={55.354}
          x2={44.386}
          y2={55.686}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="ac"
          x1={39.231}
          y1={64.139}
          x2={42.813}
          y2={64.139}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ad"
          x1={43.799}
          y1={55.514}
          x2={46.491}
          y2={55.952}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="ae"
          x1={37.808}
          y1={71.912}
          x2={43.618}
          y2={71.912}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="af"
          x1={44.823}
          y1={71.662}
          x2={44.874}
          y2={72.089}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="ag"
          x1={36.343}
          y1={74.865}
          x2={42.768}
          y2={74.865}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ah"
          x1={46.164}
          y1={72.941}
          x2={47.998}
          y2={74.907}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="ai"
          x1={42.904}
          y1={42.684}
          x2={43.652}
          y2={43.144}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="aj"
          x1={44.056}
          y1={40.463}
          x2={44.773}
          y2={40.716}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="ak"
          x1={40.592}
          y1={44.853}
          x2={42.156}
          y2={44.853}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="al"
          x1={41.785}
          y1={44.836}
          x2={43.06}
          y2={44.836}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="am"
          x1={38.48}
          y1={49.769}
          x2={42.72}
          y2={49.769}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="an"
          x1={38.758}
          y1={46.173}
          x2={42.194}
          y2={46.173}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ao"
          x1={37.66}
          y1={47.027}
          x2={45.161}
          y2={47.027}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ap"
          x1={42.246}
          y1={46.163}
          x2={44.732}
          y2={46.163}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aq"
          x1={41.803}
          y1={49.657}
          x2={45.216}
          y2={49.657}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="ar"
          x1={39.467}
          y1={53.822}
          x2={42.077}
          y2={53.822}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="as"
          x1={43.581}
          y1={53.56}
          x2={43.773}
          y2={53.967}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <linearGradient
          id="at"
          x1={41.316}
          y1={38.063}
          x2={42.23}
          y2={38.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="au"
          x1={42.327}
          y1={38.062}
          x2={42.59}
          y2={38.231}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.016} stopColor="#A4A4A4" />
          <stop offset={0.13} stopColor="#4C494F" />
          <stop offset={0.589} stopColor="#A4A4A4" />
          <stop offset={0.957} stopColor="#37343B" />
        </linearGradient>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(0 .83)"
            d="M0 0h83.741v93.366H0z"
          />
        </clipPath>
        <clipPath id="av">
          <path
            fill="#fff"
            transform="translate(37.24 14.187)"
            d="M0 0h9.224v9.212H0z"
          />
        </clipPath>
        <filter
          id="c"
          x={7.448}
          y={9.072}
          width={68.846}
          height={76.88}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={12} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend in2="shape" result="effect1_innerShadow_144_23417" />
        </filter>
      </defs>
    </svg>
  ),
  // ------------------------------------------------------------SEMINAR:SVG-------------------------------------------------------------------------------------------------------
  seminar: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 144 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_144_25198)">
        <path
          d="M139.276 89.6624C140.782 88.7922 142.139 87.7345 143.327 86.5308V111.113C143.327 117.463 139.937 123.33 134.437 126.507L80.5496 157.618C75.0519 160.793 68.2735 160.793 62.7777 157.618L8.88988 126.507C3.39019 123.331 0 117.463 0 111.113V86.5308C1.18795 87.7365 2.54758 88.7942 4.05126 89.6624L62.0949 123.174C68.013 126.595 75.3143 126.595 81.2363 123.174L139.278 89.6624H139.276Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.8874V81.5066C142.139 82.7123 140.782 83.7681 139.276 84.6383L81.2343 118.149C75.3143 121.571 68.013 121.571 62.093 118.149L4.05126 84.6403C2.54758 83.7701 1.18795 82.7123 0 81.5086V48.8894C0 42.5372 3.39019 36.6685 8.88987 33.4934L62.7777 2.38181C68.2754 -0.793286 75.0538 -0.793286 80.5515 2.38181L134.439 33.4954C139.939 36.6705 143.329 42.5372 143.329 48.8874H143.327Z"
          fill="#5CA0B5"
        />
        <g filter="url(#filter0_i_144_25198)">
          <path
            d="M130.582 105.968V54.034C130.582 49.0533 127.923 44.4514 123.612 41.9611L78.6354 15.994C74.3217 13.5036 69.0075 13.5036 64.6938 15.994L19.7176 41.9591C15.4039 44.4495 12.7477 49.0513 12.7477 54.032V105.966C12.7477 110.947 15.4039 115.549 19.7176 118.039L64.6938 144.006C69.0075 146.497 74.3217 146.497 78.6354 144.006L123.612 118.039C127.925 115.549 130.582 110.947 130.582 105.966V105.968Z"
            fill="white"
          />
        </g>
        <mask
          id="mask0_144_25198"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.582 105.968V54.034C130.582 49.0533 127.923 44.4514 123.612 41.9611L78.6354 15.994C74.3217 13.5036 69.0075 13.5036 64.6938 15.994L19.7176 41.9591C15.4039 44.4495 12.7477 49.0513 12.7477 54.032V105.966C12.7477 110.947 15.4039 115.549 19.7176 118.039L64.6938 144.006C69.0075 146.497 74.3217 146.497 78.6354 144.006L123.612 118.039C127.925 115.549 130.582 110.947 130.582 105.966V105.968Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_144_25198)">
          <path
            d="M41.3263 56.832V50.7541H43.9571C44.5012 50.7541 44.9701 50.8438 45.3637 51.0233C45.7573 51.1969 46.0612 51.4487 46.2754 51.7787C46.4896 52.1086 46.5967 52.5022 46.5967 52.9595C46.5967 53.411 46.4896 53.8017 46.2754 54.1317C46.0612 54.4616 45.7573 54.7163 45.3637 54.8957C44.9701 55.0694 44.5012 55.1562 43.9571 55.1562H42.1077L42.7329 54.5224V56.832H41.3263ZM42.7329 54.6787L42.1077 54.0101H43.879C44.3131 54.0101 44.6373 53.9175 44.8514 53.7323C45.0656 53.547 45.1727 53.2894 45.1727 52.9595C45.1727 52.6238 45.0656 52.3633 44.8514 52.1781C44.6373 51.9928 44.3131 51.9002 43.879 51.9002H42.1077L42.7329 51.2316V54.6787Z"
            fill="#5CA0B5"
          />
          <path
            d="M47.6009 56.832V50.7541H50.2317C50.7758 50.7541 51.2447 50.8438 51.6383 51.0233C52.0319 51.1969 52.3358 51.4487 52.55 51.7787C52.7642 52.1086 52.8712 52.5022 52.8712 52.9595C52.8712 53.411 52.7642 53.8017 52.55 54.1317C52.3358 54.4558 52.0319 54.7047 51.6383 54.8784C51.2447 55.052 50.7758 55.1388 50.2317 55.1388H48.3823L49.0075 54.5224V56.832H47.6009ZM51.4646 56.832L49.9452 54.6266H51.4473L52.9841 56.832H51.4646ZM49.0075 54.6787L48.3823 54.0188H50.1536C50.5877 54.0188 50.9119 53.9262 51.126 53.7409C51.3402 53.5499 51.4473 53.2894 51.4473 52.9595C51.4473 52.6238 51.3402 52.3633 51.126 52.1781C50.9119 51.9928 50.5877 51.9002 50.1536 51.9002H48.3823L49.0075 51.2316V54.6787Z"
            fill="#5CA0B5"
          />
          <path
            d="M56.9378 56.9362C56.4573 56.9362 56.0116 56.858 55.6007 56.7017C55.1955 56.5454 54.8424 56.3255 54.5414 56.0418C54.2462 55.7582 54.0146 55.4254 53.8468 55.0433C53.6847 54.6613 53.6036 54.2445 53.6036 53.793C53.6036 53.3415 53.6847 52.9248 53.8468 52.5427C54.0146 52.1607 54.2491 51.8279 54.5501 51.5442C54.8511 51.2606 55.2041 51.0406 55.6093 50.8843C56.0145 50.728 56.4545 50.6499 56.9291 50.6499C57.4095 50.6499 57.8495 50.728 58.2489 50.8843C58.6541 51.0406 59.0043 51.2606 59.2995 51.5442C59.6005 51.8279 59.8349 52.1607 60.0028 52.5427C60.1706 52.919 60.2546 53.3357 60.2546 53.793C60.2546 54.2445 60.1706 54.6642 60.0028 55.052C59.8349 55.4341 59.6005 55.7669 59.2995 56.0505C59.0043 56.3284 58.6541 56.5454 58.2489 56.7017C57.8495 56.858 57.4124 56.9362 56.9378 56.9362ZM56.9291 55.738C57.2012 55.738 57.4501 55.6916 57.6758 55.599C57.9074 55.5064 58.1099 55.3733 58.2836 55.1996C58.4573 55.026 58.5904 54.8205 58.683 54.5832C58.7814 54.3458 58.8306 54.0825 58.8306 53.793C58.8306 53.5036 58.7814 53.2402 58.683 53.0029C58.5904 52.7656 58.4573 52.5601 58.2836 52.3864C58.1157 52.2128 57.916 52.0796 57.6845 51.987C57.453 51.8944 57.2012 51.8481 56.9291 51.8481C56.657 51.8481 56.4052 51.8944 56.1737 51.987C55.948 52.0796 55.7483 52.2128 55.5746 52.3864C55.401 52.5601 55.2649 52.7656 55.1665 53.0029C55.0739 53.2402 55.0276 53.5036 55.0276 53.793C55.0276 54.0767 55.0739 54.34 55.1665 54.5832C55.2649 54.8205 55.3981 55.026 55.5659 55.1996C55.7396 55.3733 55.9422 55.5064 56.1737 55.599C56.4052 55.6916 56.657 55.738 56.9291 55.738Z"
            fill="#5CA0B5"
          />
          <path
            d="M61.3117 56.832V50.7541H62.4752L65.0626 55.0433H64.4461L66.9902 50.7541H68.145L68.1623 56.832H66.8426L66.8339 52.7772H67.077L65.0452 56.1894H64.4114L62.3362 52.7772H62.6315V56.832H61.3117Z"
            fill="#5CA0B5"
          />
          <path
            d="M69.6043 56.832V50.7541H72.2352C72.7793 50.7541 73.2481 50.8438 73.6418 51.0233C74.0354 51.1969 74.3393 51.4487 74.5534 51.7787C74.7676 52.1086 74.8747 52.5022 74.8747 52.9595C74.8747 53.411 74.7676 53.8017 74.5534 54.1317C74.3393 54.4616 74.0354 54.7163 73.6418 54.8957C73.2481 55.0694 72.7793 55.1562 72.2352 55.1562H70.3858L71.0109 54.5224V56.832H69.6043ZM71.0109 54.6787L70.3858 54.0101H72.157C72.5912 54.0101 72.9153 53.9175 73.1295 53.7323C73.3437 53.547 73.4507 53.2894 73.4507 52.9595C73.4507 52.6238 73.3437 52.3633 73.1295 52.1781C72.9153 51.9928 72.5912 51.9002 72.157 51.9002H70.3858L71.0109 51.2316V54.6787Z"
            fill="#5CA0B5"
          />
          <path
            d="M76.9768 56.832V51.9002H75.0319V50.7541H80.3283V51.9002H78.3834V56.832H76.9768Z"
            fill="#5CA0B5"
          />
          <path
            d="M81.0851 56.832V50.7541H82.4917V56.832H81.0851Z"
            fill="#5CA0B5"
          />
          <path
            d="M83.9341 56.832V50.7541H85.0976L88.6835 55.1302H88.1192V50.7541H89.5084V56.832H88.3536L84.759 52.4559H85.3234V56.832H83.9341Z"
            fill="#5CA0B5"
          />
          <path
            d="M93.8811 56.9362C93.4007 56.9362 92.9579 56.8609 92.5527 56.7104C92.1533 56.5541 91.8031 56.3342 91.5021 56.0505C91.2069 55.7669 90.9753 55.4341 90.8075 55.052C90.6454 54.67 90.5644 54.2503 90.5644 53.793C90.5644 53.3357 90.6454 52.9161 90.8075 52.534C90.9753 52.152 91.2098 51.8192 91.5108 51.5355C91.8118 51.2519 92.1649 51.0348 92.5701 50.8843C92.9753 50.728 93.421 50.6499 93.9072 50.6499C94.4455 50.6499 94.9289 50.7396 95.3572 50.9191C95.7913 51.0985 96.156 51.359 96.4512 51.7005L95.5482 52.534C95.3283 52.3025 95.088 52.1317 94.8276 52.0218C94.5671 51.906 94.2834 51.8481 93.9767 51.8481C93.6814 51.8481 93.4123 51.8944 93.1692 51.987C92.9261 52.0796 92.7148 52.2128 92.5353 52.3864C92.3617 52.5601 92.2256 52.7656 92.1272 53.0029C92.0346 53.2402 91.9883 53.5036 91.9883 53.793C91.9883 54.0767 92.0346 54.3371 92.1272 54.5745C92.2256 54.8118 92.3617 55.0202 92.5353 55.1996C92.7148 55.3733 92.9232 55.5064 93.1605 55.599C93.4036 55.6916 93.6699 55.738 93.9593 55.738C94.2371 55.738 94.5063 55.6945 94.7668 55.6077C95.033 55.5151 95.2906 55.3617 95.5395 55.1475L96.3383 56.1634C96.0084 56.4123 95.6235 56.6033 95.1835 56.7365C94.7494 56.8696 94.3153 56.9362 93.8811 56.9362ZM95.0533 55.9811V53.6975H96.3383V56.1634L95.0533 55.9811Z"
            fill="#5CA0B5"
          />
          <path
            d="M99.642 56.9362C99.1557 56.9362 98.6898 56.8725 98.244 56.7451C97.7983 56.612 97.4395 56.4412 97.1674 56.2329L97.645 55.1736C97.9054 55.3588 98.2122 55.5122 98.5653 55.6338C98.9242 55.7495 99.286 55.8074 99.6507 55.8074C99.9285 55.8074 100.151 55.7814 100.319 55.7293C100.493 55.6714 100.62 55.5932 100.701 55.4948C100.782 55.3964 100.823 55.2836 100.823 55.1562C100.823 54.9941 100.759 54.8668 100.632 54.7742C100.504 54.6758 100.337 54.5976 100.128 54.5397C99.9198 54.4761 99.6883 54.4182 99.4336 54.3661C99.1847 54.3082 98.9329 54.2387 98.6782 54.1577C98.4293 54.0767 98.2006 53.9725 97.9923 53.8451C97.7839 53.7178 97.6131 53.5499 97.48 53.3415C97.3526 53.1331 97.289 52.8669 97.289 52.5427C97.289 52.1954 97.3816 51.8799 97.5668 51.5963C97.7578 51.3069 98.0415 51.0782 98.4177 50.9104C98.7997 50.7367 99.2773 50.6499 99.8503 50.6499C100.232 50.6499 100.609 50.6962 100.979 50.7888C101.35 50.8757 101.677 51.0088 101.96 51.1882L101.526 52.2562C101.242 52.0941 100.959 51.9755 100.675 51.9002C100.392 51.8192 100.114 51.7787 99.8417 51.7787C99.5696 51.7787 99.3467 51.8105 99.1731 51.8742C98.9994 51.9378 98.875 52.0218 98.7997 52.126C98.7245 52.2244 98.6869 52.3401 98.6869 52.4733C98.6869 52.6296 98.7505 52.7569 98.8779 52.8553C99.0052 52.9479 99.1731 53.0232 99.3815 53.0811C99.5899 53.1389 99.8185 53.1968 100.067 53.2547C100.322 53.3126 100.574 53.3792 100.823 53.4544C101.077 53.5297 101.309 53.631 101.517 53.7583C101.726 53.8856 101.894 54.0535 102.021 54.2619C102.154 54.4703 102.221 54.7337 102.221 55.052C102.221 55.3935 102.125 55.7061 101.934 55.9897C101.743 56.2734 101.457 56.502 101.075 56.6757C100.698 56.8493 100.221 56.9362 99.642 56.9362Z"
            fill="#5CA0B5"
          />
          <path
            d="M35.6677 71C34.7157 71 33.8033 70.8753 32.9307 70.626C32.058 70.3653 31.3553 70.031 30.8227 69.623L31.7577 67.549C32.2677 67.9117 32.8683 68.212 33.5597 68.45C34.2623 68.6767 34.9707 68.79 35.6847 68.79C36.2287 68.79 36.665 68.739 36.9937 68.637C37.3337 68.5237 37.583 68.3707 37.7417 68.178C37.9003 67.9853 37.9797 67.7643 37.9797 67.515C37.9797 67.1977 37.855 66.9483 37.6057 66.767C37.3563 66.5743 37.0277 66.4213 36.6197 66.308C36.2117 66.1833 35.7583 66.07 35.2597 65.968C34.7723 65.8547 34.2793 65.7187 33.7807 65.56C33.2933 65.4013 32.8457 65.1973 32.4377 64.948C32.0297 64.6987 31.6953 64.37 31.4347 63.962C31.1853 63.554 31.0607 63.0327 31.0607 62.398C31.0607 61.718 31.242 61.1003 31.6047 60.545C31.9787 59.9783 32.534 59.5307 33.2707 59.202C34.0187 58.862 34.9537 58.692 36.0757 58.692C36.8237 58.692 37.5603 58.7827 38.2857 58.964C39.011 59.134 39.6513 59.3947 40.2067 59.746L39.3567 61.837C38.8013 61.5197 38.246 61.2873 37.6907 61.14C37.1353 60.9813 36.5913 60.902 36.0587 60.902C35.526 60.902 35.0897 60.9643 34.7497 61.089C34.4097 61.2137 34.166 61.378 34.0187 61.582C33.8713 61.7747 33.7977 62.0013 33.7977 62.262C33.7977 62.568 33.9223 62.8173 34.1717 63.01C34.421 63.1913 34.7497 63.3387 35.1577 63.452C35.5657 63.5653 36.0133 63.6787 36.5007 63.792C36.9993 63.9053 37.4923 64.0357 37.9797 64.183C38.4783 64.3303 38.9317 64.5287 39.3397 64.778C39.7477 65.0273 40.0763 65.356 40.3257 65.764C40.5863 66.172 40.7167 66.6877 40.7167 67.311C40.7167 67.9797 40.5297 68.5917 40.1557 69.147C39.7817 69.7023 39.2207 70.15 38.4727 70.49C37.736 70.83 36.801 71 35.6677 71ZM45.1315 63.69H50.8605V65.832H45.1315V63.69ZM45.3355 68.586H51.8125V70.796H42.5985V58.896H51.5915V61.106H45.3355V68.586ZM54.0037 70.796V58.896H56.2817L61.3477 67.294H60.1407L65.1217 58.896H67.3828L67.4167 70.796H64.8327L64.8158 62.857H65.2917L61.3137 69.538H60.0727L56.0097 62.857H56.5877V70.796H54.0037ZM70.2401 70.796V58.896H72.9941V70.796H70.2401ZM75.8182 70.796V58.896H78.0962L85.1172 67.464H84.0122V58.896H86.7322V70.796H84.4712L77.4332 62.228H78.5382V70.796H75.8182ZM87.9837 70.796L93.2877 58.896H96.0077L101.329 70.796H98.4387L94.0867 60.29H95.1747L90.8057 70.796H87.9837ZM90.6357 68.246L91.3667 66.155H97.4867L98.2347 68.246H90.6357ZM102.563 70.796V58.896H107.714C108.78 58.896 109.698 59.0717 110.468 59.423C111.239 59.763 111.834 60.256 112.253 60.902C112.673 61.548 112.882 62.3187 112.882 63.214C112.882 64.098 112.673 64.863 112.253 65.509C111.834 66.1437 111.239 66.631 110.468 66.971C109.698 67.311 108.78 67.481 107.714 67.481H104.093L105.317 66.274V70.796H102.563ZM110.128 70.796L107.153 66.478H110.094L113.103 70.796H110.128ZM105.317 66.58L104.093 65.288H107.561C108.411 65.288 109.046 65.1067 109.465 64.744C109.885 64.37 110.094 63.86 110.094 63.214C110.094 62.5567 109.885 62.0467 109.465 61.684C109.046 61.3213 108.411 61.14 107.561 61.14H104.093L105.317 59.831V66.58Z"
            fill="#5CA0B5"
          />
        </g>
        <path
          d="M73.9711 24.785C71.7899 25.7006 71.2979 28.237 70.7401 30.2787C69.9403 30.3551 69.2456 30.5629 68.3563 30.9997L68.3379 31.0234C68.9457 30.926 69.9587 30.976 70.4875 31.2233C70.1508 32.5941 69.8719 34.0518 69.1404 35.2173C68.3116 36.6408 66.1804 36.7934 65.1753 35.4752C64.1992 34.257 64.899 32.1363 66.3435 31.6075C64.7385 32.1047 63.8466 34.307 64.7701 35.7567C65.7463 37.3538 68.2695 37.6722 69.7114 36.5408C71.098 35.3568 71.319 33.4282 71.69 31.7653C71.7242 31.6127 71.7557 31.4601 71.7873 31.3075C73.9711 31.2128 76.5865 31.3917 78.0941 29.4368C80.3779 26.4847 77.1837 23.1511 73.9711 24.785ZM76.4023 29.3605C75.0894 30.0814 73.4923 30.0762 72.0188 30.2524C72.2583 29.2184 72.5477 28.187 73.0187 27.2582C73.6764 25.9558 75.5024 25.1086 76.8285 25.8506C78.2046 26.682 77.6494 28.679 76.4023 29.3605Z"
          fill="#5CA0B5"
        />
        <g
          style={{
            mixBlendMode: 'multiply',
          }}
        >
          <path
            d="M100.854 82.8938C88.8883 79.5777 78.6165 88.4316 69.6813 95.0331C66.1369 92.7477 62.5986 91.3466 57.5139 90.2561L57.361 90.2938C60.1823 91.8681 64.1945 95.3666 65.5702 98.1049C59.7266 102.66 53.8394 107.76 47.0364 110.187C38.9941 113.359 29.7149 107.061 29.8572 98.3614C29.7939 90.1681 39.5712 83.7031 47.2432 86.2186C39.0123 83.0513 28.1784 89.2281 27.2723 98.2046C26.1041 107.959 35.4682 117.473 45.0878 117.497C54.6507 117.124 61.8301 109.894 68.7639 104.247C69.4009 103.729 70.027 103.203 70.6532 102.677C79.9611 109.384 90.1579 118.622 102.725 115.466C121.733 110.723 119.404 86.602 100.854 82.8938ZM96.001 109.653C88.2469 108.356 81.6821 103.144 75.0367 99.0809C79.3844 95.5977 83.9296 92.2878 88.8894 89.9908C95.8335 86.7613 106.113 89.2048 109.166 96.5729C112.135 104.472 103.356 110.898 96.001 109.653Z"
            fill="#5CA0B5"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_144_25198"
          x={12.7477}
          y={14.1262}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_144_25198"
          />
        </filter>
        <clipPath id="clip0_144_25198">
          <rect width={143.327} height={160} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  // ----------------------------------------------------------EVENT:SVG-------------------------------------------------------------------------------------------------
  event: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="11 0 120 160"
    >
      <g clipPath="url(#a)">
        <path
          d="M139.862 89.662a19.158 19.158 0 0 0 4.052-3.131v24.582c0 6.35-3.391 12.217-8.89 15.394l-53.888 31.111a17.77 17.77 0 0 1-17.772 0L9.476 126.507a17.78 17.78 0 0 1-8.89-15.394V86.531a19.08 19.08 0 0 0 4.052 3.131l58.043 33.512a19.133 19.133 0 0 0 19.142 0l58.041-33.512h-.002Z"
          fill="#303644"
        />
        <path
          d="M143.914 48.887v32.62a19.093 19.093 0 0 1-4.052 3.131L81.821 118.15a19.128 19.128 0 0 1-19.142 0L4.638 84.64A19.212 19.212 0 0 1 .586 81.51v-32.62c0-6.352 3.39-12.22 8.89-15.396L63.364 2.382a17.773 17.773 0 0 1 17.774 0l53.888 31.113a17.776 17.776 0 0 1 8.89 15.392h-.002Z"
          fill="#35B2D9"
        />
        <g filter="url(#b)">
          <path
            d="M131.168 105.968V54.034c0-4.981-2.658-9.583-6.97-12.073L79.222 15.994a13.942 13.942 0 0 0-13.942 0L20.304 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.942 0l44.976-25.967a13.938 13.938 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="c"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={13}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M131.168 105.968V54.034c0-4.981-2.658-9.583-6.97-12.073L79.222 15.994a13.942 13.942 0 0 0-13.942 0L20.304 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.942 0l44.976-25.967a13.938 13.938 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            d="M41.913 56.832v-6.078h2.63c.545 0 1.013.09 1.407.27.394.173.698.425.912.755.214.33.321.723.321 1.18 0 .452-.107.843-.321 1.173-.214.33-.518.584-.912.764-.394.173-.862.26-1.407.26h-1.849l.625-.634v2.31h-1.406Zm1.406-2.153-.625-.669h1.771c.434 0 .759-.093.973-.278.214-.185.321-.443.321-.773 0-.335-.107-.596-.321-.78-.214-.186-.539-.279-.973-.279h-1.771l.625-.668v3.447ZM48.187 56.832v-6.078h2.631c.544 0 1.013.09 1.407.27.393.173.697.425.911.755.214.33.322.723.322 1.18 0 .452-.108.843-.322 1.173a2.054 2.054 0 0 1-.911.746c-.394.174-.863.26-1.407.26h-1.85l.626-.616v2.31h-1.407Zm3.864 0-1.52-2.205h1.503l1.536 2.205h-1.519Zm-2.457-2.153-.625-.66h1.77c.435 0 .76-.093.973-.278.214-.191.322-.452.322-.782 0-.335-.108-.596-.322-.78-.214-.186-.538-.279-.972-.279h-1.771l.625-.668v3.447ZM57.524 56.936c-.48 0-.926-.078-1.337-.234a3.21 3.21 0 0 1-1.06-.66 3.096 3.096 0 0 1-.694-.999 3.168 3.168 0 0 1-.243-1.25c0-.451.081-.868.243-1.25.168-.382.402-.715.703-.999a3.212 3.212 0 0 1 1.06-.66 3.636 3.636 0 0 1 1.32-.234c.48 0 .92.078 1.32.234a3.116 3.116 0 0 1 1.753 1.659c.168.376.252.793.252 1.25 0 .452-.084.871-.252 1.259a3.035 3.035 0 0 1-.703.998 3.186 3.186 0 0 1-1.05.652c-.4.156-.837.234-1.312.234Zm-.009-1.198c.273 0 .521-.046.747-.139a1.788 1.788 0 0 0 1.007-1.016c.099-.237.148-.5.148-.79 0-.29-.05-.553-.148-.79a1.771 1.771 0 0 0-.4-.617 1.7 1.7 0 0 0-.598-.399 2.016 2.016 0 0 0-.756-.139c-.272 0-.523.046-.755.139a1.814 1.814 0 0 0-.6.4 1.88 1.88 0 0 0-.407.616c-.093.237-.14.5-.14.79 0 .284.047.547.14.79.098.238.231.443.4.617.173.173.376.306.607.399.232.093.483.139.755.139ZM61.898 56.832v-6.078h1.163l2.588 4.29h-.617l2.544-4.29h1.155l.018 6.078h-1.32l-.009-4.055h.243l-2.031 3.412h-.634l-2.075-3.412h.295v4.055h-1.32ZM70.19 56.832v-6.078h2.632c.544 0 1.013.09 1.406.27.394.173.698.425.912.755.214.33.321.723.321 1.18 0 .452-.107.843-.321 1.173-.214.33-.518.584-.912.764-.393.173-.862.26-1.406.26h-1.85l.625-.634v2.31h-1.406Zm1.407-2.153-.625-.669h1.771c.434 0 .759-.093.973-.278.214-.185.321-.443.321-.773 0-.335-.107-.596-.321-.78-.214-.186-.538-.279-.973-.279h-1.77l.624-.668v3.447ZM77.563 56.832V51.9h-1.945v-1.146h5.297V51.9H78.97v4.932h-1.407ZM81.671 56.832v-6.078h1.407v6.078h-1.407ZM84.52 56.832v-6.078h1.164l3.586 4.376h-.564v-4.376h1.389v6.078H88.94l-3.595-4.376h.565v4.376h-1.39ZM94.468 56.936c-.481 0-.924-.075-1.329-.226-.4-.156-.75-.376-1.05-.66a3.098 3.098 0 0 1-.695-.998 3.19 3.19 0 0 1-.243-1.259c0-.457.08-.877.243-1.259.168-.382.402-.715.703-.998a3.1 3.1 0 0 1 1.06-.652c.405-.156.85-.234 1.337-.234.538 0 1.021.09 1.45.27.434.178.798.439 1.093.78l-.902.834a2.147 2.147 0 0 0-.721-.512 2.07 2.07 0 0 0-.851-.174c-.295 0-.564.046-.808.139a1.844 1.844 0 0 0-.633.4 1.88 1.88 0 0 0-.408.616c-.093.237-.14.5-.14.79 0 .284.047.544.14.782.098.237.234.445.408.625.18.173.388.306.625.399.243.093.51.139.799.139.277 0 .547-.044.807-.13.266-.093.524-.246.773-.46l.799 1.015c-.33.25-.715.44-1.155.574-.434.133-.868.2-1.302.2Zm1.172-.955v-2.284h1.285v2.466l-1.285-.182ZM100.228 56.936c-.486 0-.952-.063-1.398-.19-.445-.134-.804-.305-1.076-.513l.477-1.06a3.518 3.518 0 0 0 2.006.634c.278 0 .501-.026.669-.078a.819.819 0 0 0 .382-.234.517.517 0 0 0 .121-.339.447.447 0 0 0-.191-.382 1.452 1.452 0 0 0-.503-.234 7.658 7.658 0 0 0-.695-.174 9.868 9.868 0 0 1-.755-.208 3.22 3.22 0 0 1-.686-.313 1.577 1.577 0 0 1-.513-.503c-.127-.209-.19-.475-.19-.8 0-.347.092-.662.277-.946.191-.29.475-.518.851-.686.382-.173.86-.26 1.433-.26.382 0 .758.046 1.128.139.371.087.698.22.982.4l-.435 1.067a3.548 3.548 0 0 0-.85-.356 3.033 3.033 0 0 0-.834-.121c-.272 0-.495.031-.669.095-.173.064-.298.148-.373.252a.555.555 0 0 0-.113.347c0 .157.064.284.191.382.128.093.295.168.504.226.208.058.437.116.686.174.254.058.506.124.755.2.255.075.486.176.695.303.208.128.376.295.503.504.133.208.2.472.2.79 0 .342-.095.654-.286.938-.192.283-.478.512-.86.686-.376.173-.854.26-1.433.26ZM46.106 64.294h5.73v2.142h-5.73v-2.142Zm.204 4.896h6.477v2.21h-9.213V59.5h8.992v2.21H46.31v7.48ZM58.383 71.4l-5.134-11.9h2.975l4.488 10.54H58.96l4.556-10.54h2.737l-5.151 11.9h-2.72ZM69.78 64.294h5.73v2.142h-5.73v-2.142Zm.204 4.896h6.477v2.21h-9.214V59.5h8.993v2.21h-6.256v7.48ZM78.653 71.4V59.5h2.278l7.02 8.568h-1.104V59.5h2.72v11.9h-2.261l-7.038-8.568h1.105V71.4h-2.72ZM94.847 71.4v-9.656H91.04V59.5h10.37v2.244h-3.808V71.4h-2.754Z"
            fill="#35B2D9"
          />
          <path
            d="M151.835 138.12H98.759l-4.877-15.877h43.324l14.629 15.877ZM106.469 163.221H37.974l7.71-25.101h53.075l7.71 25.101ZM45.683 138.12H-7.393l14.63-15.877H50.56l-4.877 15.877Z"
            fill="#000"
          />
          <path
            d="m59.905 134.187-.062-.005a9.62 9.62 0 0 1-2.8-.711c-1.288-.546-1.427-1.609-1.427-2.039v-1.41c0-.617.256-1.209.677-1.644a4.912 4.912 0 0 1-.324-.449c-1.227-1.904-.703-3.979.196-5.285.466-.676 1.09-1.235 1.638-1.727.416-.372.81-.725 1.05-1.047.076-.102.158-.223.247-.36v-.546c-.001-1.246.41-1.933 1.224-2.458a3.134 3.134 0 0 1-.544-1.767c0-1.345.844-2.498 2.029-2.954.396-3.354.923-9.756 1.009-20.52a2.786 2.786 0 0 1-1.028-2.154c0-.366.071-.717.202-1.038a2.739 2.739 0 0 1-1.247-1.82 3.087 3.087 0 0 1-1.957-2.87V74H85.64v9.383c0 1.303-.811 2.42-1.957 2.87a2.737 2.737 0 0 1-1.246 1.822c.129.322.201.672.201 1.037 0 .86-.4 1.64-1.027 2.154.085 10.765.612 17.167 1.009 20.52a3.167 3.167 0 0 1 2.028 2.954c0 .652-.2 1.261-.543 1.766.814.526 1.224 1.212 1.223 2.458v.546c.088.136.17.256.247.358.24.324.634.676 1.05 1.049.549.492 1.17 1.049 1.639 1.726.899 1.307 1.422 3.38.196 5.285-.104.16-.213.31-.325.449a2.39 2.39 0 0 1 .676 1.644v1.41c0 .43-.139 1.493-1.427 2.039a9.63 9.63 0 0 1-2.8.711l-.063.005H59.905v.001Z"
            fill="#fff"
          />
          <path
            d="M84.809 128.609v-.095s1.384-.159 2.242-1.492c.87-1.35.291-2.76-.168-3.426-.676-.983-1.94-1.769-2.65-2.723a8.866 8.866 0 0 1-.461-.692.835.835 0 0 1-.12-.433v-.729c0-.779.034-.976-1.341-1.536-.258-.105-.51-.206-.745-.296h.008v-.968a1.483 1.483 0 0 0 1.4-1.478c0-.822-.667-1.488-1.488-1.488h-.367c-.389-2.809-1.123-9.811-1.19-23.034a1.112 1.112 0 0 0 1.034-1.106c0-.588-.46-1.07-1.041-1.107-.002-.395-.007-.794-.012-1.199h1.098a1.05 1.05 0 0 0 1.046-1.053v-.962h.505c.777 0 1.406-.63 1.406-1.405V75.68h-4.557v3.65h-2.636v-3.65h-9.114v3.65H65.02v-3.65h-4.556v7.707c0 .776.63 1.405 1.405 1.405h.505v.962c0 .582.468 1.053 1.046 1.053h1.099c-.006.404-.01.804-.012 1.199a1.109 1.109 0 0 0-.008 2.214c-.068 13.221-.8 20.224-1.19 23.033h-.368a1.483 1.483 0 0 0-.089 2.966v.968h.01c-.236.09-.49.191-.745.296-1.376.561-1.342.757-1.342 1.536v.729c0 .153-.04.304-.12.433a8.539 8.539 0 0 1-.46.692c-.712.953-1.974 1.74-2.651 2.723-.46.666-1.038 2.076-.168 3.426.859 1.333 2.242 1.492 2.242 1.492v.19l-.45.163-1.424.512a.734.734 0 0 0-.453.642v1.41c0 .264.162.393.405.496 1.183.502 2.27.583 2.27.583h24.494s1.087-.081 2.27-.583c.243-.103.406-.232.406-.496v-1.41a.733.733 0 0 0-.454-.642l-1.424-.512-.45-.163v-.096.001Z"
            fill="#000"
          />
          <path
            d="M62.906 118.03c2.19-.015 4.148 0 6.339-.014-.869.413-1.545.824-3.62.824-.767 0-1.977-.166-2.739-.478-.281-.115-.227-.338.02-.333v.001Z"
            fill="url(#d)"
          />
          <path
            d="M59.617 129.668h8.04c-.567.299-2.088.63-2.871.754-1.306.204-3.023.276-4.611-.163-.16-.043-.65-.166-.74-.284-.1-.132-.041-.307.182-.307Z"
            fill="url(#e)"
          />
          <path
            d="M81.575 118.031c-1.448-.016-2.74.001-4.189-.015.574.438 1.273.765 2.381.765.506 0 1.357-.153 1.86-.484.186-.121.11-.272-.054-.267l.002.001Z"
            fill="url(#f)"
          />
          <path
            d="M69.138 107.726c0 .472-.03.943-.06 1.414-.052.746-.015 1.528-.3 2.25-.221.561-.666 1.09-1.325 1.341-.535.204-1.296.128-1.798-.159a.518.518 0 0 1-.28-.494c.621-6.726.795-13.745.858-19.31.002-.177.202-.307.418-.273.816.127 1.724.796 2.054 1.358.387.66.433 1.413.433 2.143V107.726Z"
            fill="url(#g)"
          />
          <path
            d="M78.447 94.288c.064 4.903.407 11.414.86 17.687a.416.416 0 0 1-.116.326c-.302.297-.796.3-1.177.049-.458-.302-.616-1.292-.629-1.84-.164-7.239-.2-11.187-.2-15.638 0-.545 1.257-.945 1.261-.584h.001Z"
            fill="url(#h)"
          />
          <path
            d="m65.491 83.709-2.433-.022a1.406 1.406 0 0 1-1.398-1.405V76.5c0-.156.126-.282.281-.282h1.186c.156 0 .28.126.282.28l.004 3.495c0 .31.251.56.561.562l1.521.006c.31 0 .561.252.561.562v2.024a.56.56 0 0 1-.565.562Z"
            fill="url(#i)"
          />
          <path
            d="m79.968 83.709 1.403-.022a1.406 1.406 0 0 0 1.398-1.405V76.5a.281.281 0 0 0-.281-.282h-.918a.282.282 0 0 0-.281.28l-.005 3.495c0 .31-.25.56-.56.562l-.76.006c-.31 0-.561.252-.561.562v2.024a.56.56 0 0 0 .565.562Z"
            fill="url(#j)"
          />
          <path
            d="M68.3 86.157h-4.487a.113.113 0 0 1-.112-.115v-.568c0-.065.054-.117.118-.114l4.486.181c.06.004.106.054.106.115v.387c0 .063-.05.115-.112.115v-.001Z"
            fill="url(#k)"
          />
          <path
            d="M78.14 86.157h2.524c.035 0 .064-.052.064-.115v-.568c0-.065-.03-.117-.066-.115l-2.324.183c-.034.004-.26.066-.26.216v.284c0 .063.028.115.063.115h-.001Z"
            fill="url(#l)"
          />
          <path
            d="M64.697 88.527c1.8-.019 3.406.017 5.206-.001-.449.291-1.908.587-2.886.587-1.838 0-2.588-.319-2.588-.485 0-.106.181-.1.268-.101Z"
            fill="url(#m)"
          />
          <path
            d="M79.825 88.522h-3.157c.456.363 1.112.5 1.721.509.698.012 1.32-.175 1.52-.34.07-.057.077-.174-.084-.17Z"
            fill="url(#n)"
          />
          <path
            d="M63.592 113.937c2.118-.023 4.009.022 6.127-.002-1.105.611-2.245.737-3.397.737-2.163 0-3.046-.401-3.046-.609 0-.134.214-.125.316-.126Z"
            fill="url(#o)"
          />
          <path
            d="M80.885 113.937c-1.428-.023-2.704.022-4.132-.002.746.611 1.515.737 2.291.737 1.46 0 2.055-.401 2.055-.609 0-.134-.145-.125-.212-.126h-.002Z"
            fill="url(#p)"
          />
          <path
            d="M66.604 120.806c.106.155.156.426.145.614-.086 1.483-.644 3.145-2.439 3.87-.977.394-2.496.152-2.887.026-.472-.152-.833-.391-.877-1.02-.03-.426.291-.856.533-1.149.241-.291 1.45-1.5 1.836-2.06.274-.396.808-.705 1.288-.749 1.148-.105 2.096.023 2.4.466l.001.002Z"
            fill="url(#q)"
          />
          <path
            d="M80.314 121.974c.064.447.494 2.327.82 2.744.534.682 1.11.648 1.734.64.45-.007 1.215-.156 1.475-.523.216-.302.14-.78-.088-1.052-.786-.935-1.193-1.444-1.962-2.263-.284-.303-.713-.99-1.176-.907-.726.131-.876.87-.804 1.36v.001Z"
            fill="url(#r)"
          />
          <path
            d="M79.852 129.668c1.817 0 3.553 0 5.33-.007.153 0 .273.18-.214.367-.638.245-1.524.439-2.147.437-1.057-.005-1.93-.267-2.97-.797Z"
            fill="url(#s)"
          />
        </g>
        <g clipPath="url(#t)">
          <path
            d="M74.558 24.785c-2.182.916-2.674 3.452-3.232 5.494-.8.076-1.494.284-2.383.72l-.019.025c.608-.098 1.621-.048 2.15.2-.337 1.37-.616 2.828-1.347 3.994-.829 1.423-2.96 1.576-3.965.257-.976-1.218-.277-3.338 1.168-3.867-1.605.497-2.497 2.7-1.574 4.149.977 1.597 3.5 1.915 4.942.784 1.386-1.184 1.607-3.113 1.978-4.775.035-.153.066-.306.098-.458 2.184-.095 4.799.084 6.306-1.871 2.284-2.952-.91-6.286-4.123-4.652Zm2.43 4.576c-1.312.72-2.91.715-4.383.892.24-1.034.53-2.066 1-2.994.658-1.303 2.484-2.15 3.81-1.408 1.376.831.82 2.828-.426 3.51Z"
            fill="#35B2D9"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="d"
          x1={62.697}
          y1={118.427}
          x2={74.919}
          y2={118.427}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="e"
          x1={59.387}
          y1={130.125}
          x2={74.822}
          y2={130.125}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="f"
          x1={72.6}
          y1={118.398}
          x2={81.361}
          y2={118.398}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={65.373}
          y1={102.668}
          x2={72.402}
          y2={102.668}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="h"
          x1={74.852}
          y1={103.341}
          x2={79.125}
          y2={103.341}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={61.66}
          y1={79.964}
          x2={69.867}
          y2={79.964}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="j"
          x1={75.698}
          y1={79.964}
          x2={82.479}
          y2={79.964}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={63.701}
          y1={85.759}
          x2={72.493}
          y2={85.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="l"
          x1={75.159}
          y1={85.759}
          x2={80.499}
          y2={85.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={64.429}
          y1={88.817}
          x2={74.648}
          y2={88.817}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="n"
          x1={73.05}
          y1={88.777}
          x2={79.673}
          y2={88.777}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={63.276}
          y1={114.302}
          x2={75.303}
          y2={114.302}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="p"
          x1={71.972}
          y1={114.302}
          x2={80.723}
          y2={114.302}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={60.545}
          y1={122.905}
          x2={72.13}
          y2={122.905}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={75.707}
          y1={122.984}
          x2={84.111}
          y2={122.984}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="s"
          x1={73.84}
          y1={130.063}
          x2={84.844}
          y2={130.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <clipPath id="a">
          <path
            fill="#fff"
            transform="translate(.586)"
            d="M0 0h143.327v160H0z"
          />
        </clipPath>
        <clipPath id="t">
          <path
            fill="#fff"
            transform="translate(64.325 22.89)"
            d="M0 0h15.787v15.787H0z"
          />
        </clipPath>
        <filter
          id="b"
          x={13.334}
          y={14.126}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={12} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend in2="shape" result="effect1_innerShadow_18_2159" />
        </filter>
      </defs>
    </svg>
  ),
  // ----------------------------------------------------------PREMIER:SVG-------------------------------------------------------------------------------------------------
  premier: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="11 0 120 160"
    >
      <g clipPath="url(#a)">
        <path
          d="M139.276 89.662a19.152 19.152 0 0 0 4.051-3.131v24.582a17.78 17.78 0 0 1-8.89 15.394L80.55 157.618a17.77 17.77 0 0 1-17.772 0L8.89 126.507A17.78 17.78 0 0 1 0 111.113V86.531a19.08 19.08 0 0 0 4.051 3.131l58.044 33.512a19.133 19.133 0 0 0 19.141 0l58.042-33.512h-.002Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.887v32.62a19.087 19.087 0 0 1-4.051 3.131L81.234 118.15a19.128 19.128 0 0 1-19.141 0L4.051 84.64A19.212 19.212 0 0 1 0 81.51v-32.62c0-6.352 3.39-12.22 8.89-15.396L62.778 2.382a17.773 17.773 0 0 1 17.774 0l53.887 31.113a17.774 17.774 0 0 1 8.89 15.392h-.002Z"
          fill="#0F84A8"
        />
        <g filter="url(#b)">
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="c"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.581 105.968V54.034c0-4.981-2.658-9.583-6.969-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.717 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.657 9.583 6.97 12.073l44.977 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.969-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            d="M41.326 56.832v-6.078h2.631c.544 0 1.013.09 1.407.27.394.173.697.425.912.755.214.33.32.723.32 1.18 0 .452-.106.843-.32 1.173-.215.33-.519.584-.912.764-.394.173-.863.26-1.407.26h-1.85l.626-.634v2.31h-1.407Zm1.407-2.153-.625-.669h1.771c.434 0 .758-.093.973-.278.214-.185.32-.443.32-.773 0-.335-.106-.596-.32-.78-.215-.186-.539-.279-.973-.279h-1.771l.625-.668v3.447ZM47.601 56.832v-6.078h2.63c.545 0 1.014.09 1.407.27.394.173.698.425.912.755.214.33.321.723.321 1.18 0 .452-.107.843-.32 1.173a2.053 2.053 0 0 1-.913.746c-.393.174-.862.26-1.406.26h-1.85l.626-.616v2.31H47.6Zm3.864 0-1.52-2.205h1.502l1.537 2.205h-1.52Zm-2.457-2.153-.626-.66h1.772c.434 0 .758-.093.972-.278.214-.191.321-.452.321-.782 0-.335-.107-.596-.32-.78-.215-.186-.54-.279-.973-.279h-1.772l.626-.668v3.447ZM56.938 56.936c-.48 0-.926-.078-1.337-.234a3.21 3.21 0 0 1-1.06-.66 3.098 3.098 0 0 1-.694-.999 3.168 3.168 0 0 1-.243-1.25c0-.451.08-.868.243-1.25.168-.382.402-.715.703-.999a3.212 3.212 0 0 1 1.06-.66 3.636 3.636 0 0 1 1.32-.234c.48 0 .92.078 1.319.234a3.116 3.116 0 0 1 1.754 1.659c.168.376.252.793.252 1.25 0 .452-.084.871-.252 1.259a3.033 3.033 0 0 1-.703.998 3.186 3.186 0 0 1-1.051.652c-.4.156-.836.234-1.311.234Zm-.009-1.198c.272 0 .521-.046.747-.139a1.79 1.79 0 0 0 1.007-1.016c.099-.237.148-.5.148-.79 0-.29-.05-.553-.148-.79a1.774 1.774 0 0 0-.4-.617 1.702 1.702 0 0 0-.598-.399 2.016 2.016 0 0 0-.756-.139c-.272 0-.524.046-.755.139a1.812 1.812 0 0 0-.6.4 1.88 1.88 0 0 0-.407.616c-.093.237-.14.5-.14.79 0 .284.047.547.14.79.098.238.231.443.4.617.173.173.375.306.607.399.231.093.483.139.755.139ZM61.312 56.832v-6.078h1.163l2.588 4.29h-.617l2.544-4.29h1.155l.017 6.078h-1.32l-.008-4.055h.243l-2.032 3.412h-.633l-2.076-3.412h.296v4.055h-1.32ZM69.605 56.832v-6.078h2.63c.544 0 1.013.09 1.407.27.394.173.697.425.912.755.214.33.32.723.32 1.18 0 .452-.106.843-.32 1.173-.215.33-.519.584-.912.764-.394.173-.863.26-1.407.26h-1.85l.626-.634v2.31h-1.406Zm1.406-2.153-.625-.669h1.771c.434 0 .758-.093.973-.278.214-.185.32-.443.32-.773 0-.335-.106-.596-.32-.78-.215-.186-.539-.279-.973-.279h-1.771l.625-.668v3.447ZM76.977 56.832V51.9h-1.945v-1.146h5.297V51.9h-1.945v4.932h-1.407ZM81.085 56.832v-6.078h1.407v6.078h-1.407ZM83.934 56.832v-6.078h1.164l3.586 4.376h-.565v-4.376h1.39v6.078h-1.155l-3.595-4.376h.564v4.376h-1.389ZM93.881 56.936c-.48 0-.923-.075-1.328-.226-.4-.156-.75-.376-1.05-.66a3.098 3.098 0 0 1-.695-.998 3.192 3.192 0 0 1-.244-1.259c0-.457.082-.877.244-1.259.167-.382.402-.715.703-.998a3.1 3.1 0 0 1 1.06-.652c.404-.156.85-.234 1.336-.234.539 0 1.022.09 1.45.27.434.178.8.439 1.094.78l-.903.834a2.147 2.147 0 0 0-.72-.512 2.07 2.07 0 0 0-.851-.174c-.295 0-.565.046-.808.139a1.844 1.844 0 0 0-.633.4 1.88 1.88 0 0 0-.409.616c-.092.237-.138.5-.138.79 0 .284.046.544.138.782.099.237.235.445.409.625.179.173.387.306.625.399.243.093.509.139.798.139.278 0 .547-.044.808-.13.266-.093.524-.246.773-.46l.798 1.015c-.33.25-.714.44-1.154.574-.434.133-.869.2-1.303.2Zm1.172-.955v-2.284h1.285v2.466l-1.284-.182ZM99.642 56.936c-.486 0-.952-.063-1.398-.19-.445-.134-.804-.305-1.076-.513l.477-1.06a3.517 3.517 0 0 0 2.006.634c.278 0 .5-.026.668-.078a.814.814 0 0 0 .382-.234.518.518 0 0 0 .122-.339.447.447 0 0 0-.191-.382 1.45 1.45 0 0 0-.504-.234 7.582 7.582 0 0 0-.694-.174 9.879 9.879 0 0 1-.756-.208 3.22 3.22 0 0 1-.686-.313 1.577 1.577 0 0 1-.512-.503c-.127-.209-.19-.475-.19-.8 0-.347.092-.662.277-.946.191-.29.475-.518.85-.686.383-.173.86-.26 1.433-.26.383 0 .759.046 1.129.139.371.087.698.22.981.4l-.434 1.067a3.538 3.538 0 0 0-.851-.356 3.02 3.02 0 0 0-.833-.121c-.272 0-.495.031-.669.095-.173.064-.298.148-.373.252a.555.555 0 0 0-.113.347c0 .157.064.284.191.382.127.093.295.168.504.226.208.058.437.116.686.174.254.058.506.124.755.2.255.075.486.176.695.303.208.128.376.295.503.504.133.208.2.472.2.79 0 .342-.096.654-.287.938-.191.283-.477.512-.859.686-.376.173-.854.26-1.433.26ZM31 71V59.1h5.151c1.065 0 1.983.176 2.754.527.77.34 1.366.833 1.785 1.479.42.646.629 1.417.629 2.312 0 .884-.21 1.649-.629 2.295-.42.646-1.014 1.145-1.785 1.496-.77.34-1.689.51-2.754.51H32.53l1.224-1.241V71H31Zm2.754-4.216-1.224-1.309h3.468c.85 0 1.485-.181 1.904-.544.42-.363.629-.867.629-1.513 0-.657-.21-1.167-.629-1.53-.42-.363-1.054-.544-1.904-.544H32.53l1.224-1.309v6.749ZM43.285 71V59.1h5.151c1.066 0 1.983.176 2.754.527.77.34 1.366.833 1.785 1.479.42.646.63 1.417.63 2.312 0 .884-.21 1.649-.63 2.295-.42.635-1.014 1.122-1.785 1.462-.77.34-1.688.51-2.754.51h-3.62l1.223-1.207V71h-2.754Zm7.565 0-2.975-4.318h2.941L53.826 71H50.85Zm-4.81-4.216-1.225-1.292h3.468c.85 0 1.485-.181 1.904-.544.42-.374.63-.884.63-1.53 0-.657-.21-1.167-.63-1.53-.42-.363-1.054-.544-1.904-.544h-3.468l1.224-1.309v6.749Zm12.28-2.89h5.728v2.142H58.32v-2.142Zm.203 4.896H65V71h-9.214V59.1h8.993v2.21h-6.256v7.48ZM67.191 71V59.1h2.278l5.066 8.398h-1.207L78.31 59.1h2.261l.034 11.9H78.02l-.017-7.939h.476l-3.978 6.681h-1.24l-4.064-6.681h.578V71h-2.584Zm16.237 0V59.1h2.754V71h-2.754Zm8.11-7.106h5.73v2.142h-5.73v-2.142Zm.205 4.896h6.477V71h-9.214V59.1h8.993v2.21h-6.256v7.48ZM100.41 71V59.1h5.151c1.065 0 1.983.176 2.754.527.771.34 1.366.833 1.785 1.479.419.646.629 1.417.629 2.312 0 .884-.21 1.649-.629 2.295-.419.635-1.014 1.122-1.785 1.462-.771.34-1.689.51-2.754.51h-3.621l1.224-1.207V71h-2.754Zm7.565 0-2.975-4.318h2.941L110.951 71h-2.975Zm-4.811-4.216-1.224-1.292h3.468c.85 0 1.485-.181 1.904-.544.419-.374.629-.884.629-1.53 0-.657-.21-1.167-.629-1.53-.419-.363-1.054-.544-1.904-.544h-3.468l1.224-1.309v6.749Z"
            fill="#0F84A8"
          />
          <path
            d="M151.249 138.12H98.173l-4.877-15.877h43.324l14.629 15.877ZM105.883 163.221H37.388l7.71-25.101h53.075l7.71 25.101ZM45.097 138.12H-7.979l14.63-15.877h43.323l-4.877 15.877Z"
            fill="#000"
          />
          <path
            d="m59.319 134.187-.063-.005a9.62 9.62 0 0 1-2.8-.711c-1.287-.546-1.426-1.609-1.426-2.039v-1.41c0-.617.256-1.209.676-1.644a4.912 4.912 0 0 1-.324-.449c-1.226-1.904-.702-3.979.196-5.285.467-.676 1.09-1.235 1.639-1.727.416-.372.81-.725 1.05-1.047.076-.102.158-.223.247-.36v-.546c-.001-1.246.41-1.933 1.223-2.458a3.134 3.134 0 0 1-.543-1.767c0-1.345.843-2.498 2.028-2.954.397-3.354.924-9.756 1.01-20.52a2.786 2.786 0 0 1-1.028-2.154c0-.366.071-.717.201-1.038a2.739 2.739 0 0 1-1.246-1.82 3.087 3.087 0 0 1-1.957-2.87V74h26.853v9.383c0 1.303-.812 2.42-1.957 2.87a2.737 2.737 0 0 1-1.247 1.822c.13.322.202.672.202 1.037 0 .86-.4 1.64-1.028 2.154.086 10.765.613 17.167 1.01 20.52a3.167 3.167 0 0 1 2.028 2.954c0 .652-.2 1.261-.544 1.766.814.526 1.225 1.212 1.224 2.458v.546c.088.136.17.256.246.358.241.324.635.676 1.05 1.049.55.492 1.172 1.049 1.64 1.726.899 1.307 1.422 3.38.195 5.285-.104.16-.212.31-.324.449a2.39 2.39 0 0 1 .676 1.644v1.41c0 .43-.14 1.493-1.427 2.039a9.63 9.63 0 0 1-2.8.711l-.063.005H59.319v.001Z"
            fill="#fff"
          />
          <path
            d="M84.223 128.609v-.095s1.384-.159 2.242-1.492c.87-1.35.291-2.76-.168-3.426-.677-.983-1.94-1.769-2.65-2.723a8.866 8.866 0 0 1-.462-.692.834.834 0 0 1-.119-.433v-.729c0-.779.034-.976-1.342-1.536-.257-.105-.509-.206-.745-.296h.01v-.968a1.483 1.483 0 0 0 1.398-1.478c0-.822-.666-1.488-1.487-1.488h-.367c-.39-2.809-1.123-9.811-1.191-23.034a1.112 1.112 0 0 0 1.035-1.106c0-.588-.461-1.07-1.042-1.107-.002-.395-.006-.794-.012-1.199h1.099a1.05 1.05 0 0 0 1.046-1.053v-.962h.505c.776 0 1.405-.63 1.405-1.405V75.68h-4.556v3.65h-2.637v-3.65h-9.114v3.65h-2.636v-3.65h-4.556v7.707c0 .776.63 1.405 1.405 1.405h.505v.962c0 .582.467 1.053 1.046 1.053h1.098c-.005.404-.01.804-.012 1.199a1.109 1.109 0 0 0-.008 2.214c-.067 13.221-.8 20.224-1.19 23.033h-.367a1.483 1.483 0 0 0-.089 2.966v.968h.01a34.2 34.2 0 0 0-.746.296c-1.375.561-1.341.757-1.341 1.536v.729c0 .153-.04.304-.12.433a8.539 8.539 0 0 1-.46.692c-.712.953-1.975 1.74-2.651 2.723-.46.666-1.038 2.076-.168 3.426.859 1.333 2.242 1.492 2.242 1.492v.19l-.45.163-1.424.512a.734.734 0 0 0-.454.642v1.41c0 .264.163.393.406.496 1.183.502 2.27.583 2.27.583h24.493s1.088-.081 2.27-.583c.244-.103.406-.232.406-.496v-1.41a.733.733 0 0 0-.453-.642l-1.424-.512-.45-.163v-.096.001Z"
            fill="#000"
          />
          <path
            d="M62.32 118.03c2.19-.015 4.148 0 6.339-.014-.87.413-1.545.824-3.62.824-.767 0-1.977-.166-2.739-.478-.281-.115-.228-.338.02-.333v.001Z"
            fill="url(#d)"
          />
          <path
            d="M59.03 129.668h8.04c-.566.299-2.087.63-2.87.754-1.306.204-3.024.276-4.612-.163-.159-.043-.65-.166-.74-.284-.099-.132-.04-.307.183-.307Z"
            fill="url(#e)"
          />
          <path
            d="M80.988 118.031c-1.448-.016-2.74.001-4.188-.015.574.438 1.273.765 2.381.765.506 0 1.357-.153 1.86-.484.186-.121.11-.272-.054-.267l.001.001Z"
            fill="url(#f)"
          />
          <path
            d="M68.552 107.726c0 .472-.03.943-.061 1.414-.052.746-.014 1.528-.3 2.25-.22.561-.665 1.09-1.325 1.341-.534.204-1.295.128-1.797-.159a.518.518 0 0 1-.28-.494c.62-6.726.795-13.745.857-19.31.003-.177.203-.307.419-.273.816.127 1.724.796 2.053 1.358.388.66.434 1.413.434 2.143V107.726Z"
            fill="url(#g)"
          />
          <path
            d="M77.861 94.288c.064 4.903.406 11.414.86 17.687a.416.416 0 0 1-.116.326c-.302.297-.796.3-1.178.049-.457-.302-.615-1.292-.628-1.84-.165-7.239-.2-11.187-.2-15.638 0-.545 1.257-.945 1.261-.584h.001Z"
            fill="url(#h)"
          />
          <path
            d="m64.905 83.709-2.433-.022a1.406 1.406 0 0 1-1.398-1.405V76.5c0-.156.125-.282.281-.282h1.186c.156 0 .28.126.282.28l.004 3.495c0 .31.25.56.56.562l1.522.006c.31 0 .561.252.561.562v2.024a.56.56 0 0 1-.565.562Z"
            fill="url(#i)"
          />
          <path
            d="m79.382 83.709 1.403-.022a1.406 1.406 0 0 0 1.398-1.405V76.5a.281.281 0 0 0-.281-.282h-.918a.282.282 0 0 0-.282.28l-.004 3.495c0 .31-.25.56-.56.562l-.76.006c-.31 0-.562.252-.562.562v2.024c0 .312.253.564.566.562Z"
            fill="url(#j)"
          />
          <path
            d="M67.713 86.157h-4.486a.113.113 0 0 1-.112-.115v-.568c0-.065.054-.117.117-.114l4.487.181c.06.004.106.054.106.115v.387c0 .063-.05.115-.112.115v-.001Z"
            fill="url(#k)"
          />
          <path
            d="M77.553 86.157h2.525c.035 0 .064-.052.064-.115v-.568c0-.065-.03-.117-.066-.115l-2.324.183c-.034.004-.261.066-.261.216v.284c0 .063.028.115.064.115h-.002Z"
            fill="url(#l)"
          />
          <path
            d="M64.11 88.527c1.8-.019 3.407.017 5.207-.001-.45.291-1.908.587-2.886.587-1.838 0-2.589-.319-2.589-.485 0-.106.182-.1.269-.101Z"
            fill="url(#m)"
          />
          <path
            d="M79.239 88.522h-3.158c.457.363 1.113.5 1.722.509.698.012 1.319-.175 1.52-.34.07-.057.077-.174-.084-.17Z"
            fill="url(#n)"
          />
          <path
            d="M63.006 113.937c2.118-.023 4.008.022 6.127-.002-1.105.611-2.246.737-3.397.737-2.163 0-3.046-.401-3.046-.609 0-.134.214-.125.316-.126Z"
            fill="url(#o)"
          />
          <path
            d="M80.3 113.937c-1.429-.023-2.705.022-4.133-.002.746.611 1.514.737 2.291.737 1.46 0 2.055-.401 2.055-.609 0-.134-.145-.125-.213-.126Z"
            fill="url(#p)"
          />
          <path
            d="M66.018 120.806c.106.155.155.426.144.614-.085 1.483-.644 3.145-2.438 3.87-.977.394-2.496.152-2.887.026-.472-.152-.834-.391-.877-1.02-.03-.426.291-.856.533-1.149.241-.291 1.45-1.5 1.836-2.06.274-.396.808-.705 1.288-.749 1.148-.105 2.096.023 2.4.466v.002Z"
            fill="url(#q)"
          />
          <path
            d="M79.728 121.974c.064.447.494 2.327.82 2.744.533.682 1.11.648 1.734.64.45-.007 1.215-.156 1.475-.523.216-.302.14-.78-.089-1.052-.785-.935-1.192-1.444-1.961-2.263-.284-.303-.713-.99-1.177-.907-.725.131-.875.87-.804 1.36l.002.001Z"
            fill="url(#r)"
          />
          <path
            d="M79.265 129.668c1.817 0 3.553 0 5.33-.007.154 0 .274.18-.213.367-.638.245-1.524.439-2.147.437-1.057-.005-1.93-.267-2.97-.797Z"
            fill="url(#s)"
          />
        </g>
        <path
          d="M73.971 24.785c-2.181.916-2.673 3.452-3.23 5.494-.8.076-1.495.284-2.385.72l-.018.025c.608-.098 1.62-.048 2.15.2-.337 1.37-.616 2.828-1.348 3.994-.828 1.423-2.96 1.576-3.965.257-.976-1.218-.276-3.338 1.169-3.867-1.605.497-2.497 2.7-1.574 4.149.976 1.597 3.5 1.915 4.941.784 1.387-1.184 1.608-3.113 1.979-4.775.034-.153.066-.306.097-.458 2.184-.095 4.8.084 6.307-1.871 2.284-2.952-.91-6.286-4.123-4.652Zm2.431 4.576c-1.313.72-2.91.715-4.383.892.24-1.034.529-2.066 1-2.994.657-1.303 2.483-2.15 3.81-1.408 1.376.831.82 2.828-.427 3.51Z"
          fill="#0F84A8"
        />
      </g>
      <defs>
        <linearGradient
          id="d"
          x1={62.111}
          y1={118.427}
          x2={74.333}
          y2={118.427}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="e"
          x1={58.801}
          y1={130.125}
          x2={74.236}
          y2={130.125}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="f"
          x1={72.013}
          y1={118.398}
          x2={80.775}
          y2={118.398}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={64.787}
          y1={102.668}
          x2={71.816}
          y2={102.668}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="h"
          x1={74.265}
          y1={103.341}
          x2={78.539}
          y2={103.341}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={61.074}
          y1={79.964}
          x2={69.281}
          y2={79.964}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="j"
          x1={75.112}
          y1={79.964}
          x2={81.893}
          y2={79.964}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={63.115}
          y1={85.759}
          x2={71.907}
          y2={85.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="l"
          x1={74.573}
          y1={85.759}
          x2={79.913}
          y2={85.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={63.842}
          y1={88.817}
          x2={74.062}
          y2={88.817}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="n"
          x1={72.463}
          y1={88.777}
          x2={79.087}
          y2={88.777}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={62.69}
          y1={114.302}
          x2={74.716}
          y2={114.302}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="p"
          x1={71.386}
          y1={114.302}
          x2={80.137}
          y2={114.302}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={59.959}
          y1={122.905}
          x2={71.543}
          y2={122.905}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={75.121}
          y1={122.984}
          x2={83.525}
          y2={122.984}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="s"
          x1={73.253}
          y1={130.063}
          x2={84.258}
          y2={130.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h143.327v160H0z" />
        </clipPath>
        <filter
          id="b"
          x={12.748}
          y={14.126}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={12} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend in2="shape" result="effect1_innerShadow_16_3048" />
        </filter>
      </defs>
    </svg>
  ),
  // ----------------------------------------------------------PROMPTINGS-PROCESS:SVG-------------------------------------------------------------------------------------------------
  promptingsProcess: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="11 0 120 160"
    >
      <g clipPath="url(#a)">
        <path
          d="M139.276 89.662a19.152 19.152 0 0 0 4.051-3.131v24.582a17.78 17.78 0 0 1-8.89 15.394L80.55 157.618a17.77 17.77 0 0 1-17.772 0L8.89 126.507A17.78 17.78 0 0 1 0 111.113V86.531a19.08 19.08 0 0 0 4.051 3.131l58.044 33.512a19.133 19.133 0 0 0 19.141 0l58.042-33.512h-.002Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.887v32.62a19.087 19.087 0 0 1-4.051 3.131L81.234 118.15a19.128 19.128 0 0 1-19.141 0L4.051 84.64A19.212 19.212 0 0 1 0 81.51v-32.62c0-6.352 3.39-12.22 8.89-15.396L62.778 2.382a17.773 17.773 0 0 1 17.774 0l53.887 31.113a17.774 17.774 0 0 1 8.89 15.392h-.002Z"
          fill="#309B8C"
        />
        <g filter="url(#b)">
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="c"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934c0 4.981 2.656 9.583 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.94 13.94 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path
            d="M42.556 57.03V50.95h2.63c.545 0 1.014.09 1.407.27.394.173.698.425.912.755.214.33.321.724.321 1.18 0 .452-.107.843-.321 1.173-.214.33-.518.585-.912.764-.393.174-.862.26-1.406.26h-1.85l.625-.633v2.31h-1.406Zm1.406-2.154-.625-.669h1.771c.435 0 .759-.092.973-.278.214-.185.321-.442.321-.772 0-.336-.107-.596-.321-.782-.214-.185-.538-.278-.973-.278h-1.77l.624-.668v3.447ZM48.83 57.03V50.95h2.631c.544 0 1.013.09 1.407.27.393.173.697.425.911.755.215.33.322.724.322 1.18 0 .452-.107.843-.322 1.173a2.053 2.053 0 0 1-.911.747c-.394.173-.863.26-1.407.26h-1.85l.626-.616v2.31H48.83Zm3.864 0-1.52-2.206h1.503l1.537 2.205h-1.52Zm-2.457-2.154-.625-.66h1.771c.434 0 .758-.093.972-.278.215-.19.322-.451.322-.781 0-.336-.107-.596-.322-.782-.214-.185-.538-.278-.972-.278h-1.771l.625-.668v3.447ZM58.167 57.133c-.48 0-.926-.078-1.337-.234a3.212 3.212 0 0 1-1.06-.66 3.098 3.098 0 0 1-.694-.998 3.17 3.17 0 0 1-.243-1.25c0-.452.081-.869.243-1.251.168-.382.402-.715.703-.998a3.21 3.21 0 0 1 1.06-.66 3.636 3.636 0 0 1 1.32-.235c.48 0 .92.078 1.32.235.404.156.755.376 1.05.66a3.036 3.036 0 0 1 .955 2.248c0 .452-.084.871-.252 1.26a3.036 3.036 0 0 1-.703.998 3.19 3.19 0 0 1-1.05.651c-.4.156-.837.234-1.312.234Zm-.008-1.198c.272 0 .52-.046.746-.139a1.773 1.773 0 0 0 1.007-1.016c.099-.237.148-.5.148-.79 0-.29-.05-.553-.148-.79a1.772 1.772 0 0 0-.399-.616 1.7 1.7 0 0 0-.599-.4 2.016 2.016 0 0 0-.755-.139c-.273 0-.524.047-.756.14a1.81 1.81 0 0 0-.599.399c-.174.173-.31.379-.408.616-.093.237-.139.5-.139.79 0 .284.046.547.139.79.098.238.231.443.4.617.173.174.376.307.607.4.232.092.483.138.756.138ZM62.541 57.03V50.95h1.164l2.587 4.29h-.616l2.544-4.29h1.154l.018 6.078h-1.32l-.009-4.055h.243l-2.031 3.413h-.634l-2.075-3.413h.295v4.055h-1.32ZM70.834 57.03V50.95h2.63c.545 0 1.014.09 1.407.27.394.173.698.425.912.755.214.33.321.724.321 1.18 0 .452-.107.843-.321 1.173-.214.33-.518.585-.912.764-.393.174-.862.26-1.406.26h-1.85l.625-.633v2.31h-1.406Zm1.406-2.154-.625-.669h1.772c.434 0 .758-.092.972-.278.214-.185.321-.442.321-.772 0-.336-.107-.596-.321-.782-.214-.185-.538-.278-.972-.278h-1.772l.625-.668v3.447ZM78.206 57.03v-4.933h-1.945v-1.146h5.297v1.146h-1.945v4.932h-1.407ZM82.315 57.03V50.95h1.406v6.078h-1.406ZM85.164 57.03V50.95h1.163l3.586 4.376h-.564v-4.376h1.389v6.078h-1.155l-3.594-4.376h.564v4.376h-1.39ZM95.11 57.133c-.48 0-.923-.075-1.328-.225-.4-.157-.75-.377-1.05-.66a3.097 3.097 0 0 1-.695-.999 3.19 3.19 0 0 1-.243-1.259c0-.457.08-.877.243-1.259.168-.382.402-.715.703-.998a3.1 3.1 0 0 1 1.06-.651 3.687 3.687 0 0 1 1.337-.235c.538 0 1.021.09 1.45.27.434.179.798.44 1.094.78l-.903.834a2.148 2.148 0 0 0-.721-.512 2.072 2.072 0 0 0-.85-.174c-.296 0-.565.047-.808.14a1.843 1.843 0 0 0-.634.399 1.88 1.88 0 0 0-.408.616c-.093.237-.14.5-.14.79 0 .284.047.544.14.782.098.237.234.445.408.625.18.174.388.307.625.4.243.092.51.138.799.138.278 0 .547-.043.807-.13.267-.093.524-.246.773-.46l.799 1.016c-.33.249-.715.44-1.155.573a4.42 4.42 0 0 1-1.302.2Zm1.173-.955v-2.283h1.285v2.466l-1.285-.183ZM100.871 57.133a5.06 5.06 0 0 1-1.397-.19c-.446-.134-.805-.304-1.077-.513l.477-1.06a3.514 3.514 0 0 0 2.006.634c.278 0 .501-.025.669-.078a.819.819 0 0 0 .382-.234.517.517 0 0 0 .121-.339.445.445 0 0 0-.191-.382 1.452 1.452 0 0 0-.503-.234 7.592 7.592 0 0 0-.695-.174 9.814 9.814 0 0 1-.755-.208 3.23 3.23 0 0 1-.686-.313 1.577 1.577 0 0 1-.512-.503c-.128-.209-.192-.475-.192-.799 0-.347.093-.663.278-.946.191-.29.475-.518.851-.686.382-.174.86-.26 1.433-.26.382 0 .758.046 1.129.138.37.087.697.22.981.4l-.434 1.067a3.567 3.567 0 0 0-.851-.356 3.029 3.029 0 0 0-.834-.121c-.272 0-.495.032-.668.095-.174.064-.299.148-.374.252a.557.557 0 0 0-.113.347c0 .157.064.284.191.383.128.092.296.167.504.225.208.058.437.116.686.174.255.058.506.124.755.2.255.075.487.176.695.304.208.127.376.295.504.503.133.208.199.472.199.79 0 .342-.095.654-.286.938-.191.284-.478.512-.86.686-.376.174-.854.26-1.433.26ZM50.628 67.685v-6.078h2.63c.545 0 1.014.09 1.407.27.394.173.698.425.912.755.214.33.321.724.321 1.18 0 .452-.107.843-.32 1.173-.215.33-.519.585-.913.764-.393.174-.862.26-1.406.26h-1.85l.626-.633v2.31h-1.407Zm1.407-2.153-.626-.669h1.772c.434 0 .758-.092.972-.278.214-.185.321-.442.321-.772 0-.336-.107-.596-.32-.782-.215-.185-.54-.277-.973-.277h-1.772l.626-.67v3.448ZM56.903 67.685v-6.078h2.63c.544 0 1.013.09 1.407.27.394.173.698.425.912.755.214.33.32.724.32 1.18 0 .452-.106.843-.32 1.173a2.052 2.052 0 0 1-.912.747c-.394.173-.862.26-1.407.26h-1.849l.625-.616v2.31h-1.406Zm3.863 0-1.52-2.205h1.503l1.537 2.205h-1.52Zm-2.457-2.153-.625-.66h1.771c.434 0 .759-.093.973-.278.214-.19.32-.451.32-.781 0-.336-.106-.596-.32-.782-.214-.185-.539-.277-.973-.277h-1.771l.625-.67v3.448ZM66.24 67.79c-.481 0-.927-.079-1.338-.235a3.21 3.21 0 0 1-1.059-.66 3.098 3.098 0 0 1-.695-.998 3.168 3.168 0 0 1-.243-1.25c0-.452.081-.869.243-1.251.168-.382.403-.715.704-.998a3.212 3.212 0 0 1 1.059-.66 3.636 3.636 0 0 1 1.32-.235c.48 0 .92.078 1.32.235.405.156.755.376 1.05.66a3.034 3.034 0 0 1 .955 2.248c0 .452-.084.871-.252 1.26a3.034 3.034 0 0 1-.703.998 3.188 3.188 0 0 1-1.05.651c-.4.156-.837.234-1.312.234Zm-.01-1.199c.273 0 .522-.046.748-.139a1.79 1.79 0 0 0 1.007-1.016c.098-.237.147-.5.147-.79 0-.29-.049-.552-.147-.79a1.774 1.774 0 0 0-.4-.616 1.702 1.702 0 0 0-.599-.4 2.016 2.016 0 0 0-.755-.139c-.272 0-.524.047-.756.14a1.812 1.812 0 0 0-.599.399 1.88 1.88 0 0 0-.408.616c-.092.238-.139.5-.139.79 0 .284.047.547.14.79.098.238.23.443.399.617.173.174.376.307.607.4.232.092.484.138.756.138ZM73.522 67.79c-.469 0-.906-.076-1.311-.226a3.099 3.099 0 0 1-1.737-1.658 3.19 3.19 0 0 1-.243-1.26c0-.457.081-.877.243-1.259.168-.382.4-.715.695-.998.301-.284.651-.5 1.05-.651.4-.157.837-.235 1.312-.235.526 0 1.001.093 1.424.278.428.18.787.446 1.076.799l-.903.833a2.059 2.059 0 0 0-.694-.53 1.91 1.91 0 0 0-.834-.182c-.283 0-.544.047-.781.14a1.771 1.771 0 0 0-.617.399 1.88 1.88 0 0 0-.408.616c-.092.238-.139.5-.139.79 0 .29.047.553.14.79.098.238.234.443.407.617.174.174.38.307.617.4.237.092.498.138.781.138.301 0 .579-.058.834-.173a2.12 2.12 0 0 0 .694-.547l.903.833c-.29.353-.648.622-1.076.808-.423.185-.9.277-1.433.277ZM78.275 64.056H81.2v1.094h-2.926v-1.094Zm.104 2.5h3.308v1.13h-4.706v-6.079h4.593v1.13H78.38v3.82ZM84.803 67.79c-.486 0-.952-.064-1.397-.192-.446-.133-.805-.303-1.077-.512l.477-1.06a3.515 3.515 0 0 0 2.006.634c.278 0 .5-.025.669-.078a.815.815 0 0 0 .382-.234.518.518 0 0 0 .121-.338.447.447 0 0 0-.19-.383 1.455 1.455 0 0 0-.504-.234 7.582 7.582 0 0 0-.695-.174 9.879 9.879 0 0 1-.755-.208 3.23 3.23 0 0 1-.686-.313 1.577 1.577 0 0 1-.513-.503c-.127-.209-.19-.475-.19-.799 0-.347.092-.663.277-.946.191-.29.475-.519.851-.686.382-.174.86-.26 1.433-.26.382 0 .758.046 1.129.138.37.087.697.22.98.4l-.433 1.067a3.552 3.552 0 0 0-.851-.355 3.024 3.024 0 0 0-.834-.122c-.272 0-.495.032-.668.095-.174.064-.299.148-.374.252a.555.555 0 0 0-.113.348c0 .156.064.283.191.382.128.092.296.167.504.225.208.058.437.116.686.174.255.058.506.124.755.2.255.075.487.176.695.304.208.127.376.295.504.503.133.209.2.472.2.79 0 .342-.096.654-.287.938-.191.284-.478.512-.86.686-.376.174-.854.26-1.433.26ZM90.34 67.79c-.486 0-.952-.064-1.398-.192-.445-.133-.804-.303-1.076-.512l.477-1.06a3.515 3.515 0 0 0 2.006.634c.278 0 .5-.025.669-.078a.815.815 0 0 0 .382-.234.518.518 0 0 0 .121-.338.447.447 0 0 0-.19-.383 1.455 1.455 0 0 0-.505-.234 7.582 7.582 0 0 0-.694-.174 9.879 9.879 0 0 1-.756-.208 3.23 3.23 0 0 1-.685-.313 1.577 1.577 0 0 1-.513-.503c-.127-.209-.19-.475-.19-.799 0-.347.092-.663.277-.946.191-.29.475-.519.851-.686.382-.174.86-.26 1.433-.26.382 0 .758.046 1.128.138.37.087.698.22.982.4l-.434 1.067a3.552 3.552 0 0 0-.851-.355 3.024 3.024 0 0 0-.834-.122c-.272 0-.495.032-.669.095-.173.064-.298.148-.373.252a.555.555 0 0 0-.113.348c0 .156.064.283.191.382.128.092.295.167.504.225.208.058.437.116.686.174.254.058.506.124.755.2.255.075.486.176.695.304.208.127.376.295.503.503.134.209.2.472.2.79 0 .342-.095.654-.287.938-.19.284-.477.512-.859.686-.376.174-.854.26-1.433.26Z"
            fill="#309B8C"
          />
          <path
            d="M102.379 81.941c-11.966-3.316-22.238 5.538-31.173 12.14-3.544-2.286-7.082-3.687-12.167-4.778l-.153.038c2.821 1.575 6.833 5.073 8.21 7.811-5.845 4.555-11.732 9.656-18.535 12.082-8.042 3.172-17.321-3.126-17.179-11.825-.063-8.194 9.714-14.659 17.386-12.143-8.23-3.167-19.065 3.01-19.97 11.986-1.169 9.755 8.195 19.268 17.815 19.292 9.563-.373 16.742-7.603 23.676-13.25.637-.518 1.263-1.044 1.89-1.57 9.307 6.708 19.504 15.946 32.071 12.789 19.008-4.743 16.679-28.864-1.871-32.572ZM97.526 108.7c-7.754-1.296-14.319-6.509-20.964-10.572 4.347-3.483 8.892-6.793 13.852-9.09 6.944-3.23 17.224-.786 20.277 6.582 2.969 7.899-5.81 14.325-13.165 13.08Z"
            fill="#309B8C"
            style={{
              mixBlendMode: 'multiply',
            }}
          />
          <path
            d="m58.752 136.156-.058-.004a8.981 8.981 0 0 1-2.737-.717 2.024 2.024 0 0 1-1.203-1.846v-1.314c0-.576.24-1.127.631-1.532a4.526 4.526 0 0 1-.302-.419c-1.285-1.997-.442-4.24.184-5.149.408-.593.993-1.331 1.56-2.044.35-.442.688-.866.944-1.21.494-.663.795-1.809.827-2.099v-.274c.005-.821.307-1.335.724-1.691a2.085 2.085 0 0 1-.596-.693c-.332-.623-.934-1.764-1.223-2.398l-.047-.103c-.387-.841-.633-1.6-.009-3.079l.07-.164c.75-1.784 2.506-5.964 8.728-12.495.086-.091.162-.173.229-.247h-.086c-1.17.076-2.341.206-3.666.908-.306.264-.507.639-.738 1.069-.241.448-.514.956-.956 1.365-.746.689-2.1.834-3.104.834-1.978 0-3.134-.573-3.436-1.703a2.22 2.22 0 0 1-.075-.513c-.52 0-1.006-.124-1.446-.368-.51-.273-1.389-.746-1.632-5.448-.117-.813.102-2.028 1.105-3.007l.138-.134c.948-.922 3.835-3.726 5.447-6.504a6.67 6.67 0 0 1 1.033-1.335 14.562 14.562 0 0 1 1.73-1.486c-.208-.24-.417-.475-.622-.707-1.294-1.458-2.229-2.51-2.077-3.769.072-.592.39-1.11.895-1.458.306-.211.875-.604 1.935-.604.974 0 2.67.283 7.17 2.46.616.07 1.204.158 1.791.27 1.385.271 2.703.675 3.93 1.204l-.021-.316 2.62 1.707a16.85 16.85 0 0 1 2.51 2l.29.281.118.387c.03.097.058.194.086.292l.18-.873 2.066 3.325a21.537 21.537 0 0 1 1.954 4.087l.132.37-.057.387a22.237 22.237 0 0 1-.582 2.733l1.3-1.622.542 3.51c.045.29.088.583.126.884.19 1.477.258 3.214.195 5.022l-.014.419-.221.355a22.756 22.756 0 0 1-1.969 2.682l2.188-1.227-.522 3.201a41.562 41.562 0 0 1-1.022 4.618l.147-.038-1.063 2.842c-.296.791-.618 1.56-.956 2.284a2.082 2.082 0 0 1-.681.816c.402.353.69.862.696 1.661v.283c.032.29.334 1.437.827 2.099.257.345.594.768.944 1.21.566.713 1.151 1.451 1.56 2.045.624.908 1.468 3.151.182 5.148a4.792 4.792 0 0 1-.302.419c.391.405.63.956.63 1.532v1.314c0 .796-.472 1.521-1.202 1.846-1.351.599-2.6.707-2.737.717l-.059.004H58.751Z"
            fill="#fff"
          />
          <path
            d="m83.71 131.677-1.327-.478-.42-.152v-.177s1.29-.148 2.09-1.39c.81-1.259.271-2.795-.156-3.417-.631-.916-1.808-2.319-2.47-3.207-.751-1.007-1.138-2.591-1.138-3.002v-.304c-.003-.403-.04-.527-.828-.849a36.898 36.898 0 0 0-.901-.338l-.016-.005c-.257-.142-.43-.438-.43-.778 0-.485.349-.875.781-.875h1.049c.203 0 .39-.116.477-.301.33-.707.631-1.433.908-2.171a24.04 24.04 0 0 1-4.552.742 29.623 29.623 0 0 0 5.243-2.79c.51-1.682.895-3.397 1.17-5.078-3.714 2.082-8.002 2.789-8.002 2.789 4.384-2.557 7.009-5.599 8.52-8.021.06-1.772-.007-3.398-.184-4.771a32.93 32.93 0 0 0-.12-.843c-3.094 3.861-6.627 5.682-6.627 5.682 3.56-3.47 4.907-7.676 5.366-10.771a19.88 19.88 0 0 0-1.811-3.79c-.828 4.008-2.605 6.209-2.605 6.209 1.151-3.674.85-6.875.105-9.323a15.139 15.139 0 0 0-2.276-1.814c.123 1.824-.039 4.022-.65 5.795.012-3.018-.74-5.34-1.603-7.01a17.568 17.568 0 0 0-3.717-1.152 22.538 22.538 0 0 0-1.937-.28c-6.339-3.096-7.203-2.493-7.78-2.095-.907.625 1.002 2.26 2.636 4.262.382.468.383.792 0 1.084-.326.247-1.303.839-2.338 1.886a5.087 5.087 0 0 0-.792 1.022c-1.81 3.117-5.047 6.193-5.845 6.972-.832.812-.64 1.719-.64 1.719s.192 3.908.832 4.252c1.184.656 2.67-.803 3.01-.428.272.301-.928 1.553-.736 2.271.191.719 3.361.688 3.97.125.608-.563.832-1.796 1.888-2.595 1.67-.921 3.135-1.075 4.441-1.16.245-.017 1.55.012 1.897.357.647.646.287 1.367-.818 2.526-6.221 6.53-7.774 10.495-8.49 12.19-.43 1.019-.259 1.271.04 1.927.276.609.894 1.777 1.178 2.309.09.17.268.276.46.276h.986c.43 0 .781.39.781.875 0 .346-.18.644-.443.783-.063.024-.74.27-.902.338-.789.323-.825.445-.827.849v.304c0 .411-.387 1.995-1.138 3.002-.662.888-1.84 2.291-2.47 3.207-.428.621-.967 2.158-.156 3.417.8 1.242 2.09 1.391 2.09 1.391v.176l-.42.152-1.327.478a.684.684 0 0 0-.423.598v1.314c0 .182.11.344.275.418 1.141.507 2.219.587 2.219.587h22.828s1.077-.081 2.22-.587a.46.46 0 0 0 .274-.418v-1.314a.682.682 0 0 0-.422-.598l.003-.002Z"
            fill="#000"
          />
          <path
            d="M67.124 80.567c-.436-.235-1.515-.818-1.874-1.019.182.173 1.22 1.123 1.665 1.564.05.05.118.077.188.076 1.088-.019 2.169-.054 3.256-.072a33.803 33.803 0 0 0-2.847-.428 1.04 1.04 0 0 1-.388-.12Z"
            fill="url(#d)"
          />
          <path
            d="M71.251 87.54c.291 1.02.681 2.874.429 4.54-.213 1.407-.977 2.628-1.724 3.635 2.03-1.507 2.263-3.25 2.313-3.724.207-1.943-.397-3.196-1.018-4.45Z"
            fill="url(#e)"
          />
          <path
            d="M74.196 87.232c-.136-2.27-.63-3.67-1.015-4.495-.363-.315-.899-.575-1.196-.614.83 1.062 1.621 2.62 2.211 5.109Z"
            fill="url(#f)"
          />
          <path
            d="M76.767 92.947c.132-.731.83-4.502.11-7.768.056.053.48.557.709.923.425 2.337-.138 5.256-.82 6.845Z"
            fill="url(#g)"
          />
          <path
            d="M75.187 108.609c2.918-1.755 6.084-4.63 7.454-6.901.076-1.157.015-1.725-.03-3.22-.214 1.18-.626 3.176-.626 3.176s-2.14 3.603-6.798 6.945Z"
            fill="url(#h)"
          />
          <path
            d="M76.505 100.638c2.719-2.877 4.04-5.524 4.767-8.64-.226-.838-.457-1.43-.83-2.228.142.633.225 1.398.235 2.353-.388 2.293-1.788 5.537-4.17 8.516l-.002-.001Z"
            fill="url(#i)"
          />
          <path
            d="M76.8 113.942a42.417 42.417 0 0 0 4.454-2.436c.341-1.027.6-1.97.873-2.858-.225.519-.712 1.435-1.01 1.984a2.483 2.483 0 0 1-.67.787 49.15 49.15 0 0 1-3.647 2.524v-.001Z"
            fill="url(#j)"
          />
          <path
            d="M80.25 115.07c-.155.334-.235.542-.448.887a.39.39 0 0 1-.317.177c-.44.018-.754-.007-1.15-.007.37-.131.811-.166 1.14-.347.327-.179.534-.409.774-.71h.001Z"
            fill="url(#k)"
          />
          <path
            d="M74.736 119.009c.961-.014 3.14-.01 3.31-.01.444 0 .048.498-1.346.498a4.243 4.243 0 0 1-1.963-.488Z"
            fill="url(#l)"
          />
          <path
            d="M78.75 122.145c.064.051.493 1.05.637 1.347.515 1.066 1.852 2.884 1.951 3.062.13.231.053.54-.093.758-.177.264-.505.377-.81.468-.365.108-1.63.177-2.439-.475-.913-.737-.969-1.849-1.034-2.26-.118-.737-.046-2.131.203-2.708.22-.507 1.098-.568 1.584-.19v-.002Z"
            fill="url(#m)"
          />
          <path
            d="M77.417 131.945c1.639 0 3.205 0 4.806-.007.14 0 .247.168-.192.342-.574.229-1.374.41-1.935.408-.954-.005-1.74-.249-2.678-.743Z"
            fill="url(#n)"
          />
          <path
            d="M75.634 118.202c-.023.022-.016.082.01.082.701-.011 1.01-.006 1.34-.01.048 0 .088-.074.088-.164 0-.194 0-.345-.002-.542 0-.088-.039-.16-.088-.162-.103-.003-.317-.013-.423.023-.053.019-.358.21-.925.772v.001Z"
            fill="url(#o)"
          />
          <path
            d="M54.297 98.093c-.035-.547-.147-1.09-.256-1.612-.109-.52-.22-1.057-.255-1.597a2.997 2.997 0 0 1 .09-.982 1.55 1.55 0 0 1 .613-.842c.155-.1.3-.189.44-.275.321-.198.598-.369.877-.588a15.303 15.303 0 0 0 3.853-4.453c.151-.267.291-.544.427-.813.228-.453.47-.916.759-1.34.681-1 2.913-2.333 3.87-2.595-.765.807-.75 1.464-.74 1.833.305.055.999.244 1.411.773.25.32.354.694.308 1.113-.471-.512-1.61-.972-2.444-.972-.18 0-.337.021-.469.064-.82.266-1.14.732-1.583 1.38-.309.45-.587.971-.858 1.475-.14.265-.28.525-.422.771-.756 1.316-1.9 2.53-3.598 3.82-.36.272-.675.308-.935.308-.058 0-.113-.002-.165-.004a3.257 3.257 0 0 0-.136-.003c-.08 0-.17.004-.25.038-.397.166-.52.751-.48 1.113.051.456.27.729.585.729.079 0 .16-.019.24-.053.357-.153.68-.524.99-1.13.239.672.039 1.33-.55 1.777-.213.162-.418.211-.615.258-.044.01-.17.043-.17.043v.04c.005.932-.408 1.653-.538 1.734v-.01Zm11.46-10.54c-.21.442-.494.858-.885 1.158-.718.55-1.65.602-2.5.431.74.843 2.347.842 3.061-.027a1.662 1.662 0 0 0 .38-1.075 2.207 2.207 0 0 0-.056-.486Z"
            fill="url(#p)"
          />
          <path
            d="M63.398 81.764c.125.14.246.24.433.272a.898.898 0 0 0 .644-.125c.225-.15-.218-.559-.432-.724-1.752-1.35-3.067-2.307-3.258-2.253.656.71 1.149 1.187 2.614 2.829h-.001Z"
            fill="url(#q)"
          />
          <path
            d="M56.936 100.136c.454-.056.801-.373.992-.794.19-.42.267-1.08.267-1.713-.133.224-.208.4-.286.556l-.335.675c-.111.225-.564 1.132-.637 1.276h-.001Z"
            fill="url(#r)"
          />
          <path
            d="M62.683 112.713c-.059.591.274 1.485 1.062 2.697a.262.262 0 0 1-.216.406c-.438 0-.982-.003-1.243-.008a.924.924 0 0 1-.766-.435c-.557-.897-.675-1.113-1.053-1.925a1.329 1.329 0 0 1-.047-.988c1.032-3.007 2.51-5.031 4.231-7.298 1.988-2.616 4.459-4.443 5.236-6.556.23 1.058-.108 2.359-1.276 3.838-2.307 2.922-5.47 7.211-5.928 10.268v.001Z"
            fill="url(#s)"
          />
          <path
            d="M68.955 118.999c-1.01.311-2.534.628-3.89.628-.995 0-1.943-.117-2.879-.363-.147-.038-.315-.103-.3-.177.017-.088.337-.087.477-.087h6.592v-.001Z"
            fill="url(#t)"
          />
          <path
            d="M65.706 125.88c-.253.492-.515.995-.931 1.37-.505.455-1.198.679-1.89.748-.851.086-1.397.087-2.2-.208-.309-.114-.614-.255-.845-.482a1.07 1.07 0 0 1-.308-.863c.089-.908 1.565-2.217 2.298-3.778.209-.445.447-.914.879-1.169.323-.192.856-.239 1.238-.235.813.008 1.397.09 1.932.524.552.446.508 2.771-.173 4.094v-.001Z"
            fill="url(#u)"
          />
          <path
            d="M58.492 131.945h7.558c-.886.346-1.44.507-2.7.702-.62.096-1.34.142-2.092.135-.736-.007-1.504-.084-2.243-.286a4.95 4.95 0 0 1-.695-.265c-.23-.136-.198-.286.172-.286Z"
            fill="url(#v)"
          />
          <path
            d="M66.535 118.202c.046.022.032.081-.02.081-1.45-.01-2.086-.006-2.767-.009-.101 0-.183-.074-.183-.164 0-.194.001-.345.004-.542.001-.088.08-.161.18-.163.213-.003.461.04.679.058.114.009.937.176 2.108.738l-.001.001Z"
            fill="url(#w)"
          />
          <path
            d="M62.68 88.52a.322.322 0 0 1-.146-.029c-.153-.063-.235-.257-.235-.407 0-.324.209-.667.31-.782.16-.185.465-.382.834-.382.115 0 .23.02.34.06a1.4 1.4 0 0 0-.549.432c-.127.184-.194.365-.237.647-.008.043-.012.086-.016.126-.017.172-.032.322-.227.335l-.075.003.001-.002Z"
            fill="url(#x)"
          />
          <path
            d="M149.558 141.184H96.483l-4.877-15.877h43.323l14.629 15.877ZM104.192 166.285H35.697l7.71-25.101h53.076l7.709 25.101ZM43.407 141.184H-9.67L4.96 125.307h43.323l-4.876 15.877Z"
            fill="#000"
          />
        </g>
        <path
          d="M73.971 24.785c-2.181.916-2.673 3.452-3.23 5.494-.8.076-1.495.284-2.385.72l-.018.025c.608-.098 1.62-.048 2.15.2-.337 1.37-.616 2.828-1.348 3.994-.828 1.423-2.96 1.576-3.965.257-.976-1.218-.276-3.338 1.169-3.867-1.605.497-2.497 2.7-1.574 4.149.976 1.597 3.5 1.915 4.941.784 1.387-1.184 1.608-3.113 1.979-4.775.034-.153.066-.306.097-.458 2.184-.095 4.8.084 6.307-1.871 2.284-2.952-.91-6.286-4.123-4.652Zm2.431 4.576c-1.313.72-2.91.715-4.383.892.24-1.034.529-2.066 1-2.994.657-1.303 2.483-2.15 3.81-1.408 1.376.831.82 2.828-.427 3.51Z"
          fill="#309B8C"
        />
      </g>
      <defs>
        <linearGradient
          id="d"
          x1={59.629}
          y1={80.368}
          x2={69.918}
          y2={80.368}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={67.725}
          y1={91.628}
          x2={72.468}
          y2={91.628}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={69.553}
          y1={84.677}
          x2={74.005}
          y2={84.677}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={75.704}
          y1={89.064}
          x2={77.65}
          y2={89.064}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={66.946}
          y1={103.549}
          x2={82.031}
          y2={103.549}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={71.261}
          y1={95.204}
          x2={80.86}
          y2={95.204}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={70.941}
          y1={111.294}
          x2={81.667}
          y2={111.294}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={76.232}
          y1={115.606}
          x2={80.085}
          y2={115.606}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={70.905}
          y1={119.248}
          x2={77.918}
          y2={119.248}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={71.959}
          y1={124.876}
          x2={81.018}
          y2={124.876}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={71.995}
          y1={132.313}
          x2={81.919}
          y2={132.313}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={74.024}
          y1={117.844}
          x2={76.947}
          y2={117.844}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="p"
          x1={54.145}
          y1={89.047}
          x2={75.773}
          y2={95.108}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="q"
          x1={60.784}
          y1={80.492}
          x2={67.79}
          y2={80.492}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={56.936}
          y1={98.882}
          x2={59.285}
          y2={98.882}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={60.346}
          y1={107.212}
          x2={78.284}
          y2={107.212}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={61.885}
          y1={119.313}
          x2={75.083}
          y2={119.313}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={59.526}
          y1={124.655}
          x2={72.093}
          y2={124.655}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={58.175}
          y1={132.363}
          x2={72.876}
          y2={132.363}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={63.565}
          y1={117.844}
          x2={69.16}
          y2={117.844}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={61.563}
          y1={87.338}
          x2={66.111}
          y2={88.47}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h143.327v160H0z" />
        </clipPath>
        <filter
          id="b"
          x={12.748}
          y={14.126}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={8} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="shape" result="effect1_innerShadow_17_965" />
        </filter>
      </defs>
    </svg>
  ),
  // ----------------------------------------------------------TRAINING-PROGRESS:SVG-------------------------------------------------------------------------------------------------
  trainingProgress: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="11 0 120 160"
    >
      <g clipPath="url(#a)">
        <path
          d="M139.276 89.662a19.152 19.152 0 0 0 4.051-3.131v24.582a17.78 17.78 0 0 1-8.89 15.394L80.55 157.618a17.77 17.77 0 0 1-17.772 0L8.89 126.507A17.78 17.78 0 0 1 0 111.113V86.531a19.08 19.08 0 0 0 4.051 3.131l58.044 33.512a19.133 19.133 0 0 0 19.141 0l58.042-33.512h-.002Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.887v32.62a19.087 19.087 0 0 1-4.051 3.131L81.234 118.15a19.128 19.128 0 0 1-19.141 0L4.051 84.64A19.212 19.212 0 0 1 0 81.51v-32.62c0-6.352 3.39-12.22 8.89-15.396L62.778 2.382a17.773 17.773 0 0 1 17.774 0l53.887 31.113a17.774 17.774 0 0 1 8.89 15.392h-.002Z"
          fill="url(#b)"
        />
        <g filter="url(#c)">
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934a13.94 13.94 0 0 0 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.941 13.941 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="d"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934a13.94 13.94 0 0 0 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.941 13.941 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <path
            d="M33.268 57.294c-.468 0-.906-.076-1.31-.226a3.098 3.098 0 0 1-1.736-1.658 3.19 3.19 0 0 1-.244-1.26c0-.457.08-.877.243-1.258.168-.383.4-.715.694-.999.301-.284.652-.5 1.05-.651.4-.156.837-.235 1.312-.235a3.51 3.51 0 0 1 1.424.278c.428.18.787.446 1.077.799l-.903.833a2.06 2.06 0 0 0-.695-.53 1.91 1.91 0 0 0-.834-.181 2.13 2.13 0 0 0-.781.138 1.771 1.771 0 0 0-.616.4 1.88 1.88 0 0 0-.409.616c-.092.238-.139.501-.139.79 0 .29.047.553.14.79.098.238.234.443.407.617.174.174.38.307.617.4.237.092.498.138.782.138.3 0 .578-.057.833-.173a2.12 2.12 0 0 0 .695-.547l.903.833c-.29.353-.649.623-1.077.808-.423.185-.9.278-1.433.278ZM38.021 53.56h2.926v1.094h-2.926V53.56Zm.104 2.5h3.309v1.13h-4.706v-6.078h4.593v1.128h-3.196v3.82ZM42.553 57.19v-6.078h2.63c.545 0 1.014.09 1.407.269.394.173.698.425.912.755.214.33.321.724.321 1.18 0 .452-.107.843-.321 1.173a2.054 2.054 0 0 1-.912.747c-.394.173-.862.26-1.407.26h-1.849l.625-.616v2.31h-1.406Zm3.864 0-1.52-2.206h1.502l1.537 2.205h-1.52Zm-2.458-2.154-.625-.66h1.771c.434 0 .759-.092.973-.278.214-.19.321-.451.321-.781 0-.336-.107-.596-.321-.782-.214-.185-.539-.277-.973-.277h-1.77l.624-.669v3.447ZM50.112 57.19v-4.932h-1.945V51.11h5.296v1.147h-1.945v4.931h-1.406ZM54.22 57.19v-6.078h1.407v6.077H54.22ZM58.371 53.847h2.918v1.128H58.37v-1.128Zm.105 3.342h-1.407v-6.078h4.593v1.13h-3.186v4.948ZM62.614 57.19v-6.078h1.407v6.077h-1.407ZM66.757 53.56h2.926v1.094h-2.926V53.56Zm.104 2.5h3.308v1.13h-4.706v-6.078h4.594v1.128H66.86v3.82ZM71.289 57.19v-6.078h2.76c.66 0 1.242.127 1.746.382.504.248.897.599 1.18 1.05.284.452.426.987.426 1.607 0 .613-.142 1.148-.425 1.606a2.914 2.914 0 0 1-1.181 1.059c-.504.249-1.085.373-1.745.373h-2.761Zm1.406-1.155h1.285c.405 0 .756-.076 1.05-.226.302-.156.533-.376.695-.66.168-.284.252-.617.252-.998 0-.388-.084-.721-.252-1a1.608 1.608 0 0 0-.694-.65c-.295-.157-.646-.235-1.05-.235h-1.286v3.769ZM83.83 57.294c-.47 0-.906-.076-1.311-.226a3.098 3.098 0 0 1-1.737-1.658 3.19 3.19 0 0 1-.243-1.26c0-.457.08-.877.243-1.258.168-.383.4-.715.695-.999.3-.284.65-.5 1.05-.651.4-.156.837-.235 1.311-.235a3.51 3.51 0 0 1 1.424.278c.429.18.787.446 1.077.799l-.903.833a2.059 2.059 0 0 0-.695-.53 1.91 1.91 0 0 0-.833-.181 2.13 2.13 0 0 0-.782.138 1.77 1.77 0 0 0-.616.4c-.174.173-.31.379-.408.616-.093.238-.14.501-.14.79 0 .29.047.553.14.79.098.238.234.443.408.617.173.174.379.307.616.4.238.092.498.138.782.138.3 0 .579-.057.833-.173.255-.122.487-.304.695-.547l.903.833c-.29.353-.648.623-1.077.808-.422.185-.9.278-1.432.278ZM90.114 57.294c-.48 0-.926-.079-1.337-.235a3.21 3.21 0 0 1-1.06-.66 3.1 3.1 0 0 1-.694-.998 3.168 3.168 0 0 1-.243-1.25c0-.452.08-.869.243-1.25.168-.383.402-.716.703-1a3.21 3.21 0 0 1 1.06-.66 3.636 3.636 0 0 1 1.319-.234c.48 0 .92.079 1.32.235.405.156.755.376 1.05.66a3.037 3.037 0 0 1 .956 2.248c0 .452-.084.872-.252 1.26a3.035 3.035 0 0 1-.704.998 3.185 3.185 0 0 1-1.05.651c-.4.156-.837.235-1.311.235Zm-.009-1.199c.272 0 .521-.046.747-.139a1.788 1.788 0 0 0 1.007-1.015c.098-.238.148-.501.148-.79 0-.29-.05-.553-.148-.79a1.77 1.77 0 0 0-.4-.617 1.7 1.7 0 0 0-.599-.4 2.014 2.014 0 0 0-.755-.139c-.272 0-.524.047-.755.14a1.812 1.812 0 0 0-.6.399 1.88 1.88 0 0 0-.407.616c-.093.238-.14.501-.14.79 0 .284.047.547.14.79.098.238.231.443.399.617.173.174.376.307.608.4.231.092.483.138.755.138ZM93.604 57.19l2.709-6.078h1.39l2.717 6.077h-1.476l-2.223-5.365h.556l-2.232 5.365h-1.441Zm1.355-1.303.373-1.068h3.126l.382 1.068h-3.882ZM103.874 57.294c-.468 0-.905-.076-1.311-.226a3.1 3.1 0 0 1-1.736-1.658 3.192 3.192 0 0 1-.243-1.26c0-.457.081-.877.243-1.258a3.1 3.1 0 0 1 .694-.999c.301-.284.652-.5 1.051-.651a3.564 3.564 0 0 1 1.311-.235c.527 0 1.001.093 1.424.278.428.18.787.446 1.077.799l-.903.833a2.064 2.064 0 0 0-.695-.53 1.908 1.908 0 0 0-.833-.181 2.13 2.13 0 0 0-.782.138 1.766 1.766 0 0 0-.616.4c-.174.173-.31.379-.408.616a2.15 2.15 0 0 0-.139.79c0 .29.046.553.139.79.098.238.234.443.408.617.173.174.379.307.616.4.237.092.498.138.782.138.301 0 .578-.057.833-.173.255-.122.486-.304.695-.547l.903.833c-.29.353-.649.623-1.077.808-.423.185-.9.278-1.433.278ZM111.501 51.111h1.407v6.078h-1.407v-6.078Zm-2.761 6.078h-1.406v-6.078h1.406v6.078Zm2.865-2.492h-2.969v-1.19h2.969v1.19ZM28.346 67.845v-4.931H26.4v-1.147h5.296v1.147h-1.945v4.931h-1.406ZM32.454 67.845v-6.078h2.63c.545 0 1.014.09 1.407.27.394.173.698.425.912.755.214.33.321.724.321 1.18 0 .452-.107.843-.32 1.173a2.054 2.054 0 0 1-.913.747c-.393.174-.862.26-1.406.26h-1.85l.626-.616v2.31h-1.407Zm3.864 0-1.52-2.205H36.3l1.537 2.205h-1.52Zm-2.457-2.153-.626-.66h1.772c.434 0 .758-.092.972-.278.214-.19.321-.451.321-.781 0-.336-.107-.596-.32-.782-.215-.185-.54-.277-.973-.277h-1.772l.626-.669v3.447ZM38.04 67.845l2.709-6.078h1.39l2.717 6.078H43.38l-2.223-5.365h.556l-2.232 5.365H38.04Zm1.355-1.302.373-1.068h3.126l.382 1.068h-3.882ZM45.486 67.845v-6.078h1.407v6.078h-1.407ZM48.336 67.845v-6.078h1.163l3.586 4.377h-.565v-4.377h1.39v6.078h-1.155L49.16 63.47h.565v4.376h-1.39ZM55.348 67.845v-6.078h1.406v6.078h-1.406ZM58.197 67.845v-6.078h1.163l3.586 4.377h-.564v-4.377h1.389v6.078h-1.155l-3.594-4.376h.564v4.376h-1.39ZM68.144 67.95c-.48 0-.924-.076-1.329-.226-.4-.156-.75-.376-1.05-.66a3.1 3.1 0 0 1-.695-.998 3.19 3.19 0 0 1-.243-1.26c0-.457.081-.877.243-1.258.168-.383.402-.715.703-.999.301-.284.654-.5 1.06-.651.405-.157.85-.235 1.337-.235.538 0 1.022.09 1.45.27.434.179.799.44 1.094.78l-.903.834a2.146 2.146 0 0 0-.72-.512 2.07 2.07 0 0 0-.852-.173c-.295 0-.564.046-.807.139a1.843 1.843 0 0 0-.634.399c-.174.174-.31.379-.408.616-.093.238-.139.501-.139.79 0 .284.046.545.139.782.098.237.234.446.408.625.18.174.388.307.625.4.243.092.51.138.799.138.278 0 .547-.043.807-.13.267-.093.524-.246.773-.46l.799 1.016c-.33.249-.715.44-1.155.573-.434.133-.868.2-1.302.2Zm1.172-.956v-2.283H70.6v2.466l-1.285-.183ZM74.367 67.845v-6.078h2.63c.544 0 1.013.09 1.407.27.394.173.698.425.912.755.214.33.32.724.32 1.18 0 .452-.106.843-.32 1.173-.215.33-.518.585-.912.764-.394.174-.862.26-1.407.26h-1.849l.625-.633v2.31h-1.406Zm1.406-2.153-.625-.668h1.771c.434 0 .758-.093.973-.278.214-.185.321-.443.321-.773 0-.336-.107-.596-.321-.782-.215-.185-.539-.277-.973-.277h-1.771l.625-.669v3.447ZM80.641 67.845v-6.078h2.631c.544 0 1.013.09 1.407.27.393.173.697.425.911.755.214.33.322.724.322 1.18 0 .452-.108.843-.322 1.173a2.054 2.054 0 0 1-.911.747c-.394.174-.863.26-1.407.26h-1.85l.626-.616v2.31H80.64Zm3.864 0-1.52-2.205h1.503l1.536 2.205h-1.52Zm-2.457-2.153-.625-.66h1.77c.435 0 .76-.092.973-.278.215-.19.322-.451.322-.781 0-.336-.108-.596-.322-.782-.214-.185-.538-.277-.972-.277h-1.771l.625-.669v3.447ZM89.978 67.95c-.48 0-.926-.079-1.337-.235a3.212 3.212 0 0 1-1.06-.66 3.1 3.1 0 0 1-.694-.998 3.168 3.168 0 0 1-.243-1.25c0-.452.08-.869.243-1.25.168-.383.402-.716.703-1a3.21 3.21 0 0 1 1.06-.66 3.636 3.636 0 0 1 1.32-.234c.48 0 .92.079 1.32.235.404.156.754.376 1.05.66a3.033 3.033 0 0 1 .955 2.248c0 .452-.084.872-.252 1.26a3.035 3.035 0 0 1-.703.998 3.188 3.188 0 0 1-1.05.651 3.57 3.57 0 0 1-1.312.235Zm-.009-1.199c.272 0 .521-.046.747-.139a1.773 1.773 0 0 0 1.007-1.016c.099-.237.148-.5.148-.79 0-.289-.05-.552-.148-.79a1.771 1.771 0 0 0-.4-.616 1.7 1.7 0 0 0-.598-.4 2.016 2.016 0 0 0-.756-.139c-.272 0-.523.047-.755.14a1.81 1.81 0 0 0-.6.399c-.173.174-.309.379-.407.616-.093.238-.14.501-.14.79 0 .284.047.547.14.79.098.238.231.443.4.617.173.174.375.307.607.4.231.092.483.138.755.138ZM97.26 67.95c-.468 0-.905-.076-1.31-.226a3.1 3.1 0 0 1-1.737-1.658 3.193 3.193 0 0 1-.243-1.26c0-.457.081-.877.243-1.258.168-.383.4-.715.695-.999.3-.284.65-.5 1.05-.651.4-.157.837-.235 1.311-.235.527 0 1.002.093 1.424.278.429.18.788.446 1.077.799l-.903.834a2.06 2.06 0 0 0-.695-.53 1.91 1.91 0 0 0-.833-.182c-.284 0-.544.046-.782.139a1.77 1.77 0 0 0-.616.399c-.174.174-.31.379-.408.616-.093.238-.14.501-.14.79 0 .29.047.553.14.79.098.238.234.443.408.617.174.174.379.307.616.4.238.092.498.138.782.138.3 0 .579-.058.833-.173a2.12 2.12 0 0 0 .695-.547l.903.833c-.29.353-.648.623-1.077.808-.422.185-.9.278-1.432.278ZM102.014 64.216h2.926v1.094h-2.926v-1.094Zm.104 2.5h3.308v1.13h-4.706v-6.079h4.593v1.13h-3.195v3.82ZM108.542 67.95c-.486 0-.952-.064-1.398-.191-.446-.134-.804-.304-1.077-.513l.478-1.059a3.518 3.518 0 0 0 2.006.634c.278 0 .5-.026.668-.078a.813.813 0 0 0 .382-.235.518.518 0 0 0 .122-.338.447.447 0 0 0-.191-.382 1.458 1.458 0 0 0-.504-.235 7.598 7.598 0 0 0-.694-.174 9.871 9.871 0 0 1-.756-.208 3.236 3.236 0 0 1-.686-.312 1.58 1.58 0 0 1-.512-.504c-.127-.208-.191-.475-.191-.799 0-.347.093-.663.278-.946.191-.29.475-.518.851-.686.382-.174.859-.26 1.432-.26.382 0 .759.046 1.129.138.371.087.698.22.981.4l-.434 1.068a3.542 3.542 0 0 0-.851-.356 3.02 3.02 0 0 0-.833-.122c-.272 0-.495.032-.669.096-.173.063-.298.147-.373.251a.557.557 0 0 0-.113.348c0 .156.064.283.191.382.127.092.295.168.504.225.208.058.437.116.685.174.255.058.507.125.756.2.255.075.486.176.694.304.209.127.377.295.504.503.133.209.2.472.2.79 0 .342-.096.654-.287.938-.191.284-.477.513-.859.686-.377.174-.854.26-1.433.26ZM114.079 67.95c-.486 0-.952-.064-1.398-.191-.446-.134-.805-.304-1.077-.513l.478-1.059a3.518 3.518 0 0 0 2.006.634c.277 0 .5-.026.668-.078a.813.813 0 0 0 .382-.235.518.518 0 0 0 .122-.338.447.447 0 0 0-.191-.382 1.458 1.458 0 0 0-.504-.235 7.598 7.598 0 0 0-.694-.174 9.871 9.871 0 0 1-.756-.208 3.236 3.236 0 0 1-.686-.312 1.58 1.58 0 0 1-.512-.504c-.127-.208-.191-.475-.191-.799 0-.347.093-.663.278-.946.191-.29.474-.518.851-.686.382-.174.859-.26 1.432-.26.382 0 .759.046 1.129.138.371.087.698.22.981.4l-.434 1.068a3.559 3.559 0 0 0-.851-.356 3.02 3.02 0 0 0-.833-.122c-.272 0-.495.032-.669.096-.174.063-.298.147-.373.251a.551.551 0 0 0-.113.348c0 .156.064.283.191.382.127.092.295.168.503.225.209.058.437.116.686.174.255.058.507.125.756.2.254.075.486.176.694.304.209.127.377.295.504.503.133.209.2.472.2.79 0 .342-.096.654-.287.938-.191.284-.477.513-.859.686-.377.174-.854.26-1.433.26Z"
            fill="#9042AE"
          />
          <path
            d="M122.112 137.805H88.461l-3.092-10.066h27.468l9.275 10.066ZM140.304 127.739h-27.467l-6.396-6.941h23.203l10.66 6.941ZM93.349 153.719H49.92l4.888-15.914h33.652l4.888 15.914ZM54.81 137.805H21.157l9.275-10.066h27.468l-3.092 10.066ZM30.433 127.739H2.966l10.66-6.941h23.203l-6.396 6.941Z"
            fill="#000"
          />
          <path
            d="m41.122 124.849-.035-.002a5.373 5.373 0 0 1-1.635-.429 1.209 1.209 0 0 1-.718-1.103v-.785c0-.344.142-.673.377-.915a2.761 2.761 0 0 1-.18-.25c-.769-1.193-.265-2.534.109-3.077.244-.354.593-.795.932-1.221.21-.264.411-.517.564-.723.295-.396.475-1.081.494-1.254v-.163c.003-.491.184-.798.433-1.011a1.245 1.245 0 0 1-.356-.414 32.383 32.383 0 0 1-.73-1.432l-.029-.062c-.23-.502-.378-.956-.005-1.839l.041-.099c.449-1.066 1.498-3.563 5.215-7.465l.137-.147h-.052c-.699.045-1.398.123-2.19.542-.183.158-.303.382-.44.639-.145.268-.308.571-.572.815-.446.412-1.254.499-1.854.499-1.182 0-1.873-.342-2.053-1.018a1.318 1.318 0 0 1-.045-.306c-.31 0-.601-.074-.864-.22-.304-.163-.83-.446-.975-3.255-.07-.486.061-1.212.66-1.797l.083-.08c.566-.55 2.29-2.226 3.254-3.886.162-.279.37-.547.617-.797.38-.385.75-.678 1.034-.888-.124-.143-.25-.284-.372-.422-.773-.871-1.331-1.5-1.24-2.252.042-.354.232-.663.534-.871.183-.126.523-.361 1.156-.361.582 0 1.595.169 4.283 1.47.369.041.72.094 1.07.161.828.162 1.616.404 2.349.72l-.013-.19 1.566 1.02c.534.348 1.038.75 1.499 1.196l.174.167.07.231c.018.058.035.116.051.175l.108-.522 1.234 1.987c.457.735.85 1.556 1.167 2.441l.08.221-.035.232a13.297 13.297 0 0 1-.347 1.633l.776-.97.324 2.098c.027.173.053.348.075.528.114.882.154 1.92.117 3l-.008.25-.133.213a13.664 13.664 0 0 1-1.175 1.602l1.306-.733-.312 1.912c-.155.949-.36 1.875-.61 2.76l.087-.024-.634 1.698c-.177.473-.37.932-.571 1.365a1.245 1.245 0 0 1-.408.488c.24.211.413.515.416.992v.169c.02.173.2.859.494 1.254.154.206.355.459.564.723.338.426.688.867.932 1.222.374.542.878 1.883.11 3.076a2.91 2.91 0 0 1-.18.25c.233.242.375.571.375.915v.785c0 .476-.282.909-.718 1.103a5.373 5.373 0 0 1-1.635.429l-.035.002H41.122Z"
            fill="#fff"
          />
          <path
            d="m56.033 122.173-.793-.285-.25-.091v-.106s.77-.088 1.248-.831c.484-.752.163-1.67-.093-2.041-.377-.548-1.08-1.386-1.476-1.916-.448-.602-.68-1.548-.68-1.793v-.182c-.001-.241-.023-.315-.494-.508-.097-.04-.5-.187-.539-.202l-.009-.003a.523.523 0 0 1-.257-.464c0-.29.208-.523.467-.523h.626c.122 0 .233-.07.285-.18.197-.423.378-.856.543-1.297-.825.221-1.73.375-2.72.443a17.605 17.605 0 0 0 3.133-1.667c.304-1.004.534-2.029.698-3.033-2.218 1.243-4.78 1.666-4.78 1.666 2.62-1.528 4.187-3.345 5.09-4.792a17.973 17.973 0 0 0-.11-2.851 18.661 18.661 0 0 0-.072-.503c-1.848 2.307-3.959 3.394-3.959 3.394 2.128-2.073 2.932-4.586 3.206-6.435-.309-.86-.675-1.61-1.082-2.265-.495 2.395-1.556 3.71-1.556 3.71.688-2.195.508-4.107.063-5.57a9.046 9.046 0 0 0-1.36-1.084c.073 1.09-.023 2.403-.389 3.463.008-1.803-.442-3.19-.957-4.189-.797-.35-1.563-.56-2.22-.688a13.41 13.41 0 0 0-1.158-.167c-3.787-1.85-4.304-1.489-4.649-1.252-.541.374.6 1.351 1.575 2.547.229.28.23.473 0 .647-.194.148-.778.502-1.396 1.127a3.038 3.038 0 0 0-.474.611c-1.08 1.862-3.015 3.7-3.492 4.165-.497.485-.382 1.027-.382 1.027s.115 2.335.497 2.54c.708.393 1.596-.479 1.798-.255.163.18-.554.928-.44 1.357.115.429 2.009.411 2.372.074.364-.336.497-1.073 1.129-1.55.998-.55 1.873-.642 2.653-.694.146-.009.926.008 1.133.215.387.385.171.816-.489 1.508-3.716 3.902-4.644 6.271-5.072 7.283-.257.609-.154.76.024 1.152.165.363.534 1.061.703 1.379.055.102.16.165.276.165h.589c.257 0 .466.233.466.523a.524.524 0 0 1-.264.468c-.038.014-.442.161-.539.202-.471.192-.493.266-.495.507v.182c0 .245-.23 1.192-.679 1.793-.396.531-1.1 1.369-1.476 1.916-.255.371-.578 1.29-.093 2.042.478.742 1.248.83 1.248.83v.106l-.25.091-.793.285a.41.41 0 0 0-.253.358v.785c0 .108.065.205.164.249a4.467 4.467 0 0 0 1.326.351h13.639s.643-.048 1.326-.351a.275.275 0 0 0 .164-.249v-.785a.41.41 0 0 0-.252-.358l.001-.001Z"
            fill="#000"
          />
          <path
            d="M46.124 91.637c-.26-.14-.905-.489-1.12-.609.11.103.73.671.995.935.03.03.07.045.113.045.65-.011 1.295-.032 1.945-.043a20.181 20.181 0 0 0-1.701-.256.621.621 0 0 1-.232-.071v-.001Z"
            fill="url(#e)"
          />
          <path
            d="M48.59 95.804c.174.609.407 1.717.256 2.711-.127.841-.584 1.571-1.03 2.172 1.212-.9 1.352-1.942 1.382-2.224.124-1.161-.237-1.91-.608-2.66Z"
            fill="url(#f)"
          />
          <path
            d="M50.35 95.62c-.082-1.357-.377-2.193-.607-2.686-.217-.188-.537-.343-.715-.367.496.635.969 1.566 1.322 3.053Z"
            fill="url(#g)"
          />
          <path
            d="M51.885 99.034c.079-.437.496-2.69.066-4.64.034.03.287.331.423.55.255 1.397-.082 3.14-.489 4.09Z"
            fill="url(#h)"
          />
          <path
            d="M50.941 108.391c1.744-1.048 3.635-2.766 4.454-4.123.045-.691.009-1.031-.019-1.924-.127.705-.373 1.898-.373 1.898s-1.278 2.152-4.062 4.149Z"
            fill="url(#i)"
          />
          <path
            d="M51.73 103.629c1.623-1.719 2.413-3.3 2.847-5.162a7.4 7.4 0 0 0-.496-1.331c.085.378.134.835.14 1.406-.231 1.37-1.068 3.308-2.491 5.087Z"
            fill="url(#j)"
          />
          <path
            d="M51.905 111.577a25.408 25.408 0 0 0 2.661-1.455c.204-.614.36-1.177.522-1.707-.135.309-.426.856-.604 1.185-.1.183-.235.342-.4.47-.358.276-1.094.82-2.179 1.508v-.001Z"
            fill="url(#k)"
          />
          <path
            d="M53.966 112.251c-.092.199-.14.324-.267.53a.229.229 0 0 1-.19.106c-.262.01-.45-.004-.686-.004.22-.079.484-.1.68-.208.196-.107.32-.244.463-.424Z"
            fill="url(#l)"
          />
          <path
            d="M50.672 114.605c.574-.009 1.876-.007 1.978-.007.265 0 .028.298-.804.298-.461 0-.874-.132-1.173-.291Z"
            fill="url(#m)"
          />
          <path
            d="M53.07 116.478c.038.03.295.627.381.805.307.636 1.106 1.723 1.166 1.829.077.138.031.322-.056.453-.106.158-.302.225-.484.279-.218.065-.974.106-1.457-.283-.546-.441-.58-1.105-.618-1.351-.07-.44-.028-1.273.121-1.617.131-.303.656-.34.947-.114v-.001Z"
            fill="url(#n)"
          />
          <path
            d="M52.274 122.333c.979 0 1.914 0 2.871-.004.083 0 .148.1-.114.204-.344.137-.821.245-1.157.244-.57-.003-1.04-.149-1.6-.444Z"
            fill="url(#o)"
          />
          <path
            d="M51.208 114.122c-.013.014-.009.049.006.049.42-.006.604-.004.8-.005.03 0 .054-.045.054-.099 0-.116 0-.206-.002-.323 0-.053-.023-.096-.052-.097-.062-.002-.19-.008-.253.014-.032.011-.214.125-.553.461Z"
            fill="url(#p)"
          />
          <path
            d="M38.46 102.108a6.876 6.876 0 0 0-.153-.963 6.87 6.87 0 0 1-.151-.954 1.787 1.787 0 0 1 .053-.586.925.925 0 0 1 .366-.504c.093-.06.18-.112.263-.164.192-.118.358-.22.524-.352a9.143 9.143 0 0 0 2.302-2.66c.09-.16.174-.325.255-.485.136-.271.282-.547.454-.8.407-.599 1.74-1.395 2.312-1.552-.457.483-.448.875-.442 1.096.182.033.597.145.843.462.15.191.211.414.184.664-.282-.305-.962-.58-1.46-.58a.911.911 0 0 0-.28.038c-.49.159-.682.437-.947.824-.184.269-.35.58-.512.882-.084.158-.167.313-.252.46-.452.787-1.135 1.512-2.15 2.282a.86.86 0 0 1-.558.185l-.1-.002a1.938 1.938 0 0 0-.08-.002.384.384 0 0 0-.15.022c-.237.1-.31.45-.286.665.03.273.16.436.35.436a.362.362 0 0 0 .143-.032c.213-.092.406-.313.591-.675.143.402.023.795-.329 1.062a.904.904 0 0 1-.367.154l-.102.025v.025c.003.556-.243.987-.321 1.035v-.006Zm6.847-6.296a1.865 1.865 0 0 1-.528.691c-.43.329-.986.36-1.494.258.442.503 1.402.503 1.83-.017a.992.992 0 0 0 .225-.642 1.317 1.317 0 0 0-.033-.29Z"
            fill="url(#q)"
          />
          <path
            d="M43.898 92.352c.075.084.147.144.258.163.112.02.26.008.385-.075.135-.09-.13-.334-.258-.433-1.046-.806-1.832-1.378-1.946-1.346.392.424.686.71 1.561 1.69v.001Z"
            fill="url(#r)"
          />
          <path
            d="M40.037 103.329c.272-.034.479-.224.593-.475.113-.251.16-.645.16-1.023-.08.133-.125.238-.172.332l-.2.403c-.066.134-.336.677-.38.763Z"
            fill="url(#s)"
          />
          <path
            d="M43.471 110.843c-.035.353.163.887.634 1.611a.157.157 0 0 1-.129.243 49 49 0 0 1-.742-.005.551.551 0 0 1-.458-.26c-.333-.536-.404-.665-.63-1.15a.793.793 0 0 1-.027-.59c.616-1.797 1.5-3.006 2.528-4.36 1.187-1.563 2.663-2.655 3.128-3.917.137.632-.064 1.409-.762 2.293-1.379 1.745-3.268 4.308-3.542 6.134v.001Z"
            fill="url(#t)"
          />
          <path
            d="M47.218 114.599c-.604.186-1.514.375-2.324.375-.594 0-1.16-.07-1.72-.217-.088-.023-.188-.061-.18-.106.011-.052.202-.052.285-.052H47.22Z"
            fill="url(#u)"
          />
          <path
            d="M45.277 118.709c-.151.294-.308.595-.556.819-.302.272-.716.405-1.13.447-.508.051-.834.052-1.314-.125-.184-.067-.367-.152-.505-.287a.64.64 0 0 1-.184-.516c.053-.543.935-1.325 1.373-2.257.125-.266.267-.546.525-.698.194-.115.512-.143.74-.141.486.005.834.054 1.155.313.329.267.303 1.655-.104 2.446v-.001Z"
            fill="url(#v)"
          />
          <path
            d="M40.967 122.333h4.516c-.53.207-.86.303-1.613.42-.371.057-.802.084-1.25.08a5.272 5.272 0 0 1-1.34-.171 2.878 2.878 0 0 1-.416-.158c-.138-.081-.118-.171.103-.171Z"
            fill="url(#w)"
          />
          <path
            d="M45.772 114.122c.028.014.019.049-.012.049-.866-.006-1.246-.004-1.653-.005-.06 0-.11-.045-.11-.099 0-.115.002-.206.003-.323.001-.053.048-.096.108-.097.127-.002.275.023.405.034.069.005.56.105 1.26.441Z"
            fill="url(#x)"
          />
          <path
            d="M43.47 96.389a.192.192 0 0 1-.088-.018c-.092-.037-.14-.153-.14-.243 0-.193.124-.398.184-.467a.682.682 0 0 1 .499-.228c.069 0 .137.011.204.035a.836.836 0 0 0-.329.259.852.852 0 0 0-.142.386l-.009.075c-.01.103-.02.193-.136.2a.619.619 0 0 1-.044.002v-.001Z"
            fill="url(#y)"
          />
          <path
            d="m87.715 126.324-.035-.003a5.258 5.258 0 0 1-1.534-.389c-.706-.3-.782-.882-.782-1.118v-.772c0-.339.14-.663.371-.901a2.71 2.71 0 0 1-.178-.247c-.672-1.043-.385-2.18.108-2.896.255-.371.597-.677.898-.947.228-.204.443-.397.575-.573.042-.056.087-.123.135-.198v-.299c0-.683.225-1.059.671-1.347a1.717 1.717 0 0 1-.298-.969c0-.737.463-1.368 1.112-1.619.217-1.838.506-5.346.553-11.245a1.528 1.528 0 0 1-.453-1.75 1.5 1.5 0 0 1-.683-.997 1.692 1.692 0 0 1-1.073-1.573v-5.143h14.718v5.143c0 .714-.445 1.326-1.073 1.573-.078.421-.333.78-.683.998a1.52 1.52 0 0 1-.453 1.749c.047 5.9.336 9.408.553 11.246.65.25 1.112.882 1.112 1.619 0 .358-.11.691-.298.968.446.288.671.664.67 1.347v.299c.048.074.093.141.136.196.132.178.347.371.575.575.301.27.642.575.898.946.493.717.78 1.853.108 2.897-.057.087-.117.17-.178.246.23.238.37.562.37.901v.773c0 .235-.076.818-.782 1.117a5.285 5.285 0 0 1-1.535.39l-.034.002H87.715v.001Z"
            fill="#fff"
          />
          <path
            d="M101.363 123.267v-.052s.759-.087 1.229-.818c.477-.74.16-1.512-.092-1.877-.371-.539-1.063-.97-1.452-1.493a4.531 4.531 0 0 1-.253-.379.46.46 0 0 1-.066-.237v-.4c0-.427.019-.535-.735-.841-.141-.058-.279-.113-.408-.163h.005v-.53a.813.813 0 0 0-.049-1.626h-.201c-.213-1.539-.615-5.377-.652-12.624a.609.609 0 0 0-.004-1.213 81.993 81.993 0 0 0-.007-.656h.602a.576.576 0 0 0 .574-.578v-.527h.276a.77.77 0 0 0 .771-.77v-4.224h-2.498v2.001h-1.445v-2h-4.995v2H90.52v-2H88.02v4.223c0 .425.346.77.77.77h.277v.527c0 .319.257.578.574.578h.602c-.003.221-.006.44-.007.656a.607.607 0 0 0-.004 1.213c-.037 7.246-.439 11.085-.653 12.624h-.2a.814.814 0 0 0-.049 1.626v.53h.004c-.129.05-.267.105-.408.163-.754.307-.735.414-.735.841v.4a.457.457 0 0 1-.066.237 4.606 4.606 0 0 1-.252.379c-.39.523-1.082.954-1.453 1.493-.251.365-.568 1.137-.092 1.877.47.731 1.23.818 1.23.818v.104l-.248.089-.78.281a.403.403 0 0 0-.249.352v.773c0 .144.09.215.223.272a4.425 4.425 0 0 0 1.244.319h13.423s.597-.045 1.245-.319c.133-.057.222-.128.222-.272v-.773a.402.402 0 0 0-.249-.352l-.78-.281-.247-.089v-.052Z"
            fill="#000"
          />
          <path
            d="M89.36 117.469c1.2-.008 2.273 0 3.473-.008-.476.227-.846.452-1.984.452-.42 0-1.083-.091-1.5-.262-.155-.063-.125-.185.01-.182Z"
            fill="url(#z)"
          />
          <path
            d="M87.557 123.847h4.406c-.31.164-1.144.345-1.573.413-.716.112-1.657.151-2.528-.089-.087-.024-.356-.091-.405-.156-.054-.072-.023-.168.1-.168Z"
            fill="url(#A)"
          />
          <path
            d="M99.59 117.47c-.793-.009-1.501 0-2.295-.009.315.241.698.42 1.305.42.278 0 .744-.084 1.02-.265.102-.067.06-.149-.03-.147v.001Z"
            fill="url(#B)"
          />
          <path
            d="M92.775 111.823c0 .258-.016.517-.034.775-.028.408-.007.837-.163 1.233a1.277 1.277 0 0 1-.727.734c-.293.112-.71.071-.985-.087a.283.283 0 0 1-.153-.27c.34-3.687.435-7.533.47-10.583 0-.098.11-.168.229-.15.447.07.945.437 1.125.744.213.362.238.775.238 1.175v6.429Z"
            fill="url(#C)"
          />
          <path
            d="M97.877 104.458c.035 2.687.223 6.255.471 9.693a.227.227 0 0 1-.064.178c-.165.164-.436.165-.645.027-.25-.165-.337-.707-.344-1.008-.09-3.967-.11-6.131-.11-8.57 0-.299.689-.518.691-.32Z"
            fill="url(#D)"
          />
          <path
            d="m90.776 98.66-1.333-.013a.77.77 0 0 1-.767-.77V94.71c0-.086.07-.155.155-.155h.65c.085 0 .153.07.154.154l.002 1.915c0 .17.138.307.308.308l.834.003c.17 0 .307.138.307.308v1.11c0 .17-.139.309-.31.307Z"
            fill="url(#E)"
          />
          <path
            d="m98.71 98.66.77-.013a.77.77 0 0 0 .766-.77V94.71a.154.154 0 0 0-.155-.155h-.503a.154.154 0 0 0-.154.154l-.002 1.915c0 .17-.138.307-.308.308l-.416.003a.308.308 0 0 0-.308.308v1.11c0 .17.14.309.31.307Z"
            fill="url(#F)"
          />
          <path
            d="M92.315 100.001h-2.459a.062.062 0 0 1-.06-.063v-.311c0-.036.029-.064.063-.063l2.46.1c.032.001.057.029.057.063v.212a.063.063 0 0 1-.06.063v-.001Z"
            fill="url(#G)"
          />
          <path
            d="M97.708 100.001h1.384c.02 0 .035-.028.035-.063v-.311c0-.036-.016-.064-.036-.063l-1.274.1c-.019.002-.143.036-.143.118v.156c0 .035.016.063.035.063Z"
            fill="url(#H)"
          />
          <path
            d="M90.341 101.3c.986-.01 1.867.009 2.853-.001-.246.16-1.046.322-1.582.322-1.007 0-1.418-.175-1.418-.266 0-.058.1-.055.147-.055Z"
            fill="url(#I)"
          />
          <path
            d="M98.632 101.297h-1.73c.25.199.61.274.943.279.383.007.723-.096.833-.186.038-.031.042-.095-.046-.093Z"
            fill="url(#J)"
          />
          <path
            d="M89.735 115.226c1.161-.013 2.197.012 3.358-.001-.605.335-1.23.404-1.861.404-1.186 0-1.67-.22-1.67-.334 0-.073.117-.069.173-.069Z"
            fill="url(#K)"
          />
          <path
            d="M99.213 115.226c-.783-.013-1.482.012-2.265-.001.409.335.83.404 1.256.404.8 0 1.126-.22 1.126-.334 0-.073-.08-.069-.116-.069Z"
            fill="url(#L)"
          />
          <path
            d="M91.386 118.99a.612.612 0 0 1 .08.337c-.047.813-.354 1.723-1.337 2.121-.535.216-1.368.083-1.582.014-.259-.083-.457-.214-.481-.559-.016-.233.16-.469.292-.629.132-.16.794-.823 1.006-1.13.15-.217.443-.386.706-.41.63-.058 1.15.012 1.316.256Z"
            fill="url(#M)"
          />
          <path
            d="M98.9 119.631c.035.245.27 1.275.45 1.504.292.373.608.355.95.35.246-.004.665-.085.808-.286.118-.166.077-.428-.048-.577-.431-.512-.654-.791-1.076-1.24-.155-.166-.39-.543-.644-.497-.398.072-.48.476-.44.745v.001Z"
            fill="url(#N)"
          />
          <path
            d="M98.647 123.847c.995 0 1.947 0 2.92-.003.084 0 .151.098-.117.201-.349.134-.835.241-1.176.239-.58-.003-1.058-.146-1.627-.437Z"
            fill="url(#O)"
          />
          <path
            d="m17.679 118.203-.03-.002c-.069-.006-.684-.058-1.364-.348-.627-.265-.695-.785-.695-.996v-.688c0-.309.13-.604.344-.818-.612-.852-.284-1.877.087-2.358.204-.264.522-.531.859-.812.208-.174.467-.392.563-.506.23-.274.447-.637.525-.8v-.122c0-.727.359-1.017.94-1.255a9.25 9.25 0 0 1 .29-.111c.708-1.672.862-3.241.862-4.288v-.215h-.725c-.346 0-.687-.19-.87-.484l-.343-.547a1.047 1.047 0 0 1-.049-1.005l.01-.02c.11-.222.314-.423.532-.53l1.03-.499a4.473 4.473 0 0 1-1.53-3.381c0-2.475 2.007-4.487 4.473-4.487 2.467 0 4.474 2.012 4.474 4.486a4.47 4.47 0 0 1-1.53 3.381l1.027.498c.22.107.424.308.533.526l.012.025c.156.314.137.708-.05 1.005l-.342.547a1.046 1.046 0 0 1-.87.483h-.725v.215c0 1.047.154 2.617.862 4.289.109.04.214.08.29.111.58.237.94.527.94 1.237v.139c.077.164.296.526.525.801.095.114.355.332.563.506.337.282.655.548.859.812.37.482.7 1.506.087 2.358.213.213.344.509.344.819v.688c0 .211-.068.73-.696.996a4.668 4.668 0 0 1-1.363.347l-.03.002h-9.82v.001Z"
            fill="#fff"
          />
          <path
            d="m28.551 115.855-.693-.25-.22-.08v-.093s.582-.059.943-.561c.366-.507.123-1.127-.07-1.378-.285-.369-1.104-.935-1.402-1.293-.339-.406-.715-1.045-.715-1.21v-.238c0-.252.011-.315-.432-.496-.147-.06-.429-.163-.586-.217a11.905 11.905 0 0 1-1.074-4.941v-1.034h1.541a.236.236 0 0 0 .18-.098l.342-.548a.233.233 0 0 0 .01-.204l-.012-.025a.405.405 0 0 0-.158-.155l-2.163-1.049a.535.535 0 0 0-.093-.032v-.131a3.667 3.667 0 0 0 2.297-3.404 3.663 3.663 0 0 0-3.657-3.668 3.662 3.662 0 0 0-3.658 3.667c0 1.543.951 2.862 2.297 3.404v.131a.537.537 0 0 0-.092.032l-2.163 1.049a.405.405 0 0 0-.158.155l-.012.025a.234.234 0 0 0 .01.204l.343.547a.234.234 0 0 0 .178.099h1.542v1.034c0 1.541-.31 3.287-1.074 4.941-.157.054-.44.157-.586.217-.443.181-.432.244-.432.496v.238c0 .165-.376.804-.715 1.21-.299.358-1.117.924-1.402 1.293-.193.251-.437.871-.07 1.378.36.501.943.561.943.561v.093l-.22.08-.693.25a.357.357 0 0 0-.22.313v.689c0 .129.078.192.197.242.576.245 1.106.285 1.106.285h9.76s.529-.04 1.105-.285c.119-.05.198-.113.198-.242v-.689c0-.129-.1-.27-.221-.313v.001Z"
            fill="#000"
          />
          <path
            d="M17.52 115.969h3.215c-.339.125-.63.289-1.148.368-.265.041-.57.075-.89.071a3.107 3.107 0 0 1-.953-.15 1.807 1.807 0 0 1-.296-.139c-.098-.071-.084-.15.073-.15Z"
            fill="url(#P)"
          />
          <path
            d="M21.67 95.514c-1.597.535-2.035 2.142-1.944 3.026.018.172.112.657.537.749.637.138.89-.409.881-.491-.26-2.215 1.054-2.964 1.06-3.15.004-.167-.295-.214-.533-.134Z"
            fill="url(#Q)"
          />
          <path
            d="M21.436 103.162c.087-.031.113-.12.118-.214.02-.358-.27-.456-.578-.387-.257.057-.888.375-1.185.523-.04.019-.038.077.004.092.338.123 1.242.127 1.641-.014Z"
            fill="url(#R)"
          />
          <path
            d="M20.736 109.469c-.05.155-.08.33.078.402.123.056.29.047.408-.013.288-.148.403-.424.443-.747.117-.957.183-1.928.171-2.889-.005-.435-.059-.96-.426-1.202 0 1.825-.247 3.181-.674 4.448v.001Z"
            fill="url(#S)"
          />
          <path
            d="M20.73 111.661c-.235-.147-.556-.184-.885-.116-.274.057-.508.172-.617.367-.152.274-.933 1.18-1 1.247-.409.411-.346.907.012 1.006.342.094.749.105 1.104.105.493.001.956-.392 1.125-.752.19-.405.27-.517.413-.939.098-.296.162-.72-.153-.918Z"
            fill="url(#T)"
          />
          <path
            d="M19.668 110.571c.248.115.644.176.894.176.552 0 .966-.123 1.183-.304-.716.006-1.355 0-2.07.006-.082-.002-.099.08-.007.122Z"
            fill="url(#U)"
          />
          <path
            d="M25.474 115.995c.751 0 1.488 0 2.232-.003.064 0 .052.121-.152.212-.267.12-.575.182-.836.181-.443-.003-.809-.131-1.244-.39Z"
            fill="url(#V)"
          />
          <path
            d="M23.907 105.446c-.108.06-.175.123-.194.366-.08 1.024.05 2.296.236 2.923.189.634.27.952.752.952-.595-1.392-.794-3.028-.794-4.241Z"
            fill="url(#W)"
          />
          <path
            d="M24.955 103.189c.109-.01.21-.034.293-.068.027-.01.06-.021.074-.043.018-.027-.018-.058-.12-.112a7.988 7.988 0 0 0-.758-.317c-.057-.022-.226-.084-.245.041a.655.655 0 0 0 .067.328.21.21 0 0 0 .103.099c.144.064.375.09.586.071v.001Z"
            fill="url(#X)"
          />
          <path
            d="M25.65 98.316c-.063-.344-.157-.489-.224-.504-.037-.008-.066.02-.08.073-.176.655-.35.986-.522 1.199-.003.002-.006.007-.008.01-.044.055-.09.1-.133.14a.5.5 0 0 0-.052.393c.023.09.08.23.164.32.12.131.256.176.321.138.506-.628.596-1.435.535-1.769Z"
            fill="url(#Y)"
          />
          <path
            d="M25.302 112.509c.031.207.18 1.102.34 1.295.26.316.534.374.838.37.22-.004.605-.052.736-.281a.495.495 0 0 0-.054-.521c-.383-.432-.667-.749-.951-1.163-.112-.162-.335-.296-.561-.257-.353.06-.383.33-.348.558v-.001Z"
            fill="url(#Z)"
          />
          <path
            d="M25.479 110.449c-.485-.006-.919 0-1.404-.006.192.15.427.261.798.261.17 0 .455-.052.623-.164.063-.042.037-.093-.017-.091Z"
            fill="url(#aa)"
          />
          <path
            d="m112.411 118.203-.031-.003a4.645 4.645 0 0 1-1.363-.347c-.627-.266-.695-.785-.695-.996v-.688c0-.309.131-.604.345-.818-.613-.852-.285-1.877.086-2.358.204-.264.522-.531.859-.812.208-.175.468-.392.563-.506.229-.274.448-.637.525-.8v-.122c-.001-.727.359-1.017.94-1.255.076-.031.181-.071.29-.111.708-1.672.862-3.241.862-4.289v-.215h-.725c-.346 0-.687-.189-.871-.483l-.342-.547a1.05 1.05 0 0 1-.049-1.005l.011-.02a1.22 1.22 0 0 1 .531-.53l1.03-.499a4.472 4.472 0 0 1-1.529-3.381c0-2.474 2.006-4.486 4.473-4.486s4.474 2.012 4.474 4.486a4.472 4.472 0 0 1-1.529 3.381l1.026.498c.221.107.424.308.533.526l.012.025a1.05 1.05 0 0 1-.049 1.005l-.342.547a1.047 1.047 0 0 1-.871.483h-.725v.215c0 1.047.154 2.617.862 4.289.109.04.215.08.29.111.581.237.941.527.94 1.237v.139c.078.164.296.526.525.801.096.114.355.331.563.506.337.282.655.548.859.812.371.482.7 1.506.087 2.358.213.213.344.509.344.818v.689c0 .211-.068.73-.696.996a4.674 4.674 0 0 1-1.363.347l-.03.002h-9.821.001Z"
            fill="#fff"
          />
          <path
            d="m123.283 115.855-.693-.25-.219-.08v-.093h-.001s.582-.059.944-.561c.365-.507.122-1.127-.071-1.378-.285-.369-1.103-.935-1.402-1.293-.339-.406-.715-1.045-.715-1.21v-.238c0-.252.011-.315-.432-.496-.147-.06-.429-.163-.586-.217a11.911 11.911 0 0 1-1.074-4.941v-1.034h1.542a.234.234 0 0 0 .178-.098l.343-.548a.232.232 0 0 0 .01-.204l-.012-.025a.406.406 0 0 0-.158-.155l-2.163-1.049a.528.528 0 0 0-.093-.032v-.131a3.667 3.667 0 0 0 2.297-3.404 3.662 3.662 0 0 0-3.657-3.668 3.663 3.663 0 0 0-3.658 3.668c0 1.543.951 2.862 2.298 3.404v.131a.528.528 0 0 0-.093.032l-2.163 1.049a.406.406 0 0 0-.158.155l-.012.025a.232.232 0 0 0 .01.204l.343.548a.234.234 0 0 0 .178.098h1.542v1.034c0 1.541-.31 3.287-1.074 4.941-.157.054-.439.157-.586.217-.443.181-.432.244-.432.496v.238c0 .165-.376.804-.715 1.21-.299.358-1.117.924-1.402 1.293-.193.251-.436.871-.071 1.378.362.502.944.561.944.561v.093l-.219.08-.694.25a.358.358 0 0 0-.22.313v.689c0 .129.079.192.197.242.576.245 1.106.285 1.106.285h9.759s.53-.04 1.106-.285c.119-.05.198-.113.198-.242v-.689c0-.128-.1-.27-.221-.313h-.001Z"
            fill="#000"
          />
          <path
            d="M112.253 115.969h3.215c-.339.125-.631.289-1.148.368-.265.041-.57.075-.89.071a3.113 3.113 0 0 1-.954-.15 1.813 1.813 0 0 1-.295-.139c-.098-.071-.084-.15.073-.15h-.001Z"
            fill="url(#ab)"
          />
          <path
            d="M116.403 95.514c-1.597.535-2.036 2.142-1.944 3.026.017.172.112.657.536.749.638.138.891-.409.882-.491-.26-2.215 1.053-2.964 1.059-3.15.004-.167-.294-.214-.533-.134Z"
            fill="url(#ac)"
          />
          <path
            d="M116.168 103.162c.088-.031.113-.12.118-.214.02-.358-.27-.456-.578-.387-.257.057-.888.375-1.185.523-.04.019-.038.077.004.092.338.123 1.242.127 1.641-.014Z"
            fill="url(#ad)"
          />
          <path
            d="M115.468 109.469c-.05.155-.08.33.079.402.122.056.29.047.407-.013.289-.148.404-.424.443-.747.118-.957.183-1.928.172-2.889-.006-.435-.059-.96-.427-1.202 0 1.825-.247 3.181-.674 4.448v.001Z"
            fill="url(#ae)"
          />
          <path
            d="M115.461 111.661c-.234-.147-.556-.184-.884-.116-.274.057-.508.172-.617.367-.152.274-.933 1.18-1 1.247-.409.411-.345.907.012 1.006.342.094.749.105 1.104.105.493.001.956-.392 1.125-.752.189-.405.271-.517.413-.939.099-.296.162-.72-.153-.918Z"
            fill="url(#af)"
          />
          <path
            d="M114.4 110.571c.249.115.645.176.895.176.552 0 .966-.123 1.182-.304-.715.006-1.355 0-2.07.006-.081-.002-.098.08-.007.122Z"
            fill="url(#ag)"
          />
          <path
            d="M120.206 115.995c.752 0 1.488 0 2.232-.003.064 0 .052.121-.152.212-.267.12-.575.182-.836.181-.443-.003-.809-.131-1.244-.39Z"
            fill="url(#ah)"
          />
          <path
            d="M118.639 105.446c-.108.06-.175.123-.194.366-.08 1.024.05 2.296.236 2.923.189.634.27.952.753.952-.596-1.392-.795-3.028-.795-4.241Z"
            fill="url(#ai)"
          />
          <path
            d="M119.687 103.189c.109-.01.21-.034.293-.068.027-.01.06-.021.074-.043.018-.027-.018-.058-.12-.112a7.934 7.934 0 0 0-.758-.317c-.057-.022-.226-.084-.245.041a.65.65 0 0 0 .067.328.21.21 0 0 0 .103.099c.144.064.375.09.586.071v.001Z"
            fill="url(#aj)"
          />
          <path
            d="M120.383 98.316c-.063-.344-.158-.489-.225-.504-.037-.008-.066.02-.081.073-.175.655-.349.986-.521 1.199-.003.002-.006.007-.008.01-.044.055-.089.1-.133.14-.052.083-.096.222-.052.393a.8.8 0 0 0 .164.32c.12.131.256.176.322.138.505-.628.595-1.435.534-1.769Z"
            fill="url(#ak)"
          />
          <path
            d="M120.034 112.509c.032.207.181 1.102.34 1.295.26.316.534.374.838.37.22-.004.605-.052.737-.281a.493.493 0 0 0-.055-.521c-.382-.432-.666-.749-.951-1.163-.111-.162-.335-.296-.56-.257-.354.06-.383.33-.349.558v-.001Z"
            fill="url(#al)"
          />
          <path
            d="M120.211 110.449c-.485-.006-.919 0-1.404-.006.192.15.427.261.798.261.17 0 .455-.052.623-.164.063-.042.037-.093-.017-.091Z"
            fill="url(#am)"
          />
          <path
            d="m63.849 134.682-.034-.002a5.156 5.156 0 0 1-1.495-.379c-.687-.293-.761-.859-.761-1.089v-.752c0-.303.115-.594.308-.82a3.021 3.021 0 0 1-.332-.422c-.829-1.268-.283-2.697.12-3.276.272-.388.718-.833 1.149-1.265.329-.329.67-.669.842-.897.119-.157.247-.346.374-.552l.001-.234v-.678c0-.835.203-1.35 1.32-1.846.168-.075.34-.15.502-.218.612-1.731 2.007-6.334 1.956-12.148-.018-2.146-.223-4.37-.568-6.224h-.651a1.665 1.665 0 0 1-.553-3.235c.057-.426.337-.858.764-1.129a1.586 1.586 0 0 1 .204-2.36c-.652-1.456-1.87-4.24-2.432-5.96-.3-.916-.053-1.642.754-2.22.837-.597 2.015-1.097 3.323-1.418.007-.063.019-.125.033-.186l-.51-.26.493-1.22-1.592.456v-6.011l1.592.455-.493-1.22.732-.372c.052-.026.37-.183.885-.326v-.06c0-1.022.832-1.854 1.854-1.854 1.023 0 1.855.832 1.855 1.855l-.001.059c.515.143.833.3.885.327l.732.372-.493 1.22 1.591-.456v6.01l-1.59-.454.492 1.22-.51.259c.015.06.026.123.033.186 1.308.321 2.486.821 3.322 1.419.808.577 1.055 1.303.755 2.22-.559 1.707-1.763 4.464-2.42 5.93a1.586 1.586 0 0 1 .225 2.413c.408.271.674.691.73 1.106a1.664 1.664 0 0 1-.554 3.234h-.65c-.344 1.856-.549 4.08-.568 6.225-.051 5.813 1.345 10.416 1.957 12.148.162.068.334.143.502.219 1.116.496 1.32 1.01 1.319 1.845v.679l.001.233a7.3 7.3 0 0 0 .374.552c.173.229.513.569.842.898.431.431.877.877 1.149 1.265.404.579.95 2.008.12 3.276a3.086 3.086 0 0 1-.33.422c.192.225.307.516.307.819v.753c0 .23-.074.797-.761 1.088a5.134 5.134 0 0 1-1.496.38l-.033.002H63.847l.002-.002Z"
            fill="#fff"
          />
          <path
            d="M79.573 131.654s.871-.098 1.412-.925c.547-.838.183-1.861-.106-2.274-.426-.61-1.523-1.543-1.97-2.135a8.513 8.513 0 0 1-.49-.734.455.455 0 0 1-.063-.223 18.422 18.422 0 0 1-.004-.369v-.643c0-.5.02-.704-.788-1.063a11.747 11.747 0 0 0-.84-.349c-.551-1.468-2.206-6.419-2.149-12.843.019-2.14.227-4.796.73-7.112h1.382a.77.77 0 0 0 .768-.768v-.004a.77.77 0 0 0-.767-.768h-.33v-.639c0-.211-.266-.672-.85-.672h-.48v-1.012h.35a.693.693 0 0 0 0-1.387h-.349s2.061-4.479 2.826-6.816c.184-.562.056-.871-.424-1.214-.997-.713-2.468-1.217-3.905-1.462a.68.68 0 0 0 .22-.497c0-.387-.337-.704-.75-.704h-.13a4.878 4.878 0 0 0 1.102-.356l-.871-2.158 2.212.633v-3.637l-2.212.633.871-2.158s-.675-.343-1.714-.452a.96.96 0 1 0-1.238 0c-1.04.11-1.715.452-1.715.452l.871 2.158-2.211-.633v3.637l2.212-.633-.872 2.158s.418.213 1.102.356h-.13c-.412 0-.75.317-.75.704a.68.68 0 0 0 .22.497c-1.437.245-2.908.75-3.905 1.462-.48.343-.608.652-.424 1.214.765 2.337 2.826 6.816 2.826 6.816h-.292a.693.693 0 0 0 0 1.387h.292v1.012h-.48c-.583 0-.849.461-.849.672v.639h-.33a.77.77 0 0 0-.768.768v.004a.77.77 0 0 0 .767.768h1.384c.503 2.316.711 4.972.73 7.112.056 6.423-1.598 11.374-2.15 12.843-.218.075-.525.208-.84.348-.809.36-.788.563-.788 1.063v.644c0 .131-.001.255-.004.368a.454.454 0 0 1-.063.223 8.49 8.49 0 0 1-.49.734c-.447.592-1.544 1.525-1.97 2.136-.29.413-.653 1.435-.106 2.273.54.828 1.413.926 1.413.926v.101l-.24.087-.76.274a.39.39 0 0 0-.243.342v.753c0 .141.087.21.216.265a4.311 4.311 0 0 0 1.212.311h15.505s.581-.044 1.212-.311c.13-.055.217-.124.217-.265v-.753a.39.39 0 0 0-.242-.342l-.76-.274-.24-.087v-.101Z"
            fill="#000"
          />
          <path
            d="M68.417 82.116a.075.075 0 0 0-.096.072v2.335c0 .054.076.066.092.015l.451-1.484a.47.47 0 0 1 .33-.311l.66-.132c.045-.012.045-.076 0-.086l-1.437-.41Z"
            fill="url(#an)"
          />
          <path
            d="m70.533 81.754.147-1.124a.627.627 0 0 1 .151-.338 1.56 1.56 0 0 1 .444-.342c.014-.007.009-.029-.007-.029a3.83 3.83 0 0 0-1.383.278.076.076 0 0 0-.042.099c.236.582.49 1.19.605 1.466.017.042.079.035.085-.01Z"
            fill="url(#ao)"
          />
          <path
            d="M71.013 86.81c-.404-.007-.853-.163-1.132-.284a.073.073 0 0 1-.036-.098c.217-.466.498-1.29.612-1.637.006-.018.033-.012.03.007-.036.276-.109.85-.162 1.35a.218.218 0 0 0 .088.2c.103.076.29.228.606.44.01.006.006.023-.006.022Z"
            fill="url(#ap)"
          />
          <path
            d="M73.091 80.12c.082.01.187.037.276.075a.078.078 0 0 1 .042.1c-.23.567-.374 1.02-.621 1.631-.007.017-.032.009-.029-.009.124-.66.204-1.184.316-1.785.001-.008.008-.014.016-.013Z"
            fill="url(#aq)"
          />
          <path
            d="M76.952 90.355c-.025.057-.36.233-1.04.277-.388.025-1.062.059-1.563-.079-.089-.024-.113-.063.01-.08.212-.029.734-.043 1.492-.11.74-.066 1.142-.099 1.101-.008Z"
            fill="url(#ar)"
          />
          <path
            d="M63.753 132.27c1.479 0 3.054-.003 4.628-.003a7.302 7.302 0 0 1-1.653.405c-.38.051-.821.081-1.28.077a5.765 5.765 0 0 1-1.374-.164 2.981 2.981 0 0 1-.426-.152c-.14-.078-.12-.163.105-.163Z"
            fill="url(#as)"
          />
          <path
            d="M76.734 132.267c1.023 0 2 0 3-.004.087 0 .155.096-.119.196-.359.131-.858.235-1.209.233-.595-.003-1.086-.142-1.672-.425Z"
            fill="url(#at)"
          />
          <path
            d="M68.239 97.995h2.636a3.32 3.32 0 0 1-1.539.381 2.495 2.495 0 0 1-1.172-.287c-.058-.035-.047-.094.075-.094Z"
            fill="url(#au)"
          />
          <path
            d="M74.965 97.996h-1.391c.24.199.532.31.811.31.344 0 .617-.194.637-.23.02-.038.007-.08-.058-.08Z"
            fill="url(#av)"
          />
          <path
            d="M67.851 100.474h2.844c-.411.224-1.002.308-1.551.314-.628.007-1.197-.104-1.378-.206-.063-.035-.06-.111.085-.108Z"
            fill="url(#aw)"
          />
          <path
            d="M75.48 100.474h-1.906c.275.224.672.308 1.04.314.42.007.796-.108.918-.21.042-.035.046-.107-.051-.104Z"
            fill="url(#ax)"
          />
          <path
            d="M66.847 101.768c1.266-.011 2.396.01 3.662-.001-.661.278-1.343.336-2.03.336-1.294 0-1.821-.183-1.821-.278 0-.061.128-.057.189-.058v.001Z"
            fill="url(#ay)"
          />
          <path
            d="M76.42 101.768c-.931-.011-1.763.01-2.693-.001.486.279.987.337 1.493.337.951 0 1.339-.191 1.339-.286 0-.05-.094-.05-.139-.05Z"
            fill="url(#az)"
          />
          <path
            d="M69.112 104.467c.54 2.97.693 5.469.583 8.185-.067 1.643-.26 3.293-.507 4.917-.24 1.574-.5 2.889-1.058 4.612.294.363.85.305 1.28.135.422-.167.668-.498.765-.892.112-.452.162-.955.195-1.42.2-2.958.425-5.9.278-8.863-.068-1.37-.204-4.393-.601-5.772-.14-.486-.446-.777-.934-.903v.001Z"
            fill="url(#aA)"
          />
          <path
            d="M74.362 121.959c-.558-2.772-.696-4.166-.945-6.387-.217-1.943-.294-6.925.4-10.339.342.302.293.652.22 1.176-.334 2.366-.246 4.69-.17 6.884.057 1.61.647 6.468 1.586 8.932.081.215-.42.263-.591.199-.216-.08-.455-.239-.5-.465Z"
            fill="url(#aB)"
          />
          <path
            d="M66.36 123.621c1.392-.01 2.636 0 4.028-.009-.552.25-.982.501-2.3.501-.487 0-1.257-.101-1.74-.29-.179-.07-.145-.205.012-.202Z"
            fill="url(#aC)"
          />
          <path
            d="M77.126 123.621c-.972-.01-1.84 0-2.812-.009.386.25.855.438 1.599.438.34 0 .91-.087 1.249-.276.124-.07.074-.156-.036-.153Z"
            fill="url(#aD)"
          />
          <path
            d="M68.215 128.758c-.695.785-1.528 1.22-3.091.941-.319-.057-.653-.204-.796-.494-.156-.315.021-.674.204-.974.285-.468.765-.907 1.402-1.722.077-.099.377-.744 1.974-.658 1.05.056.958.697.96.803.01.922-.2 1.591-.653 2.104Z"
            fill="url(#aE)"
          />
          <path
            d="M77.047 126.047c.306.141.555.561.763.828l.912 1.175c.135.175.263.357.349.561.236.561-.129.939-.458 1.001-.79.15-1.51.07-1.885-.305-.339-.339-.464-1.074-.522-1.34-.113-.527-.274-1.122-.149-1.665.084-.366.63-.421.99-.255Z"
            fill="url(#aF)"
          />
          <path
            d="M73.053 86.295a.195.195 0 0 1-.041.142 2.27 2.27 0 0 1-.335.329c.14-.029.597-.155.776-.236a.076.076 0 0 0 .039-.094c-.2-.534-.353-.865-.534-1.359-.005-.015-.028-.01-.026.006.047.401.08.814.12 1.212h.001Z"
            fill="url(#aG)"
          />
          <path
            d="M74.904 82.231c-.078.685-.256 1.673-.296 1.919a.111.111 0 0 1-.056.084l-.256.133.495.154c.074.023.147-.035.147-.13-.002-.615 0-1.258 0-2.155 0-.027-.03-.031-.034-.006v.001Z"
            fill="url(#aH)"
          />
          <path
            d="m70.973 87.483-.808.002c-.085.004-.212-.002-.216.079-.004.06.105.215.407.238.475.036.712-.2.712-.264 0-.04-.054-.055-.095-.055Z"
            fill="url(#aI)"
          />
          <path
            d="M73.191 87.484c.13 0 .138.047.126.085-.031.102-.194.189-.37.189-.265 0-.473-.15-.473-.214 0-.046.04-.058.163-.058l.554-.003v.001Z"
            fill="url(#aJ)"
          />
          <path
            d="M69.095 97.015c.259.134.631.174.89.06.123-.054.19-.214.175-.35-.218-2.077-.41-3.09-.58-4.94a.448.448 0 0 0-.403-.406c-.618-.067-1.158-.053-1.775-.075-.183-.006-.318.206-.265.383.583 1.948 1.041 3.076 1.706 5.05a.566.566 0 0 0 .251.277Z"
            fill="url(#aK)"
          />
          <path
            d="M68.944 89.995a.739.739 0 0 0 .526-.265 4.72 4.72 0 0 0 .342-.464c.075-.117.179-.344.134-.394-.08-.091-.273-.06-.389-.026-.654.192-1.446.467-2.007.855-.055.038-.072.119-.028.17.049.056.125.077.198.092.258.055.84.056 1.224.034v-.002Z"
            fill="url(#aL)"
          />
          <path
            d="M71.275 90.513c-.786-.009-3.387-.035-5.046-.205-.26-.027-.207.062-.166.1.04.037.147.082.2.098.484.145.859.221 1.677.272 1.205.074 2.627-.033 3.342-.186.108-.024.204-.076-.007-.079Z"
            fill="url(#aM)"
          />
          <path
            d="M74.386 89.013c.363.119 1.274.456 1.238.639-.012.058-.026.107-.153.13-.446.079-.7.062-.862-.028-.12-.068-.236-.186-.337-.28-.102-.094-.299-.303-.298-.417.002-.175.33-.072.412-.045Z"
            fill="url(#aN)"
          />
          <path
            d="M74.957 91.521c.018-.103.057-.201.144-.26a.657.657 0 0 1 .299-.088c.163-.017.45-.023.613-.011.118.008.263.02.303.133.023.065-.007.172-.026.237-.078.264-1.133 3.642-1.658 5.206-.04.123-.208.26-.361.254-.09-.003-.156-.037-.2-.125-.044-.084.044-.553.085-.755.225-1.11.732-4.183.8-4.59h.001Z"
            fill="url(#aO)"
          />
          <path
            d="M70.507 99.851a24.61 24.61 0 0 0-.119-.355.15.15 0 0 0-.144-.1c-.441.003-.834 0-1.28.005a.057.057 0 0 0-.056.056c.002.144-.002.254 0 .401 0 .023.017.042.039.042.44.002 1.303 0 1.525-.001a.036.036 0 0 0 .034-.048Z"
            fill="url(#aP)"
          />
          <path
            d="M73.575 99.851c.025-.077.076-.23.119-.355a.151.151 0 0 1 .144-.1c.39.004.363.005.518.005.03 0 .055.026.055.055 0 .145.003.255 0 .402a.04.04 0 0 1-.04.041h-.761a.036.036 0 0 1-.035-.049v.001Z"
            fill="url(#aQ)"
          />
          <path
            d="M71.116 79.055a.238.238 0 0 1-.053-.006c-.117-.025-.14-.158-.144-.198-.024-.23.093-.646.505-.784a.204.204 0 0 1 .063-.01c.032 0 .058.008.072.022a.042.042 0 0 1 .012.03c0 .013-.015.028-.04.056-.086.092-.285.306-.232.75 0 .012-.012.045-.039.076a.189.189 0 0 1-.144.064Z"
            fill="url(#aR)"
          />
          <path
            d="M72.284 79.248c-.017.01-.065-.004-.095-.038a.253.253 0 0 1-.047-.088c-.01-.045-.001-.081.015-.1a.804.804 0 0 1 .037-.039c.045-.053.11-.13.159-.298.004-.013.012-.02.02-.018.018.004.042.041.056.13a.64.64 0 0 1-.145.451Z"
            fill="url(#aS)"
          />
        </g>
        <path
          d="M73.971 24.785c-2.181.916-2.673 3.452-3.23 5.494-.8.076-1.495.284-2.385.72l-.018.025c.608-.098 1.62-.048 2.15.2-.337 1.37-.616 2.828-1.348 3.994-.828 1.423-2.96 1.576-3.965.257-.976-1.218-.276-3.338 1.169-3.867-1.605.497-2.497 2.7-1.574 4.149.976 1.597 3.5 1.915 4.941.784 1.387-1.184 1.608-3.113 1.979-4.775.034-.153.066-.306.097-.458 2.184-.095 4.8.084 6.307-1.871 2.284-2.952-.91-6.286-4.123-4.652Zm2.431 4.576c-1.313.72-2.91.715-4.383.892.24-1.034.529-2.066 1-2.994.657-1.303 2.483-2.15 3.81-1.408 1.376.831.82 2.828-.427 3.51Z"
          fill="#9245B0"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={63.344}
          y1={-23.285}
          x2={136.752}
          y2={87.616}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#9245B0" />
          <stop offset={0.302} stopColor="#8B3DAA" />
          <stop offset={0.474} stopColor="#9245B0" />
          <stop offset={0.641} stopColor="#6F3386" />
          <stop offset={0.823} stopColor="#9245B0" />
          <stop offset={0.957} stopColor="#9245B0" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={41.646}
          y1={91.518}
          x2={47.793}
          y2={91.518}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={46.483}
          y1={98.246}
          x2={49.317}
          y2={98.246}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={47.576}
          y1={94.093}
          x2={50.236}
          y2={94.093}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={51.25}
          y1={96.714}
          x2={52.413}
          y2={96.714}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={46.018}
          y1={105.368}
          x2={55.031}
          y2={105.368}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={48.596}
          y1={100.382}
          x2={54.331}
          y2={100.382}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={48.404}
          y1={109.995}
          x2={54.813}
          y2={109.995}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={51.566}
          y1={112.571}
          x2={53.867}
          y2={112.571}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={48.383}
          y1={114.747}
          x2={52.573}
          y2={114.747}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={49.013}
          y1={118.11}
          x2={54.425}
          y2={118.11}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={49.035}
          y1={122.553}
          x2={54.964}
          y2={122.553}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="p"
          x1={50.246}
          y1={113.908}
          x2={51.993}
          y2={113.908}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={38.37}
          y1={96.704}
          x2={51.292}
          y2={100.325}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={42.337}
          y1={91.592}
          x2={46.522}
          y2={91.592}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={40.037}
          y1={102.58}
          x2={41.441}
          y2={102.58}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={42.075}
          y1={107.557}
          x2={52.792}
          y2={107.557}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={42.994}
          y1={114.786}
          x2={50.88}
          y2={114.786}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={41.584}
          y1={117.977}
          x2={49.093}
          y2={117.977}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={40.778}
          y1={122.583}
          x2={49.561}
          y2={122.583}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={43.998}
          y1={113.909}
          x2={47.341}
          y2={113.909}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="y"
          x1={42.802}
          y1={95.683}
          x2={45.519}
          y2={96.359}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="z"
          x1={89.245}
          y1={117.687}
          x2={95.943}
          y2={117.687}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="A"
          x1={87.431}
          y1={124.097}
          x2={95.89}
          y2={124.097}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="B"
          x1={94.672}
          y1={117.671}
          x2={99.474}
          y2={117.671}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="C"
          x1={90.711}
          y1={109.051}
          x2={94.564}
          y2={109.051}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="D"
          x1={95.906}
          y1={109.419}
          x2={98.249}
          y2={109.419}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="E"
          x1={88.676}
          y1={96.607}
          x2={93.174}
          y2={96.607}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="F"
          x1={96.37}
          y1={96.607}
          x2={100.087}
          y2={96.607}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="G"
          x1={89.795}
          y1={99.783}
          x2={94.614}
          y2={99.783}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="H"
          x1={96.075}
          y1={99.783}
          x2={99.001}
          y2={99.783}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="I"
          x1={90.194}
          y1={101.459}
          x2={95.794}
          y2={101.459}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="J"
          x1={94.919}
          y1={101.437}
          x2={98.549}
          y2={101.437}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="K"
          x1={89.562}
          y1={115.426}
          x2={96.153}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="L"
          x1={94.328}
          y1={115.426}
          x2={99.124}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="M"
          x1={88.065}
          y1={120.141}
          x2={94.415}
          y2={120.141}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="N"
          x1={96.375}
          y1={120.184}
          x2={100.981}
          y2={120.184}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="O"
          x1={95.352}
          y1={124.064}
          x2={101.383}
          y2={124.064}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="P"
          x1={17.386}
          y1={116.189}
          x2={23.638}
          y2={116.189}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Q"
          x1={19.715}
          y1={97.394}
          x2={24.36}
          y2={97.394}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.04} stopColor="#9CAABD" />
          <stop offset={0.13} stopColor="#778291" />
          <stop offset={0.21} stopColor="#575F6A" />
          <stop offset={0.3} stopColor="#3C4149" />
          <stop offset={0.4} stopColor="#26292E" />
          <stop offset={0.51} stopColor="#151719" />
          <stop offset={0.63} stopColor="#090A0B" />
          <stop offset={0.77} stopColor="#020202" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="R"
          x1={19.762}
          y1={102.904}
          x2={23.108}
          y2={102.904}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="S"
          x1={20.696}
          y1={107.464}
          x2={22.828}
          y2={107.464}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="T"
          x1={17.946}
          y1={112.891}
          x2={23.577}
          y2={112.891}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="U"
          x1={19.606}
          y1={110.595}
          x2={23.599}
          y2={110.595}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="V"
          x1={22.98}
          y1={116.188}
          x2={27.545}
          y2={116.188}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="W"
          x1={22.58}
          y1={107.666}
          x2={24.617}
          y2={107.55}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="X"
          x1={22.951}
          y1={102.904}
          x2={25.229}
          y2={102.904}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="Y"
          x1={23.452}
          y1={98.954}
          x2={25.576}
          y2={98.954}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="Z"
          x1={23.117}
          y1={113.059}
          x2={27.096}
          y2={113.059}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="aa"
          x1={22.472}
          y1={110.574}
          x2={25.407}
          y2={110.574}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="ab"
          x1={112.118}
          y1={93.931}
          x2={118.371}
          y2={93.931}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ac"
          x1={114.447}
          y1={93.931}
          x2={119.092}
          y2={93.931}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.04} stopColor="#9CAABD" />
          <stop offset={0.13} stopColor="#778291" />
          <stop offset={0.21} stopColor="#575F6A" />
          <stop offset={0.3} stopColor="#3C4149" />
          <stop offset={0.4} stopColor="#26292E" />
          <stop offset={0.51} stopColor="#151719" />
          <stop offset={0.63} stopColor="#090A0B" />
          <stop offset={0.77} stopColor="#020202" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ad"
          x1={114.494}
          y1={102.904}
          x2={117.84}
          y2={102.904}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ae"
          x1={115.428}
          y1={107.464}
          x2={117.56}
          y2={107.464}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="af"
          x1={112.679}
          y1={112.891}
          x2={118.31}
          y2={112.891}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ag"
          x1={114.338}
          y1={110.595}
          x2={118.332}
          y2={110.595}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ah"
          x1={117.712}
          y1={93.931}
          x2={122.277}
          y2={93.931}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="ai"
          x1={117.312}
          y1={107.666}
          x2={119.349}
          y2={107.55}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="aj"
          x1={117.683}
          y1={102.904}
          x2={119.961}
          y2={102.904}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="ak"
          x1={118.184}
          y1={98.954}
          x2={120.308}
          y2={98.954}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="al"
          x1={117.849}
          y1={113.059}
          x2={121.829}
          y2={113.059}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="am"
          x1={117.204}
          y1={110.574}
          x2={120.14}
          y2={110.574}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.19} stopColor="#020203" />
          <stop offset={0.34} stopColor="#0A0B0D" />
          <stop offset={0.48} stopColor="#181B1E" />
          <stop offset={0.62} stopColor="#2C3035" />
          <stop offset={0.74} stopColor="#454B54" />
          <stop offset={0.86} stopColor="#646D7A" />
          <stop offset={0.98} stopColor="#8895A6" />
          <stop offset={1} stopColor="#8F9CAE" />
        </linearGradient>
        <linearGradient
          id="an"
          x1={68.321}
          y1={83.342}
          x2={71.246}
          y2={83.342}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ao"
          x1={69.838}
          y1={80.856}
          x2={72.536}
          y2={80.856}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ap"
          x1={69.838}
          y1={85.796}
          x2={72.053}
          y2={85.796}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aq"
          x1={72.038}
          y1={81.027}
          x2={73.358}
          y2={81.027}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="ar"
          x1={71.326}
          y1={90.477}
          x2={76.724}
          y2={90.477}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="as"
          x1={63.559}
          y1={132.508}
          x2={72.56}
          y2={132.508}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="at"
          x1={73.35}
          y1={132.478}
          x2={79.545}
          y2={132.478}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="au"
          x1={68.13}
          y1={98.186}
          x2={73.253}
          y2={98.186}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="av"
          x1={71.971}
          y1={98.15}
          x2={74.905}
          y2={98.15}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aw"
          x1={67.727}
          y1={100.631}
          x2={73.266}
          y2={100.631}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ax"
          x1={71.389}
          y1={100.631}
          x2={75.388}
          y2={100.631}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="ay"
          x1={66.658}
          y1={101.934}
          x2={73.846}
          y2={101.934}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="az"
          x1={70.612}
          y1={101.934}
          x2={76.314}
          y2={101.934}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aA"
          x1={68.13}
          y1={113.458}
          x2={72.918}
          y2={113.458}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aB"
          x1={70.868}
          y1={114.115}
          x2={75.28}
          y2={113.778}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aC"
          x1={66.227}
          y1={123.862}
          x2={73.994}
          y2={123.862}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aD"
          x1={71.102}
          y1={123.831}
          x2={76.983}
          y2={123.831}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aE"
          x1={64.268}
          y1={127.813}
          x2={72.857}
          y2={127.813}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aF"
          x1={72.563}
          y1={127.82}
          x2={78.876}
          y2={127.82}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aG"
          x1={71.774}
          y1={85.917}
          x2={73.426}
          y2={85.917}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aH"
          x1={73.59}
          y1={83.37}
          x2={74.882}
          y2={83.37}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aI"
          x1={69.948}
          y1={87.644}
          x2={72.039}
          y2={87.644}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aJ"
          x1={71.543}
          y1={87.621}
          x2={73.248}
          y2={87.621}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aK"
          x1={67.126}
          y1={94.224}
          x2={72.793}
          y2={94.224}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aL"
          x1={67.496}
          y1={89.411}
          x2={72.089}
          y2={89.411}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aM"
          x1={66.028}
          y1={90.553}
          x2={76.056}
          y2={90.553}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aN"
          x1={72.159}
          y1={89.396}
          x2={75.483}
          y2={89.396}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aO"
          x1={71.567}
          y1={94.074}
          x2={76.13}
          y2={94.074}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aP"
          x1={68.444}
          y1={99.648}
          x2={71.933}
          y2={99.648}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aQ"
          x1={72.638}
          y1={99.648}
          x2={74.483}
          y2={99.648}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aR"
          x1={70.916}
          y1={78.556}
          x2={72.139}
          y2={78.556}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="aS"
          x1={71.813}
          y1={78.959}
          x2={72.408}
          y2={78.959}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h143.327v160H0z" />
        </clipPath>
        <filter
          id="c"
          x={12.748}
          y={14.126}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={12} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="shape" result="effect1_innerShadow_16_1587" />
        </filter>
      </defs>
    </svg>
  ),
  // ----------------------------------------------------------COACHING-SESSION:SVG-------------------------------------------------------------------------------------------------
  coachingSession: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="11 0 120 160"
    >
      <g clipPath="url(#a)">
        <path
          d="M139.276 89.662a19.152 19.152 0 0 0 4.051-3.131v24.582a17.78 17.78 0 0 1-8.89 15.394L80.55 157.618a17.77 17.77 0 0 1-17.772 0L8.89 126.507A17.78 17.78 0 0 1 0 111.113V86.531a19.08 19.08 0 0 0 4.051 3.131l58.044 33.512a19.133 19.133 0 0 0 19.141 0l58.042-33.512h-.002Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.887v32.62a19.087 19.087 0 0 1-4.051 3.131L81.234 118.15a19.128 19.128 0 0 1-19.141 0L4.051 84.64A19.212 19.212 0 0 1 0 81.51v-32.62c0-6.352 3.39-12.22 8.89-15.396L62.778 2.382a17.773 17.773 0 0 1 17.774 0l53.887 31.113a17.774 17.774 0 0 1 8.89 15.392h-.002Z"
          fill="url(#b)"
        />
        <g filter="url(#c)">
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934a13.94 13.94 0 0 0 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.941 13.941 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </g>
        <mask
          id="d"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.582 105.968V54.034c0-4.981-2.659-9.583-6.97-12.073L78.635 15.994a13.942 13.942 0 0 0-13.941 0L19.718 41.959a13.939 13.939 0 0 0-6.97 12.073v51.934a13.94 13.94 0 0 0 6.97 12.073l44.976 25.967a13.944 13.944 0 0 0 13.941 0l44.977-25.967a13.941 13.941 0 0 0 6.97-12.073v.002Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <path
            d="M52.685 47.898c-.42 0-.813-.07-1.177-.212a2.8 2.8 0 0 1-.935-.62 2.911 2.911 0 0 1-.623-.936 3.112 3.112 0 0 1-.219-1.181c0-.43.073-.823.218-1.181.151-.359.359-.671.624-.937.27-.266.584-.47.943-.611a3.08 3.08 0 0 1 1.177-.22c.473 0 .899.087 1.278.26.385.169.707.419.967.75l-.81.782a1.861 1.861 0 0 0-.624-.497 1.654 1.654 0 0 0-.749-.17 1.84 1.84 0 0 0-.701.13 1.585 1.585 0 0 0-.553.374 1.77 1.77 0 0 0-.367.579c-.083.222-.124.47-.124.74 0 .272.041.52.124.742.088.223.21.416.367.579.155.163.34.287.553.374.213.087.447.13.701.13.27 0 .52-.054.749-.162.228-.114.436-.285.623-.514l.81.782a2.54 2.54 0 0 1-.966.758c-.38.174-.808.26-1.286.26ZM58.326 47.898a3.22 3.22 0 0 1-1.2-.22 2.867 2.867 0 0 1-.951-.62 2.912 2.912 0 0 1-.624-.936 3.091 3.091 0 0 1-.218-1.173c0-.424.073-.815.218-1.173a2.852 2.852 0 0 1 1.583-1.556 3.14 3.14 0 0 1 1.184-.22c.432 0 .827.073 1.185.22a2.85 2.85 0 0 1 1.574 1.556c.151.353.227.744.227 1.173 0 .424-.076.817-.227 1.181a2.85 2.85 0 0 1-.63.937c-.266.26-.58.464-.944.61-.358.148-.75.22-1.177.22Zm-.008-1.124c.245 0 .468-.044.67-.13.209-.088.39-.212.546-.375.156-.163.276-.356.359-.579.088-.222.132-.47.132-.741 0-.272-.044-.519-.132-.741a1.67 1.67 0 0 0-.359-.579 1.524 1.524 0 0 0-.538-.374 1.74 1.74 0 0 0-.678-.13c-.244 0-.47.043-.678.13a1.623 1.623 0 0 0-.538.374 1.772 1.772 0 0 0-.366.579c-.083.222-.125.47-.125.74 0 .267.042.514.125.742.089.223.208.416.359.579.156.163.337.287.545.374.208.087.434.13.678.13ZM61.46 47.8l2.431-5.702h1.247l2.44 5.702h-1.325l-1.996-5.034h.5L62.752 47.8h-1.294Zm1.215-1.222.335-1.002h2.806l.343 1.002h-3.484ZM70.678 47.898c-.42 0-.813-.07-1.176-.212a2.8 2.8 0 0 1-.936-.62 2.913 2.913 0 0 1-.623-.936 3.112 3.112 0 0 1-.218-1.181c0-.43.072-.823.218-1.181.15-.359.358-.671.623-.937.27-.266.585-.47.943-.611a3.08 3.08 0 0 1 1.177-.22c.473 0 .9.087 1.278.26.385.169.707.419.967.75l-.81.782a1.86 1.86 0 0 0-.624-.497 1.653 1.653 0 0 0-.748-.17 1.84 1.84 0 0 0-.702.13 1.585 1.585 0 0 0-.553.374 1.77 1.77 0 0 0-.367.579c-.083.222-.124.47-.124.74 0 .272.041.52.124.742.089.223.21.416.367.579.156.163.34.287.553.374.213.087.447.13.702.13.27 0 .52-.054.748-.162.228-.114.436-.285.623-.514l.811.782a2.54 2.54 0 0 1-.966.758c-.38.174-.809.26-1.287.26ZM77.525 42.098h1.262V47.8h-1.262v-5.702ZM75.046 47.8h-1.262v-5.702h1.262V47.8Zm2.572-2.338h-2.665v-1.116h2.665v1.116ZM80.078 47.8v-5.702h1.263V47.8h-1.263ZM82.636 47.8v-5.702h1.044l3.22 4.105h-.508v-4.105h1.248V47.8h-1.037l-3.227-4.106h.507V47.8h-1.247ZM91.565 47.898c-.432 0-.83-.07-1.193-.212a2.887 2.887 0 0 1-.943-.62 2.913 2.913 0 0 1-.623-.936 3.112 3.112 0 0 1-.219-1.181c0-.43.073-.823.219-1.181.15-.359.36-.671.63-.937.271-.266.588-.47.952-.611.363-.147.764-.22 1.2-.22.483 0 .917.084 1.302.252.39.169.717.413.982.734l-.81.782a1.932 1.932 0 0 0-.648-.48 1.791 1.791 0 0 0-.764-.164c-.265 0-.506.044-.724.13a1.648 1.648 0 0 0-.57.375 1.771 1.771 0 0 0-.366.579c-.083.222-.124.47-.124.74 0 .267.041.511.124.734.089.223.21.418.367.587.16.163.348.287.56.374.219.087.458.13.718.13.25 0 .49-.04.725-.122.239-.087.47-.23.693-.431l.717.953a3.228 3.228 0 0 1-1.036.537c-.39.125-.78.188-1.17.188Zm1.052-.896v-2.143h1.153v2.314l-1.153-.171ZM45.776 61a7.416 7.416 0 0 1-2.133-.305c-.68-.212-1.228-.484-1.643-.817l.729-1.69c.397.296.865.54 1.404.735.548.184 1.1.277 1.656.277.425 0 .765-.042 1.02-.125.266-.092.46-.217.584-.374a.848.848 0 0 0 .185-.54.724.724 0 0 0-.291-.61 2.181 2.181 0 0 0-.769-.373 11.201 11.201 0 0 0-1.06-.277c-.38-.092-.764-.203-1.152-.333a4.82 4.82 0 0 1-1.047-.498 2.461 2.461 0 0 1-.782-.803c-.194-.333-.291-.757-.291-1.274 0-.554.14-1.057.423-1.51.292-.461.725-.826 1.299-1.094.583-.277 1.312-.415 2.186-.415.583 0 1.157.074 1.723.221.565.139 1.064.351 1.497.637l-.663 1.704a5.297 5.297 0 0 0-1.298-.568 4.435 4.435 0 0 0-1.272-.194c-.415 0-.755.05-1.02.152s-.455.236-.57.402a.913.913 0 0 0-.172.554c0 .25.097.452.291.61.195.147.45.267.769.36.318.092.667.184 1.047.276.388.093.772.199 1.152.319.389.12.742.281 1.06.484.318.204.574.471.769.804.203.332.304.752.304 1.26 0 .545-.145 1.043-.437 1.495-.291.453-.729.818-1.312 1.094-.574.277-1.302.416-2.186.416ZM53.152 55.045h4.466v1.745h-4.466v-1.745Zm.16 3.988h5.048v1.8h-7.182V51.14h7.01v1.8H53.31v6.093ZM63.115 61a7.417 7.417 0 0 1-2.133-.305c-.68-.212-1.228-.484-1.643-.817l.729-1.69c.397.296.865.54 1.404.735.548.184 1.1.277 1.656.277.424 0 .764-.042 1.02-.125.266-.092.46-.217.584-.374a.849.849 0 0 0 .185-.54.724.724 0 0 0-.291-.61 2.182 2.182 0 0 0-.769-.373 11.21 11.21 0 0 0-1.06-.277c-.38-.092-.764-.203-1.153-.333a4.819 4.819 0 0 1-1.047-.498 2.46 2.46 0 0 1-.781-.803c-.195-.333-.292-.757-.292-1.274 0-.554.142-1.057.424-1.51.292-.461.725-.826 1.299-1.094.583-.277 1.312-.415 2.186-.415.583 0 1.157.074 1.723.221a4.73 4.73 0 0 1 1.497.637l-.663 1.704a5.295 5.295 0 0 0-1.298-.568 4.434 4.434 0 0 0-1.272-.194c-.415 0-.756.05-1.02.152-.265.102-.455.236-.57.402a.913.913 0 0 0-.172.554c0 .25.097.452.291.61.194.147.45.267.769.36.317.092.666.184 1.046.276.389.093.773.199 1.153.319.389.12.742.281 1.06.484.318.204.574.471.769.804.203.332.304.752.304 1.26 0 .545-.145 1.043-.437 1.495-.291.453-.729.818-1.312 1.094-.574.277-1.303.416-2.186.416ZM71.564 61a7.417 7.417 0 0 1-2.133-.305c-.68-.212-1.228-.484-1.643-.817l.729-1.69c.397.296.866.54 1.404.735.548.184 1.1.277 1.657.277.424 0 .764-.042 1.02-.125.265-.092.46-.217.583-.374a.849.849 0 0 0 .185-.54.724.724 0 0 0-.291-.61 2.182 2.182 0 0 0-.769-.373 11.201 11.201 0 0 0-1.06-.277c-.38-.092-.764-.203-1.152-.333a4.819 4.819 0 0 1-1.047-.498 2.46 2.46 0 0 1-.782-.803c-.194-.333-.291-.757-.291-1.274 0-.554.141-1.057.424-1.51.291-.461.724-.826 1.298-1.094.583-.277 1.312-.415 2.186-.415.583 0 1.157.074 1.723.221a4.73 4.73 0 0 1 1.497.637l-.662 1.704a5.294 5.294 0 0 0-1.299-.568 4.434 4.434 0 0 0-1.272-.194c-.415 0-.755.05-1.02.152s-.455.236-.57.402a.913.913 0 0 0-.172.554c0 .25.097.452.291.61.195.147.45.267.769.36.318.092.667.184 1.047.276.388.093.773.199 1.152.319.389.12.742.281 1.06.484.318.204.575.471.769.804.203.332.305.752.305 1.26 0 .545-.146 1.043-.438 1.495-.291.453-.728.818-1.311 1.094-.575.277-1.303.416-2.187.416ZM76.966 60.834V51.14h2.147v9.694h-2.147ZM85.819 61a5.474 5.474 0 0 1-2.04-.374 4.876 4.876 0 0 1-1.617-1.052 4.951 4.951 0 0 1-1.06-1.593 5.253 5.253 0 0 1-.371-1.994c0-.72.124-1.385.37-1.994.257-.61.615-1.14 1.074-1.593.46-.452.998-.803 1.617-1.052a5.336 5.336 0 0 1 2.014-.374 5.27 5.27 0 0 1 2.014.374c.618.249 1.152.6 1.603 1.052.46.453.817.983 1.073 1.593.256.6.384 1.264.384 1.994 0 .72-.128 1.39-.384 2.008a4.847 4.847 0 0 1-1.073 1.593c-.45.443-.985.789-1.603 1.038-.61.25-1.277.374-2.001.374Zm-.013-1.911a2.86 2.86 0 0 0 1.14-.222c.353-.147.662-.36.927-.637a2.84 2.84 0 0 0 .61-.983 3.39 3.39 0 0 0 .224-1.26 3.39 3.39 0 0 0-.225-1.26 2.842 2.842 0 0 0-.61-.984 2.592 2.592 0 0 0-.914-.637 2.959 2.959 0 0 0-1.152-.221c-.415 0-.8.074-1.153.221a2.76 2.76 0 0 0-.914.637 3.012 3.012 0 0 0-.623.984 3.58 3.58 0 0 0-.212 1.26c0 .452.07.872.212 1.26.15.379.353.706.61.983.264.277.574.49.927.637.353.148.737.222 1.153.222ZM92.494 60.834V51.14h1.775l5.472 6.98h-.861v-6.98H101v9.694h-1.762l-5.486-6.98h.862v6.98h-2.12Z"
            fill="#9042AE"
          />
          <path
            d="M122.112 137.805H88.461l-3.092-10.066h27.468l9.275 10.066ZM140.304 127.739h-27.467l-6.396-6.941h23.203l10.66 6.941ZM93.349 153.719H49.92l4.888-15.914h33.652l4.888 15.914ZM54.81 137.805H21.157l9.275-10.066h27.468l-3.092 10.066ZM30.433 127.739H2.966l10.66-6.941h23.203l-6.396 6.941Z"
            fill="#000"
          />
          <path
            d="m41.122 124.85-.035-.003a5.356 5.356 0 0 1-1.635-.428 1.209 1.209 0 0 1-.718-1.103v-.785c0-.344.142-.674.377-.916a2.627 2.627 0 0 1-.18-.25c-.769-1.193-.265-2.533.109-3.076.244-.354.593-.795.932-1.221.21-.264.411-.518.564-.724.295-.395.475-1.08.494-1.253v-.164c.003-.49.184-.798.433-1.011a1.24 1.24 0 0 1-.356-.413 32.98 32.98 0 0 1-.73-1.433l-.029-.061c-.23-.503-.378-.957-.005-1.84l.041-.098c.449-1.066 1.498-3.563 5.215-7.465.051-.055.097-.103.137-.148h-.052c-.699.046-1.398.123-2.19.543-.183.157-.303.382-.44.638-.145.268-.308.571-.572.816-.446.412-1.254.498-1.854.498-1.182 0-1.873-.342-2.053-1.017a1.331 1.331 0 0 1-.045-.307c-.31 0-.601-.074-.864-.22-.304-.163-.83-.445-.975-3.255-.07-.485.061-1.212.66-1.796l.083-.08c.566-.551 2.29-2.227 3.254-3.886.162-.28.37-.548.617-.798.38-.385.75-.677 1.034-.887-.124-.144-.25-.284-.372-.423-.773-.87-1.331-1.5-1.24-2.252.042-.353.232-.663.534-.87.183-.127.523-.362 1.156-.362.582 0 1.595.17 4.283 1.47.369.042.72.095 1.07.162.828.161 1.616.403 2.349.719l-.013-.19 1.566 1.02c.534.348 1.038.75 1.499 1.196l.174.168.07.23.051.175.108-.521 1.234 1.986c.457.735.85 1.557 1.167 2.442l.08.22-.035.232a13.297 13.297 0 0 1-.347 1.633l.776-.969.324 2.097c.027.174.053.349.075.528.114.883.154 1.921.117 3.001l-.008.25-.133.212a13.488 13.488 0 0 1-1.175 1.602l1.306-.733-.312 1.913c-.155.948-.36 1.874-.61 2.759l.087-.023-.634 1.698c-.177.473-.37.932-.571 1.365a1.242 1.242 0 0 1-.408.487c.24.211.413.515.416.993v.169c.02.173.2.858.494 1.253.154.207.355.46.564.724.338.426.688.867.932 1.222.374.542.878 1.882.11 3.075a2.761 2.761 0 0 1-.18.25c.233.242.375.572.375.916v.785c0 .476-.282.909-.718 1.103a5.356 5.356 0 0 1-1.635.428l-.035.003H41.122Z"
            fill="#fff"
          />
          <path
            d="m56.033 122.173-.793-.285-.25-.091v-.105s.77-.089 1.248-.831c.484-.752.163-1.67-.093-2.041-.377-.548-1.08-1.386-1.476-1.917-.448-.601-.68-1.548-.68-1.793v-.182c-.001-.241-.023-.314-.494-.507-.097-.041-.5-.188-.539-.202l-.009-.003a.526.526 0 0 1-.257-.465c0-.29.208-.523.467-.523h.626a.314.314 0 0 0 .285-.179c.197-.423.378-.857.543-1.298-.825.221-1.73.375-2.72.444a17.732 17.732 0 0 0 3.133-1.667c.304-1.005.534-2.029.698-3.034-2.218 1.244-4.78 1.666-4.78 1.666 2.62-1.527 4.187-3.345 5.09-4.792a17.966 17.966 0 0 0-.11-2.85 19.774 19.774 0 0 0-.072-.504c-1.848 2.307-3.959 3.395-3.959 3.395 2.128-2.074 2.932-4.586 3.206-6.436-.309-.859-.675-1.61-1.082-2.264-.495 2.395-1.556 3.71-1.556 3.71.688-2.195.508-4.108.063-5.57a9.047 9.047 0 0 0-1.36-1.084c.073 1.09-.023 2.403-.389 3.462.008-1.803-.442-3.19-.957-4.188-.797-.35-1.563-.56-2.22-.688a13.449 13.449 0 0 0-1.158-.168c-3.787-1.849-4.304-1.489-4.649-1.251-.541.374.6 1.35 1.575 2.546.229.28.23.473 0 .648-.194.147-.778.501-1.396 1.127a3.037 3.037 0 0 0-.474.61c-1.08 1.862-3.015 3.7-3.492 4.165-.497.486-.382 1.028-.382 1.028s.115 2.334.497 2.54c.708.392 1.596-.479 1.798-.256.163.18-.554.928-.44 1.357.115.43 2.009.411 2.372.075.364-.336.497-1.073 1.129-1.551.998-.55 1.873-.642 2.653-.693.146-.01.926.008 1.133.214.387.385.172.817-.489 1.509-3.716 3.902-4.644 6.27-5.072 7.283-.257.609-.154.759.024 1.151.165.364.534 1.062.703 1.379.055.102.16.166.276.166h.589c.257 0 .466.233.466.522a.524.524 0 0 1-.264.468c-.038.014-.442.161-.539.202-.471.193-.493.266-.495.508v.181c0 .245-.23 1.192-.679 1.793-.396.531-1.099 1.369-1.476 1.917-.255.371-.578 1.289-.093 2.041a1.869 1.869 0 0 0 1.248.831v.105l-.25.091-.793.286a.408.408 0 0 0-.253.357v.785c0 .109.065.206.164.249a4.431 4.431 0 0 0 1.326.351h13.639s.644-.048 1.326-.351a.273.273 0 0 0 .164-.249v-.785a.406.406 0 0 0-.252-.357l.001-.002Z"
            fill="#000"
          />
          <path
            d="M46.124 91.638c-.26-.14-.905-.489-1.12-.61.11.104.73.672.995.935.03.03.07.046.113.045.65-.01 1.295-.032 1.945-.042a20.181 20.181 0 0 0-1.701-.256.623.623 0 0 1-.232-.072Z"
            fill="url(#e)"
          />
          <path
            d="M48.59 95.804c.174.61.407 1.717.256 2.712-.127.84-.584 1.57-1.03 2.172 1.212-.9 1.352-1.942 1.382-2.225.124-1.16-.237-1.91-.608-2.659Z"
            fill="url(#f)"
          />
          <path
            d="M50.35 95.62c-.082-1.357-.377-2.193-.607-2.685-.217-.189-.537-.344-.715-.368.496.635.969 1.566 1.322 3.053Z"
            fill="url(#g)"
          />
          <path
            d="M51.885 99.034c.079-.436.496-2.69.066-4.64.034.031.287.332.423.55.255 1.397-.082 3.141-.489 4.09Z"
            fill="url(#h)"
          />
          <path
            d="M50.941 108.392c1.744-1.049 3.635-2.766 4.454-4.123.045-.692.009-1.031-.019-1.925-.127.706-.373 1.898-.373 1.898s-1.278 2.153-4.062 4.15Z"
            fill="url(#i)"
          />
          <path
            d="M51.73 103.629c1.623-1.718 2.413-3.3 2.847-5.161a7.4 7.4 0 0 0-.496-1.332c.085.378.134.835.14 1.406-.231 1.37-1.068 3.308-2.491 5.088v-.001Z"
            fill="url(#j)"
          />
          <path
            d="M51.905 111.577a25.226 25.226 0 0 0 2.661-1.455c.204-.613.36-1.177.522-1.707-.135.31-.426.857-.604 1.185-.1.184-.235.343-.4.47-.358.277-1.094.821-2.179 1.508v-.001Z"
            fill="url(#k)"
          />
          <path
            d="M53.966 112.251c-.092.2-.14.324-.267.53a.225.225 0 0 1-.19.106c-.262.011-.45-.004-.686-.004.22-.078.484-.099.68-.207.196-.107.32-.245.463-.425Z"
            fill="url(#l)"
          />
          <path
            d="M50.672 114.605c.574-.008 1.876-.006 1.978-.006.265 0 .028.298-.804.298-.461 0-.874-.133-1.173-.292Z"
            fill="url(#m)"
          />
          <path
            d="M53.07 116.479c.038.03.295.627.381.804.307.637 1.106 1.723 1.166 1.829.077.139.031.323-.056.453-.106.158-.302.225-.484.28-.218.064-.974.106-1.457-.284-.546-.44-.58-1.104-.618-1.35-.07-.441-.028-1.273.121-1.618.131-.303.656-.339.947-.114Z"
            fill="url(#n)"
          />
          <path
            d="M52.274 122.333c.979 0 1.914 0 2.871-.003.083 0 .148.1-.114.204-.344.137-.821.244-1.157.243-.57-.003-1.04-.149-1.6-.444Z"
            fill="url(#o)"
          />
          <path
            d="M51.208 114.123c-.013.013-.009.049.006.049.42-.007.604-.004.8-.006.03 0 .054-.044.054-.098 0-.116 0-.206-.002-.324 0-.052-.023-.096-.052-.097-.062-.002-.19-.007-.253.014-.032.011-.214.126-.553.461v.001Z"
            fill="url(#p)"
          />
          <path
            d="M38.46 102.109a6.853 6.853 0 0 0-.153-.963 6.893 6.893 0 0 1-.151-.954 1.789 1.789 0 0 1 .053-.587.925.925 0 0 1 .366-.503c.093-.06.18-.113.263-.165.192-.118.358-.22.524-.351a9.143 9.143 0 0 0 2.302-2.66c.09-.16.174-.326.255-.486.136-.27.282-.547.454-.8.407-.599 1.74-1.394 2.312-1.551-.457.482-.448.874-.442 1.095.182.033.597.146.843.462.15.192.211.415.184.665-.282-.306-.962-.58-1.46-.58a.908.908 0 0 0-.28.038c-.49.158-.682.437-.947.824-.184.269-.35.58-.512.882-.084.157-.167.313-.252.46-.452.786-1.135 1.511-2.15 2.282a.859.859 0 0 1-.558.184c-.035 0-.068 0-.1-.002a1.938 1.938 0 0 0-.08-.002.386.386 0 0 0-.15.023c-.237.1-.31.449-.286.665.03.272.16.435.35.435a.362.362 0 0 0 .143-.032c.213-.091.406-.313.591-.675.143.402.023.795-.329 1.062-.127.097-.25.126-.367.154l-.102.026v.024c.003.557-.243.987-.321 1.036v-.006Zm6.847-6.297a1.865 1.865 0 0 1-.528.692c-.43.328-.986.359-1.494.257.442.504 1.402.503 1.83-.016a.993.993 0 0 0 .225-.643 1.317 1.317 0 0 0-.033-.29Z"
            fill="url(#q)"
          />
          <path
            d="M43.898 92.353c.075.084.147.144.258.163.112.019.26.008.385-.076.135-.09-.13-.333-.258-.432-1.046-.806-1.832-1.378-1.946-1.346.392.424.686.71 1.561 1.69Z"
            fill="url(#r)"
          />
          <path
            d="M40.037 103.329c.272-.034.479-.223.593-.475.113-.251.16-.644.16-1.023-.08.134-.125.239-.172.332l-.2.404-.38.762Z"
            fill="url(#s)"
          />
          <path
            d="M43.471 110.843c-.035.353.163.888.634 1.612a.156.156 0 0 1-.129.242c-.261 0-.586-.001-.742-.004a.554.554 0 0 1-.458-.26c-.333-.536-.404-.665-.63-1.151a.79.79 0 0 1-.027-.589c.616-1.797 1.5-3.007 2.528-4.361 1.187-1.563 2.663-2.655 3.128-3.916.137.631-.064 1.408-.762 2.292-1.379 1.746-3.268 4.309-3.542 6.135Z"
            fill="url(#t)"
          />
          <path
            d="M47.218 114.599c-.604.186-1.514.375-2.324.375-.594 0-1.16-.069-1.72-.216-.088-.023-.188-.062-.18-.106.011-.053.202-.052.285-.052H47.22v-.001Z"
            fill="url(#u)"
          />
          <path
            d="M45.277 118.71c-.151.294-.308.594-.556.818-.302.272-.716.406-1.13.447-.508.052-.834.052-1.314-.124-.184-.068-.367-.153-.505-.288a.638.638 0 0 1-.184-.515c.053-.543.935-1.325 1.373-2.258.125-.265.267-.545.525-.698.194-.115.512-.143.74-.14.486.004.834.053 1.155.313.329.266.303 1.655-.104 2.445Z"
            fill="url(#v)"
          />
          <path
            d="M40.967 122.333h4.516c-.53.207-.86.304-1.613.42-.371.057-.802.085-1.25.081a5.317 5.317 0 0 1-1.34-.171 3.002 3.002 0 0 1-.416-.159c-.138-.081-.118-.171.103-.171Z"
            fill="url(#w)"
          />
          <path
            d="M45.772 114.123c.028.013.019.049-.012.049-.866-.007-1.246-.004-1.653-.006-.06 0-.11-.044-.11-.098 0-.116.002-.206.003-.324.001-.052.048-.096.108-.097.127-.002.275.024.405.034.069.006.56.106 1.26.441v.001Z"
            fill="url(#x)"
          />
          <path
            d="M43.47 96.39a.192.192 0 0 1-.088-.018c-.092-.038-.14-.154-.14-.244 0-.193.124-.398.184-.467a.682.682 0 0 1 .499-.228c.069 0 .137.012.204.035a.836.836 0 0 0-.329.26.852.852 0 0 0-.142.386l-.009.075c-.01.103-.02.193-.136.2a.619.619 0 0 1-.044.002v-.002Z"
            fill="url(#y)"
          />
          <path
            d="m87.715 126.324-.035-.002a5.277 5.277 0 0 1-1.534-.39c-.706-.299-.782-.881-.782-1.117v-.773c0-.339.14-.663.371-.901a2.712 2.712 0 0 1-.178-.246c-.672-1.044-.385-2.181.108-2.896.255-.371.597-.678.898-.947.228-.204.443-.397.575-.574a3.56 3.56 0 0 0 .135-.197v-.299c0-.684.225-1.06.671-1.347a1.723 1.723 0 0 1-.298-.969c0-.737.463-1.369 1.112-1.619.217-1.838.506-5.347.553-11.246a1.526 1.526 0 0 1-.453-1.749 1.501 1.501 0 0 1-.683-.998 1.691 1.691 0 0 1-1.072-1.573V93.34h14.717v5.142c0 .714-.445 1.327-1.073 1.573a1.499 1.499 0 0 1-.683.998 1.525 1.525 0 0 1-.453 1.75c.047 5.899.336 9.408.553 11.245.65.251 1.112.882 1.112 1.619 0 .358-.11.692-.298.969.446.288.671.663.67 1.347v.299c.048.074.094.14.136.196.132.178.347.37.575.575.301.269.642.575.898.946.493.716.78 1.852.108 2.896-.057.088-.117.17-.178.246.23.239.37.563.37.901v.773c0 .236-.076.818-.782 1.118a5.296 5.296 0 0 1-1.535.389l-.034.003H87.715Z"
            fill="#fff"
          />
          <path
            d="M101.363 123.268v-.052s.759-.088 1.229-.818c.477-.74.16-1.513-.092-1.878-.371-.539-1.063-.969-1.452-1.492a4.702 4.702 0 0 1-.253-.379.464.464 0 0 1-.066-.238v-.399c0-.427.019-.535-.735-.842-.141-.058-.279-.113-.408-.163h.005v-.53a.812.812 0 0 0-.049-1.625h-.201c-.213-1.54-.615-5.378-.652-12.624a.61.61 0 0 0 .567-.606.61.61 0 0 0-.571-.607 82.713 82.713 0 0 0-.007-.657h.602a.576.576 0 0 0 .574-.577v-.528h.276a.77.77 0 0 0 .771-.77V94.26h-2.498v2h-1.445v-2h-4.995v2H90.52v-2H88.02v4.223c0 .426.346.77.77.77h.277v.528c0 .319.257.577.574.577h.602c-.003.222-.006.441-.007.657a.608.608 0 0 0-.004 1.213c-.037 7.246-.439 11.084-.653 12.624h-.2a.813.813 0 0 0-.049 1.625v.53h.004c-.129.05-.267.105-.408.163-.754.307-.735.415-.735.842v.399a.458.458 0 0 1-.066.238 4.783 4.783 0 0 1-.252.379c-.39.522-1.082.953-1.453 1.492-.251.365-.568 1.138-.092 1.878a1.84 1.84 0 0 0 1.23.818v.103l-.248.09-.78.281a.4.4 0 0 0-.249.352v.772c0 .145.09.216.223.272a4.384 4.384 0 0 0 1.244.319h13.423s.597-.044 1.245-.319c.133-.056.222-.127.222-.272v-.772a.4.4 0 0 0-.249-.352l-.78-.281-.247-.09v-.052.001Z"
            fill="#000"
          />
          <path
            d="M89.36 117.47c1.2-.009 2.273 0 3.473-.008-.476.226-.846.452-1.984.452-.42 0-1.083-.091-1.5-.262-.155-.063-.125-.185.01-.183v.001Z"
            fill="url(#z)"
          />
          <path
            d="M87.557 123.848h4.406c-.31.164-1.144.345-1.573.413-.716.112-1.657.151-2.528-.089-.087-.024-.356-.091-.405-.156-.054-.072-.023-.168.1-.168Z"
            fill="url(#A)"
          />
          <path
            d="M99.59 117.47c-.793-.009-1.501.001-2.295-.008.315.24.698.42 1.305.42.278 0 .744-.085 1.02-.266.102-.066.06-.149-.03-.146Z"
            fill="url(#B)"
          />
          <path
            d="M92.775 111.823c0 .259-.016.517-.034.775-.028.409-.007.838-.163 1.233a1.282 1.282 0 0 1-.727.735c-.293.111-.71.07-.985-.087a.284.284 0 0 1-.153-.271c.34-3.686.435-7.533.47-10.583 0-.097.11-.168.229-.149.447.069.945.436 1.125.744.213.361.238.774.238 1.174v6.429Z"
            fill="url(#C)"
          />
          <path
            d="M97.877 104.458c.035 2.687.223 6.256.471 9.694a.227.227 0 0 1-.064.178c-.165.163-.436.164-.645.027-.25-.166-.337-.708-.344-1.009-.09-3.967-.11-6.13-.11-8.57 0-.299.689-.518.691-.32Z"
            fill="url(#D)"
          />
          <path
            d="m90.776 98.66-1.333-.012a.77.77 0 0 1-.767-.77v-3.169c0-.085.07-.154.155-.154h.65c.085 0 .153.069.154.153l.002 1.915c0 .17.138.308.308.308l.834.004c.17 0 .307.138.307.308v1.11c0 .17-.139.308-.31.307Z"
            fill="url(#E)"
          />
          <path
            d="m98.71 98.66.77-.012a.77.77 0 0 0 .766-.77v-3.169a.154.154 0 0 0-.155-.154h-.503a.154.154 0 0 0-.154.153l-.002 1.915c0 .17-.138.308-.308.308l-.416.004a.308.308 0 0 0-.308.308v1.11c0 .17.14.308.31.307Z"
            fill="url(#F)"
          />
          <path
            d="M92.315 100.001h-2.459a.062.062 0 0 1-.06-.063v-.31c0-.037.029-.065.063-.063l2.46.1c.032 0 .057.028.057.062v.212a.062.062 0 0 1-.06.063v-.001Z"
            fill="url(#G)"
          />
          <path
            d="M97.708 100.001h1.384c.02 0 .035-.028.035-.063v-.31c0-.037-.016-.065-.036-.064l-1.274.1c-.019.002-.143.037-.143.119v.156c0 .034.016.062.035.062Z"
            fill="url(#H)"
          />
          <path
            d="M90.341 101.3c.986-.01 1.867.01 2.853 0-.246.159-1.046.322-1.582.322-1.007 0-1.418-.175-1.418-.266 0-.059.1-.055.147-.056Z"
            fill="url(#I)"
          />
          <path
            d="M98.632 101.297h-1.73c.25.2.61.274.943.28.383.006.723-.096.833-.187.038-.031.042-.095-.046-.093Z"
            fill="url(#J)"
          />
          <path
            d="M89.735 115.226c1.161-.012 2.197.012 3.358-.001-.605.335-1.23.404-1.861.404-1.186 0-1.67-.22-1.67-.334 0-.073.117-.068.173-.069Z"
            fill="url(#K)"
          />
          <path
            d="M99.213 115.226c-.783-.012-1.482.012-2.265-.001.41.335.83.404 1.256.404.8 0 1.126-.22 1.126-.334 0-.073-.079-.068-.116-.069Z"
            fill="url(#L)"
          />
          <path
            d="M91.386 118.991a.609.609 0 0 1 .08.336c-.047.813-.354 1.724-1.337 2.121-.535.216-1.368.084-1.582.015-.259-.084-.457-.215-.481-.559-.016-.234.16-.47.292-.63.132-.16.794-.822 1.006-1.129.15-.217.443-.387.706-.411.63-.057 1.15.013 1.316.256v.001Z"
            fill="url(#M)"
          />
          <path
            d="M98.9 119.631c.035.245.27 1.275.45 1.504.292.374.608.355.95.351.246-.004.665-.086.808-.287.118-.165.077-.427-.048-.577-.431-.512-.654-.791-1.076-1.24-.155-.165-.39-.542-.644-.497-.398.072-.48.477-.44.746Z"
            fill="url(#N)"
          />
          <path
            d="M98.647 123.848c.995 0 1.947 0 2.92-.004.084 0 .151.099-.117.201-.349.135-.835.241-1.176.24-.58-.003-1.058-.147-1.627-.437Z"
            fill="url(#O)"
          />
          <path
            d="m61.666 135.669-.042-.003a6.574 6.574 0 0 1-1.914-.486c-.88-.374-.976-1.099-.976-1.394v-.963c0-.388.148-.761.395-1.049a3.932 3.932 0 0 1-.425-.54c-1.061-1.625-.363-3.454.154-4.195.348-.497.919-1.067 1.47-1.619.422-.422.858-.858 1.08-1.149.151-.201.315-.444.478-.707l.001-.299v-.869c0-1.068.26-1.728 1.689-2.363.216-.096.436-.193.644-.279.784-2.217 2.57-8.11 2.505-15.553-.024-2.748-.286-5.595-.728-7.97h-.834a2.131 2.131 0 0 1-.708-4.141c.073-.546.432-1.099.979-1.445a2.03 2.03 0 0 1 .261-3.02c-.835-1.866-2.394-5.43-3.114-7.632-.384-1.173-.068-2.103.966-2.842 1.071-.766 2.579-1.405 4.253-1.816.01-.08.025-.161.044-.239l-.653-.331.63-1.563-2.037.583V66.09l2.037.583-.63-1.562.936-.476a6.41 6.41 0 0 1 1.134-.418l-.001-.076a2.377 2.377 0 0 1 2.374-2.374 2.377 2.377 0 0 1 2.375 2.374c0 .025 0 .05-.002.076.66.184 1.067.385 1.134.419l.937.476-.63 1.561 2.036-.583v7.696l-2.036-.583.63 1.563-.654.331c.02.078.034.158.044.239 1.674.41 3.182 1.051 4.253 1.816 1.034.739 1.35 1.669.966 2.842-.715 2.186-2.257 5.716-3.097 7.592a2.031 2.031 0 0 1 .287 3.09c.523.348.864.885.935 1.416a2.131 2.131 0 0 1-.71 4.141h-.832c-.44 2.376-.703 5.224-.727 7.97-.065 7.442 1.721 13.336 2.505 15.554.207.086.428.183.643.279 1.428.636 1.69 1.294 1.689 2.363v.869c0 .104 0 .204.002.299.163.264.327.506.478.707.221.292.657.728 1.079 1.15.551.551 1.122 1.122 1.47 1.619.517.741 1.215 2.57.155 4.194a3.861 3.861 0 0 1-.425.54c.246.288.395.661.395 1.049v.964c0 .295-.095 1.02-.975 1.393a6.572 6.572 0 0 1-1.915.486l-.042.003H61.665l.001-.002Z"
            fill="#fff"
          />
          <path
            d="M81.798 131.792s1.116-.127 1.808-1.185c.7-1.073.235-2.382-.135-2.911-.546-.781-1.95-1.977-2.523-2.734-.21-.279-.429-.609-.627-.94a.577.577 0 0 1-.081-.286 22.94 22.94 0 0 1-.005-.471v-.824c0-.64.027-.901-1.008-1.361-.405-.18-.798-.351-1.077-.446h.001c-.706-1.88-2.824-8.22-2.751-16.444.024-2.739.29-6.14.934-9.105h1.77c.54 0 .983-.443.983-.984v-.005a.986.986 0 0 0-.983-.983h-.422v-.819c0-.27-.34-.86-1.087-.86h-.614v-1.296h.447a.888.888 0 0 0 0-1.775h-.447s2.639-5.734 3.618-8.727c.236-.72.071-1.115-.543-1.554-1.276-.913-3.16-1.558-5-1.872a.872.872 0 0 0 .282-.636c0-.495-.432-.901-.96-.901h-.166c.875-.184 1.41-.456 1.41-.456l-1.115-2.764 2.832.811v-4.656l-2.832.81 1.116-2.763s-.864-.44-2.195-.578a1.229 1.229 0 1 0-1.585 0c-1.332.14-2.195.578-2.195.578l1.115 2.764-2.832-.811v4.656l2.832-.81-1.115 2.763s.535.272 1.41.456h-.166c-.528 0-.96.406-.96.901a.87.87 0 0 0 .281.636c-1.84.314-3.723.96-5 1.872-.613.439-.778.835-.542 1.554.98 2.993 3.618 8.727 3.618 8.727h-.374a.888.888 0 0 0 0 1.775h.374v1.297h-.615c-.746 0-1.087.59-1.087.86v.818h-.423a.986.986 0 0 0-.983.983v.005c0 .54.442.983.983.983l1.772.001c.643 2.964.91 6.366.934 9.105.072 8.224-2.046 14.563-2.752 16.443-.28.096-.673.266-1.077.446-1.035.46-1.008.721-1.008 1.361v.824c0 .168-.002.327-.005.472a.582.582 0 0 1-.08.285c-.2.331-.418.662-.628.94-.573.758-1.977 1.952-2.523 2.734-.37.529-.836 1.838-.134 2.911a2.708 2.708 0 0 0 1.807 1.185v.13l-.307.111-.973.35a.502.502 0 0 0-.31.439v.964c0 .18.11.268.276.339.809.343 1.552.398 1.552.398H81.56s.743-.055 1.551-.398c.167-.071.277-.159.277-.339v-.964a.5.5 0 0 0-.31-.439l-.973-.35-.307-.111v-.13.001Z"
            fill="#000"
          />
          <path
            d="M67.516 68.367a.096.096 0 0 0-.123.091v2.991c0 .069.097.084.117.019l.578-1.9a.6.6 0 0 1 .423-.398l.845-.17c.057-.014.057-.096-.001-.11l-1.84-.523Z"
            fill="url(#P)"
          />
          <path
            d="m70.225 67.903.188-1.439a.802.802 0 0 1 .194-.433c.16-.178.353-.327.567-.437.018-.01.012-.037-.008-.037a4.904 4.904 0 0 0-1.771.356.097.097 0 0 0-.053.126c.302.746.626 1.524.773 1.878.023.053.102.044.109-.013Z"
            fill="url(#Q)"
          />
          <path
            d="M70.84 74.378c-.519-.01-1.094-.21-1.45-.365a.093.093 0 0 1-.046-.125c.277-.597.637-1.653.783-2.096.008-.023.042-.015.04.009a77.58 77.58 0 0 0-.209 1.728.28.28 0 0 0 .112.256c.133.097.371.292.776.563.013.008.008.03-.007.03Z"
            fill="url(#R)"
          />
          <path
            d="M73.5 65.811c.105.014.239.048.353.097a.1.1 0 0 1 .053.128c-.293.726-.478 1.307-.795 2.088-.009.022-.04.011-.036-.011.158-.844.26-1.516.404-2.286.002-.01.01-.018.02-.017v.001Z"
            fill="url(#S)"
          />
          <path
            d="M78.443 78.916c-.033.073-.46.298-1.333.354-.495.033-1.359.076-2-.1-.113-.031-.144-.08.013-.102.271-.038.94-.056 1.91-.142.948-.084 1.463-.126 1.41-.01Z"
            fill="url(#T)"
          />
          <path
            d="M61.544 132.58c1.894 0 3.91-.004 5.925-.004a9.263 9.263 0 0 1-2.116.518c-.487.066-1.052.104-1.64.099a7.4 7.4 0 0 1-1.758-.209 3.951 3.951 0 0 1-.545-.195c-.18-.1-.155-.21.134-.21v.001Z"
            fill="url(#U)"
          />
          <path
            d="M78.164 132.576c1.31 0 2.561 0 3.842-.005.11 0 .197.123-.154.251-.46.168-1.098.3-1.547.299-.762-.004-1.39-.183-2.14-.545Z"
            fill="url(#V)"
          />
          <path
            d="M67.287 88.698h3.375a4.252 4.252 0 0 1-1.97.488c-.834 0-1.437-.33-1.5-.368-.075-.045-.06-.12.095-.12Z"
            fill="url(#W)"
          />
          <path
            d="M75.898 88.698h-1.78c.306.255.681.397 1.038.397.44 0 .79-.248.816-.294.025-.049.009-.103-.074-.103Z"
            fill="url(#X)"
          />
          <path
            d="M66.791 91.871h3.64c-.526.288-1.283.395-1.985.403-.804.009-1.532-.134-1.764-.264-.08-.045-.077-.142.11-.139Z"
            fill="url(#Y)"
          />
          <path
            d="M76.558 91.871h-2.44c.352.288.86.395 1.331.403.54.009 1.02-.139 1.175-.269.054-.045.06-.137-.065-.134Z"
            fill="url(#Z)"
          />
          <path
            d="M65.505 93.527c1.62-.013 3.068.013 4.688-.001-.846.357-1.718.431-2.599.431-1.655 0-2.33-.234-2.33-.356 0-.078.163-.074.241-.074Z"
            fill="url(#aa)"
          />
          <path
            d="M77.761 93.527c-1.191-.013-2.256.013-3.447-.001.622.358 1.264.432 1.911.432 1.218 0 1.715-.244 1.715-.366 0-.064-.121-.065-.178-.065Z"
            fill="url(#ab)"
          />
          <path
            d="M68.406 96.983c.69 3.803.887 7.003.745 10.48-.085 2.103-.333 4.216-.649 6.295-.307 2.015-.64 3.7-1.354 5.906.376.464 1.087.39 1.639.172.54-.214.855-.638.98-1.143.142-.577.207-1.222.248-1.817.258-3.787.544-7.554.356-11.348-.086-1.754-.26-5.624-.769-7.39-.18-.622-.57-.994-1.196-1.156v.001Z"
            fill="url(#ac)"
          />
          <path
            d="M75.126 119.378c-.714-3.548-.89-5.332-1.209-8.177-.278-2.487-.376-8.865.513-13.236.437.386.374.834.28 1.505-.427 3.03-.314 6.005-.216 8.814.072 2.061.828 8.281 2.03 11.435.104.276-.537.338-.758.255-.276-.102-.581-.306-.639-.595v-.001Z"
            fill="url(#ad)"
          />
          <path
            d="M64.881 121.507c1.783-.012 3.375.001 5.157-.011-.706.32-1.256.641-2.944.641-.624 0-1.61-.129-2.228-.371-.229-.089-.186-.262.016-.258v-.001Z"
            fill="url(#ae)"
          />
          <path
            d="M78.666 121.507c-1.245-.012-2.356.001-3.6-.011.493.32 1.093.561 2.046.561.436 0 1.167-.112 1.6-.354.159-.089.094-.199-.046-.195v-.001Z"
            fill="url(#af)"
          />
          <path
            d="M67.257 128.084c-.89 1.005-1.957 1.562-3.958 1.205-.408-.073-.836-.262-1.02-.633-.199-.403.028-.863.262-1.247.365-.599.98-1.16 1.795-2.204.1-.127.483-.953 2.527-.844 1.345.072 1.228.894 1.23 1.029.013 1.181-.255 2.038-.836 2.693v.001Z"
            fill="url(#ag)"
          />
          <path
            d="M78.565 124.613c.391.18.71.718.976 1.06l1.168 1.504c.173.224.336.458.446.719.304.718-.164 1.202-.585 1.281-1.011.192-1.933.089-2.413-.39-.435-.434-.596-1.375-.669-1.716-.145-.675-.35-1.437-.19-2.131.107-.469.805-.54 1.267-.327Z"
            fill="url(#ah)"
          />
          <path
            d="M73.451 73.717a.25.25 0 0 1-.053.182c-.11.14-.22.243-.429.421.179-.036.765-.198.994-.301a.097.097 0 0 0 .05-.122c-.257-.682-.452-1.107-.683-1.738-.008-.02-.036-.015-.034.006.06.515.102 1.043.154 1.552h.001Z"
            fill="url(#ai)"
          />
          <path
            d="M75.82 68.514c-.098.877-.327 2.142-.378 2.457a.143.143 0 0 1-.072.108l-.327.17s.359.113.633.197c.094.03.188-.045.188-.166-.002-.788 0-1.611 0-2.76 0-.033-.04-.04-.043-.007v.001Z"
            fill="url(#aj)"
          />
          <path
            d="M70.788 75.24h-1.035c-.108.007-.27 0-.277.102-.004.077.135.276.521.305.61.047.913-.255.913-.337 0-.053-.07-.07-.122-.07Z"
            fill="url(#ak)"
          />
          <path
            d="M73.628 75.24c.166 0 .176.06.16.11-.039.13-.247.24-.473.24-.34 0-.606-.192-.605-.273 0-.059.05-.075.208-.075l.71-.003v.001Z"
            fill="url(#al)"
          />
          <path
            d="M68.383 87.442c.332.173.809.223 1.139.078.158-.07.243-.274.224-.45-.278-2.658-.523-3.955-.74-6.323a.573.573 0 0 0-.517-.52c-.792-.086-1.483-.068-2.274-.096-.233-.008-.407.263-.339.49.747 2.495 1.334 3.939 2.185 6.466a.725.725 0 0 0 .321.355h.001Z"
            fill="url(#am)"
          />
          <path
            d="M68.19 78.455a.947.947 0 0 0 .674-.34 6.04 6.04 0 0 0 .438-.594c.096-.15.228-.44.171-.505-.102-.116-.35-.076-.498-.033-.838.246-1.852.598-2.57 1.096-.07.048-.092.151-.036.217.063.071.16.098.254.118.33.07 1.076.072 1.567.043v-.002Z"
            fill="url(#an)"
          />
          <path
            d="M71.174 79.118c-1.006-.012-4.337-.045-6.46-.262-.333-.035-.264.079-.213.127a.857.857 0 0 0 .258.126c.618.186 1.098.283 2.146.348 1.543.095 3.363-.042 4.279-.238.137-.03.26-.098-.01-.1Z"
            fill="url(#ao)"
          />
          <path
            d="M75.158 77.197c.464.152 1.631.584 1.585.819-.015.074-.033.137-.196.166-.571.1-.897.08-1.104-.036-.154-.086-.302-.237-.431-.357-.13-.121-.383-.389-.382-.535.002-.224.422-.092.527-.057Z"
            fill="url(#ap)"
          />
          <path
            d="M75.89 80.409c.022-.133.071-.258.183-.333a.84.84 0 0 1 .383-.112c.209-.022.575-.03.784-.016.152.011.337.028.389.171.03.083-.01.22-.034.304-.1.338-1.45 4.663-2.122 6.665-.052.157-.267.334-.463.325-.116-.004-.199-.047-.256-.16-.056-.108.056-.708.109-.967.288-1.42.937-5.355 1.025-5.877h.001Z"
            fill="url(#aq)"
          />
          <path
            d="M70.191 91.074a32.89 32.89 0 0 0-.152-.454.193.193 0 0 0-.184-.13c-.565.005-1.068.002-1.64.008a.073.073 0 0 0-.07.071c.001.185-.004.326-.002.514 0 .029.022.054.05.054.563.003 1.669-.001 1.954-.002.032 0 .053-.03.043-.061h.001Z"
            fill="url(#ar)"
          />
          <path
            d="M74.12 91.074c.032-.098.096-.294.152-.454a.194.194 0 0 1 .184-.13c.5.006.465.008.664.008.038 0 .07.032.07.07-.001.186.003.327 0 .515 0 .029-.022.053-.05.053l-.976-.001a.046.046 0 0 1-.044-.062Z"
            fill="url(#as)"
          />
          <path
            d="M70.97 64.448a.307.307 0 0 1-.067-.007c-.15-.032-.179-.203-.184-.255-.03-.294.118-.827.647-1.003a.265.265 0 0 1 .08-.013c.04 0 .075.01.093.03.01.01.014.022.014.036 0 .017-.018.037-.052.073-.108.117-.363.392-.296.96.001.015-.015.058-.05.097a.242.242 0 0 1-.185.082Z"
            fill="url(#at)"
          />
          <path
            d="M72.467 64.696c-.022.012-.083-.005-.122-.05a.325.325 0 0 1-.06-.112c-.014-.057-.002-.104.019-.129.012-.015.046-.047.047-.048.058-.07.142-.168.203-.382.006-.017.015-.026.027-.023.022.005.053.053.071.167a.819.819 0 0 1-.186.577Z"
            fill="url(#au)"
          />
        </g>
        <path
          d="M73.971 24.785c-2.181.916-2.673 3.452-3.23 5.494-.8.076-1.495.284-2.385.72l-.018.025c.608-.098 1.62-.048 2.15.2-.337 1.37-.616 2.828-1.348 3.994-.828 1.423-2.96 1.576-3.965.257-.976-1.218-.276-3.338 1.169-3.867-1.605.497-2.497 2.7-1.574 4.149.976 1.597 3.5 1.915 4.941.784 1.387-1.184 1.608-3.113 1.979-4.775.034-.153.066-.306.097-.458 2.184-.095 4.8.084 6.307-1.871 2.284-2.952-.91-6.286-4.123-4.652Zm2.431 4.576c-1.313.72-2.91.715-4.383.892.24-1.034.529-2.066 1-2.994.657-1.303 2.483-2.15 3.81-1.408 1.376.831.82 2.828-.427 3.51Z"
          fill="#9042AE"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={63.344}
          y1={-23.285}
          x2={136.752}
          y2={87.616}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#9245B0" />
          <stop offset={0.302} stopColor="#8B3DAA" />
          <stop offset={0.474} stopColor="#9245B0" />
          <stop offset={0.641} stopColor="#6F3386" />
          <stop offset={0.823} stopColor="#9245B0" />
          <stop offset={0.957} stopColor="#9245B0" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={41.646}
          y1={91.519}
          x2={47.793}
          y2={91.519}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={46.483}
          y1={98.246}
          x2={49.317}
          y2={98.246}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={47.576}
          y1={94.093}
          x2={50.236}
          y2={94.093}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={51.25}
          y1={96.714}
          x2={52.413}
          y2={96.714}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={46.018}
          y1={105.368}
          x2={55.031}
          y2={105.368}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={48.596}
          y1={100.383}
          x2={54.331}
          y2={100.383}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="k"
          x1={48.404}
          y1={109.996}
          x2={54.813}
          y2={109.996}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={51.566}
          y1={112.572}
          x2={53.867}
          y2={112.572}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={48.383}
          y1={114.748}
          x2={52.573}
          y2={114.748}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={49.013}
          y1={118.11}
          x2={54.425}
          y2={118.11}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="o"
          x1={49.035}
          y1={122.553}
          x2={54.964}
          y2={122.553}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="p"
          x1={50.246}
          y1={113.909}
          x2={51.993}
          y2={113.909}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.18} stopColor="#020203" />
          <stop offset={0.33} stopColor="#0A0B0D" />
          <stop offset={0.47} stopColor="#181A1E" />
          <stop offset={0.6} stopColor="#2C2F35" />
          <stop offset={0.72} stopColor="#454B54" />
          <stop offset={0.84} stopColor="#646C7A" />
          <stop offset={0.95} stopColor="#8893A6" />
          <stop offset={1} stopColor="#9AA7BC" />
        </linearGradient>
        <linearGradient
          id="q"
          x1={38.37}
          y1={96.704}
          x2={51.292}
          y2={100.325}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="r"
          x1={42.337}
          y1={91.593}
          x2={46.522}
          y2={91.593}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="s"
          x1={40.037}
          y1={102.58}
          x2={41.441}
          y2={102.58}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="t"
          x1={42.075}
          y1={107.557}
          x2={52.792}
          y2={107.557}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="u"
          x1={42.994}
          y1={114.787}
          x2={50.88}
          y2={114.787}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="v"
          x1={41.584}
          y1={117.978}
          x2={49.093}
          y2={117.978}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="w"
          x1={40.778}
          y1={122.584}
          x2={49.561}
          y2={122.584}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="x"
          x1={43.998}
          y1={113.909}
          x2={47.341}
          y2={113.909}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="y"
          x1={42.802}
          y1={95.683}
          x2={45.519}
          y2={96.359}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="z"
          x1={89.245}
          y1={117.688}
          x2={95.943}
          y2={117.688}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="A"
          x1={87.431}
          y1={124.098}
          x2={95.89}
          y2={124.098}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="B"
          x1={94.672}
          y1={117.671}
          x2={99.474}
          y2={117.671}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="C"
          x1={90.711}
          y1={109.051}
          x2={94.564}
          y2={109.051}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="D"
          x1={95.906}
          y1={109.42}
          x2={98.249}
          y2={109.42}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="E"
          x1={88.676}
          y1={96.608}
          x2={93.174}
          y2={96.608}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="F"
          x1={96.37}
          y1={96.608}
          x2={100.087}
          y2={96.608}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="G"
          x1={89.795}
          y1={99.784}
          x2={94.614}
          y2={99.784}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="H"
          x1={96.075}
          y1={99.784}
          x2={99.001}
          y2={99.784}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="I"
          x1={90.194}
          y1={101.459}
          x2={95.794}
          y2={101.459}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="J"
          x1={94.919}
          y1={101.437}
          x2={98.549}
          y2={101.437}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="K"
          x1={89.562}
          y1={115.426}
          x2={96.153}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="L"
          x1={94.328}
          y1={115.426}
          x2={99.124}
          y2={115.426}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="M"
          x1={88.065}
          y1={120.141}
          x2={94.415}
          y2={120.141}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="N"
          x1={96.375}
          y1={120.185}
          x2={100.981}
          y2={120.185}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="O"
          x1={95.352}
          y1={124.065}
          x2={101.383}
          y2={124.065}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="P"
          x1={67.393}
          y1={69.936}
          x2={71.137}
          y2={69.936}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Q"
          x1={69.335}
          y1={66.754}
          x2={72.789}
          y2={66.754}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="R"
          x1={69.335}
          y1={73.078}
          x2={72.17}
          y2={73.078}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="S"
          x1={73.445}
          y1={65.361}
          x2={74.61}
          y2={65.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="T"
          x1={76.532}
          y1={78.757}
          x2={76.594}
          y2={79.352}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="U"
          x1={61.296}
          y1={132.885}
          x2={72.819}
          y2={132.885}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="V"
          x1={79.905}
          y1={132.465}
          x2={79.984}
          y2={133.183}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="W"
          x1={67.147}
          y1={88.942}
          x2={73.707}
          y2={88.942}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="X"
          x1={74.942}
          y1={88.621}
          x2={75.027}
          y2={89.132}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="Y"
          x1={66.632}
          y1={92.073}
          x2={73.724}
          y2={92.073}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="Z"
          x1={75.241}
          y1={91.793}
          x2={75.307}
          y2={92.318}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="aa"
          x1={65.263}
          y1={93.74}
          x2={74.466}
          y2={93.74}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ab"
          x1={75.916}
          y1={93.44}
          x2={75.97}
          y2={94.009}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ac"
          x1={67.147}
          y1={108.495}
          x2={73.278}
          y2={108.495}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ad"
          x1={74.965}
          y1={93.713}
          x2={79.573}
          y2={94.461}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ae"
          x1={64.712}
          y1={121.816}
          x2={74.656}
          y2={121.816}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="af"
          x1={76.718}
          y1={121.387}
          x2={76.805}
          y2={122.119}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ag"
          x1={62.203}
          y1={126.874}
          x2={73.2}
          y2={126.874}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ah"
          x1={79.013}
          y1={123.578}
          x2={82.156}
          y2={126.944}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ai"
          x1={73.433}
          y1={71.727}
          x2={74.714}
          y2={72.514}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="aj"
          x1={75.406}
          y1={67.921}
          x2={76.633}
          y2={68.354}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="ak"
          x1={69.475}
          y1={75.445}
          x2={72.152}
          y2={75.445}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="al"
          x1={71.518}
          y1={75.415}
          x2={73.7}
          y2={75.415}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="am"
          x1={65.862}
          y1={83.869}
          x2={73.119}
          y2={83.869}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="an"
          x1={66.337}
          y1={77.706}
          x2={72.217}
          y2={77.706}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ao"
          x1={64.457}
          y1={79.169}
          x2={77.296}
          y2={79.169}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="ap"
          x1={72.307}
          y1={77.688}
          x2={76.561}
          y2={77.688}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="aq"
          x1={71.549}
          y1={83.677}
          x2={77.39}
          y2={83.677}
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={0.2} stopColor="#020203" />
          <stop offset={0.36} stopColor="#0A0B0D" />
          <stop offset={0.5} stopColor="#181A1E" />
          <stop offset={0.64} stopColor="#2C2F35" />
          <stop offset={0.77} stopColor="#454B54" />
          <stop offset={0.9} stopColor="#636B79" />
          <stop offset={1} stopColor="#818C9E" />
        </linearGradient>
        <linearGradient
          id="ar"
          x1={67.55}
          y1={90.814}
          x2={72.017}
          y2={90.814}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="as"
          x1={74.592}
          y1={90.366}
          x2={74.921}
          y2={91.063}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <linearGradient
          id="at"
          x1={70.714}
          y1={63.809}
          x2={72.28}
          y2={63.809}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3C3D9" />
          <stop offset={0.1} stopColor="#8995A6" />
          <stop offset={0.21} stopColor="#656E7A" />
          <stop offset={0.32} stopColor="#454C54" />
          <stop offset={0.44} stopColor="#2C3035" />
          <stop offset={0.56} stopColor="#181B1E" />
          <stop offset={0.69} stopColor="#0A0B0D" />
          <stop offset={0.83} stopColor="#020203" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="au"
          x1={72.446}
          y1={63.807}
          x2={72.895}
          y2={64.096}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.12} stopColor="#F1F1F1" />
          <stop offset={0.302} stopColor="#CECECE" />
          <stop offset={0.474} stopColor="#F1F1F1" />
          <stop offset={0.641} stopColor="#DFDFDF" />
          <stop offset={0.823} stopColor="#F1F1F1" />
          <stop offset={0.957} stopColor="#BFBFBF" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h143.327v160H0z" />
        </clipPath>
        <filter
          id="c"
          x={12.748}
          y={14.126}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={8} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="shape" result="effect1_innerShadow_144_25573" />
        </filter>
      </defs>
    </svg>
  ),
  // ----------------------------------------------------------PROSPERITY:SVG-------------------------------------------------------------------------------------------------
  promptingsProsperity: (width: number, height: number) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 144 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_665_82226)">
        <path
          d="M139.276 89.6624C140.782 88.7922 142.139 87.7345 143.327 86.5308V111.113C143.327 117.463 139.937 123.33 134.437 126.507L80.5496 157.618C75.0519 160.793 68.2735 160.793 62.7777 157.618L8.88988 126.507C3.39019 123.331 0 117.463 0 111.113V86.5308C1.18795 87.7365 2.54758 88.7942 4.05126 89.6624L62.0949 123.174C68.013 126.595 75.3143 126.595 81.2363 123.174L139.278 89.6624H139.276Z"
          fill="#303644"
        />
        <path
          d="M143.327 48.8874V81.5066C142.139 82.7123 140.782 83.7681 139.276 84.6383L81.2343 118.149C75.3143 121.571 68.013 121.571 62.093 118.149L4.05126 84.6403C2.54758 83.7701 1.18795 82.7123 0 81.5086V48.8894C0 42.5372 3.39019 36.6685 8.88987 33.4934L62.7777 2.38181C68.2754 -0.793286 75.0538 -0.793286 80.5515 2.38181L134.439 33.4954C139.939 36.6705 143.329 42.5372 143.329 48.8874H143.327Z"
          fill="#5CA0B5"
        />
        <g filter="url(#filter0_i_665_82226)">
          <path
            d="M130.582 105.968V54.0338C130.582 49.0531 127.923 44.4513 123.612 41.961L78.6354 15.9939C74.3217 13.5035 69.0075 13.5035 64.6938 15.9939L19.7176 41.959C15.4039 44.4494 12.7477 49.0512 12.7477 54.0319V105.966C12.7477 110.947 15.4039 115.549 19.7176 118.039L64.6938 144.006C69.0075 146.496 74.3217 146.496 78.6354 144.006L123.612 118.039C127.925 115.549 130.582 110.947 130.582 105.966V105.968Z"
            fill="white"
          />
        </g>
        <mask
          id="mask0_665_82226"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={12}
          y={14}
          width={119}
          height={132}
        >
          <path
            d="M130.582 105.968V54.0338C130.582 49.0531 127.923 44.4513 123.612 41.961L78.6354 15.9939C74.3217 13.5035 69.0075 13.5035 64.6938 15.9939L19.7176 41.959C15.4039 44.4494 12.7477 49.0512 12.7477 54.0319V105.966C12.7477 110.947 15.4039 115.549 19.7176 118.039L64.6938 144.006C69.0075 146.496 74.3217 146.496 78.6354 144.006L123.612 118.039C127.925 115.549 130.582 110.947 130.582 105.966V105.968Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_665_82226)">
          <path
            d="M37.3309 59V52H40.5309C41.1709 52 41.7209 52.1033 42.1809 52.31C42.6475 52.5167 43.0075 52.8167 43.2609 53.21C43.5142 53.5967 43.6409 54.0567 43.6409 54.59C43.6409 55.1167 43.5142 55.5733 43.2609 55.96C43.0075 56.3467 42.6475 56.6467 42.1809 56.86C41.7209 57.0667 41.1709 57.17 40.5309 57.17H38.4309L39.3109 56.31V59H37.3309ZM39.3109 56.52L38.4309 55.61H40.4109C40.8242 55.61 41.1309 55.52 41.3309 55.34C41.5375 55.16 41.6409 54.91 41.6409 54.59C41.6409 54.2633 41.5375 54.01 41.3309 53.83C41.1309 53.65 40.8242 53.56 40.4109 53.56H38.4309L39.3109 52.65V56.52Z"
            fill="#5CA0B5"
          />
          <path
            d="M44.6063 59V52H47.8063C48.4463 52 48.9963 52.1033 49.4563 52.31C49.9229 52.5167 50.2829 52.8167 50.5363 53.21C50.7896 53.5967 50.9163 54.0567 50.9163 54.59C50.9163 55.1167 50.7896 55.5733 50.5363 55.96C50.2829 56.34 49.9229 56.6333 49.4563 56.84C48.9963 57.04 48.4463 57.14 47.8063 57.14H45.7063L46.5863 56.31V59H44.6063ZM48.9363 59L47.1963 56.45H49.3063L51.0563 59H48.9363ZM46.5863 56.52L45.7063 55.61H47.6863C48.0996 55.61 48.4063 55.52 48.6063 55.34C48.8129 55.16 48.9163 54.91 48.9163 54.59C48.9163 54.2633 48.8129 54.01 48.6063 53.83C48.4063 53.65 48.0996 53.56 47.6863 53.56H45.7063L46.5863 52.65V56.52Z"
            fill="#5CA0B5"
          />
          <path
            d="M55.5386 59.14C54.9786 59.14 54.4619 59.05 53.9886 58.87C53.5153 58.69 53.1019 58.4367 52.7486 58.11C52.4019 57.7767 52.1319 57.39 51.9386 56.95C51.7453 56.51 51.6486 56.0267 51.6486 55.5C51.6486 54.9733 51.7453 54.49 51.9386 54.05C52.1319 53.61 52.4019 53.2267 52.7486 52.9C53.1019 52.5667 53.5153 52.31 53.9886 52.13C54.4619 51.95 54.9786 51.86 55.5386 51.86C56.1053 51.86 56.6219 51.95 57.0886 52.13C57.5619 52.31 57.9719 52.5667 58.3186 52.9C58.6653 53.2267 58.9353 53.61 59.1286 54.05C59.3286 54.49 59.4286 54.9733 59.4286 55.5C59.4286 56.0267 59.3286 56.5133 59.1286 56.96C58.9353 57.4 58.6653 57.7833 58.3186 58.11C57.9719 58.4367 57.5619 58.69 57.0886 58.87C56.6219 59.05 56.1053 59.14 55.5386 59.14ZM55.5386 57.5C55.8053 57.5 56.0519 57.4533 56.2786 57.36C56.5119 57.2667 56.7119 57.1333 56.8786 56.96C57.0519 56.78 57.1853 56.5667 57.2786 56.32C57.3786 56.0733 57.4286 55.8 57.4286 55.5C57.4286 55.1933 57.3786 54.92 57.2786 54.68C57.1853 54.4333 57.0519 54.2233 56.8786 54.05C56.7119 53.87 56.5119 53.7333 56.2786 53.64C56.0519 53.5467 55.8053 53.5 55.5386 53.5C55.2719 53.5 55.0219 53.5467 54.7886 53.64C54.5619 53.7333 54.3619 53.87 54.1886 54.05C54.0219 54.2233 53.8886 54.4333 53.7886 54.68C53.6953 54.92 53.6486 55.1933 53.6486 55.5C53.6486 55.8 53.6953 56.0733 53.7886 56.32C53.8886 56.5667 54.0219 56.78 54.1886 56.96C54.3619 57.1333 54.5619 57.2667 54.7886 57.36C55.0219 57.4533 55.2719 57.5 55.5386 57.5Z"
            fill="#5CA0B5"
          />
          <path
            d="M60.4656 59V52H62.0956L64.9956 56.76H64.1356L66.9556 52H68.5856L68.6056 59H66.7856L66.7656 54.77H67.0756L64.9656 58.31H64.0856L61.9156 54.77H62.2956V59H60.4656Z"
            fill="#5CA0B5"
          />
          <path
            d="M70.0066 59V52H73.2066C73.8466 52 74.3966 52.1033 74.8566 52.31C75.3233 52.5167 75.6833 52.8167 75.9366 53.21C76.19 53.5967 76.3167 54.0567 76.3167 54.59C76.3167 55.1167 76.19 55.5733 75.9366 55.96C75.6833 56.3467 75.3233 56.6467 74.8566 56.86C74.3966 57.0667 73.8466 57.17 73.2066 57.17H71.1066L71.9866 56.31V59H70.0066ZM71.9866 56.52L71.1066 55.61H73.0866C73.5 55.61 73.8066 55.52 74.0066 55.34C74.2133 55.16 74.3167 54.91 74.3167 54.59C74.3167 54.2633 74.2133 54.01 74.0066 53.83C73.8066 53.65 73.5 53.56 73.0866 53.56H71.1066L71.9866 52.65V56.52Z"
            fill="#5CA0B5"
          />
          <path
            d="M78.5963 59V53.57H76.4463V52H82.7163V53.57H80.5763V59H78.5963Z"
            fill="#5CA0B5"
          />
          <path d="M83.4539 59V52H85.4339V59H83.4539Z" fill="#5CA0B5" />
          <path
            d="M86.8426 59V52H88.4726L92.3326 56.66H91.5626V52H93.5026V59H91.8726L88.0126 54.34H88.7826V59H86.8426Z"
            fill="#5CA0B5"
          />
          <path
            d="M98.3992 59.14C97.8459 59.14 97.3326 59.0533 96.8592 58.88C96.3859 58.7 95.9759 58.4467 95.6292 58.12C95.2892 57.7933 95.0226 57.41 94.8292 56.97C94.6359 56.5233 94.5392 56.0333 94.5392 55.5C94.5392 54.9667 94.6359 54.48 94.8292 54.04C95.0226 53.5933 95.2926 53.2067 95.6392 52.88C95.9859 52.5533 96.3959 52.3033 96.8692 52.13C97.3492 51.95 97.8726 51.86 98.4392 51.86C99.0992 51.86 99.6892 51.97 100.209 52.19C100.729 52.41 101.159 52.7267 101.499 53.14L100.239 54.28C99.9992 54.02 99.7392 53.8267 99.4592 53.7C99.1859 53.5667 98.8792 53.5 98.5392 53.5C98.2392 53.5 97.9659 53.5467 97.7192 53.64C97.4726 53.7333 97.2626 53.87 97.0892 54.05C96.9159 54.2233 96.7792 54.4333 96.6792 54.68C96.5859 54.92 96.5392 55.1933 96.5392 55.5C96.5392 55.7933 96.5859 56.0633 96.6792 56.31C96.7792 56.5567 96.9159 56.77 97.0892 56.95C97.2626 57.1233 97.4692 57.26 97.7092 57.36C97.9559 57.4533 98.2259 57.5 98.5192 57.5C98.8126 57.5 99.0992 57.4533 99.3792 57.36C99.6592 57.26 99.9426 57.0933 100.229 56.86L101.339 58.25C100.939 58.5367 100.476 58.7567 99.9492 58.91C99.4226 59.0633 98.9059 59.14 98.3992 59.14ZM99.5892 57.99V55.35H101.339V58.25L99.5892 57.99Z"
            fill="#5CA0B5"
          />
          <path
            d="M105.055 59.14C104.481 59.14 103.928 59.07 103.395 58.93C102.868 58.7833 102.438 58.5967 102.105 58.37L102.755 56.91C103.068 57.11 103.428 57.2767 103.835 57.41C104.248 57.5367 104.658 57.6 105.065 57.6C105.338 57.6 105.558 57.5767 105.725 57.53C105.891 57.4767 106.011 57.41 106.085 57.33C106.165 57.2433 106.205 57.1433 106.205 57.03C106.205 56.87 106.131 56.7433 105.985 56.65C105.838 56.5567 105.648 56.48 105.415 56.42C105.181 56.36 104.921 56.3 104.635 56.24C104.355 56.18 104.071 56.1033 103.785 56.01C103.505 55.9167 103.248 55.7967 103.015 55.65C102.781 55.4967 102.591 55.3 102.445 55.06C102.298 54.8133 102.225 54.5033 102.225 54.13C102.225 53.71 102.338 53.33 102.565 52.99C102.798 52.65 103.145 52.3767 103.605 52.17C104.065 51.9633 104.638 51.86 105.325 51.86C105.785 51.86 106.235 51.9133 106.675 52.02C107.121 52.12 107.518 52.27 107.865 52.47L107.255 53.94C106.921 53.76 106.591 53.6267 106.265 53.54C105.938 53.4467 105.621 53.4 105.315 53.4C105.041 53.4 104.821 53.43 104.655 53.49C104.488 53.5433 104.368 53.6167 104.295 53.71C104.221 53.8033 104.185 53.91 104.185 54.03C104.185 54.1833 104.255 54.3067 104.395 54.4C104.541 54.4867 104.731 54.56 104.965 54.62C105.205 54.6733 105.465 54.73 105.745 54.79C106.031 54.85 106.315 54.9267 106.595 55.02C106.881 55.1067 107.141 55.2267 107.375 55.38C107.608 55.5267 107.795 55.7233 107.935 55.97C108.081 56.21 108.155 56.5133 108.155 56.88C108.155 57.2867 108.038 57.6633 107.805 58.01C107.578 58.35 107.235 58.6233 106.775 58.83C106.321 59.0367 105.748 59.14 105.055 59.14Z"
            fill="#5CA0B5"
          />
          <path
            d="M33.5816 71V65.57H31.4316V64H37.7016V65.57H35.5616V71H33.5816Z"
            fill="#5CA0B5"
          />
          <path
            d="M41.8716 71.14C41.3116 71.14 40.7949 71.05 40.3216 70.87C39.8483 70.69 39.4349 70.4367 39.0816 70.11C38.7349 69.7767 38.4649 69.39 38.2716 68.95C38.0783 68.51 37.9816 68.0267 37.9816 67.5C37.9816 66.9733 38.0783 66.49 38.2716 66.05C38.4649 65.61 38.7349 65.2267 39.0816 64.9C39.4349 64.5667 39.8483 64.31 40.3216 64.13C40.7949 63.95 41.3116 63.86 41.8716 63.86C42.4383 63.86 42.9549 63.95 43.4216 64.13C43.8949 64.31 44.3049 64.5667 44.6516 64.9C44.9983 65.2267 45.2683 65.61 45.4616 66.05C45.6616 66.49 45.7616 66.9733 45.7616 67.5C45.7616 68.0267 45.6616 68.5133 45.4616 68.96C45.2683 69.4 44.9983 69.7833 44.6516 70.11C44.3049 70.4367 43.8949 70.69 43.4216 70.87C42.9549 71.05 42.4383 71.14 41.8716 71.14ZM41.8716 69.5C42.1383 69.5 42.3849 69.4533 42.6116 69.36C42.8449 69.2667 43.0449 69.1333 43.2116 68.96C43.3849 68.78 43.5183 68.5667 43.6116 68.32C43.7116 68.0733 43.7616 67.8 43.7616 67.5C43.7616 67.1933 43.7116 66.92 43.6116 66.68C43.5183 66.4333 43.3849 66.2233 43.2116 66.05C43.0449 65.87 42.8449 65.7333 42.6116 65.64C42.3849 65.5467 42.1383 65.5 41.8716 65.5C41.6049 65.5 41.3549 65.5467 41.1216 65.64C40.8949 65.7333 40.6949 65.87 40.5216 66.05C40.3549 66.2233 40.2216 66.4333 40.1216 66.68C40.0283 66.92 39.9816 67.1933 39.9816 67.5C39.9816 67.8 40.0283 68.0733 40.1216 68.32C40.2216 68.5667 40.3549 68.78 40.5216 68.96C40.6949 69.1333 40.8949 69.2667 41.1216 69.36C41.3549 69.4533 41.6049 69.5 41.8716 69.5Z"
            fill="#5CA0B5"
          />
          <path
            d="M49.7088 71V64H52.9088C53.5488 64 54.0988 64.1033 54.5588 64.31C55.0255 64.5167 55.3855 64.8167 55.6388 65.21C55.8921 65.5967 56.0188 66.0567 56.0188 66.59C56.0188 67.1167 55.8921 67.5733 55.6388 67.96C55.3855 68.3467 55.0255 68.6467 54.5588 68.86C54.0988 69.0667 53.5488 69.17 52.9088 69.17H50.8088L51.6888 68.31V71H49.7088ZM51.6888 68.52L50.8088 67.61H52.7888C53.2021 67.61 53.5088 67.52 53.7088 67.34C53.9155 67.16 54.0188 66.91 54.0188 66.59C54.0188 66.2633 53.9155 66.01 53.7088 65.83C53.5088 65.65 53.2021 65.56 52.7888 65.56H50.8088L51.6888 64.65V68.52Z"
            fill="#5CA0B5"
          />
          <path
            d="M56.9842 71V64H60.1842C60.8242 64 61.3742 64.1033 61.8342 64.31C62.3009 64.5167 62.6609 64.8167 62.9142 65.21C63.1675 65.5967 63.2942 66.0567 63.2942 66.59C63.2942 67.1167 63.1675 67.5733 62.9142 67.96C62.6609 68.34 62.3009 68.6333 61.8342 68.84C61.3742 69.04 60.8242 69.14 60.1842 69.14H58.0842L58.9642 68.31V71H56.9842ZM61.3142 71L59.5742 68.45H61.6842L63.4342 71H61.3142ZM58.9642 68.52L58.0842 67.61H60.0642C60.4775 67.61 60.7842 67.52 60.9842 67.34C61.1909 67.16 61.2942 66.91 61.2942 66.59C61.2942 66.2633 61.1909 66.01 60.9842 65.83C60.7842 65.65 60.4775 65.56 60.0642 65.56H58.0842L58.9642 64.65V68.52Z"
            fill="#5CA0B5"
          />
          <path
            d="M67.9165 71.14C67.3565 71.14 66.8399 71.05 66.3665 70.87C65.8932 70.69 65.4799 70.4367 65.1265 70.11C64.7799 69.7767 64.5099 69.39 64.3165 68.95C64.1232 68.51 64.0265 68.0267 64.0265 67.5C64.0265 66.9733 64.1232 66.49 64.3165 66.05C64.5099 65.61 64.7799 65.2267 65.1265 64.9C65.4799 64.5667 65.8932 64.31 66.3665 64.13C66.8399 63.95 67.3565 63.86 67.9165 63.86C68.4832 63.86 68.9999 63.95 69.4665 64.13C69.9399 64.31 70.3499 64.5667 70.6965 64.9C71.0432 65.2267 71.3132 65.61 71.5065 66.05C71.7065 66.49 71.8065 66.9733 71.8065 67.5C71.8065 68.0267 71.7065 68.5133 71.5065 68.96C71.3132 69.4 71.0432 69.7833 70.6965 70.11C70.3499 70.4367 69.9399 70.69 69.4665 70.87C68.9999 71.05 68.4832 71.14 67.9165 71.14ZM67.9165 69.5C68.1832 69.5 68.4299 69.4533 68.6565 69.36C68.8899 69.2667 69.0899 69.1333 69.2565 68.96C69.4299 68.78 69.5632 68.5667 69.6565 68.32C69.7565 68.0733 69.8065 67.8 69.8065 67.5C69.8065 67.1933 69.7565 66.92 69.6565 66.68C69.5632 66.4333 69.4299 66.2233 69.2565 66.05C69.0899 65.87 68.8899 65.7333 68.6565 65.64C68.4299 65.5467 68.1832 65.5 67.9165 65.5C67.6499 65.5 67.3999 65.5467 67.1665 65.64C66.9399 65.7333 66.7399 65.87 66.5665 66.05C66.3999 66.2233 66.2665 66.4333 66.1665 66.68C66.0732 66.92 66.0265 67.1933 66.0265 67.5C66.0265 67.8 66.0732 68.0733 66.1665 68.32C66.2665 68.5667 66.3999 68.78 66.5665 68.96C66.7399 69.1333 66.9399 69.2667 67.1665 69.36C67.3999 69.4533 67.6499 69.5 67.9165 69.5Z"
            fill="#5CA0B5"
          />
          <path
            d="M75.3036 71.14C74.7302 71.14 74.1769 71.07 73.6436 70.93C73.1169 70.7833 72.6869 70.5967 72.3536 70.37L73.0036 68.91C73.3169 69.11 73.6769 69.2767 74.0836 69.41C74.4969 69.5367 74.9069 69.6 75.3136 69.6C75.5869 69.6 75.8069 69.5767 75.9736 69.53C76.1402 69.4767 76.2602 69.41 76.3336 69.33C76.4136 69.2433 76.4536 69.1433 76.4536 69.03C76.4536 68.87 76.3802 68.7433 76.2336 68.65C76.0869 68.5567 75.8969 68.48 75.6636 68.42C75.4302 68.36 75.1702 68.3 74.8836 68.24C74.6036 68.18 74.3202 68.1033 74.0336 68.01C73.7536 67.9167 73.4969 67.7967 73.2636 67.65C73.0302 67.4967 72.8402 67.3 72.6936 67.06C72.5469 66.8133 72.4736 66.5033 72.4736 66.13C72.4736 65.71 72.5869 65.33 72.8136 64.99C73.0469 64.65 73.3936 64.3767 73.8536 64.17C74.3136 63.9633 74.8869 63.86 75.5736 63.86C76.0336 63.86 76.4836 63.9133 76.9236 64.02C77.3702 64.12 77.7669 64.27 78.1136 64.47L77.5036 65.94C77.1702 65.76 76.8402 65.6267 76.5136 65.54C76.1869 65.4467 75.8702 65.4 75.5636 65.4C75.2902 65.4 75.0702 65.43 74.9036 65.49C74.7369 65.5433 74.6169 65.6167 74.5436 65.71C74.4702 65.8033 74.4336 65.91 74.4336 66.03C74.4336 66.1833 74.5036 66.3067 74.6436 66.4C74.7902 66.4867 74.9802 66.56 75.2136 66.62C75.4536 66.6733 75.7136 66.73 75.9936 66.79C76.2802 66.85 76.5636 66.9267 76.8436 67.02C77.1302 67.1067 77.3902 67.2267 77.6236 67.38C77.8569 67.5267 78.0436 67.7233 78.1836 67.97C78.3302 68.21 78.4036 68.5133 78.4036 68.88C78.4036 69.2867 78.2869 69.6633 78.0536 70.01C77.8269 70.35 77.4836 70.6233 77.0236 70.83C76.5702 71.0367 75.9969 71.14 75.3036 71.14Z"
            fill="#5CA0B5"
          />
          <path
            d="M79.3182 71V64H82.5182C83.1582 64 83.7082 64.1033 84.1682 64.31C84.6348 64.5167 84.9948 64.8167 85.2482 65.21C85.5015 65.5967 85.6282 66.0567 85.6282 66.59C85.6282 67.1167 85.5015 67.5733 85.2482 67.96C84.9948 68.3467 84.6348 68.6467 84.1682 68.86C83.7082 69.0667 83.1582 69.17 82.5182 69.17H80.4182L81.2982 68.31V71H79.3182ZM81.2982 68.52L80.4182 67.61H82.3982C82.8115 67.61 83.1182 67.52 83.3182 67.34C83.5248 67.16 83.6282 66.91 83.6282 66.59C83.6282 66.2633 83.5248 66.01 83.3182 65.83C83.1182 65.65 82.8115 65.56 82.3982 65.56H80.4182L81.2982 64.65V68.52Z"
            fill="#5CA0B5"
          />
          <path
            d="M88.4136 66.71H91.6636V68.19H88.4136V66.71ZM88.5536 69.47H92.2136V71H86.5936V64H92.0836V65.53H88.5536V69.47Z"
            fill="#5CA0B5"
          />
          <path
            d="M93.3123 71V64H96.5123C97.1523 64 97.7023 64.1033 98.1623 64.31C98.629 64.5167 98.989 64.8167 99.2423 65.21C99.4956 65.5967 99.6223 66.0567 99.6223 66.59C99.6223 67.1167 99.4956 67.5733 99.2423 67.96C98.989 68.34 98.629 68.6333 98.1623 68.84C97.7023 69.04 97.1523 69.14 96.5123 69.14H94.4123L95.2923 68.31V71H93.3123ZM97.6423 71L95.9023 68.45H98.0123L99.7623 71H97.6423ZM95.2923 68.52L94.4123 67.61H96.3923C96.8056 67.61 97.1123 67.52 97.3123 67.34C97.519 67.16 97.6223 66.91 97.6223 66.59C97.6223 66.2633 97.519 66.01 97.3123 65.83C97.1123 65.65 96.8056 65.56 96.3923 65.56H94.4123L95.2923 64.65V68.52Z"
            fill="#5CA0B5"
          />
          <path d="M100.715 71V64H102.695V71H100.715Z" fill="#5CA0B5" />
          <path
            d="M105.593 71V65.57H103.443V64H109.713V65.57H107.573V71H105.593Z"
            fill="#5CA0B5"
          />
          <path
            d="M112.055 71V68.04L112.515 69.23L109.385 64H111.475L113.735 67.79H112.525L114.795 64H116.715L113.595 69.23L114.035 68.04V71H112.055Z"
            fill="#5CA0B5"
          />
        </g>
        <path
          d="M73.9711 24.7851C71.7899 25.7007 71.2979 28.2371 70.7401 30.2789C69.9403 30.3552 69.2456 30.563 68.3563 30.9998L68.3379 31.0235C68.9457 30.9261 69.9587 30.9761 70.4875 31.2234C70.1508 32.5943 69.8719 34.0519 69.1404 35.2175C68.3116 36.6409 66.1804 36.7935 65.1753 35.4753C64.1992 34.2571 64.899 32.1364 66.3435 31.6076C64.7385 32.1049 63.8466 34.3071 64.7701 35.7568C65.7463 37.3539 68.2695 37.6723 69.7114 36.5409C71.098 35.3569 71.319 33.4283 71.69 31.7654C71.7242 31.6128 71.7557 31.4602 71.7873 31.3076C73.9711 31.2129 76.5865 31.3918 78.0941 29.4369C80.3779 26.4848 77.1837 23.1512 73.9711 24.7851ZM76.4023 29.3606C75.0893 30.0815 73.4923 30.0763 72.0188 30.2526C72.2583 29.2185 72.5477 28.1871 73.0187 27.2584C73.6764 25.956 75.5024 25.1087 76.8285 25.8507C78.2046 26.6821 77.6494 28.6792 76.4023 29.3606Z"
          fill="#5CA0B5"
        />
        <g
          style={{
            mixBlendMode: 'multiply',
          }}
        >
          <path
            d="M100.854 82.8938C88.8883 79.5777 78.6165 88.4316 69.6813 95.0331C66.1369 92.7477 62.5986 91.3466 57.5139 90.2561L57.361 90.2938C60.1823 91.8681 64.1945 95.3666 65.5702 98.1049C59.7266 102.66 53.8394 107.76 47.0364 110.187C38.9941 113.359 29.7149 107.061 29.8572 98.3614C29.7939 90.1681 39.5712 83.7031 47.2432 86.2186C39.0123 83.0513 28.1784 89.2281 27.2723 98.2046C26.1041 107.959 35.4682 117.473 45.0878 117.497C54.6507 117.124 61.8301 109.894 68.7639 104.247C69.4009 103.729 70.027 103.203 70.6532 102.677C79.9611 109.384 90.1579 118.622 102.725 115.466C121.733 110.723 119.404 86.602 100.854 82.8938ZM96.001 109.653C88.2469 108.356 81.682 103.144 75.0367 99.0809C79.3844 95.5977 83.9296 92.2878 88.8894 89.9908C95.8335 86.7613 106.113 89.2048 109.166 96.5729C112.135 104.472 103.356 110.898 96.001 109.653Z"
            fill="#5CA0B5"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_665_82226"
          x={12.7477}
          y={14.1261}
          width={117.834}
          height={131.748}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_665_82226"
          />
        </filter>
        <clipPath id="clip0_665_82226">
          <rect width={143.327} height={160} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
}

export type CoachingBadgeType = keyof typeof coachingBadges
